import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

import { UserMetadata } from '@almaris/shared/model/user'
import {
  EstateFeatures,
  EstateSellerData,
  EstateCoownership,
  EstateServicesAndConditions,
  EstateDiagnosticsData,
  EstateVirtualVisits,
} from '@almaris/shared/model/estate'
import {
  VisitSpanSpan,
} from '@almaris/shared/model/visit-span'

const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  bigint: { input: number; output: number; }
  bytea: { input: any; output: any; }
  citext: { input: string; output: string; }
  estate_coownership: { input: EstateCoownership; output: EstateCoownership; }
  estate_diagnostics_data: { input: EstateDiagnosticsData; output: EstateDiagnosticsData; }
  estate_features: { input: EstateFeatures; output: EstateFeatures; }
  estate_seller_data: { input: EstateSellerData; output: EstateSellerData; }
  estate_services_and_conditions: { input: EstateServicesAndConditions; output: EstateServicesAndConditions; }
  estate_virtual_visits: { input: EstateVirtualVisits; output: EstateVirtualVisits; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: string; output: string; }
  user_metadata: { input: UserMetadata; output: UserMetadata; }
  uuid: { input: string; output: string; }
  visit_span_span: { input: VisitSpanSpan; output: VisitSpanSpan; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "agency" */
export type Agency = {
  __typename?: 'agency';
  /** An array relationship */
  agency_members: Array<Agency_Member>;
  /** An aggregate relationship */
  agency_members_aggregate: Agency_Member_Aggregate;
  /** An array relationship */
  buyer_members: Array<Buyer_Member>;
  /** An aggregate relationship */
  buyer_members_aggregate: Buyer_Member_Aggregate;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  sellers: Array<Seller>;
  /** An aggregate relationship */
  sellers_aggregate: Seller_Aggregate;
};


/** columns and relationships of "agency" */
export type AgencyAgency_MembersArgs = {
  distinct_on?: InputMaybe<Array<Agency_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Member_Order_By>>;
  where?: InputMaybe<Agency_Member_Bool_Exp>;
};


/** columns and relationships of "agency" */
export type AgencyAgency_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agency_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Member_Order_By>>;
  where?: InputMaybe<Agency_Member_Bool_Exp>;
};


/** columns and relationships of "agency" */
export type AgencyBuyer_MembersArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Member_Order_By>>;
  where?: InputMaybe<Buyer_Member_Bool_Exp>;
};


/** columns and relationships of "agency" */
export type AgencyBuyer_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Member_Order_By>>;
  where?: InputMaybe<Buyer_Member_Bool_Exp>;
};


/** columns and relationships of "agency" */
export type AgencySellersArgs = {
  distinct_on?: InputMaybe<Array<Seller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Order_By>>;
  where?: InputMaybe<Seller_Bool_Exp>;
};


/** columns and relationships of "agency" */
export type AgencySellers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Order_By>>;
  where?: InputMaybe<Seller_Bool_Exp>;
};

/** aggregated selection of "agency" */
export type Agency_Aggregate = {
  __typename?: 'agency_aggregate';
  aggregate?: Maybe<Agency_Aggregate_Fields>;
  nodes: Array<Agency>;
};

/** aggregate fields of "agency" */
export type Agency_Aggregate_Fields = {
  __typename?: 'agency_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Agency_Max_Fields>;
  min?: Maybe<Agency_Min_Fields>;
};


/** aggregate fields of "agency" */
export type Agency_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agency_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "agency". All fields are combined with a logical 'AND'. */
export type Agency_Bool_Exp = {
  _and?: InputMaybe<Array<Agency_Bool_Exp>>;
  _not?: InputMaybe<Agency_Bool_Exp>;
  _or?: InputMaybe<Array<Agency_Bool_Exp>>;
  agency_members?: InputMaybe<Agency_Member_Bool_Exp>;
  agency_members_aggregate?: InputMaybe<Agency_Member_Aggregate_Bool_Exp>;
  buyer_members?: InputMaybe<Buyer_Member_Bool_Exp>;
  buyer_members_aggregate?: InputMaybe<Buyer_Member_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  sellers?: InputMaybe<Seller_Bool_Exp>;
  sellers_aggregate?: InputMaybe<Seller_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "agency" */
export enum Agency_Constraint {
  /** unique or primary key constraint on columns "name" */
  AgencyNameKey = 'agency_name_key',
  /** unique or primary key constraint on columns "id" */
  AgencyPkey = 'agency_pkey'
}

/** input type for inserting data into table "agency" */
export type Agency_Insert_Input = {
  agency_members?: InputMaybe<Agency_Member_Arr_Rel_Insert_Input>;
  buyer_members?: InputMaybe<Buyer_Member_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sellers?: InputMaybe<Seller_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Agency_Max_Fields = {
  __typename?: 'agency_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "agency_member" */
export type Agency_Member = {
  __typename?: 'agency_member';
  /** An object relationship */
  agency: Agency;
  agencyId: Scalars['uuid']['output'];
  archived: Scalars['Boolean']['output'];
  hasSetPassword?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  inviteDate?: Maybe<Scalars['timestamptz']['output']>;
  /** Only used during the invitation phase */
  inviteEmail?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  pictureFileId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "agency_member" */
export type Agency_Member_Aggregate = {
  __typename?: 'agency_member_aggregate';
  aggregate?: Maybe<Agency_Member_Aggregate_Fields>;
  nodes: Array<Agency_Member>;
};

export type Agency_Member_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Agency_Member_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Agency_Member_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Agency_Member_Aggregate_Bool_Exp_Count>;
};

export type Agency_Member_Aggregate_Bool_Exp_Bool_And = {
  arguments: Agency_Member_Select_Column_Agency_Member_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Agency_Member_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Agency_Member_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Agency_Member_Select_Column_Agency_Member_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Agency_Member_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Agency_Member_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Agency_Member_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Agency_Member_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "agency_member" */
export type Agency_Member_Aggregate_Fields = {
  __typename?: 'agency_member_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Agency_Member_Max_Fields>;
  min?: Maybe<Agency_Member_Min_Fields>;
};


/** aggregate fields of "agency_member" */
export type Agency_Member_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agency_Member_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "agency_member" */
export type Agency_Member_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Agency_Member_Max_Order_By>;
  min?: InputMaybe<Agency_Member_Min_Order_By>;
};

/** input type for inserting array relation for remote table "agency_member" */
export type Agency_Member_Arr_Rel_Insert_Input = {
  data: Array<Agency_Member_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Agency_Member_On_Conflict>;
};

/** Boolean expression to filter rows from the table "agency_member". All fields are combined with a logical 'AND'. */
export type Agency_Member_Bool_Exp = {
  _and?: InputMaybe<Array<Agency_Member_Bool_Exp>>;
  _not?: InputMaybe<Agency_Member_Bool_Exp>;
  _or?: InputMaybe<Array<Agency_Member_Bool_Exp>>;
  agency?: InputMaybe<Agency_Bool_Exp>;
  agencyId?: InputMaybe<Uuid_Comparison_Exp>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  hasSetPassword?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inviteDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  inviteEmail?: InputMaybe<String_Comparison_Exp>;
  picture?: InputMaybe<String_Comparison_Exp>;
  pictureFileId?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "agency_member" */
export enum Agency_Member_Constraint {
  /** unique or primary key constraint on columns "id" */
  AgencyMemberPkey = 'agency_member_pkey'
}

/** input type for inserting data into table "agency_member" */
export type Agency_Member_Insert_Input = {
  agency?: InputMaybe<Agency_Obj_Rel_Insert_Input>;
  agencyId?: InputMaybe<Scalars['uuid']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  hasSetPassword?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inviteDate?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Only used during the invitation phase */
  inviteEmail?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  pictureFileId?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Agency_Member_Max_Fields = {
  __typename?: 'agency_member_max_fields';
  agencyId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  inviteDate?: Maybe<Scalars['timestamptz']['output']>;
  /** Only used during the invitation phase */
  inviteEmail?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  pictureFileId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "agency_member" */
export type Agency_Member_Max_Order_By = {
  agencyId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inviteDate?: InputMaybe<Order_By>;
  /** Only used during the invitation phase */
  inviteEmail?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  pictureFileId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Agency_Member_Min_Fields = {
  __typename?: 'agency_member_min_fields';
  agencyId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  inviteDate?: Maybe<Scalars['timestamptz']['output']>;
  /** Only used during the invitation phase */
  inviteEmail?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  pictureFileId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "agency_member" */
export type Agency_Member_Min_Order_By = {
  agencyId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inviteDate?: InputMaybe<Order_By>;
  /** Only used during the invitation phase */
  inviteEmail?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  pictureFileId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "agency_member" */
export type Agency_Member_Mutation_Response = {
  __typename?: 'agency_member_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Agency_Member>;
};

/** input type for inserting object relation for remote table "agency_member" */
export type Agency_Member_Obj_Rel_Insert_Input = {
  data: Agency_Member_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Agency_Member_On_Conflict>;
};

/** on_conflict condition type for table "agency_member" */
export type Agency_Member_On_Conflict = {
  constraint: Agency_Member_Constraint;
  update_columns?: Array<Agency_Member_Update_Column>;
  where?: InputMaybe<Agency_Member_Bool_Exp>;
};

/** Ordering options when selecting data from "agency_member". */
export type Agency_Member_Order_By = {
  agency?: InputMaybe<Agency_Order_By>;
  agencyId?: InputMaybe<Order_By>;
  archived?: InputMaybe<Order_By>;
  hasSetPassword?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inviteDate?: InputMaybe<Order_By>;
  inviteEmail?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  pictureFileId?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agency_member */
export type Agency_Member_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "agency_member" */
export enum Agency_Member_Select_Column {
  /** column name */
  AgencyId = 'agencyId',
  /** column name */
  Archived = 'archived',
  /** column name */
  HasSetPassword = 'hasSetPassword',
  /** column name */
  Id = 'id',
  /** column name */
  InviteDate = 'inviteDate',
  /** column name */
  InviteEmail = 'inviteEmail',
  /** column name */
  Picture = 'picture',
  /** column name */
  PictureFileId = 'pictureFileId',
  /** column name */
  UserId = 'userId'
}

/** select "agency_member_aggregate_bool_exp_bool_and_arguments_columns" columns of table "agency_member" */
export enum Agency_Member_Select_Column_Agency_Member_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Archived = 'archived',
  /** column name */
  HasSetPassword = 'hasSetPassword'
}

/** select "agency_member_aggregate_bool_exp_bool_or_arguments_columns" columns of table "agency_member" */
export enum Agency_Member_Select_Column_Agency_Member_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Archived = 'archived',
  /** column name */
  HasSetPassword = 'hasSetPassword'
}

/** input type for updating data in table "agency_member" */
export type Agency_Member_Set_Input = {
  agencyId?: InputMaybe<Scalars['uuid']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  hasSetPassword?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inviteDate?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Only used during the invitation phase */
  inviteEmail?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  pictureFileId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "agency_member" */
export type Agency_Member_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agency_Member_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agency_Member_Stream_Cursor_Value_Input = {
  agencyId?: InputMaybe<Scalars['uuid']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  hasSetPassword?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inviteDate?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Only used during the invitation phase */
  inviteEmail?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  pictureFileId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "agency_member" */
export enum Agency_Member_Update_Column {
  /** column name */
  AgencyId = 'agencyId',
  /** column name */
  Archived = 'archived',
  /** column name */
  HasSetPassword = 'hasSetPassword',
  /** column name */
  Id = 'id',
  /** column name */
  InviteDate = 'inviteDate',
  /** column name */
  InviteEmail = 'inviteEmail',
  /** column name */
  Picture = 'picture',
  /** column name */
  PictureFileId = 'pictureFileId',
  /** column name */
  UserId = 'userId'
}

export type Agency_Member_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Agency_Member_Set_Input>;
  /** filter the rows which have to be updated */
  where: Agency_Member_Bool_Exp;
};

/** aggregate min on columns */
export type Agency_Min_Fields = {
  __typename?: 'agency_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "agency" */
export type Agency_Mutation_Response = {
  __typename?: 'agency_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Agency>;
};

/** input type for inserting object relation for remote table "agency" */
export type Agency_Obj_Rel_Insert_Input = {
  data: Agency_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Agency_On_Conflict>;
};

/** on_conflict condition type for table "agency" */
export type Agency_On_Conflict = {
  constraint: Agency_Constraint;
  update_columns?: Array<Agency_Update_Column>;
  where?: InputMaybe<Agency_Bool_Exp>;
};

/** Ordering options when selecting data from "agency". */
export type Agency_Order_By = {
  agency_members_aggregate?: InputMaybe<Agency_Member_Aggregate_Order_By>;
  buyer_members_aggregate?: InputMaybe<Buyer_Member_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sellers_aggregate?: InputMaybe<Seller_Aggregate_Order_By>;
};

/** primary key columns input for table: agency */
export type Agency_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "agency" */
export enum Agency_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "agency" */
export type Agency_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "agency" */
export type Agency_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agency_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agency_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "agency" */
export enum Agency_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Agency_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Agency_Set_Input>;
  /** filter the rows which have to be updated */
  where: Agency_Bool_Exp;
};

/** columns and relationships of "application" */
export type Application = {
  __typename?: 'application';
  acceptedDraftCompromise: Scalars['Boolean']['output'];
  acquisitionAmount?: Maybe<Scalars['numeric']['output']>;
  additionalSuspensiveConditionDescription?: Maybe<Scalars['String']['output']>;
  alertOnHigherOffer?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  application_medias: Array<Application_Media>;
  /** An aggregate relationship */
  application_medias_aggregate: Application_Media_Aggregate;
  /** An object relationship */
  application_status: Application_Status;
  archived: Scalars['Boolean']['output'];
  authenticActFileId?: Maybe<Scalars['uuid']['output']>;
  authenticActSignatureDate?: Maybe<Scalars['timestamptz']['output']>;
  buyerId: Scalars['uuid']['output'];
  /** An object relationship */
  buyer_member: Buyer_Member;
  /** An array relationship */
  buyer_member_folders: Array<Buyer_Member_Folder>;
  /** An aggregate relationship */
  buyer_member_folders_aggregate: Buyer_Member_Folder_Aggregate;
  cancellationDocumentFileId?: Maybe<Scalars['uuid']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  confirmOfferOnHonor?: Maybe<Scalars['Boolean']['output']>;
  contribution?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  dateConfirmConformityAndAcceptedPrivacyPolicy?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  estate: Estate;
  estateId: Scalars['uuid']['output'];
  hasDraftBeenEdited: Scalars['Boolean']['output'];
  hasNoAdditionalSuspensiveCondition?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  loan?: Maybe<Scalars['Int']['output']>;
  needsPropertySaleToFinanceAcquisition?: Maybe<Scalars['Boolean']['output']>;
  notary: Scalars['jsonb']['output'];
  offerAmount?: Maybe<Scalars['Int']['output']>;
  promiseOfSaleSignatureDate?: Maybe<Scalars['timestamptz']['output']>;
  promiseOfSalesFileId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  round?: Maybe<Estate_Round>;
  roundId?: Maybe<Scalars['uuid']['output']>;
  score: Scalars['Int']['output'];
  status: Application_Status_Enum;
  submitDate?: Maybe<Scalars['timestamptz']['output']>;
  tags?: Maybe<Scalars['jsonb']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "application" */
export type ApplicationApplication_MediasArgs = {
  distinct_on?: InputMaybe<Array<Application_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Media_Order_By>>;
  where?: InputMaybe<Application_Media_Bool_Exp>;
};


/** columns and relationships of "application" */
export type ApplicationApplication_Medias_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Media_Order_By>>;
  where?: InputMaybe<Application_Media_Bool_Exp>;
};


/** columns and relationships of "application" */
export type ApplicationBuyer_Member_FoldersArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Member_Folder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Member_Folder_Order_By>>;
  where?: InputMaybe<Buyer_Member_Folder_Bool_Exp>;
};


/** columns and relationships of "application" */
export type ApplicationBuyer_Member_Folders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Member_Folder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Member_Folder_Order_By>>;
  where?: InputMaybe<Buyer_Member_Folder_Bool_Exp>;
};


/** columns and relationships of "application" */
export type ApplicationNotaryArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "application" */
export type ApplicationTagsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "application" */
export type Application_Aggregate = {
  __typename?: 'application_aggregate';
  aggregate?: Maybe<Application_Aggregate_Fields>;
  nodes: Array<Application>;
};

export type Application_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Application_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Application_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Application_Aggregate_Bool_Exp_Count>;
};

export type Application_Aggregate_Bool_Exp_Bool_And = {
  arguments: Application_Select_Column_Application_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Application_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Application_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Application_Select_Column_Application_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Application_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Application_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Application_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Application_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "application" */
export type Application_Aggregate_Fields = {
  __typename?: 'application_aggregate_fields';
  avg?: Maybe<Application_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Application_Max_Fields>;
  min?: Maybe<Application_Min_Fields>;
  stddev?: Maybe<Application_Stddev_Fields>;
  stddev_pop?: Maybe<Application_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Application_Stddev_Samp_Fields>;
  sum?: Maybe<Application_Sum_Fields>;
  var_pop?: Maybe<Application_Var_Pop_Fields>;
  var_samp?: Maybe<Application_Var_Samp_Fields>;
  variance?: Maybe<Application_Variance_Fields>;
};


/** aggregate fields of "application" */
export type Application_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Application_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "application" */
export type Application_Aggregate_Order_By = {
  avg?: InputMaybe<Application_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Application_Max_Order_By>;
  min?: InputMaybe<Application_Min_Order_By>;
  stddev?: InputMaybe<Application_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Application_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Application_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Application_Sum_Order_By>;
  var_pop?: InputMaybe<Application_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Application_Var_Samp_Order_By>;
  variance?: InputMaybe<Application_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Application_Append_Input = {
  notary?: InputMaybe<Scalars['jsonb']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "application" */
export type Application_Arr_Rel_Insert_Input = {
  data: Array<Application_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Application_On_Conflict>;
};

/** aggregate avg on columns */
export type Application_Avg_Fields = {
  __typename?: 'application_avg_fields';
  acquisitionAmount?: Maybe<Scalars['Float']['output']>;
  contribution?: Maybe<Scalars['Float']['output']>;
  loan?: Maybe<Scalars['Float']['output']>;
  offerAmount?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "application" */
export type Application_Avg_Order_By = {
  acquisitionAmount?: InputMaybe<Order_By>;
  contribution?: InputMaybe<Order_By>;
  loan?: InputMaybe<Order_By>;
  offerAmount?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "application". All fields are combined with a logical 'AND'. */
export type Application_Bool_Exp = {
  _and?: InputMaybe<Array<Application_Bool_Exp>>;
  _not?: InputMaybe<Application_Bool_Exp>;
  _or?: InputMaybe<Array<Application_Bool_Exp>>;
  acceptedDraftCompromise?: InputMaybe<Boolean_Comparison_Exp>;
  acquisitionAmount?: InputMaybe<Numeric_Comparison_Exp>;
  additionalSuspensiveConditionDescription?: InputMaybe<String_Comparison_Exp>;
  alertOnHigherOffer?: InputMaybe<Boolean_Comparison_Exp>;
  application_medias?: InputMaybe<Application_Media_Bool_Exp>;
  application_medias_aggregate?: InputMaybe<Application_Media_Aggregate_Bool_Exp>;
  application_status?: InputMaybe<Application_Status_Bool_Exp>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  authenticActFileId?: InputMaybe<Uuid_Comparison_Exp>;
  authenticActSignatureDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  buyerId?: InputMaybe<Uuid_Comparison_Exp>;
  buyer_member?: InputMaybe<Buyer_Member_Bool_Exp>;
  buyer_member_folders?: InputMaybe<Buyer_Member_Folder_Bool_Exp>;
  buyer_member_folders_aggregate?: InputMaybe<Buyer_Member_Folder_Aggregate_Bool_Exp>;
  cancellationDocumentFileId?: InputMaybe<Uuid_Comparison_Exp>;
  comment?: InputMaybe<String_Comparison_Exp>;
  confirmOfferOnHonor?: InputMaybe<Boolean_Comparison_Exp>;
  contribution?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  dateConfirmConformityAndAcceptedPrivacyPolicy?: InputMaybe<Timestamptz_Comparison_Exp>;
  estate?: InputMaybe<Estate_Bool_Exp>;
  estateId?: InputMaybe<Uuid_Comparison_Exp>;
  hasDraftBeenEdited?: InputMaybe<Boolean_Comparison_Exp>;
  hasNoAdditionalSuspensiveCondition?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  loan?: InputMaybe<Int_Comparison_Exp>;
  needsPropertySaleToFinanceAcquisition?: InputMaybe<Boolean_Comparison_Exp>;
  notary?: InputMaybe<Jsonb_Comparison_Exp>;
  offerAmount?: InputMaybe<Int_Comparison_Exp>;
  promiseOfSaleSignatureDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  promiseOfSalesFileId?: InputMaybe<Uuid_Comparison_Exp>;
  round?: InputMaybe<Estate_Round_Bool_Exp>;
  roundId?: InputMaybe<Uuid_Comparison_Exp>;
  score?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<Application_Status_Enum_Comparison_Exp>;
  submitDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  tags?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "application" */
export enum Application_Constraint {
  /** unique or primary key constraint on columns "id" */
  ApplicationPkey = 'application_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Application_Delete_At_Path_Input = {
  notary?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Application_Delete_Elem_Input = {
  notary?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Application_Delete_Key_Input = {
  notary?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "application" */
export type Application_Inc_Input = {
  acquisitionAmount?: InputMaybe<Scalars['numeric']['input']>;
  contribution?: InputMaybe<Scalars['Int']['input']>;
  loan?: InputMaybe<Scalars['Int']['input']>;
  offerAmount?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "application" */
export type Application_Insert_Input = {
  acceptedDraftCompromise?: InputMaybe<Scalars['Boolean']['input']>;
  acquisitionAmount?: InputMaybe<Scalars['numeric']['input']>;
  additionalSuspensiveConditionDescription?: InputMaybe<Scalars['String']['input']>;
  alertOnHigherOffer?: InputMaybe<Scalars['Boolean']['input']>;
  application_medias?: InputMaybe<Application_Media_Arr_Rel_Insert_Input>;
  application_status?: InputMaybe<Application_Status_Obj_Rel_Insert_Input>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  authenticActFileId?: InputMaybe<Scalars['uuid']['input']>;
  authenticActSignatureDate?: InputMaybe<Scalars['timestamptz']['input']>;
  buyerId?: InputMaybe<Scalars['uuid']['input']>;
  buyer_member?: InputMaybe<Buyer_Member_Obj_Rel_Insert_Input>;
  buyer_member_folders?: InputMaybe<Buyer_Member_Folder_Arr_Rel_Insert_Input>;
  cancellationDocumentFileId?: InputMaybe<Scalars['uuid']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmOfferOnHonor?: InputMaybe<Scalars['Boolean']['input']>;
  contribution?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dateConfirmConformityAndAcceptedPrivacyPolicy?: InputMaybe<Scalars['timestamptz']['input']>;
  estate?: InputMaybe<Estate_Obj_Rel_Insert_Input>;
  estateId?: InputMaybe<Scalars['uuid']['input']>;
  hasDraftBeenEdited?: InputMaybe<Scalars['Boolean']['input']>;
  hasNoAdditionalSuspensiveCondition?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  loan?: InputMaybe<Scalars['Int']['input']>;
  needsPropertySaleToFinanceAcquisition?: InputMaybe<Scalars['Boolean']['input']>;
  notary?: InputMaybe<Scalars['jsonb']['input']>;
  offerAmount?: InputMaybe<Scalars['Int']['input']>;
  promiseOfSaleSignatureDate?: InputMaybe<Scalars['timestamptz']['input']>;
  promiseOfSalesFileId?: InputMaybe<Scalars['uuid']['input']>;
  round?: InputMaybe<Estate_Round_Obj_Rel_Insert_Input>;
  roundId?: InputMaybe<Scalars['uuid']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Application_Status_Enum>;
  submitDate?: InputMaybe<Scalars['timestamptz']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Application_Max_Fields = {
  __typename?: 'application_max_fields';
  acquisitionAmount?: Maybe<Scalars['numeric']['output']>;
  additionalSuspensiveConditionDescription?: Maybe<Scalars['String']['output']>;
  authenticActFileId?: Maybe<Scalars['uuid']['output']>;
  authenticActSignatureDate?: Maybe<Scalars['timestamptz']['output']>;
  buyerId?: Maybe<Scalars['uuid']['output']>;
  cancellationDocumentFileId?: Maybe<Scalars['uuid']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  contribution?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dateConfirmConformityAndAcceptedPrivacyPolicy?: Maybe<Scalars['timestamptz']['output']>;
  estateId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  loan?: Maybe<Scalars['Int']['output']>;
  offerAmount?: Maybe<Scalars['Int']['output']>;
  promiseOfSaleSignatureDate?: Maybe<Scalars['timestamptz']['output']>;
  promiseOfSalesFileId?: Maybe<Scalars['uuid']['output']>;
  roundId?: Maybe<Scalars['uuid']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  submitDate?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "application" */
export type Application_Max_Order_By = {
  acquisitionAmount?: InputMaybe<Order_By>;
  additionalSuspensiveConditionDescription?: InputMaybe<Order_By>;
  authenticActFileId?: InputMaybe<Order_By>;
  authenticActSignatureDate?: InputMaybe<Order_By>;
  buyerId?: InputMaybe<Order_By>;
  cancellationDocumentFileId?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  contribution?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dateConfirmConformityAndAcceptedPrivacyPolicy?: InputMaybe<Order_By>;
  estateId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loan?: InputMaybe<Order_By>;
  offerAmount?: InputMaybe<Order_By>;
  promiseOfSaleSignatureDate?: InputMaybe<Order_By>;
  promiseOfSalesFileId?: InputMaybe<Order_By>;
  roundId?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  submitDate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** columns and relationships of "application_media" */
export type Application_Media = {
  __typename?: 'application_media';
  /** An object relationship */
  application: Application;
  applicationId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  file: Files;
  fileId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: Application_Media_Type_Enum;
};

/** aggregated selection of "application_media" */
export type Application_Media_Aggregate = {
  __typename?: 'application_media_aggregate';
  aggregate?: Maybe<Application_Media_Aggregate_Fields>;
  nodes: Array<Application_Media>;
};

export type Application_Media_Aggregate_Bool_Exp = {
  count?: InputMaybe<Application_Media_Aggregate_Bool_Exp_Count>;
};

export type Application_Media_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Application_Media_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Application_Media_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "application_media" */
export type Application_Media_Aggregate_Fields = {
  __typename?: 'application_media_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Application_Media_Max_Fields>;
  min?: Maybe<Application_Media_Min_Fields>;
};


/** aggregate fields of "application_media" */
export type Application_Media_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Application_Media_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "application_media" */
export type Application_Media_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Application_Media_Max_Order_By>;
  min?: InputMaybe<Application_Media_Min_Order_By>;
};

/** input type for inserting array relation for remote table "application_media" */
export type Application_Media_Arr_Rel_Insert_Input = {
  data: Array<Application_Media_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Application_Media_On_Conflict>;
};

/** Boolean expression to filter rows from the table "application_media". All fields are combined with a logical 'AND'. */
export type Application_Media_Bool_Exp = {
  _and?: InputMaybe<Array<Application_Media_Bool_Exp>>;
  _not?: InputMaybe<Application_Media_Bool_Exp>;
  _or?: InputMaybe<Array<Application_Media_Bool_Exp>>;
  application?: InputMaybe<Application_Bool_Exp>;
  applicationId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  fileId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Application_Media_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "application_media" */
export enum Application_Media_Constraint {
  /** unique or primary key constraint on columns "id" */
  ApplicationMediaPkey = 'application_media_pkey'
}

/** input type for inserting data into table "application_media" */
export type Application_Media_Insert_Input = {
  application?: InputMaybe<Application_Obj_Rel_Insert_Input>;
  applicationId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Application_Media_Type_Enum>;
};

/** aggregate max on columns */
export type Application_Media_Max_Fields = {
  __typename?: 'application_media_max_fields';
  applicationId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "application_media" */
export type Application_Media_Max_Order_By = {
  applicationId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Application_Media_Min_Fields = {
  __typename?: 'application_media_min_fields';
  applicationId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "application_media" */
export type Application_Media_Min_Order_By = {
  applicationId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "application_media" */
export type Application_Media_Mutation_Response = {
  __typename?: 'application_media_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Application_Media>;
};

/** on_conflict condition type for table "application_media" */
export type Application_Media_On_Conflict = {
  constraint: Application_Media_Constraint;
  update_columns?: Array<Application_Media_Update_Column>;
  where?: InputMaybe<Application_Media_Bool_Exp>;
};

/** Ordering options when selecting data from "application_media". */
export type Application_Media_Order_By = {
  application?: InputMaybe<Application_Order_By>;
  applicationId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: application_media */
export type Application_Media_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "application_media" */
export enum Application_Media_Select_Column {
  /** column name */
  ApplicationId = 'applicationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "application_media" */
export type Application_Media_Set_Input = {
  applicationId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Application_Media_Type_Enum>;
};

/** Streaming cursor of the table "application_media" */
export type Application_Media_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Application_Media_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Application_Media_Stream_Cursor_Value_Input = {
  applicationId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Application_Media_Type_Enum>;
};

/** columns and relationships of "application_media_type" */
export type Application_Media_Type = {
  __typename?: 'application_media_type';
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "application_media_type" */
export type Application_Media_Type_Aggregate = {
  __typename?: 'application_media_type_aggregate';
  aggregate?: Maybe<Application_Media_Type_Aggregate_Fields>;
  nodes: Array<Application_Media_Type>;
};

/** aggregate fields of "application_media_type" */
export type Application_Media_Type_Aggregate_Fields = {
  __typename?: 'application_media_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Application_Media_Type_Max_Fields>;
  min?: Maybe<Application_Media_Type_Min_Fields>;
};


/** aggregate fields of "application_media_type" */
export type Application_Media_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Application_Media_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "application_media_type". All fields are combined with a logical 'AND'. */
export type Application_Media_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Application_Media_Type_Bool_Exp>>;
  _not?: InputMaybe<Application_Media_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Application_Media_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "application_media_type" */
export enum Application_Media_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  ApplicationMediaTypePkey = 'application_media_type_pkey'
}

export enum Application_Media_Type_Enum {
  /** Avis d'imposition */
  AvisImpot = 'avis_impot',
  /** Justificatif d'apport */
  JustificatifApport = 'justificatif_apport',
  /** Justificatif de revenus */
  JustificatifRevenus = 'justificatif_revenus',
  /** Autre document */
  Other = 'other',
  /** Simulation de prêt bancaire */
  SimulationPret = 'simulation_pret'
}

/** Boolean expression to compare columns of type "application_media_type_enum". All fields are combined with logical 'AND'. */
export type Application_Media_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Application_Media_Type_Enum>;
  _in?: InputMaybe<Array<Application_Media_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Application_Media_Type_Enum>;
  _nin?: InputMaybe<Array<Application_Media_Type_Enum>>;
};

/** input type for inserting data into table "application_media_type" */
export type Application_Media_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Application_Media_Type_Max_Fields = {
  __typename?: 'application_media_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Application_Media_Type_Min_Fields = {
  __typename?: 'application_media_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "application_media_type" */
export type Application_Media_Type_Mutation_Response = {
  __typename?: 'application_media_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Application_Media_Type>;
};

/** on_conflict condition type for table "application_media_type" */
export type Application_Media_Type_On_Conflict = {
  constraint: Application_Media_Type_Constraint;
  update_columns?: Array<Application_Media_Type_Update_Column>;
  where?: InputMaybe<Application_Media_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "application_media_type". */
export type Application_Media_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: application_media_type */
export type Application_Media_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "application_media_type" */
export enum Application_Media_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "application_media_type" */
export type Application_Media_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "application_media_type" */
export type Application_Media_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Application_Media_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Application_Media_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "application_media_type" */
export enum Application_Media_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Application_Media_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Application_Media_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Application_Media_Type_Bool_Exp;
};

/** update columns of table "application_media" */
export enum Application_Media_Update_Column {
  /** column name */
  ApplicationId = 'applicationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type'
}

export type Application_Media_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Application_Media_Set_Input>;
  /** filter the rows which have to be updated */
  where: Application_Media_Bool_Exp;
};

/** aggregate min on columns */
export type Application_Min_Fields = {
  __typename?: 'application_min_fields';
  acquisitionAmount?: Maybe<Scalars['numeric']['output']>;
  additionalSuspensiveConditionDescription?: Maybe<Scalars['String']['output']>;
  authenticActFileId?: Maybe<Scalars['uuid']['output']>;
  authenticActSignatureDate?: Maybe<Scalars['timestamptz']['output']>;
  buyerId?: Maybe<Scalars['uuid']['output']>;
  cancellationDocumentFileId?: Maybe<Scalars['uuid']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  contribution?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dateConfirmConformityAndAcceptedPrivacyPolicy?: Maybe<Scalars['timestamptz']['output']>;
  estateId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  loan?: Maybe<Scalars['Int']['output']>;
  offerAmount?: Maybe<Scalars['Int']['output']>;
  promiseOfSaleSignatureDate?: Maybe<Scalars['timestamptz']['output']>;
  promiseOfSalesFileId?: Maybe<Scalars['uuid']['output']>;
  roundId?: Maybe<Scalars['uuid']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  submitDate?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "application" */
export type Application_Min_Order_By = {
  acquisitionAmount?: InputMaybe<Order_By>;
  additionalSuspensiveConditionDescription?: InputMaybe<Order_By>;
  authenticActFileId?: InputMaybe<Order_By>;
  authenticActSignatureDate?: InputMaybe<Order_By>;
  buyerId?: InputMaybe<Order_By>;
  cancellationDocumentFileId?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  contribution?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dateConfirmConformityAndAcceptedPrivacyPolicy?: InputMaybe<Order_By>;
  estateId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loan?: InputMaybe<Order_By>;
  offerAmount?: InputMaybe<Order_By>;
  promiseOfSaleSignatureDate?: InputMaybe<Order_By>;
  promiseOfSalesFileId?: InputMaybe<Order_By>;
  roundId?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  submitDate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "application" */
export type Application_Mutation_Response = {
  __typename?: 'application_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Application>;
};

/** input type for inserting object relation for remote table "application" */
export type Application_Obj_Rel_Insert_Input = {
  data: Application_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Application_On_Conflict>;
};

/** on_conflict condition type for table "application" */
export type Application_On_Conflict = {
  constraint: Application_Constraint;
  update_columns?: Array<Application_Update_Column>;
  where?: InputMaybe<Application_Bool_Exp>;
};

/** Ordering options when selecting data from "application". */
export type Application_Order_By = {
  acceptedDraftCompromise?: InputMaybe<Order_By>;
  acquisitionAmount?: InputMaybe<Order_By>;
  additionalSuspensiveConditionDescription?: InputMaybe<Order_By>;
  alertOnHigherOffer?: InputMaybe<Order_By>;
  application_medias_aggregate?: InputMaybe<Application_Media_Aggregate_Order_By>;
  application_status?: InputMaybe<Application_Status_Order_By>;
  archived?: InputMaybe<Order_By>;
  authenticActFileId?: InputMaybe<Order_By>;
  authenticActSignatureDate?: InputMaybe<Order_By>;
  buyerId?: InputMaybe<Order_By>;
  buyer_member?: InputMaybe<Buyer_Member_Order_By>;
  buyer_member_folders_aggregate?: InputMaybe<Buyer_Member_Folder_Aggregate_Order_By>;
  cancellationDocumentFileId?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  confirmOfferOnHonor?: InputMaybe<Order_By>;
  contribution?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dateConfirmConformityAndAcceptedPrivacyPolicy?: InputMaybe<Order_By>;
  estate?: InputMaybe<Estate_Order_By>;
  estateId?: InputMaybe<Order_By>;
  hasDraftBeenEdited?: InputMaybe<Order_By>;
  hasNoAdditionalSuspensiveCondition?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loan?: InputMaybe<Order_By>;
  needsPropertySaleToFinanceAcquisition?: InputMaybe<Order_By>;
  notary?: InputMaybe<Order_By>;
  offerAmount?: InputMaybe<Order_By>;
  promiseOfSaleSignatureDate?: InputMaybe<Order_By>;
  promiseOfSalesFileId?: InputMaybe<Order_By>;
  round?: InputMaybe<Estate_Round_Order_By>;
  roundId?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  submitDate?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: application */
export type Application_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Application_Prepend_Input = {
  notary?: InputMaybe<Scalars['jsonb']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "application" */
export enum Application_Select_Column {
  /** column name */
  AcceptedDraftCompromise = 'acceptedDraftCompromise',
  /** column name */
  AcquisitionAmount = 'acquisitionAmount',
  /** column name */
  AdditionalSuspensiveConditionDescription = 'additionalSuspensiveConditionDescription',
  /** column name */
  AlertOnHigherOffer = 'alertOnHigherOffer',
  /** column name */
  Archived = 'archived',
  /** column name */
  AuthenticActFileId = 'authenticActFileId',
  /** column name */
  AuthenticActSignatureDate = 'authenticActSignatureDate',
  /** column name */
  BuyerId = 'buyerId',
  /** column name */
  CancellationDocumentFileId = 'cancellationDocumentFileId',
  /** column name */
  Comment = 'comment',
  /** column name */
  ConfirmOfferOnHonor = 'confirmOfferOnHonor',
  /** column name */
  Contribution = 'contribution',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DateConfirmConformityAndAcceptedPrivacyPolicy = 'dateConfirmConformityAndAcceptedPrivacyPolicy',
  /** column name */
  EstateId = 'estateId',
  /** column name */
  HasDraftBeenEdited = 'hasDraftBeenEdited',
  /** column name */
  HasNoAdditionalSuspensiveCondition = 'hasNoAdditionalSuspensiveCondition',
  /** column name */
  Id = 'id',
  /** column name */
  Loan = 'loan',
  /** column name */
  NeedsPropertySaleToFinanceAcquisition = 'needsPropertySaleToFinanceAcquisition',
  /** column name */
  Notary = 'notary',
  /** column name */
  OfferAmount = 'offerAmount',
  /** column name */
  PromiseOfSaleSignatureDate = 'promiseOfSaleSignatureDate',
  /** column name */
  PromiseOfSalesFileId = 'promiseOfSalesFileId',
  /** column name */
  RoundId = 'roundId',
  /** column name */
  Score = 'score',
  /** column name */
  Status = 'status',
  /** column name */
  SubmitDate = 'submitDate',
  /** column name */
  Tags = 'tags',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "application_aggregate_bool_exp_bool_and_arguments_columns" columns of table "application" */
export enum Application_Select_Column_Application_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AcceptedDraftCompromise = 'acceptedDraftCompromise',
  /** column name */
  AlertOnHigherOffer = 'alertOnHigherOffer',
  /** column name */
  Archived = 'archived',
  /** column name */
  ConfirmOfferOnHonor = 'confirmOfferOnHonor',
  /** column name */
  HasDraftBeenEdited = 'hasDraftBeenEdited',
  /** column name */
  HasNoAdditionalSuspensiveCondition = 'hasNoAdditionalSuspensiveCondition',
  /** column name */
  NeedsPropertySaleToFinanceAcquisition = 'needsPropertySaleToFinanceAcquisition'
}

/** select "application_aggregate_bool_exp_bool_or_arguments_columns" columns of table "application" */
export enum Application_Select_Column_Application_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AcceptedDraftCompromise = 'acceptedDraftCompromise',
  /** column name */
  AlertOnHigherOffer = 'alertOnHigherOffer',
  /** column name */
  Archived = 'archived',
  /** column name */
  ConfirmOfferOnHonor = 'confirmOfferOnHonor',
  /** column name */
  HasDraftBeenEdited = 'hasDraftBeenEdited',
  /** column name */
  HasNoAdditionalSuspensiveCondition = 'hasNoAdditionalSuspensiveCondition',
  /** column name */
  NeedsPropertySaleToFinanceAcquisition = 'needsPropertySaleToFinanceAcquisition'
}

/** input type for updating data in table "application" */
export type Application_Set_Input = {
  acceptedDraftCompromise?: InputMaybe<Scalars['Boolean']['input']>;
  acquisitionAmount?: InputMaybe<Scalars['numeric']['input']>;
  additionalSuspensiveConditionDescription?: InputMaybe<Scalars['String']['input']>;
  alertOnHigherOffer?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  authenticActFileId?: InputMaybe<Scalars['uuid']['input']>;
  authenticActSignatureDate?: InputMaybe<Scalars['timestamptz']['input']>;
  buyerId?: InputMaybe<Scalars['uuid']['input']>;
  cancellationDocumentFileId?: InputMaybe<Scalars['uuid']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmOfferOnHonor?: InputMaybe<Scalars['Boolean']['input']>;
  contribution?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dateConfirmConformityAndAcceptedPrivacyPolicy?: InputMaybe<Scalars['timestamptz']['input']>;
  estateId?: InputMaybe<Scalars['uuid']['input']>;
  hasDraftBeenEdited?: InputMaybe<Scalars['Boolean']['input']>;
  hasNoAdditionalSuspensiveCondition?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  loan?: InputMaybe<Scalars['Int']['input']>;
  needsPropertySaleToFinanceAcquisition?: InputMaybe<Scalars['Boolean']['input']>;
  notary?: InputMaybe<Scalars['jsonb']['input']>;
  offerAmount?: InputMaybe<Scalars['Int']['input']>;
  promiseOfSaleSignatureDate?: InputMaybe<Scalars['timestamptz']['input']>;
  promiseOfSalesFileId?: InputMaybe<Scalars['uuid']['input']>;
  roundId?: InputMaybe<Scalars['uuid']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Application_Status_Enum>;
  submitDate?: InputMaybe<Scalars['timestamptz']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "application_status" */
export type Application_Status = {
  __typename?: 'application_status';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "application_status" */
export type Application_Status_Aggregate = {
  __typename?: 'application_status_aggregate';
  aggregate?: Maybe<Application_Status_Aggregate_Fields>;
  nodes: Array<Application_Status>;
};

/** aggregate fields of "application_status" */
export type Application_Status_Aggregate_Fields = {
  __typename?: 'application_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Application_Status_Max_Fields>;
  min?: Maybe<Application_Status_Min_Fields>;
};


/** aggregate fields of "application_status" */
export type Application_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Application_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "application_status". All fields are combined with a logical 'AND'. */
export type Application_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Application_Status_Bool_Exp>>;
  _not?: InputMaybe<Application_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Application_Status_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "application_status" */
export enum Application_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  ApplicationStatusPkey = 'application_status_pkey'
}

export enum Application_Status_Enum {
  /** Acceptée */
  Accepted = 'Accepted',
  /** Annulée */
  Cancelled = 'Cancelled',
  /** Brouillon */
  Draft = 'Draft',
  /** Soumise */
  Submitted = 'Submitted'
}

/** Boolean expression to compare columns of type "application_status_enum". All fields are combined with logical 'AND'. */
export type Application_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Application_Status_Enum>;
  _in?: InputMaybe<Array<Application_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Application_Status_Enum>;
  _nin?: InputMaybe<Array<Application_Status_Enum>>;
};

/** input type for inserting data into table "application_status" */
export type Application_Status_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Application_Status_Max_Fields = {
  __typename?: 'application_status_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Application_Status_Min_Fields = {
  __typename?: 'application_status_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "application_status" */
export type Application_Status_Mutation_Response = {
  __typename?: 'application_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Application_Status>;
};

/** input type for inserting object relation for remote table "application_status" */
export type Application_Status_Obj_Rel_Insert_Input = {
  data: Application_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Application_Status_On_Conflict>;
};

/** on_conflict condition type for table "application_status" */
export type Application_Status_On_Conflict = {
  constraint: Application_Status_Constraint;
  update_columns?: Array<Application_Status_Update_Column>;
  where?: InputMaybe<Application_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "application_status". */
export type Application_Status_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: application_status */
export type Application_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "application_status" */
export enum Application_Status_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "application_status" */
export type Application_Status_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "application_status" */
export type Application_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Application_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Application_Status_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "application_status" */
export enum Application_Status_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Application_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Application_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Application_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Application_Stddev_Fields = {
  __typename?: 'application_stddev_fields';
  acquisitionAmount?: Maybe<Scalars['Float']['output']>;
  contribution?: Maybe<Scalars['Float']['output']>;
  loan?: Maybe<Scalars['Float']['output']>;
  offerAmount?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "application" */
export type Application_Stddev_Order_By = {
  acquisitionAmount?: InputMaybe<Order_By>;
  contribution?: InputMaybe<Order_By>;
  loan?: InputMaybe<Order_By>;
  offerAmount?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Application_Stddev_Pop_Fields = {
  __typename?: 'application_stddev_pop_fields';
  acquisitionAmount?: Maybe<Scalars['Float']['output']>;
  contribution?: Maybe<Scalars['Float']['output']>;
  loan?: Maybe<Scalars['Float']['output']>;
  offerAmount?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "application" */
export type Application_Stddev_Pop_Order_By = {
  acquisitionAmount?: InputMaybe<Order_By>;
  contribution?: InputMaybe<Order_By>;
  loan?: InputMaybe<Order_By>;
  offerAmount?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Application_Stddev_Samp_Fields = {
  __typename?: 'application_stddev_samp_fields';
  acquisitionAmount?: Maybe<Scalars['Float']['output']>;
  contribution?: Maybe<Scalars['Float']['output']>;
  loan?: Maybe<Scalars['Float']['output']>;
  offerAmount?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "application" */
export type Application_Stddev_Samp_Order_By = {
  acquisitionAmount?: InputMaybe<Order_By>;
  contribution?: InputMaybe<Order_By>;
  loan?: InputMaybe<Order_By>;
  offerAmount?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "application" */
export type Application_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Application_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Application_Stream_Cursor_Value_Input = {
  acceptedDraftCompromise?: InputMaybe<Scalars['Boolean']['input']>;
  acquisitionAmount?: InputMaybe<Scalars['numeric']['input']>;
  additionalSuspensiveConditionDescription?: InputMaybe<Scalars['String']['input']>;
  alertOnHigherOffer?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  authenticActFileId?: InputMaybe<Scalars['uuid']['input']>;
  authenticActSignatureDate?: InputMaybe<Scalars['timestamptz']['input']>;
  buyerId?: InputMaybe<Scalars['uuid']['input']>;
  cancellationDocumentFileId?: InputMaybe<Scalars['uuid']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmOfferOnHonor?: InputMaybe<Scalars['Boolean']['input']>;
  contribution?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dateConfirmConformityAndAcceptedPrivacyPolicy?: InputMaybe<Scalars['timestamptz']['input']>;
  estateId?: InputMaybe<Scalars['uuid']['input']>;
  hasDraftBeenEdited?: InputMaybe<Scalars['Boolean']['input']>;
  hasNoAdditionalSuspensiveCondition?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  loan?: InputMaybe<Scalars['Int']['input']>;
  needsPropertySaleToFinanceAcquisition?: InputMaybe<Scalars['Boolean']['input']>;
  notary?: InputMaybe<Scalars['jsonb']['input']>;
  offerAmount?: InputMaybe<Scalars['Int']['input']>;
  promiseOfSaleSignatureDate?: InputMaybe<Scalars['timestamptz']['input']>;
  promiseOfSalesFileId?: InputMaybe<Scalars['uuid']['input']>;
  roundId?: InputMaybe<Scalars['uuid']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Application_Status_Enum>;
  submitDate?: InputMaybe<Scalars['timestamptz']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Application_Sum_Fields = {
  __typename?: 'application_sum_fields';
  acquisitionAmount?: Maybe<Scalars['numeric']['output']>;
  contribution?: Maybe<Scalars['Int']['output']>;
  loan?: Maybe<Scalars['Int']['output']>;
  offerAmount?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "application" */
export type Application_Sum_Order_By = {
  acquisitionAmount?: InputMaybe<Order_By>;
  contribution?: InputMaybe<Order_By>;
  loan?: InputMaybe<Order_By>;
  offerAmount?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** update columns of table "application" */
export enum Application_Update_Column {
  /** column name */
  AcceptedDraftCompromise = 'acceptedDraftCompromise',
  /** column name */
  AcquisitionAmount = 'acquisitionAmount',
  /** column name */
  AdditionalSuspensiveConditionDescription = 'additionalSuspensiveConditionDescription',
  /** column name */
  AlertOnHigherOffer = 'alertOnHigherOffer',
  /** column name */
  Archived = 'archived',
  /** column name */
  AuthenticActFileId = 'authenticActFileId',
  /** column name */
  AuthenticActSignatureDate = 'authenticActSignatureDate',
  /** column name */
  BuyerId = 'buyerId',
  /** column name */
  CancellationDocumentFileId = 'cancellationDocumentFileId',
  /** column name */
  Comment = 'comment',
  /** column name */
  ConfirmOfferOnHonor = 'confirmOfferOnHonor',
  /** column name */
  Contribution = 'contribution',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DateConfirmConformityAndAcceptedPrivacyPolicy = 'dateConfirmConformityAndAcceptedPrivacyPolicy',
  /** column name */
  EstateId = 'estateId',
  /** column name */
  HasDraftBeenEdited = 'hasDraftBeenEdited',
  /** column name */
  HasNoAdditionalSuspensiveCondition = 'hasNoAdditionalSuspensiveCondition',
  /** column name */
  Id = 'id',
  /** column name */
  Loan = 'loan',
  /** column name */
  NeedsPropertySaleToFinanceAcquisition = 'needsPropertySaleToFinanceAcquisition',
  /** column name */
  Notary = 'notary',
  /** column name */
  OfferAmount = 'offerAmount',
  /** column name */
  PromiseOfSaleSignatureDate = 'promiseOfSaleSignatureDate',
  /** column name */
  PromiseOfSalesFileId = 'promiseOfSalesFileId',
  /** column name */
  RoundId = 'roundId',
  /** column name */
  Score = 'score',
  /** column name */
  Status = 'status',
  /** column name */
  SubmitDate = 'submitDate',
  /** column name */
  Tags = 'tags',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Application_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Application_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Application_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Application_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Application_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Application_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Application_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Application_Set_Input>;
  /** filter the rows which have to be updated */
  where: Application_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Application_Var_Pop_Fields = {
  __typename?: 'application_var_pop_fields';
  acquisitionAmount?: Maybe<Scalars['Float']['output']>;
  contribution?: Maybe<Scalars['Float']['output']>;
  loan?: Maybe<Scalars['Float']['output']>;
  offerAmount?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "application" */
export type Application_Var_Pop_Order_By = {
  acquisitionAmount?: InputMaybe<Order_By>;
  contribution?: InputMaybe<Order_By>;
  loan?: InputMaybe<Order_By>;
  offerAmount?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Application_Var_Samp_Fields = {
  __typename?: 'application_var_samp_fields';
  acquisitionAmount?: Maybe<Scalars['Float']['output']>;
  contribution?: Maybe<Scalars['Float']['output']>;
  loan?: Maybe<Scalars['Float']['output']>;
  offerAmount?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "application" */
export type Application_Var_Samp_Order_By = {
  acquisitionAmount?: InputMaybe<Order_By>;
  contribution?: InputMaybe<Order_By>;
  loan?: InputMaybe<Order_By>;
  offerAmount?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Application_Variance_Fields = {
  __typename?: 'application_variance_fields';
  acquisitionAmount?: Maybe<Scalars['Float']['output']>;
  contribution?: Maybe<Scalars['Float']['output']>;
  loan?: Maybe<Scalars['Float']['output']>;
  offerAmount?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "application" */
export type Application_Variance_Order_By = {
  acquisitionAmount?: InputMaybe<Order_By>;
  contribution?: InputMaybe<Order_By>;
  loan?: InputMaybe<Order_By>;
  offerAmount?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** Oauth requests, inserted before redirecting to the provider's site. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProviderRequests = {
  __typename?: 'authProviderRequests';
  id: Scalars['uuid']['output'];
  options?: Maybe<Scalars['jsonb']['output']>;
};


/** Oauth requests, inserted before redirecting to the provider's site. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProviderRequestsOptionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "auth.provider_requests" */
export type AuthProviderRequests_Aggregate = {
  __typename?: 'authProviderRequests_aggregate';
  aggregate?: Maybe<AuthProviderRequests_Aggregate_Fields>;
  nodes: Array<AuthProviderRequests>;
};

/** aggregate fields of "auth.provider_requests" */
export type AuthProviderRequests_Aggregate_Fields = {
  __typename?: 'authProviderRequests_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthProviderRequests_Max_Fields>;
  min?: Maybe<AuthProviderRequests_Min_Fields>;
};


/** aggregate fields of "auth.provider_requests" */
export type AuthProviderRequests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthProviderRequests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AuthProviderRequests_Append_Input = {
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "auth.provider_requests". All fields are combined with a logical 'AND'. */
export type AuthProviderRequests_Bool_Exp = {
  _and?: InputMaybe<Array<AuthProviderRequests_Bool_Exp>>;
  _not?: InputMaybe<AuthProviderRequests_Bool_Exp>;
  _or?: InputMaybe<Array<AuthProviderRequests_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  options?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.provider_requests" */
export enum AuthProviderRequests_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProviderRequestsPkey = 'provider_requests_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AuthProviderRequests_Delete_At_Path_Input = {
  options?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AuthProviderRequests_Delete_Elem_Input = {
  options?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AuthProviderRequests_Delete_Key_Input = {
  options?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "auth.provider_requests" */
export type AuthProviderRequests_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type AuthProviderRequests_Max_Fields = {
  __typename?: 'authProviderRequests_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type AuthProviderRequests_Min_Fields = {
  __typename?: 'authProviderRequests_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "auth.provider_requests" */
export type AuthProviderRequests_Mutation_Response = {
  __typename?: 'authProviderRequests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthProviderRequests>;
};

/** on_conflict condition type for table "auth.provider_requests" */
export type AuthProviderRequests_On_Conflict = {
  constraint: AuthProviderRequests_Constraint;
  update_columns?: Array<AuthProviderRequests_Update_Column>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.provider_requests". */
export type AuthProviderRequests_Order_By = {
  id?: InputMaybe<Order_By>;
  options?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.provider_requests */
export type AuthProviderRequests_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AuthProviderRequests_Prepend_Input = {
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "auth.provider_requests" */
export enum AuthProviderRequests_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Options = 'options'
}

/** input type for updating data in table "auth.provider_requests" */
export type AuthProviderRequests_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "authProviderRequests" */
export type AuthProviderRequests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthProviderRequests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthProviderRequests_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "auth.provider_requests" */
export enum AuthProviderRequests_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Options = 'options'
}

export type AuthProviderRequests_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AuthProviderRequests_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AuthProviderRequests_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AuthProviderRequests_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AuthProviderRequests_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AuthProviderRequests_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthProviderRequests_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthProviderRequests_Bool_Exp;
};

/** List of available Oauth providers. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProviders = {
  __typename?: 'authProviders';
  id: Scalars['String']['output'];
  /** An array relationship */
  userProviders: Array<AuthUserProviders>;
  /** An aggregate relationship */
  userProviders_aggregate: AuthUserProviders_Aggregate;
};


/** List of available Oauth providers. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProvidersUserProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


/** List of available Oauth providers. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProvidersUserProviders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};

/** aggregated selection of "auth.providers" */
export type AuthProviders_Aggregate = {
  __typename?: 'authProviders_aggregate';
  aggregate?: Maybe<AuthProviders_Aggregate_Fields>;
  nodes: Array<AuthProviders>;
};

/** aggregate fields of "auth.providers" */
export type AuthProviders_Aggregate_Fields = {
  __typename?: 'authProviders_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthProviders_Max_Fields>;
  min?: Maybe<AuthProviders_Min_Fields>;
};


/** aggregate fields of "auth.providers" */
export type AuthProviders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthProviders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "auth.providers". All fields are combined with a logical 'AND'. */
export type AuthProviders_Bool_Exp = {
  _and?: InputMaybe<Array<AuthProviders_Bool_Exp>>;
  _not?: InputMaybe<AuthProviders_Bool_Exp>;
  _or?: InputMaybe<Array<AuthProviders_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  userProviders?: InputMaybe<AuthUserProviders_Bool_Exp>;
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "auth.providers" */
export enum AuthProviders_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProvidersPkey = 'providers_pkey'
}

/** input type for inserting data into table "auth.providers" */
export type AuthProviders_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  userProviders?: InputMaybe<AuthUserProviders_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type AuthProviders_Max_Fields = {
  __typename?: 'authProviders_max_fields';
  id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AuthProviders_Min_Fields = {
  __typename?: 'authProviders_min_fields';
  id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "auth.providers" */
export type AuthProviders_Mutation_Response = {
  __typename?: 'authProviders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthProviders>;
};

/** input type for inserting object relation for remote table "auth.providers" */
export type AuthProviders_Obj_Rel_Insert_Input = {
  data: AuthProviders_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthProviders_On_Conflict>;
};

/** on_conflict condition type for table "auth.providers" */
export type AuthProviders_On_Conflict = {
  constraint: AuthProviders_Constraint;
  update_columns?: Array<AuthProviders_Update_Column>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.providers". */
export type AuthProviders_Order_By = {
  id?: InputMaybe<Order_By>;
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Order_By>;
};

/** primary key columns input for table: auth.providers */
export type AuthProviders_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "auth.providers" */
export enum AuthProviders_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "auth.providers" */
export type AuthProviders_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "authProviders" */
export type AuthProviders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthProviders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthProviders_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "auth.providers" */
export enum AuthProviders_Update_Column {
  /** column name */
  Id = 'id'
}

export type AuthProviders_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthProviders_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthProviders_Bool_Exp;
};

/** columns and relationships of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes = {
  __typename?: 'authRefreshTokenTypes';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  refreshTokens: Array<AuthRefreshTokens>;
  /** An aggregate relationship */
  refreshTokens_aggregate: AuthRefreshTokens_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "auth.refresh_token_types" */
export type AuthRefreshTokenTypesRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


/** columns and relationships of "auth.refresh_token_types" */
export type AuthRefreshTokenTypesRefreshTokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};

/** aggregated selection of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Aggregate = {
  __typename?: 'authRefreshTokenTypes_aggregate';
  aggregate?: Maybe<AuthRefreshTokenTypes_Aggregate_Fields>;
  nodes: Array<AuthRefreshTokenTypes>;
};

/** aggregate fields of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Aggregate_Fields = {
  __typename?: 'authRefreshTokenTypes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthRefreshTokenTypes_Max_Fields>;
  min?: Maybe<AuthRefreshTokenTypes_Min_Fields>;
};


/** aggregate fields of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "auth.refresh_token_types". All fields are combined with a logical 'AND'. */
export type AuthRefreshTokenTypes_Bool_Exp = {
  _and?: InputMaybe<Array<AuthRefreshTokenTypes_Bool_Exp>>;
  _not?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
  _or?: InputMaybe<Array<AuthRefreshTokenTypes_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  refreshTokens?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.refresh_token_types" */
export enum AuthRefreshTokenTypes_Constraint {
  /** unique or primary key constraint on columns "value" */
  RefreshTokenTypesPkey = 'refresh_token_types_pkey'
}

export enum AuthRefreshTokenTypes_Enum {
  /** Personal access token */
  Pat = 'pat',
  /** Regular refresh token */
  Regular = 'regular'
}

/** Boolean expression to compare columns of type "authRefreshTokenTypes_enum". All fields are combined with logical 'AND'. */
export type AuthRefreshTokenTypes_Enum_Comparison_Exp = {
  _eq?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  _in?: InputMaybe<Array<AuthRefreshTokenTypes_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  _nin?: InputMaybe<Array<AuthRefreshTokenTypes_Enum>>;
};

/** input type for inserting data into table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  refreshTokens?: InputMaybe<AuthRefreshTokens_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type AuthRefreshTokenTypes_Max_Fields = {
  __typename?: 'authRefreshTokenTypes_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AuthRefreshTokenTypes_Min_Fields = {
  __typename?: 'authRefreshTokenTypes_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Mutation_Response = {
  __typename?: 'authRefreshTokenTypes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthRefreshTokenTypes>;
};

/** on_conflict condition type for table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_On_Conflict = {
  constraint: AuthRefreshTokenTypes_Constraint;
  update_columns?: Array<AuthRefreshTokenTypes_Update_Column>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.refresh_token_types". */
export type AuthRefreshTokenTypes_Order_By = {
  comment?: InputMaybe<Order_By>;
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.refresh_token_types */
export type AuthRefreshTokenTypes_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "auth.refresh_token_types" */
export enum AuthRefreshTokenTypes_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "authRefreshTokenTypes" */
export type AuthRefreshTokenTypes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthRefreshTokenTypes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthRefreshTokenTypes_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "auth.refresh_token_types" */
export enum AuthRefreshTokenTypes_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type AuthRefreshTokenTypes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthRefreshTokenTypes_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthRefreshTokenTypes_Bool_Exp;
};

/** User refresh tokens. Hasura auth uses them to rotate new access tokens as long as the refresh token is not expired. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRefreshTokens = {
  __typename?: 'authRefreshTokens';
  createdAt: Scalars['timestamptz']['output'];
  expiresAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  refreshTokenHash?: Maybe<Scalars['String']['output']>;
  type: AuthRefreshTokenTypes_Enum;
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};


/** User refresh tokens. Hasura auth uses them to rotate new access tokens as long as the refresh token is not expired. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRefreshTokensMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate = {
  __typename?: 'authRefreshTokens_aggregate';
  aggregate?: Maybe<AuthRefreshTokens_Aggregate_Fields>;
  nodes: Array<AuthRefreshTokens>;
};

export type AuthRefreshTokens_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthRefreshTokens_Aggregate_Bool_Exp_Count>;
};

export type AuthRefreshTokens_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate_Fields = {
  __typename?: 'authRefreshTokens_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthRefreshTokens_Max_Fields>;
  min?: Maybe<AuthRefreshTokens_Min_Fields>;
};


/** aggregate fields of "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AuthRefreshTokens_Max_Order_By>;
  min?: InputMaybe<AuthRefreshTokens_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AuthRefreshTokens_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "auth.refresh_tokens" */
export type AuthRefreshTokens_Arr_Rel_Insert_Input = {
  data: Array<AuthRefreshTokens_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthRefreshTokens_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.refresh_tokens". All fields are combined with a logical 'AND'. */
export type AuthRefreshTokens_Bool_Exp = {
  _and?: InputMaybe<Array<AuthRefreshTokens_Bool_Exp>>;
  _not?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
  _or?: InputMaybe<Array<AuthRefreshTokens_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  expiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  refreshTokenHash?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<AuthRefreshTokenTypes_Enum_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.refresh_tokens" */
export enum AuthRefreshTokens_Constraint {
  /** unique or primary key constraint on columns "id" */
  RefreshTokensPkey = 'refresh_tokens_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AuthRefreshTokens_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AuthRefreshTokens_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AuthRefreshTokens_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "auth.refresh_tokens" */
export type AuthRefreshTokens_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  refreshTokenHash?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type AuthRefreshTokens_Max_Fields = {
  __typename?: 'authRefreshTokens_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  expiresAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  refreshTokenHash?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  refreshTokenHash?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AuthRefreshTokens_Min_Fields = {
  __typename?: 'authRefreshTokens_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  expiresAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  refreshTokenHash?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  refreshTokenHash?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.refresh_tokens" */
export type AuthRefreshTokens_Mutation_Response = {
  __typename?: 'authRefreshTokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthRefreshTokens>;
};

/** on_conflict condition type for table "auth.refresh_tokens" */
export type AuthRefreshTokens_On_Conflict = {
  constraint: AuthRefreshTokens_Constraint;
  update_columns?: Array<AuthRefreshTokens_Update_Column>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.refresh_tokens". */
export type AuthRefreshTokens_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  refreshTokenHash?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.refresh_tokens */
export type AuthRefreshTokens_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AuthRefreshTokens_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "auth.refresh_tokens" */
export enum AuthRefreshTokens_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  RefreshTokenHash = 'refreshTokenHash',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "auth.refresh_tokens" */
export type AuthRefreshTokens_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  refreshTokenHash?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "authRefreshTokens" */
export type AuthRefreshTokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthRefreshTokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthRefreshTokens_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  refreshTokenHash?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "auth.refresh_tokens" */
export enum AuthRefreshTokens_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  RefreshTokenHash = 'refreshTokenHash',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'userId'
}

export type AuthRefreshTokens_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AuthRefreshTokens_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AuthRefreshTokens_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AuthRefreshTokens_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AuthRefreshTokens_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AuthRefreshTokens_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthRefreshTokens_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthRefreshTokens_Bool_Exp;
};

/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRoles = {
  __typename?: 'authRoles';
  role: Scalars['String']['output'];
  /** An array relationship */
  userRoles: Array<AuthUserRoles>;
  /** An aggregate relationship */
  userRoles_aggregate: AuthUserRoles_Aggregate;
  /** An array relationship */
  usersByDefaultRole: Array<Users>;
  /** An aggregate relationship */
  usersByDefaultRole_aggregate: Users_Aggregate;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUserRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUserRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUsersByDefaultRoleArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUsersByDefaultRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** aggregated selection of "auth.roles" */
export type AuthRoles_Aggregate = {
  __typename?: 'authRoles_aggregate';
  aggregate?: Maybe<AuthRoles_Aggregate_Fields>;
  nodes: Array<AuthRoles>;
};

/** aggregate fields of "auth.roles" */
export type AuthRoles_Aggregate_Fields = {
  __typename?: 'authRoles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthRoles_Max_Fields>;
  min?: Maybe<AuthRoles_Min_Fields>;
};


/** aggregate fields of "auth.roles" */
export type AuthRoles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthRoles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "auth.roles". All fields are combined with a logical 'AND'. */
export type AuthRoles_Bool_Exp = {
  _and?: InputMaybe<Array<AuthRoles_Bool_Exp>>;
  _not?: InputMaybe<AuthRoles_Bool_Exp>;
  _or?: InputMaybe<Array<AuthRoles_Bool_Exp>>;
  role?: InputMaybe<String_Comparison_Exp>;
  userRoles?: InputMaybe<AuthUserRoles_Bool_Exp>;
  userRoles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Bool_Exp>;
  usersByDefaultRole?: InputMaybe<Users_Bool_Exp>;
  usersByDefaultRole_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "auth.roles" */
export enum AuthRoles_Constraint {
  /** unique or primary key constraint on columns "role" */
  RolesPkey = 'roles_pkey'
}

/** input type for inserting data into table "auth.roles" */
export type AuthRoles_Insert_Input = {
  role?: InputMaybe<Scalars['String']['input']>;
  userRoles?: InputMaybe<AuthUserRoles_Arr_Rel_Insert_Input>;
  usersByDefaultRole?: InputMaybe<Users_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type AuthRoles_Max_Fields = {
  __typename?: 'authRoles_max_fields';
  role?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AuthRoles_Min_Fields = {
  __typename?: 'authRoles_min_fields';
  role?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "auth.roles" */
export type AuthRoles_Mutation_Response = {
  __typename?: 'authRoles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthRoles>;
};

/** input type for inserting object relation for remote table "auth.roles" */
export type AuthRoles_Obj_Rel_Insert_Input = {
  data: AuthRoles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthRoles_On_Conflict>;
};

/** on_conflict condition type for table "auth.roles" */
export type AuthRoles_On_Conflict = {
  constraint: AuthRoles_Constraint;
  update_columns?: Array<AuthRoles_Update_Column>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.roles". */
export type AuthRoles_Order_By = {
  role?: InputMaybe<Order_By>;
  userRoles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Order_By>;
  usersByDefaultRole_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
};

/** primary key columns input for table: auth.roles */
export type AuthRoles_Pk_Columns_Input = {
  role: Scalars['String']['input'];
};

/** select columns of table "auth.roles" */
export enum AuthRoles_Select_Column {
  /** column name */
  Role = 'role'
}

/** input type for updating data in table "auth.roles" */
export type AuthRoles_Set_Input = {
  role?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "authRoles" */
export type AuthRoles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthRoles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthRoles_Stream_Cursor_Value_Input = {
  role?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "auth.roles" */
export enum AuthRoles_Update_Column {
  /** column name */
  Role = 'role'
}

export type AuthRoles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthRoles_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthRoles_Bool_Exp;
};

/** Active providers for a given user. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthUserProviders = {
  __typename?: 'authUserProviders';
  accessToken: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  provider: AuthProviders;
  providerId: Scalars['String']['output'];
  providerUserId: Scalars['String']['output'];
  refreshToken?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "auth.user_providers" */
export type AuthUserProviders_Aggregate = {
  __typename?: 'authUserProviders_aggregate';
  aggregate?: Maybe<AuthUserProviders_Aggregate_Fields>;
  nodes: Array<AuthUserProviders>;
};

export type AuthUserProviders_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthUserProviders_Aggregate_Bool_Exp_Count>;
};

export type AuthUserProviders_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AuthUserProviders_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.user_providers" */
export type AuthUserProviders_Aggregate_Fields = {
  __typename?: 'authUserProviders_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthUserProviders_Max_Fields>;
  min?: Maybe<AuthUserProviders_Min_Fields>;
};


/** aggregate fields of "auth.user_providers" */
export type AuthUserProviders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.user_providers" */
export type AuthUserProviders_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AuthUserProviders_Max_Order_By>;
  min?: InputMaybe<AuthUserProviders_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.user_providers" */
export type AuthUserProviders_Arr_Rel_Insert_Input = {
  data: Array<AuthUserProviders_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthUserProviders_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.user_providers". All fields are combined with a logical 'AND'. */
export type AuthUserProviders_Bool_Exp = {
  _and?: InputMaybe<Array<AuthUserProviders_Bool_Exp>>;
  _not?: InputMaybe<AuthUserProviders_Bool_Exp>;
  _or?: InputMaybe<Array<AuthUserProviders_Bool_Exp>>;
  accessToken?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  provider?: InputMaybe<AuthProviders_Bool_Exp>;
  providerId?: InputMaybe<String_Comparison_Exp>;
  providerUserId?: InputMaybe<String_Comparison_Exp>;
  refreshToken?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.user_providers" */
export enum AuthUserProviders_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserProvidersPkey = 'user_providers_pkey',
  /** unique or primary key constraint on columns "provider_user_id", "provider_id" */
  UserProvidersProviderIdProviderUserIdKey = 'user_providers_provider_id_provider_user_id_key',
  /** unique or primary key constraint on columns "user_id", "provider_id" */
  UserProvidersUserIdProviderIdKey = 'user_providers_user_id_provider_id_key'
}

/** input type for inserting data into table "auth.user_providers" */
export type AuthUserProviders_Insert_Input = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  provider?: InputMaybe<AuthProviders_Obj_Rel_Insert_Input>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerUserId?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type AuthUserProviders_Max_Fields = {
  __typename?: 'authUserProviders_max_fields';
  accessToken?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  providerUserId?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "auth.user_providers" */
export type AuthUserProviders_Max_Order_By = {
  accessToken?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  providerUserId?: InputMaybe<Order_By>;
  refreshToken?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AuthUserProviders_Min_Fields = {
  __typename?: 'authUserProviders_min_fields';
  accessToken?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  providerUserId?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "auth.user_providers" */
export type AuthUserProviders_Min_Order_By = {
  accessToken?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  providerUserId?: InputMaybe<Order_By>;
  refreshToken?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.user_providers" */
export type AuthUserProviders_Mutation_Response = {
  __typename?: 'authUserProviders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthUserProviders>;
};

/** on_conflict condition type for table "auth.user_providers" */
export type AuthUserProviders_On_Conflict = {
  constraint: AuthUserProviders_Constraint;
  update_columns?: Array<AuthUserProviders_Update_Column>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user_providers". */
export type AuthUserProviders_Order_By = {
  accessToken?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<AuthProviders_Order_By>;
  providerId?: InputMaybe<Order_By>;
  providerUserId?: InputMaybe<Order_By>;
  refreshToken?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.user_providers */
export type AuthUserProviders_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "auth.user_providers" */
export enum AuthUserProviders_Select_Column {
  /** column name */
  AccessToken = 'accessToken',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUserId = 'providerUserId',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "auth.user_providers" */
export type AuthUserProviders_Set_Input = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerUserId?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "authUserProviders" */
export type AuthUserProviders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthUserProviders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthUserProviders_Stream_Cursor_Value_Input = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerUserId?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "auth.user_providers" */
export enum AuthUserProviders_Update_Column {
  /** column name */
  AccessToken = 'accessToken',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUserId = 'providerUserId',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type AuthUserProviders_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthUserProviders_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthUserProviders_Bool_Exp;
};

/** Roles of users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthUserRoles = {
  __typename?: 'authUserRoles';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  role: Scalars['String']['output'];
  /** An object relationship */
  roleByRole: AuthRoles;
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "auth.user_roles" */
export type AuthUserRoles_Aggregate = {
  __typename?: 'authUserRoles_aggregate';
  aggregate?: Maybe<AuthUserRoles_Aggregate_Fields>;
  nodes: Array<AuthUserRoles>;
};

export type AuthUserRoles_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthUserRoles_Aggregate_Bool_Exp_Count>;
};

export type AuthUserRoles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AuthUserRoles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.user_roles" */
export type AuthUserRoles_Aggregate_Fields = {
  __typename?: 'authUserRoles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthUserRoles_Max_Fields>;
  min?: Maybe<AuthUserRoles_Min_Fields>;
};


/** aggregate fields of "auth.user_roles" */
export type AuthUserRoles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.user_roles" */
export type AuthUserRoles_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AuthUserRoles_Max_Order_By>;
  min?: InputMaybe<AuthUserRoles_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.user_roles" */
export type AuthUserRoles_Arr_Rel_Insert_Input = {
  data: Array<AuthUserRoles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthUserRoles_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.user_roles". All fields are combined with a logical 'AND'. */
export type AuthUserRoles_Bool_Exp = {
  _and?: InputMaybe<Array<AuthUserRoles_Bool_Exp>>;
  _not?: InputMaybe<AuthUserRoles_Bool_Exp>;
  _or?: InputMaybe<Array<AuthUserRoles_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  roleByRole?: InputMaybe<AuthRoles_Bool_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.user_roles" */
export enum AuthUserRoles_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserRolesPkey = 'user_roles_pkey',
  /** unique or primary key constraint on columns "user_id", "role" */
  UserRolesUserIdRoleKey = 'user_roles_user_id_role_key'
}

/** input type for inserting data into table "auth.user_roles" */
export type AuthUserRoles_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  roleByRole?: InputMaybe<AuthRoles_Obj_Rel_Insert_Input>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type AuthUserRoles_Max_Fields = {
  __typename?: 'authUserRoles_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "auth.user_roles" */
export type AuthUserRoles_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AuthUserRoles_Min_Fields = {
  __typename?: 'authUserRoles_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "auth.user_roles" */
export type AuthUserRoles_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.user_roles" */
export type AuthUserRoles_Mutation_Response = {
  __typename?: 'authUserRoles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthUserRoles>;
};

/** on_conflict condition type for table "auth.user_roles" */
export type AuthUserRoles_On_Conflict = {
  constraint: AuthUserRoles_Constraint;
  update_columns?: Array<AuthUserRoles_Update_Column>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user_roles". */
export type AuthUserRoles_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  roleByRole?: InputMaybe<AuthRoles_Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.user_roles */
export type AuthUserRoles_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "auth.user_roles" */
export enum AuthUserRoles_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "auth.user_roles" */
export type AuthUserRoles_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "authUserRoles" */
export type AuthUserRoles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthUserRoles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthUserRoles_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "auth.user_roles" */
export enum AuthUserRoles_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'userId'
}

export type AuthUserRoles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthUserRoles_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthUserRoles_Bool_Exp;
};

/** User webauthn security keys. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthUserSecurityKeys = {
  __typename?: 'authUserSecurityKeys';
  counter: Scalars['bigint']['output'];
  credentialId: Scalars['String']['output'];
  credentialPublicKey?: Maybe<Scalars['bytea']['output']>;
  id: Scalars['uuid']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  transports: Scalars['String']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate = {
  __typename?: 'authUserSecurityKeys_aggregate';
  aggregate?: Maybe<AuthUserSecurityKeys_Aggregate_Fields>;
  nodes: Array<AuthUserSecurityKeys>;
};

export type AuthUserSecurityKeys_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthUserSecurityKeys_Aggregate_Bool_Exp_Count>;
};

export type AuthUserSecurityKeys_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate_Fields = {
  __typename?: 'authUserSecurityKeys_aggregate_fields';
  avg?: Maybe<AuthUserSecurityKeys_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<AuthUserSecurityKeys_Max_Fields>;
  min?: Maybe<AuthUserSecurityKeys_Min_Fields>;
  stddev?: Maybe<AuthUserSecurityKeys_Stddev_Fields>;
  stddev_pop?: Maybe<AuthUserSecurityKeys_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AuthUserSecurityKeys_Stddev_Samp_Fields>;
  sum?: Maybe<AuthUserSecurityKeys_Sum_Fields>;
  var_pop?: Maybe<AuthUserSecurityKeys_Var_Pop_Fields>;
  var_samp?: Maybe<AuthUserSecurityKeys_Var_Samp_Fields>;
  variance?: Maybe<AuthUserSecurityKeys_Variance_Fields>;
};


/** aggregate fields of "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate_Order_By = {
  avg?: InputMaybe<AuthUserSecurityKeys_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AuthUserSecurityKeys_Max_Order_By>;
  min?: InputMaybe<AuthUserSecurityKeys_Min_Order_By>;
  stddev?: InputMaybe<AuthUserSecurityKeys_Stddev_Order_By>;
  stddev_pop?: InputMaybe<AuthUserSecurityKeys_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<AuthUserSecurityKeys_Stddev_Samp_Order_By>;
  sum?: InputMaybe<AuthUserSecurityKeys_Sum_Order_By>;
  var_pop?: InputMaybe<AuthUserSecurityKeys_Var_Pop_Order_By>;
  var_samp?: InputMaybe<AuthUserSecurityKeys_Var_Samp_Order_By>;
  variance?: InputMaybe<AuthUserSecurityKeys_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Arr_Rel_Insert_Input = {
  data: Array<AuthUserSecurityKeys_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthUserSecurityKeys_On_Conflict>;
};

/** aggregate avg on columns */
export type AuthUserSecurityKeys_Avg_Fields = {
  __typename?: 'authUserSecurityKeys_avg_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Avg_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "auth.user_security_keys". All fields are combined with a logical 'AND'. */
export type AuthUserSecurityKeys_Bool_Exp = {
  _and?: InputMaybe<Array<AuthUserSecurityKeys_Bool_Exp>>;
  _not?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
  _or?: InputMaybe<Array<AuthUserSecurityKeys_Bool_Exp>>;
  counter?: InputMaybe<Bigint_Comparison_Exp>;
  credentialId?: InputMaybe<String_Comparison_Exp>;
  credentialPublicKey?: InputMaybe<Bytea_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  nickname?: InputMaybe<String_Comparison_Exp>;
  transports?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.user_security_keys" */
export enum AuthUserSecurityKeys_Constraint {
  /** unique or primary key constraint on columns "credential_id" */
  UserSecurityKeyCredentialIdKey = 'user_security_key_credential_id_key',
  /** unique or primary key constraint on columns "id" */
  UserSecurityKeysPkey = 'user_security_keys_pkey'
}

/** input type for incrementing numeric columns in table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Inc_Input = {
  counter?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Insert_Input = {
  counter?: InputMaybe<Scalars['bigint']['input']>;
  credentialId?: InputMaybe<Scalars['String']['input']>;
  credentialPublicKey?: InputMaybe<Scalars['bytea']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  transports?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type AuthUserSecurityKeys_Max_Fields = {
  __typename?: 'authUserSecurityKeys_max_fields';
  counter?: Maybe<Scalars['bigint']['output']>;
  credentialId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  transports?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Max_Order_By = {
  counter?: InputMaybe<Order_By>;
  credentialId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nickname?: InputMaybe<Order_By>;
  transports?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AuthUserSecurityKeys_Min_Fields = {
  __typename?: 'authUserSecurityKeys_min_fields';
  counter?: Maybe<Scalars['bigint']['output']>;
  credentialId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  transports?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Min_Order_By = {
  counter?: InputMaybe<Order_By>;
  credentialId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nickname?: InputMaybe<Order_By>;
  transports?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Mutation_Response = {
  __typename?: 'authUserSecurityKeys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthUserSecurityKeys>;
};

/** on_conflict condition type for table "auth.user_security_keys" */
export type AuthUserSecurityKeys_On_Conflict = {
  constraint: AuthUserSecurityKeys_Constraint;
  update_columns?: Array<AuthUserSecurityKeys_Update_Column>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user_security_keys". */
export type AuthUserSecurityKeys_Order_By = {
  counter?: InputMaybe<Order_By>;
  credentialId?: InputMaybe<Order_By>;
  credentialPublicKey?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nickname?: InputMaybe<Order_By>;
  transports?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.user_security_keys */
export type AuthUserSecurityKeys_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "auth.user_security_keys" */
export enum AuthUserSecurityKeys_Select_Column {
  /** column name */
  Counter = 'counter',
  /** column name */
  CredentialId = 'credentialId',
  /** column name */
  CredentialPublicKey = 'credentialPublicKey',
  /** column name */
  Id = 'id',
  /** column name */
  Nickname = 'nickname',
  /** column name */
  Transports = 'transports',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Set_Input = {
  counter?: InputMaybe<Scalars['bigint']['input']>;
  credentialId?: InputMaybe<Scalars['String']['input']>;
  credentialPublicKey?: InputMaybe<Scalars['bytea']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  transports?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type AuthUserSecurityKeys_Stddev_Fields = {
  __typename?: 'authUserSecurityKeys_stddev_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Stddev_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type AuthUserSecurityKeys_Stddev_Pop_Fields = {
  __typename?: 'authUserSecurityKeys_stddev_pop_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Stddev_Pop_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type AuthUserSecurityKeys_Stddev_Samp_Fields = {
  __typename?: 'authUserSecurityKeys_stddev_samp_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Stddev_Samp_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "authUserSecurityKeys" */
export type AuthUserSecurityKeys_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthUserSecurityKeys_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthUserSecurityKeys_Stream_Cursor_Value_Input = {
  counter?: InputMaybe<Scalars['bigint']['input']>;
  credentialId?: InputMaybe<Scalars['String']['input']>;
  credentialPublicKey?: InputMaybe<Scalars['bytea']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  transports?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type AuthUserSecurityKeys_Sum_Fields = {
  __typename?: 'authUserSecurityKeys_sum_fields';
  counter?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Sum_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** update columns of table "auth.user_security_keys" */
export enum AuthUserSecurityKeys_Update_Column {
  /** column name */
  Counter = 'counter',
  /** column name */
  CredentialId = 'credentialId',
  /** column name */
  CredentialPublicKey = 'credentialPublicKey',
  /** column name */
  Id = 'id',
  /** column name */
  Nickname = 'nickname',
  /** column name */
  Transports = 'transports',
  /** column name */
  UserId = 'userId'
}

export type AuthUserSecurityKeys_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AuthUserSecurityKeys_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthUserSecurityKeys_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthUserSecurityKeys_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AuthUserSecurityKeys_Var_Pop_Fields = {
  __typename?: 'authUserSecurityKeys_var_pop_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Var_Pop_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type AuthUserSecurityKeys_Var_Samp_Fields = {
  __typename?: 'authUserSecurityKeys_var_samp_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Var_Samp_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type AuthUserSecurityKeys_Variance_Fields = {
  __typename?: 'authUserSecurityKeys_variance_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Variance_Order_By = {
  counter?: InputMaybe<Order_By>;
};

export type Auth_Refresh_Tokens = {
  __typename?: 'auth_refresh_tokens';
  metadata: Scalars['user_metadata']['output'];
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** columns and relationships of "storage.buckets" */
export type Buckets = {
  __typename?: 'buckets';
  cacheControl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  downloadExpiration: Scalars['Int']['output'];
  /** An array relationship */
  files: Array<Files>;
  /** An aggregate relationship */
  files_aggregate: Files_Aggregate;
  id: Scalars['String']['output'];
  maxUploadFileSize: Scalars['Int']['output'];
  minUploadFileSize: Scalars['Int']['output'];
  presignedUrlsEnabled: Scalars['Boolean']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "storage.buckets" */
export type BucketsFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


/** columns and relationships of "storage.buckets" */
export type BucketsFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};

/** aggregated selection of "storage.buckets" */
export type Buckets_Aggregate = {
  __typename?: 'buckets_aggregate';
  aggregate?: Maybe<Buckets_Aggregate_Fields>;
  nodes: Array<Buckets>;
};

/** aggregate fields of "storage.buckets" */
export type Buckets_Aggregate_Fields = {
  __typename?: 'buckets_aggregate_fields';
  avg?: Maybe<Buckets_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Buckets_Max_Fields>;
  min?: Maybe<Buckets_Min_Fields>;
  stddev?: Maybe<Buckets_Stddev_Fields>;
  stddev_pop?: Maybe<Buckets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Buckets_Stddev_Samp_Fields>;
  sum?: Maybe<Buckets_Sum_Fields>;
  var_pop?: Maybe<Buckets_Var_Pop_Fields>;
  var_samp?: Maybe<Buckets_Var_Samp_Fields>;
  variance?: Maybe<Buckets_Variance_Fields>;
};


/** aggregate fields of "storage.buckets" */
export type Buckets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Buckets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Buckets_Avg_Fields = {
  __typename?: 'buckets_avg_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "storage.buckets". All fields are combined with a logical 'AND'. */
export type Buckets_Bool_Exp = {
  _and?: InputMaybe<Array<Buckets_Bool_Exp>>;
  _not?: InputMaybe<Buckets_Bool_Exp>;
  _or?: InputMaybe<Array<Buckets_Bool_Exp>>;
  cacheControl?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  downloadExpiration?: InputMaybe<Int_Comparison_Exp>;
  files?: InputMaybe<Files_Bool_Exp>;
  files_aggregate?: InputMaybe<Files_Aggregate_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  maxUploadFileSize?: InputMaybe<Int_Comparison_Exp>;
  minUploadFileSize?: InputMaybe<Int_Comparison_Exp>;
  presignedUrlsEnabled?: InputMaybe<Boolean_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "storage.buckets" */
export enum Buckets_Constraint {
  /** unique or primary key constraint on columns "id" */
  BucketsPkey = 'buckets_pkey'
}

/** input type for incrementing numeric columns in table "storage.buckets" */
export type Buckets_Inc_Input = {
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "storage.buckets" */
export type Buckets_Insert_Input = {
  cacheControl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  files?: InputMaybe<Files_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Buckets_Max_Fields = {
  __typename?: 'buckets_max_fields';
  cacheControl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  downloadExpiration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Int']['output']>;
  minUploadFileSize?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Buckets_Min_Fields = {
  __typename?: 'buckets_min_fields';
  cacheControl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  downloadExpiration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Int']['output']>;
  minUploadFileSize?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "storage.buckets" */
export type Buckets_Mutation_Response = {
  __typename?: 'buckets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Buckets>;
};

/** input type for inserting object relation for remote table "storage.buckets" */
export type Buckets_Obj_Rel_Insert_Input = {
  data: Buckets_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Buckets_On_Conflict>;
};

/** on_conflict condition type for table "storage.buckets" */
export type Buckets_On_Conflict = {
  constraint: Buckets_Constraint;
  update_columns?: Array<Buckets_Update_Column>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};

/** Ordering options when selecting data from "storage.buckets". */
export type Buckets_Order_By = {
  cacheControl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  downloadExpiration?: InputMaybe<Order_By>;
  files_aggregate?: InputMaybe<Files_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  maxUploadFileSize?: InputMaybe<Order_By>;
  minUploadFileSize?: InputMaybe<Order_By>;
  presignedUrlsEnabled?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storage.buckets */
export type Buckets_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "storage.buckets" */
export enum Buckets_Select_Column {
  /** column name */
  CacheControl = 'cacheControl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DownloadExpiration = 'downloadExpiration',
  /** column name */
  Id = 'id',
  /** column name */
  MaxUploadFileSize = 'maxUploadFileSize',
  /** column name */
  MinUploadFileSize = 'minUploadFileSize',
  /** column name */
  PresignedUrlsEnabled = 'presignedUrlsEnabled',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "storage.buckets" */
export type Buckets_Set_Input = {
  cacheControl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Buckets_Stddev_Fields = {
  __typename?: 'buckets_stddev_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Buckets_Stddev_Pop_Fields = {
  __typename?: 'buckets_stddev_pop_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Buckets_Stddev_Samp_Fields = {
  __typename?: 'buckets_stddev_samp_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "buckets" */
export type Buckets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Buckets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Buckets_Stream_Cursor_Value_Input = {
  cacheControl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Buckets_Sum_Fields = {
  __typename?: 'buckets_sum_fields';
  downloadExpiration?: Maybe<Scalars['Int']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Int']['output']>;
  minUploadFileSize?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "storage.buckets" */
export enum Buckets_Update_Column {
  /** column name */
  CacheControl = 'cacheControl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DownloadExpiration = 'downloadExpiration',
  /** column name */
  Id = 'id',
  /** column name */
  MaxUploadFileSize = 'maxUploadFileSize',
  /** column name */
  MinUploadFileSize = 'minUploadFileSize',
  /** column name */
  PresignedUrlsEnabled = 'presignedUrlsEnabled',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Buckets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Buckets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Buckets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Buckets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Buckets_Var_Pop_Fields = {
  __typename?: 'buckets_var_pop_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Buckets_Var_Samp_Fields = {
  __typename?: 'buckets_var_samp_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Buckets_Variance_Fields = {
  __typename?: 'buckets_variance_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "buyer_member" */
export type Buyer_Member = {
  __typename?: 'buyer_member';
  /** An object relationship */
  agency: Agency;
  agencyId: Scalars['uuid']['output'];
  /** An array relationship */
  applications: Array<Application>;
  /** An aggregate relationship */
  applications_aggregate: Application_Aggregate;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  userId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  visits: Array<Visit>;
  /** An aggregate relationship */
  visits_aggregate: Visit_Aggregate;
};


/** columns and relationships of "buyer_member" */
export type Buyer_MemberApplicationsArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


/** columns and relationships of "buyer_member" */
export type Buyer_MemberApplications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


/** columns and relationships of "buyer_member" */
export type Buyer_MemberVisitsArgs = {
  distinct_on?: InputMaybe<Array<Visit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visit_Order_By>>;
  where?: InputMaybe<Visit_Bool_Exp>;
};


/** columns and relationships of "buyer_member" */
export type Buyer_MemberVisits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Visit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visit_Order_By>>;
  where?: InputMaybe<Visit_Bool_Exp>;
};

/** aggregated selection of "buyer_member" */
export type Buyer_Member_Aggregate = {
  __typename?: 'buyer_member_aggregate';
  aggregate?: Maybe<Buyer_Member_Aggregate_Fields>;
  nodes: Array<Buyer_Member>;
};

export type Buyer_Member_Aggregate_Bool_Exp = {
  count?: InputMaybe<Buyer_Member_Aggregate_Bool_Exp_Count>;
};

export type Buyer_Member_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Buyer_Member_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Buyer_Member_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "buyer_member" */
export type Buyer_Member_Aggregate_Fields = {
  __typename?: 'buyer_member_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Buyer_Member_Max_Fields>;
  min?: Maybe<Buyer_Member_Min_Fields>;
};


/** aggregate fields of "buyer_member" */
export type Buyer_Member_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Buyer_Member_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "buyer_member" */
export type Buyer_Member_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Buyer_Member_Max_Order_By>;
  min?: InputMaybe<Buyer_Member_Min_Order_By>;
};

/** input type for inserting array relation for remote table "buyer_member" */
export type Buyer_Member_Arr_Rel_Insert_Input = {
  data: Array<Buyer_Member_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Buyer_Member_On_Conflict>;
};

/** Boolean expression to filter rows from the table "buyer_member". All fields are combined with a logical 'AND'. */
export type Buyer_Member_Bool_Exp = {
  _and?: InputMaybe<Array<Buyer_Member_Bool_Exp>>;
  _not?: InputMaybe<Buyer_Member_Bool_Exp>;
  _or?: InputMaybe<Array<Buyer_Member_Bool_Exp>>;
  agency?: InputMaybe<Agency_Bool_Exp>;
  agencyId?: InputMaybe<Uuid_Comparison_Exp>;
  applications?: InputMaybe<Application_Bool_Exp>;
  applications_aggregate?: InputMaybe<Application_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
  visits?: InputMaybe<Visit_Bool_Exp>;
  visits_aggregate?: InputMaybe<Visit_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "buyer_member" */
export enum Buyer_Member_Constraint {
  /** unique or primary key constraint on columns "id" */
  BuyerMemberPkey = 'buyer_member_pkey'
}

/** columns and relationships of "buyer_member_folder" */
export type Buyer_Member_Folder = {
  __typename?: 'buyer_member_folder';
  address?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  application: Application;
  applicationId: Scalars['uuid']['output'];
  bankAccountBankAddress?: Maybe<Scalars['String']['output']>;
  bankAccountBankName?: Maybe<Scalars['String']['output']>;
  bankAccountBic?: Maybe<Scalars['String']['output']>;
  bankAccountHolder?: Maybe<Scalars['String']['output']>;
  bankAccountIban?: Maybe<Scalars['String']['output']>;
  bankAccountRibFileId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  bank_account_rib_file?: Maybe<Files>;
  birthDate?: Maybe<Scalars['timestamptz']['output']>;
  birthName?: Maybe<Scalars['String']['output']>;
  birthPlace?: Maybe<Scalars['String']['output']>;
  civility?: Maybe<Civility_Enum>;
  comment?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  countryOfTaxResidence?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamp']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fluentInFrench?: Maybe<Scalars['Boolean']['output']>;
  homePhone?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  identityDocumentFileId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  identity_document_file?: Maybe<Files>;
  individualOrLegalEntity?: Maybe<Seller_Type_Enum>;
  isBuyerLegalRepresentative?: Maybe<Scalars['Boolean']['output']>;
  kbisFileId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  kbis_file?: Maybe<Files>;
  languagesSpoken?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  legalForm?: Maybe<Seller_Legal_Status_Enum>;
  legalRepresentativeBirthDate?: Maybe<Scalars['String']['output']>;
  legalRepresentativeBirthName?: Maybe<Scalars['String']['output']>;
  legalRepresentativeBirthPlace?: Maybe<Scalars['String']['output']>;
  legalRepresentativeCivility?: Maybe<Scalars['String']['output']>;
  legalRepresentativeFirstName?: Maybe<Scalars['String']['output']>;
  legalRepresentativeLastName?: Maybe<Scalars['String']['output']>;
  legalRepresentativeNationality?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  registeredOfficeAddress?: Maybe<Scalars['String']['output']>;
  sirenNumber?: Maybe<Scalars['String']['output']>;
  subjectToVat?: Maybe<Scalars['Boolean']['output']>;
  taxRegimeCompany?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  workPhone?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "buyer_member_folder" */
export type Buyer_Member_Folder_Aggregate = {
  __typename?: 'buyer_member_folder_aggregate';
  aggregate?: Maybe<Buyer_Member_Folder_Aggregate_Fields>;
  nodes: Array<Buyer_Member_Folder>;
};

export type Buyer_Member_Folder_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Buyer_Member_Folder_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Buyer_Member_Folder_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Buyer_Member_Folder_Aggregate_Bool_Exp_Count>;
};

export type Buyer_Member_Folder_Aggregate_Bool_Exp_Bool_And = {
  arguments: Buyer_Member_Folder_Select_Column_Buyer_Member_Folder_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Buyer_Member_Folder_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Buyer_Member_Folder_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Buyer_Member_Folder_Select_Column_Buyer_Member_Folder_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Buyer_Member_Folder_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Buyer_Member_Folder_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Buyer_Member_Folder_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Buyer_Member_Folder_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "buyer_member_folder" */
export type Buyer_Member_Folder_Aggregate_Fields = {
  __typename?: 'buyer_member_folder_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Buyer_Member_Folder_Max_Fields>;
  min?: Maybe<Buyer_Member_Folder_Min_Fields>;
};


/** aggregate fields of "buyer_member_folder" */
export type Buyer_Member_Folder_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Buyer_Member_Folder_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "buyer_member_folder" */
export type Buyer_Member_Folder_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Buyer_Member_Folder_Max_Order_By>;
  min?: InputMaybe<Buyer_Member_Folder_Min_Order_By>;
};

/** input type for inserting array relation for remote table "buyer_member_folder" */
export type Buyer_Member_Folder_Arr_Rel_Insert_Input = {
  data: Array<Buyer_Member_Folder_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Buyer_Member_Folder_On_Conflict>;
};

/** Boolean expression to filter rows from the table "buyer_member_folder". All fields are combined with a logical 'AND'. */
export type Buyer_Member_Folder_Bool_Exp = {
  _and?: InputMaybe<Array<Buyer_Member_Folder_Bool_Exp>>;
  _not?: InputMaybe<Buyer_Member_Folder_Bool_Exp>;
  _or?: InputMaybe<Array<Buyer_Member_Folder_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  application?: InputMaybe<Application_Bool_Exp>;
  applicationId?: InputMaybe<Uuid_Comparison_Exp>;
  bankAccountBankAddress?: InputMaybe<String_Comparison_Exp>;
  bankAccountBankName?: InputMaybe<String_Comparison_Exp>;
  bankAccountBic?: InputMaybe<String_Comparison_Exp>;
  bankAccountHolder?: InputMaybe<String_Comparison_Exp>;
  bankAccountIban?: InputMaybe<String_Comparison_Exp>;
  bankAccountRibFileId?: InputMaybe<Uuid_Comparison_Exp>;
  bank_account_rib_file?: InputMaybe<Files_Bool_Exp>;
  birthDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  birthName?: InputMaybe<String_Comparison_Exp>;
  birthPlace?: InputMaybe<String_Comparison_Exp>;
  civility?: InputMaybe<Civility_Enum_Comparison_Exp>;
  comment?: InputMaybe<String_Comparison_Exp>;
  companyName?: InputMaybe<String_Comparison_Exp>;
  countryOfTaxResidence?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  emailAddress?: InputMaybe<String_Comparison_Exp>;
  firstName?: InputMaybe<String_Comparison_Exp>;
  fluentInFrench?: InputMaybe<Boolean_Comparison_Exp>;
  homePhone?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identityDocumentFileId?: InputMaybe<Uuid_Comparison_Exp>;
  identity_document_file?: InputMaybe<Files_Bool_Exp>;
  individualOrLegalEntity?: InputMaybe<Seller_Type_Enum_Comparison_Exp>;
  isBuyerLegalRepresentative?: InputMaybe<Boolean_Comparison_Exp>;
  kbisFileId?: InputMaybe<Uuid_Comparison_Exp>;
  kbis_file?: InputMaybe<Files_Bool_Exp>;
  languagesSpoken?: InputMaybe<String_Comparison_Exp>;
  lastName?: InputMaybe<String_Comparison_Exp>;
  legalForm?: InputMaybe<Seller_Legal_Status_Enum_Comparison_Exp>;
  legalRepresentativeBirthDate?: InputMaybe<String_Comparison_Exp>;
  legalRepresentativeBirthName?: InputMaybe<String_Comparison_Exp>;
  legalRepresentativeBirthPlace?: InputMaybe<String_Comparison_Exp>;
  legalRepresentativeCivility?: InputMaybe<String_Comparison_Exp>;
  legalRepresentativeFirstName?: InputMaybe<String_Comparison_Exp>;
  legalRepresentativeLastName?: InputMaybe<String_Comparison_Exp>;
  legalRepresentativeNationality?: InputMaybe<String_Comparison_Exp>;
  maritalStatus?: InputMaybe<String_Comparison_Exp>;
  mobilePhone?: InputMaybe<String_Comparison_Exp>;
  nationality?: InputMaybe<String_Comparison_Exp>;
  registeredOfficeAddress?: InputMaybe<String_Comparison_Exp>;
  sirenNumber?: InputMaybe<String_Comparison_Exp>;
  subjectToVat?: InputMaybe<Boolean_Comparison_Exp>;
  taxRegimeCompany?: InputMaybe<String_Comparison_Exp>;
  vatNumber?: InputMaybe<String_Comparison_Exp>;
  workPhone?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "buyer_member_folder" */
export enum Buyer_Member_Folder_Constraint {
  /** unique or primary key constraint on columns "id" */
  BuyerMemberFolderPkey = 'buyer_member_folder_pkey'
}

/** input type for inserting data into table "buyer_member_folder" */
export type Buyer_Member_Folder_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  application?: InputMaybe<Application_Obj_Rel_Insert_Input>;
  applicationId?: InputMaybe<Scalars['uuid']['input']>;
  bankAccountBankAddress?: InputMaybe<Scalars['String']['input']>;
  bankAccountBankName?: InputMaybe<Scalars['String']['input']>;
  bankAccountBic?: InputMaybe<Scalars['String']['input']>;
  bankAccountHolder?: InputMaybe<Scalars['String']['input']>;
  bankAccountIban?: InputMaybe<Scalars['String']['input']>;
  bankAccountRibFileId?: InputMaybe<Scalars['uuid']['input']>;
  bank_account_rib_file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  birthDate?: InputMaybe<Scalars['timestamptz']['input']>;
  birthName?: InputMaybe<Scalars['String']['input']>;
  birthPlace?: InputMaybe<Scalars['String']['input']>;
  civility?: InputMaybe<Civility_Enum>;
  comment?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  countryOfTaxResidence?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fluentInFrench?: InputMaybe<Scalars['Boolean']['input']>;
  homePhone?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  identityDocumentFileId?: InputMaybe<Scalars['uuid']['input']>;
  identity_document_file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  individualOrLegalEntity?: InputMaybe<Seller_Type_Enum>;
  isBuyerLegalRepresentative?: InputMaybe<Scalars['Boolean']['input']>;
  kbisFileId?: InputMaybe<Scalars['uuid']['input']>;
  kbis_file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  languagesSpoken?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  legalForm?: InputMaybe<Seller_Legal_Status_Enum>;
  legalRepresentativeBirthDate?: InputMaybe<Scalars['String']['input']>;
  legalRepresentativeBirthName?: InputMaybe<Scalars['String']['input']>;
  legalRepresentativeBirthPlace?: InputMaybe<Scalars['String']['input']>;
  legalRepresentativeCivility?: InputMaybe<Scalars['String']['input']>;
  legalRepresentativeFirstName?: InputMaybe<Scalars['String']['input']>;
  legalRepresentativeLastName?: InputMaybe<Scalars['String']['input']>;
  legalRepresentativeNationality?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  registeredOfficeAddress?: InputMaybe<Scalars['String']['input']>;
  sirenNumber?: InputMaybe<Scalars['String']['input']>;
  subjectToVat?: InputMaybe<Scalars['Boolean']['input']>;
  taxRegimeCompany?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  workPhone?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Buyer_Member_Folder_Max_Fields = {
  __typename?: 'buyer_member_folder_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  applicationId?: Maybe<Scalars['uuid']['output']>;
  bankAccountBankAddress?: Maybe<Scalars['String']['output']>;
  bankAccountBankName?: Maybe<Scalars['String']['output']>;
  bankAccountBic?: Maybe<Scalars['String']['output']>;
  bankAccountHolder?: Maybe<Scalars['String']['output']>;
  bankAccountIban?: Maybe<Scalars['String']['output']>;
  bankAccountRibFileId?: Maybe<Scalars['uuid']['output']>;
  birthDate?: Maybe<Scalars['timestamptz']['output']>;
  birthName?: Maybe<Scalars['String']['output']>;
  birthPlace?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  countryOfTaxResidence?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  homePhone?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  identityDocumentFileId?: Maybe<Scalars['uuid']['output']>;
  kbisFileId?: Maybe<Scalars['uuid']['output']>;
  languagesSpoken?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  legalRepresentativeBirthDate?: Maybe<Scalars['String']['output']>;
  legalRepresentativeBirthName?: Maybe<Scalars['String']['output']>;
  legalRepresentativeBirthPlace?: Maybe<Scalars['String']['output']>;
  legalRepresentativeCivility?: Maybe<Scalars['String']['output']>;
  legalRepresentativeFirstName?: Maybe<Scalars['String']['output']>;
  legalRepresentativeLastName?: Maybe<Scalars['String']['output']>;
  legalRepresentativeNationality?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  registeredOfficeAddress?: Maybe<Scalars['String']['output']>;
  sirenNumber?: Maybe<Scalars['String']['output']>;
  taxRegimeCompany?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  workPhone?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "buyer_member_folder" */
export type Buyer_Member_Folder_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  applicationId?: InputMaybe<Order_By>;
  bankAccountBankAddress?: InputMaybe<Order_By>;
  bankAccountBankName?: InputMaybe<Order_By>;
  bankAccountBic?: InputMaybe<Order_By>;
  bankAccountHolder?: InputMaybe<Order_By>;
  bankAccountIban?: InputMaybe<Order_By>;
  bankAccountRibFileId?: InputMaybe<Order_By>;
  birthDate?: InputMaybe<Order_By>;
  birthName?: InputMaybe<Order_By>;
  birthPlace?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  companyName?: InputMaybe<Order_By>;
  countryOfTaxResidence?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  emailAddress?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  homePhone?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identityDocumentFileId?: InputMaybe<Order_By>;
  kbisFileId?: InputMaybe<Order_By>;
  languagesSpoken?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  legalRepresentativeBirthDate?: InputMaybe<Order_By>;
  legalRepresentativeBirthName?: InputMaybe<Order_By>;
  legalRepresentativeBirthPlace?: InputMaybe<Order_By>;
  legalRepresentativeCivility?: InputMaybe<Order_By>;
  legalRepresentativeFirstName?: InputMaybe<Order_By>;
  legalRepresentativeLastName?: InputMaybe<Order_By>;
  legalRepresentativeNationality?: InputMaybe<Order_By>;
  maritalStatus?: InputMaybe<Order_By>;
  mobilePhone?: InputMaybe<Order_By>;
  nationality?: InputMaybe<Order_By>;
  registeredOfficeAddress?: InputMaybe<Order_By>;
  sirenNumber?: InputMaybe<Order_By>;
  taxRegimeCompany?: InputMaybe<Order_By>;
  vatNumber?: InputMaybe<Order_By>;
  workPhone?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Buyer_Member_Folder_Min_Fields = {
  __typename?: 'buyer_member_folder_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  applicationId?: Maybe<Scalars['uuid']['output']>;
  bankAccountBankAddress?: Maybe<Scalars['String']['output']>;
  bankAccountBankName?: Maybe<Scalars['String']['output']>;
  bankAccountBic?: Maybe<Scalars['String']['output']>;
  bankAccountHolder?: Maybe<Scalars['String']['output']>;
  bankAccountIban?: Maybe<Scalars['String']['output']>;
  bankAccountRibFileId?: Maybe<Scalars['uuid']['output']>;
  birthDate?: Maybe<Scalars['timestamptz']['output']>;
  birthName?: Maybe<Scalars['String']['output']>;
  birthPlace?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  countryOfTaxResidence?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  homePhone?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  identityDocumentFileId?: Maybe<Scalars['uuid']['output']>;
  kbisFileId?: Maybe<Scalars['uuid']['output']>;
  languagesSpoken?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  legalRepresentativeBirthDate?: Maybe<Scalars['String']['output']>;
  legalRepresentativeBirthName?: Maybe<Scalars['String']['output']>;
  legalRepresentativeBirthPlace?: Maybe<Scalars['String']['output']>;
  legalRepresentativeCivility?: Maybe<Scalars['String']['output']>;
  legalRepresentativeFirstName?: Maybe<Scalars['String']['output']>;
  legalRepresentativeLastName?: Maybe<Scalars['String']['output']>;
  legalRepresentativeNationality?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  registeredOfficeAddress?: Maybe<Scalars['String']['output']>;
  sirenNumber?: Maybe<Scalars['String']['output']>;
  taxRegimeCompany?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  workPhone?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "buyer_member_folder" */
export type Buyer_Member_Folder_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  applicationId?: InputMaybe<Order_By>;
  bankAccountBankAddress?: InputMaybe<Order_By>;
  bankAccountBankName?: InputMaybe<Order_By>;
  bankAccountBic?: InputMaybe<Order_By>;
  bankAccountHolder?: InputMaybe<Order_By>;
  bankAccountIban?: InputMaybe<Order_By>;
  bankAccountRibFileId?: InputMaybe<Order_By>;
  birthDate?: InputMaybe<Order_By>;
  birthName?: InputMaybe<Order_By>;
  birthPlace?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  companyName?: InputMaybe<Order_By>;
  countryOfTaxResidence?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  emailAddress?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  homePhone?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identityDocumentFileId?: InputMaybe<Order_By>;
  kbisFileId?: InputMaybe<Order_By>;
  languagesSpoken?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  legalRepresentativeBirthDate?: InputMaybe<Order_By>;
  legalRepresentativeBirthName?: InputMaybe<Order_By>;
  legalRepresentativeBirthPlace?: InputMaybe<Order_By>;
  legalRepresentativeCivility?: InputMaybe<Order_By>;
  legalRepresentativeFirstName?: InputMaybe<Order_By>;
  legalRepresentativeLastName?: InputMaybe<Order_By>;
  legalRepresentativeNationality?: InputMaybe<Order_By>;
  maritalStatus?: InputMaybe<Order_By>;
  mobilePhone?: InputMaybe<Order_By>;
  nationality?: InputMaybe<Order_By>;
  registeredOfficeAddress?: InputMaybe<Order_By>;
  sirenNumber?: InputMaybe<Order_By>;
  taxRegimeCompany?: InputMaybe<Order_By>;
  vatNumber?: InputMaybe<Order_By>;
  workPhone?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "buyer_member_folder" */
export type Buyer_Member_Folder_Mutation_Response = {
  __typename?: 'buyer_member_folder_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Buyer_Member_Folder>;
};

/** on_conflict condition type for table "buyer_member_folder" */
export type Buyer_Member_Folder_On_Conflict = {
  constraint: Buyer_Member_Folder_Constraint;
  update_columns?: Array<Buyer_Member_Folder_Update_Column>;
  where?: InputMaybe<Buyer_Member_Folder_Bool_Exp>;
};

/** Ordering options when selecting data from "buyer_member_folder". */
export type Buyer_Member_Folder_Order_By = {
  address?: InputMaybe<Order_By>;
  application?: InputMaybe<Application_Order_By>;
  applicationId?: InputMaybe<Order_By>;
  bankAccountBankAddress?: InputMaybe<Order_By>;
  bankAccountBankName?: InputMaybe<Order_By>;
  bankAccountBic?: InputMaybe<Order_By>;
  bankAccountHolder?: InputMaybe<Order_By>;
  bankAccountIban?: InputMaybe<Order_By>;
  bankAccountRibFileId?: InputMaybe<Order_By>;
  bank_account_rib_file?: InputMaybe<Files_Order_By>;
  birthDate?: InputMaybe<Order_By>;
  birthName?: InputMaybe<Order_By>;
  birthPlace?: InputMaybe<Order_By>;
  civility?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  companyName?: InputMaybe<Order_By>;
  countryOfTaxResidence?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  emailAddress?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  fluentInFrench?: InputMaybe<Order_By>;
  homePhone?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identityDocumentFileId?: InputMaybe<Order_By>;
  identity_document_file?: InputMaybe<Files_Order_By>;
  individualOrLegalEntity?: InputMaybe<Order_By>;
  isBuyerLegalRepresentative?: InputMaybe<Order_By>;
  kbisFileId?: InputMaybe<Order_By>;
  kbis_file?: InputMaybe<Files_Order_By>;
  languagesSpoken?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  legalForm?: InputMaybe<Order_By>;
  legalRepresentativeBirthDate?: InputMaybe<Order_By>;
  legalRepresentativeBirthName?: InputMaybe<Order_By>;
  legalRepresentativeBirthPlace?: InputMaybe<Order_By>;
  legalRepresentativeCivility?: InputMaybe<Order_By>;
  legalRepresentativeFirstName?: InputMaybe<Order_By>;
  legalRepresentativeLastName?: InputMaybe<Order_By>;
  legalRepresentativeNationality?: InputMaybe<Order_By>;
  maritalStatus?: InputMaybe<Order_By>;
  mobilePhone?: InputMaybe<Order_By>;
  nationality?: InputMaybe<Order_By>;
  registeredOfficeAddress?: InputMaybe<Order_By>;
  sirenNumber?: InputMaybe<Order_By>;
  subjectToVat?: InputMaybe<Order_By>;
  taxRegimeCompany?: InputMaybe<Order_By>;
  vatNumber?: InputMaybe<Order_By>;
  workPhone?: InputMaybe<Order_By>;
};

/** primary key columns input for table: buyer_member_folder */
export type Buyer_Member_Folder_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "buyer_member_folder" */
export enum Buyer_Member_Folder_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  ApplicationId = 'applicationId',
  /** column name */
  BankAccountBankAddress = 'bankAccountBankAddress',
  /** column name */
  BankAccountBankName = 'bankAccountBankName',
  /** column name */
  BankAccountBic = 'bankAccountBic',
  /** column name */
  BankAccountHolder = 'bankAccountHolder',
  /** column name */
  BankAccountIban = 'bankAccountIban',
  /** column name */
  BankAccountRibFileId = 'bankAccountRibFileId',
  /** column name */
  BirthDate = 'birthDate',
  /** column name */
  BirthName = 'birthName',
  /** column name */
  BirthPlace = 'birthPlace',
  /** column name */
  Civility = 'civility',
  /** column name */
  Comment = 'comment',
  /** column name */
  CompanyName = 'companyName',
  /** column name */
  CountryOfTaxResidence = 'countryOfTaxResidence',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EmailAddress = 'emailAddress',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  FluentInFrench = 'fluentInFrench',
  /** column name */
  HomePhone = 'homePhone',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityDocumentFileId = 'identityDocumentFileId',
  /** column name */
  IndividualOrLegalEntity = 'individualOrLegalEntity',
  /** column name */
  IsBuyerLegalRepresentative = 'isBuyerLegalRepresentative',
  /** column name */
  KbisFileId = 'kbisFileId',
  /** column name */
  LanguagesSpoken = 'languagesSpoken',
  /** column name */
  LastName = 'lastName',
  /** column name */
  LegalForm = 'legalForm',
  /** column name */
  LegalRepresentativeBirthDate = 'legalRepresentativeBirthDate',
  /** column name */
  LegalRepresentativeBirthName = 'legalRepresentativeBirthName',
  /** column name */
  LegalRepresentativeBirthPlace = 'legalRepresentativeBirthPlace',
  /** column name */
  LegalRepresentativeCivility = 'legalRepresentativeCivility',
  /** column name */
  LegalRepresentativeFirstName = 'legalRepresentativeFirstName',
  /** column name */
  LegalRepresentativeLastName = 'legalRepresentativeLastName',
  /** column name */
  LegalRepresentativeNationality = 'legalRepresentativeNationality',
  /** column name */
  MaritalStatus = 'maritalStatus',
  /** column name */
  MobilePhone = 'mobilePhone',
  /** column name */
  Nationality = 'nationality',
  /** column name */
  RegisteredOfficeAddress = 'registeredOfficeAddress',
  /** column name */
  SirenNumber = 'sirenNumber',
  /** column name */
  SubjectToVat = 'subjectToVat',
  /** column name */
  TaxRegimeCompany = 'taxRegimeCompany',
  /** column name */
  VatNumber = 'vatNumber',
  /** column name */
  WorkPhone = 'workPhone'
}

/** select "buyer_member_folder_aggregate_bool_exp_bool_and_arguments_columns" columns of table "buyer_member_folder" */
export enum Buyer_Member_Folder_Select_Column_Buyer_Member_Folder_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  FluentInFrench = 'fluentInFrench',
  /** column name */
  IsBuyerLegalRepresentative = 'isBuyerLegalRepresentative',
  /** column name */
  SubjectToVat = 'subjectToVat'
}

/** select "buyer_member_folder_aggregate_bool_exp_bool_or_arguments_columns" columns of table "buyer_member_folder" */
export enum Buyer_Member_Folder_Select_Column_Buyer_Member_Folder_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  FluentInFrench = 'fluentInFrench',
  /** column name */
  IsBuyerLegalRepresentative = 'isBuyerLegalRepresentative',
  /** column name */
  SubjectToVat = 'subjectToVat'
}

/** input type for updating data in table "buyer_member_folder" */
export type Buyer_Member_Folder_Set_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  applicationId?: InputMaybe<Scalars['uuid']['input']>;
  bankAccountBankAddress?: InputMaybe<Scalars['String']['input']>;
  bankAccountBankName?: InputMaybe<Scalars['String']['input']>;
  bankAccountBic?: InputMaybe<Scalars['String']['input']>;
  bankAccountHolder?: InputMaybe<Scalars['String']['input']>;
  bankAccountIban?: InputMaybe<Scalars['String']['input']>;
  bankAccountRibFileId?: InputMaybe<Scalars['uuid']['input']>;
  birthDate?: InputMaybe<Scalars['timestamptz']['input']>;
  birthName?: InputMaybe<Scalars['String']['input']>;
  birthPlace?: InputMaybe<Scalars['String']['input']>;
  civility?: InputMaybe<Civility_Enum>;
  comment?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  countryOfTaxResidence?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fluentInFrench?: InputMaybe<Scalars['Boolean']['input']>;
  homePhone?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  identityDocumentFileId?: InputMaybe<Scalars['uuid']['input']>;
  individualOrLegalEntity?: InputMaybe<Seller_Type_Enum>;
  isBuyerLegalRepresentative?: InputMaybe<Scalars['Boolean']['input']>;
  kbisFileId?: InputMaybe<Scalars['uuid']['input']>;
  languagesSpoken?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  legalForm?: InputMaybe<Seller_Legal_Status_Enum>;
  legalRepresentativeBirthDate?: InputMaybe<Scalars['String']['input']>;
  legalRepresentativeBirthName?: InputMaybe<Scalars['String']['input']>;
  legalRepresentativeBirthPlace?: InputMaybe<Scalars['String']['input']>;
  legalRepresentativeCivility?: InputMaybe<Scalars['String']['input']>;
  legalRepresentativeFirstName?: InputMaybe<Scalars['String']['input']>;
  legalRepresentativeLastName?: InputMaybe<Scalars['String']['input']>;
  legalRepresentativeNationality?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  registeredOfficeAddress?: InputMaybe<Scalars['String']['input']>;
  sirenNumber?: InputMaybe<Scalars['String']['input']>;
  subjectToVat?: InputMaybe<Scalars['Boolean']['input']>;
  taxRegimeCompany?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  workPhone?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "buyer_member_folder" */
export type Buyer_Member_Folder_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Buyer_Member_Folder_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Buyer_Member_Folder_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  applicationId?: InputMaybe<Scalars['uuid']['input']>;
  bankAccountBankAddress?: InputMaybe<Scalars['String']['input']>;
  bankAccountBankName?: InputMaybe<Scalars['String']['input']>;
  bankAccountBic?: InputMaybe<Scalars['String']['input']>;
  bankAccountHolder?: InputMaybe<Scalars['String']['input']>;
  bankAccountIban?: InputMaybe<Scalars['String']['input']>;
  bankAccountRibFileId?: InputMaybe<Scalars['uuid']['input']>;
  birthDate?: InputMaybe<Scalars['timestamptz']['input']>;
  birthName?: InputMaybe<Scalars['String']['input']>;
  birthPlace?: InputMaybe<Scalars['String']['input']>;
  civility?: InputMaybe<Civility_Enum>;
  comment?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  countryOfTaxResidence?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fluentInFrench?: InputMaybe<Scalars['Boolean']['input']>;
  homePhone?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  identityDocumentFileId?: InputMaybe<Scalars['uuid']['input']>;
  individualOrLegalEntity?: InputMaybe<Seller_Type_Enum>;
  isBuyerLegalRepresentative?: InputMaybe<Scalars['Boolean']['input']>;
  kbisFileId?: InputMaybe<Scalars['uuid']['input']>;
  languagesSpoken?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  legalForm?: InputMaybe<Seller_Legal_Status_Enum>;
  legalRepresentativeBirthDate?: InputMaybe<Scalars['String']['input']>;
  legalRepresentativeBirthName?: InputMaybe<Scalars['String']['input']>;
  legalRepresentativeBirthPlace?: InputMaybe<Scalars['String']['input']>;
  legalRepresentativeCivility?: InputMaybe<Scalars['String']['input']>;
  legalRepresentativeFirstName?: InputMaybe<Scalars['String']['input']>;
  legalRepresentativeLastName?: InputMaybe<Scalars['String']['input']>;
  legalRepresentativeNationality?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  registeredOfficeAddress?: InputMaybe<Scalars['String']['input']>;
  sirenNumber?: InputMaybe<Scalars['String']['input']>;
  subjectToVat?: InputMaybe<Scalars['Boolean']['input']>;
  taxRegimeCompany?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  workPhone?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "buyer_member_folder" */
export enum Buyer_Member_Folder_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  ApplicationId = 'applicationId',
  /** column name */
  BankAccountBankAddress = 'bankAccountBankAddress',
  /** column name */
  BankAccountBankName = 'bankAccountBankName',
  /** column name */
  BankAccountBic = 'bankAccountBic',
  /** column name */
  BankAccountHolder = 'bankAccountHolder',
  /** column name */
  BankAccountIban = 'bankAccountIban',
  /** column name */
  BankAccountRibFileId = 'bankAccountRibFileId',
  /** column name */
  BirthDate = 'birthDate',
  /** column name */
  BirthName = 'birthName',
  /** column name */
  BirthPlace = 'birthPlace',
  /** column name */
  Civility = 'civility',
  /** column name */
  Comment = 'comment',
  /** column name */
  CompanyName = 'companyName',
  /** column name */
  CountryOfTaxResidence = 'countryOfTaxResidence',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EmailAddress = 'emailAddress',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  FluentInFrench = 'fluentInFrench',
  /** column name */
  HomePhone = 'homePhone',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityDocumentFileId = 'identityDocumentFileId',
  /** column name */
  IndividualOrLegalEntity = 'individualOrLegalEntity',
  /** column name */
  IsBuyerLegalRepresentative = 'isBuyerLegalRepresentative',
  /** column name */
  KbisFileId = 'kbisFileId',
  /** column name */
  LanguagesSpoken = 'languagesSpoken',
  /** column name */
  LastName = 'lastName',
  /** column name */
  LegalForm = 'legalForm',
  /** column name */
  LegalRepresentativeBirthDate = 'legalRepresentativeBirthDate',
  /** column name */
  LegalRepresentativeBirthName = 'legalRepresentativeBirthName',
  /** column name */
  LegalRepresentativeBirthPlace = 'legalRepresentativeBirthPlace',
  /** column name */
  LegalRepresentativeCivility = 'legalRepresentativeCivility',
  /** column name */
  LegalRepresentativeFirstName = 'legalRepresentativeFirstName',
  /** column name */
  LegalRepresentativeLastName = 'legalRepresentativeLastName',
  /** column name */
  LegalRepresentativeNationality = 'legalRepresentativeNationality',
  /** column name */
  MaritalStatus = 'maritalStatus',
  /** column name */
  MobilePhone = 'mobilePhone',
  /** column name */
  Nationality = 'nationality',
  /** column name */
  RegisteredOfficeAddress = 'registeredOfficeAddress',
  /** column name */
  SirenNumber = 'sirenNumber',
  /** column name */
  SubjectToVat = 'subjectToVat',
  /** column name */
  TaxRegimeCompany = 'taxRegimeCompany',
  /** column name */
  VatNumber = 'vatNumber',
  /** column name */
  WorkPhone = 'workPhone'
}

export type Buyer_Member_Folder_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Buyer_Member_Folder_Set_Input>;
  /** filter the rows which have to be updated */
  where: Buyer_Member_Folder_Bool_Exp;
};

/** input type for inserting data into table "buyer_member" */
export type Buyer_Member_Insert_Input = {
  agency?: InputMaybe<Agency_Obj_Rel_Insert_Input>;
  agencyId?: InputMaybe<Scalars['uuid']['input']>;
  applications?: InputMaybe<Application_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  visits?: InputMaybe<Visit_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Buyer_Member_Max_Fields = {
  __typename?: 'buyer_member_max_fields';
  agencyId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "buyer_member" */
export type Buyer_Member_Max_Order_By = {
  agencyId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Buyer_Member_Min_Fields = {
  __typename?: 'buyer_member_min_fields';
  agencyId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "buyer_member" */
export type Buyer_Member_Min_Order_By = {
  agencyId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "buyer_member" */
export type Buyer_Member_Mutation_Response = {
  __typename?: 'buyer_member_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Buyer_Member>;
};

/** input type for inserting object relation for remote table "buyer_member" */
export type Buyer_Member_Obj_Rel_Insert_Input = {
  data: Buyer_Member_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Buyer_Member_On_Conflict>;
};

/** on_conflict condition type for table "buyer_member" */
export type Buyer_Member_On_Conflict = {
  constraint: Buyer_Member_Constraint;
  update_columns?: Array<Buyer_Member_Update_Column>;
  where?: InputMaybe<Buyer_Member_Bool_Exp>;
};

/** Ordering options when selecting data from "buyer_member". */
export type Buyer_Member_Order_By = {
  agency?: InputMaybe<Agency_Order_By>;
  agencyId?: InputMaybe<Order_By>;
  applications_aggregate?: InputMaybe<Application_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
  visits_aggregate?: InputMaybe<Visit_Aggregate_Order_By>;
};

/** primary key columns input for table: buyer_member */
export type Buyer_Member_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "buyer_member" */
export enum Buyer_Member_Select_Column {
  /** column name */
  AgencyId = 'agencyId',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "buyer_member" */
export type Buyer_Member_Set_Input = {
  agencyId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "buyer_member" */
export type Buyer_Member_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Buyer_Member_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Buyer_Member_Stream_Cursor_Value_Input = {
  agencyId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "buyer_member" */
export enum Buyer_Member_Update_Column {
  /** column name */
  AgencyId = 'agencyId',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'userId'
}

export type Buyer_Member_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Buyer_Member_Set_Input>;
  /** filter the rows which have to be updated */
  where: Buyer_Member_Bool_Exp;
};

/** Boolean expression to compare columns of type "bytea". All fields are combined with logical 'AND'. */
export type Bytea_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bytea']['input']>;
  _gt?: InputMaybe<Scalars['bytea']['input']>;
  _gte?: InputMaybe<Scalars['bytea']['input']>;
  _in?: InputMaybe<Array<Scalars['bytea']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bytea']['input']>;
  _lte?: InputMaybe<Scalars['bytea']['input']>;
  _neq?: InputMaybe<Scalars['bytea']['input']>;
  _nin?: InputMaybe<Array<Scalars['bytea']['input']>>;
};

/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export type Citext_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['citext']['input']>;
  _gt?: InputMaybe<Scalars['citext']['input']>;
  _gte?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['citext']['input']>;
  _in?: InputMaybe<Array<Scalars['citext']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['citext']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['citext']['input']>;
  _lt?: InputMaybe<Scalars['citext']['input']>;
  _lte?: InputMaybe<Scalars['citext']['input']>;
  _neq?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['citext']['input']>;
  _nin?: InputMaybe<Array<Scalars['citext']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['citext']['input']>;
};

/** columns and relationships of "civility" */
export type Civility = {
  __typename?: 'civility';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "civility" */
export type Civility_Aggregate = {
  __typename?: 'civility_aggregate';
  aggregate?: Maybe<Civility_Aggregate_Fields>;
  nodes: Array<Civility>;
};

/** aggregate fields of "civility" */
export type Civility_Aggregate_Fields = {
  __typename?: 'civility_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Civility_Max_Fields>;
  min?: Maybe<Civility_Min_Fields>;
};


/** aggregate fields of "civility" */
export type Civility_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Civility_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "civility". All fields are combined with a logical 'AND'. */
export type Civility_Bool_Exp = {
  _and?: InputMaybe<Array<Civility_Bool_Exp>>;
  _not?: InputMaybe<Civility_Bool_Exp>;
  _or?: InputMaybe<Array<Civility_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "civility" */
export enum Civility_Constraint {
  /** unique or primary key constraint on columns "value" */
  CivilityPkey = 'civility_pkey'
}

export enum Civility_Enum {
  Mr = 'Mr',
  Mrs = 'Mrs'
}

/** Boolean expression to compare columns of type "civility_enum". All fields are combined with logical 'AND'. */
export type Civility_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Civility_Enum>;
  _in?: InputMaybe<Array<Civility_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Civility_Enum>;
  _nin?: InputMaybe<Array<Civility_Enum>>;
};

/** input type for inserting data into table "civility" */
export type Civility_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Civility_Max_Fields = {
  __typename?: 'civility_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Civility_Min_Fields = {
  __typename?: 'civility_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "civility" */
export type Civility_Mutation_Response = {
  __typename?: 'civility_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Civility>;
};

/** on_conflict condition type for table "civility" */
export type Civility_On_Conflict = {
  constraint: Civility_Constraint;
  update_columns?: Array<Civility_Update_Column>;
  where?: InputMaybe<Civility_Bool_Exp>;
};

/** Ordering options when selecting data from "civility". */
export type Civility_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: civility */
export type Civility_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "civility" */
export enum Civility_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "civility" */
export type Civility_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "civility" */
export type Civility_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Civility_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Civility_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "civility" */
export enum Civility_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Civility_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Civility_Set_Input>;
  /** filter the rows which have to be updated */
  where: Civility_Bool_Exp;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "estate" */
export type Estate = {
  __typename?: 'estate';
  address: Scalars['String']['output'];
  applicationAcceptedDate?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  applications: Array<Application>;
  /** An aggregate relationship */
  applications_aggregate: Application_Aggregate;
  archived: Scalars['Boolean']['output'];
  canConnectedBuyerSeeAddress: Scalars['Boolean']['output'];
  city: Scalars['String']['output'];
  coownership: Scalars['estate_coownership']['output'];
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  /** Current round based on round number. There should alway be a current round (as one is created right away) */
  currentRoundId?: Maybe<Scalars['uuid']['output']>;
  diagnosticsData: Scalars['estate_diagnostics_data']['output'];
  endEstimate?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  estateRounds: Array<Estate_Round>;
  /** An aggregate relationship */
  estateRounds_aggregate: Estate_Round_Aggregate;
  /** An array relationship */
  estate_links: Array<Estate_Link>;
  /** An aggregate relationship */
  estate_links_aggregate: Estate_Link_Aggregate;
  /** An array relationship */
  estate_media: Array<Estate_Media>;
  /** An aggregate relationship */
  estate_media_aggregate: Estate_Media_Aggregate;
  /** An array relationship */
  estate_sellers: Array<Estate_Seller>;
  /** An aggregate relationship */
  estate_sellers_aggregate: Estate_Seller_Aggregate;
  /** An object relationship */
  estate_type?: Maybe<Estate_Type>;
  /** An object relationship */
  estimationAskedBy?: Maybe<Seller_Member>;
  estimationAskedBySellerMemberId?: Maybe<Scalars['uuid']['output']>;
  estimationAskedDate?: Maybe<Scalars['timestamptz']['output']>;
  estimationPublishedDate?: Maybe<Scalars['timestamptz']['output']>;
  features: Scalars['estate_features']['output'];
  firstPrice?: Maybe<Scalars['Int']['output']>;
  flags?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  isPublished: Scalars['Boolean']['output'];
  isSaleOpen: Scalars['Boolean']['output'];
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  mandate?: Maybe<Mandate>;
  /** The number of visit per slot */
  maxVisitPerSlot: Scalars['numeric']['output'];
  missionHeadId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  mission_head?: Maybe<Agency_Member>;
  name?: Maybe<Scalars['String']['output']>;
  publicLatitude?: Maybe<Scalars['numeric']['output']>;
  publicLongitude?: Maybe<Scalars['numeric']['output']>;
  publicationDescription?: Maybe<Scalars['String']['output']>;
  publicationMention?: Maybe<Scalars['String']['output']>;
  publicationTitle?: Maybe<Scalars['String']['output']>;
  reservePrice?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  seller: Seller;
  sellerData?: Maybe<Scalars['estate_seller_data']['output']>;
  sellerId: Scalars['uuid']['output'];
  servicesAndConditions: Scalars['estate_services_and_conditions']['output'];
  startEstimate?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Estate_Type_Enum>;
  virtualVisits: Scalars['estate_virtual_visits']['output'];
  /** The duration of a visit, used to sub-divide VisitSpans in slots, in minutes */
  visitSlotDuration: Scalars['numeric']['output'];
  /** An array relationship */
  visit_spans: Array<Visit_Span>;
  /** An aggregate relationship */
  visit_spans_aggregate: Visit_Span_Aggregate;
  /** An array relationship */
  visits: Array<Visit>;
  /** An aggregate relationship */
  visits_aggregate: Visit_Aggregate;
  zipCode: Scalars['String']['output'];
};


/** columns and relationships of "estate" */
export type EstateApplicationsArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


/** columns and relationships of "estate" */
export type EstateApplications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


/** columns and relationships of "estate" */
export type EstateCoownershipArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "estate" */
export type EstateDiagnosticsDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "estate" */
export type EstateEstateRoundsArgs = {
  distinct_on?: InputMaybe<Array<Estate_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Round_Order_By>>;
  where?: InputMaybe<Estate_Round_Bool_Exp>;
};


/** columns and relationships of "estate" */
export type EstateEstateRounds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Round_Order_By>>;
  where?: InputMaybe<Estate_Round_Bool_Exp>;
};


/** columns and relationships of "estate" */
export type EstateEstate_LinksArgs = {
  distinct_on?: InputMaybe<Array<Estate_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Link_Order_By>>;
  where?: InputMaybe<Estate_Link_Bool_Exp>;
};


/** columns and relationships of "estate" */
export type EstateEstate_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Link_Order_By>>;
  where?: InputMaybe<Estate_Link_Bool_Exp>;
};


/** columns and relationships of "estate" */
export type EstateEstate_MediaArgs = {
  distinct_on?: InputMaybe<Array<Estate_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Media_Order_By>>;
  where?: InputMaybe<Estate_Media_Bool_Exp>;
};


/** columns and relationships of "estate" */
export type EstateEstate_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Media_Order_By>>;
  where?: InputMaybe<Estate_Media_Bool_Exp>;
};


/** columns and relationships of "estate" */
export type EstateEstate_SellersArgs = {
  distinct_on?: InputMaybe<Array<Estate_Seller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Seller_Order_By>>;
  where?: InputMaybe<Estate_Seller_Bool_Exp>;
};


/** columns and relationships of "estate" */
export type EstateEstate_Sellers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Seller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Seller_Order_By>>;
  where?: InputMaybe<Estate_Seller_Bool_Exp>;
};


/** columns and relationships of "estate" */
export type EstateFeaturesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "estate" */
export type EstateFlagsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "estate" */
export type EstateSellerDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "estate" */
export type EstateServicesAndConditionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "estate" */
export type EstateVirtualVisitsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "estate" */
export type EstateVisit_SpansArgs = {
  distinct_on?: InputMaybe<Array<Visit_Span_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visit_Span_Order_By>>;
  where?: InputMaybe<Visit_Span_Bool_Exp>;
};


/** columns and relationships of "estate" */
export type EstateVisit_Spans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Visit_Span_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visit_Span_Order_By>>;
  where?: InputMaybe<Visit_Span_Bool_Exp>;
};


/** columns and relationships of "estate" */
export type EstateVisitsArgs = {
  distinct_on?: InputMaybe<Array<Visit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visit_Order_By>>;
  where?: InputMaybe<Visit_Bool_Exp>;
};


/** columns and relationships of "estate" */
export type EstateVisits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Visit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visit_Order_By>>;
  where?: InputMaybe<Visit_Bool_Exp>;
};

/** aggregated selection of "estate" */
export type Estate_Aggregate = {
  __typename?: 'estate_aggregate';
  aggregate?: Maybe<Estate_Aggregate_Fields>;
  nodes: Array<Estate>;
};

export type Estate_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Estate_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Estate_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Estate_Aggregate_Bool_Exp_Count>;
};

export type Estate_Aggregate_Bool_Exp_Bool_And = {
  arguments: Estate_Select_Column_Estate_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Estate_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Estate_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Estate_Select_Column_Estate_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Estate_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Estate_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Estate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Estate_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "estate" */
export type Estate_Aggregate_Fields = {
  __typename?: 'estate_aggregate_fields';
  avg?: Maybe<Estate_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Estate_Max_Fields>;
  min?: Maybe<Estate_Min_Fields>;
  stddev?: Maybe<Estate_Stddev_Fields>;
  stddev_pop?: Maybe<Estate_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Estate_Stddev_Samp_Fields>;
  sum?: Maybe<Estate_Sum_Fields>;
  var_pop?: Maybe<Estate_Var_Pop_Fields>;
  var_samp?: Maybe<Estate_Var_Samp_Fields>;
  variance?: Maybe<Estate_Variance_Fields>;
};


/** aggregate fields of "estate" */
export type Estate_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Estate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "estate" */
export type Estate_Aggregate_Order_By = {
  avg?: InputMaybe<Estate_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Estate_Max_Order_By>;
  min?: InputMaybe<Estate_Min_Order_By>;
  stddev?: InputMaybe<Estate_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Estate_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Estate_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Estate_Sum_Order_By>;
  var_pop?: InputMaybe<Estate_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Estate_Var_Samp_Order_By>;
  variance?: InputMaybe<Estate_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Estate_Append_Input = {
  coownership?: InputMaybe<Scalars['jsonb']['input']>;
  diagnosticsData?: InputMaybe<Scalars['jsonb']['input']>;
  features?: InputMaybe<Scalars['jsonb']['input']>;
  flags?: InputMaybe<Scalars['jsonb']['input']>;
  sellerData?: InputMaybe<Scalars['jsonb']['input']>;
  servicesAndConditions?: InputMaybe<Scalars['jsonb']['input']>;
  virtualVisits?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "estate" */
export type Estate_Arr_Rel_Insert_Input = {
  data: Array<Estate_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Estate_On_Conflict>;
};

/** aggregate avg on columns */
export type Estate_Avg_Fields = {
  __typename?: 'estate_avg_fields';
  endEstimate?: Maybe<Scalars['Float']['output']>;
  firstPrice?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The number of visit per slot */
  maxVisitPerSlot?: Maybe<Scalars['Float']['output']>;
  publicLatitude?: Maybe<Scalars['Float']['output']>;
  publicLongitude?: Maybe<Scalars['Float']['output']>;
  reservePrice?: Maybe<Scalars['Float']['output']>;
  startEstimate?: Maybe<Scalars['Float']['output']>;
  /** The duration of a visit, used to sub-divide VisitSpans in slots, in minutes */
  visitSlotDuration?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "estate" */
export type Estate_Avg_Order_By = {
  endEstimate?: InputMaybe<Order_By>;
  firstPrice?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  /** The number of visit per slot */
  maxVisitPerSlot?: InputMaybe<Order_By>;
  publicLatitude?: InputMaybe<Order_By>;
  publicLongitude?: InputMaybe<Order_By>;
  reservePrice?: InputMaybe<Order_By>;
  startEstimate?: InputMaybe<Order_By>;
  /** The duration of a visit, used to sub-divide VisitSpans in slots, in minutes */
  visitSlotDuration?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "estate". All fields are combined with a logical 'AND'. */
export type Estate_Bool_Exp = {
  _and?: InputMaybe<Array<Estate_Bool_Exp>>;
  _not?: InputMaybe<Estate_Bool_Exp>;
  _or?: InputMaybe<Array<Estate_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  applicationAcceptedDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  applications?: InputMaybe<Application_Bool_Exp>;
  applications_aggregate?: InputMaybe<Application_Aggregate_Bool_Exp>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  canConnectedBuyerSeeAddress?: InputMaybe<Boolean_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  coownership?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currentRoundId?: InputMaybe<Uuid_Comparison_Exp>;
  diagnosticsData?: InputMaybe<Jsonb_Comparison_Exp>;
  endEstimate?: InputMaybe<Int_Comparison_Exp>;
  estateRounds?: InputMaybe<Estate_Round_Bool_Exp>;
  estateRounds_aggregate?: InputMaybe<Estate_Round_Aggregate_Bool_Exp>;
  estate_links?: InputMaybe<Estate_Link_Bool_Exp>;
  estate_links_aggregate?: InputMaybe<Estate_Link_Aggregate_Bool_Exp>;
  estate_media?: InputMaybe<Estate_Media_Bool_Exp>;
  estate_media_aggregate?: InputMaybe<Estate_Media_Aggregate_Bool_Exp>;
  estate_sellers?: InputMaybe<Estate_Seller_Bool_Exp>;
  estate_sellers_aggregate?: InputMaybe<Estate_Seller_Aggregate_Bool_Exp>;
  estate_type?: InputMaybe<Estate_Type_Bool_Exp>;
  estimationAskedBy?: InputMaybe<Seller_Member_Bool_Exp>;
  estimationAskedBySellerMemberId?: InputMaybe<Uuid_Comparison_Exp>;
  estimationAskedDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  estimationPublishedDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  features?: InputMaybe<Jsonb_Comparison_Exp>;
  firstPrice?: InputMaybe<Int_Comparison_Exp>;
  flags?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isPublished?: InputMaybe<Boolean_Comparison_Exp>;
  isSaleOpen?: InputMaybe<Boolean_Comparison_Exp>;
  latitude?: InputMaybe<Numeric_Comparison_Exp>;
  longitude?: InputMaybe<Numeric_Comparison_Exp>;
  mandate?: InputMaybe<Mandate_Bool_Exp>;
  maxVisitPerSlot?: InputMaybe<Numeric_Comparison_Exp>;
  missionHeadId?: InputMaybe<Uuid_Comparison_Exp>;
  mission_head?: InputMaybe<Agency_Member_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  publicLatitude?: InputMaybe<Numeric_Comparison_Exp>;
  publicLongitude?: InputMaybe<Numeric_Comparison_Exp>;
  publicationDescription?: InputMaybe<String_Comparison_Exp>;
  publicationMention?: InputMaybe<String_Comparison_Exp>;
  publicationTitle?: InputMaybe<String_Comparison_Exp>;
  reservePrice?: InputMaybe<Int_Comparison_Exp>;
  seller?: InputMaybe<Seller_Bool_Exp>;
  sellerData?: InputMaybe<Jsonb_Comparison_Exp>;
  sellerId?: InputMaybe<Uuid_Comparison_Exp>;
  servicesAndConditions?: InputMaybe<Jsonb_Comparison_Exp>;
  startEstimate?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<Estate_Type_Enum_Comparison_Exp>;
  virtualVisits?: InputMaybe<Jsonb_Comparison_Exp>;
  visitSlotDuration?: InputMaybe<Numeric_Comparison_Exp>;
  visit_spans?: InputMaybe<Visit_Span_Bool_Exp>;
  visit_spans_aggregate?: InputMaybe<Visit_Span_Aggregate_Bool_Exp>;
  visits?: InputMaybe<Visit_Bool_Exp>;
  visits_aggregate?: InputMaybe<Visit_Aggregate_Bool_Exp>;
  zipCode?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "estate" */
export enum Estate_Constraint {
  /** unique or primary key constraint on columns "id" */
  EstatePkey = 'estate_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Estate_Delete_At_Path_Input = {
  coownership?: InputMaybe<Array<Scalars['String']['input']>>;
  diagnosticsData?: InputMaybe<Array<Scalars['String']['input']>>;
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  flags?: InputMaybe<Array<Scalars['String']['input']>>;
  sellerData?: InputMaybe<Array<Scalars['String']['input']>>;
  servicesAndConditions?: InputMaybe<Array<Scalars['String']['input']>>;
  virtualVisits?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Estate_Delete_Elem_Input = {
  coownership?: InputMaybe<Scalars['Int']['input']>;
  diagnosticsData?: InputMaybe<Scalars['Int']['input']>;
  features?: InputMaybe<Scalars['Int']['input']>;
  flags?: InputMaybe<Scalars['Int']['input']>;
  sellerData?: InputMaybe<Scalars['Int']['input']>;
  servicesAndConditions?: InputMaybe<Scalars['Int']['input']>;
  virtualVisits?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Estate_Delete_Key_Input = {
  coownership?: InputMaybe<Scalars['String']['input']>;
  diagnosticsData?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Scalars['String']['input']>;
  sellerData?: InputMaybe<Scalars['String']['input']>;
  servicesAndConditions?: InputMaybe<Scalars['String']['input']>;
  virtualVisits?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "estate" */
export type Estate_Inc_Input = {
  endEstimate?: InputMaybe<Scalars['Int']['input']>;
  firstPrice?: InputMaybe<Scalars['Int']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  /** The number of visit per slot */
  maxVisitPerSlot?: InputMaybe<Scalars['numeric']['input']>;
  publicLatitude?: InputMaybe<Scalars['numeric']['input']>;
  publicLongitude?: InputMaybe<Scalars['numeric']['input']>;
  reservePrice?: InputMaybe<Scalars['Int']['input']>;
  startEstimate?: InputMaybe<Scalars['Int']['input']>;
  /** The duration of a visit, used to sub-divide VisitSpans in slots, in minutes */
  visitSlotDuration?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "estate" */
export type Estate_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  applicationAcceptedDate?: InputMaybe<Scalars['timestamptz']['input']>;
  applications?: InputMaybe<Application_Arr_Rel_Insert_Input>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  canConnectedBuyerSeeAddress?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  coownership?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  diagnosticsData?: InputMaybe<Scalars['jsonb']['input']>;
  endEstimate?: InputMaybe<Scalars['Int']['input']>;
  estateRounds?: InputMaybe<Estate_Round_Arr_Rel_Insert_Input>;
  estate_links?: InputMaybe<Estate_Link_Arr_Rel_Insert_Input>;
  estate_media?: InputMaybe<Estate_Media_Arr_Rel_Insert_Input>;
  estate_sellers?: InputMaybe<Estate_Seller_Arr_Rel_Insert_Input>;
  estate_type?: InputMaybe<Estate_Type_Obj_Rel_Insert_Input>;
  estimationAskedBy?: InputMaybe<Seller_Member_Obj_Rel_Insert_Input>;
  estimationAskedBySellerMemberId?: InputMaybe<Scalars['uuid']['input']>;
  estimationAskedDate?: InputMaybe<Scalars['timestamptz']['input']>;
  estimationPublishedDate?: InputMaybe<Scalars['timestamptz']['input']>;
  features?: InputMaybe<Scalars['jsonb']['input']>;
  firstPrice?: InputMaybe<Scalars['Int']['input']>;
  flags?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isSaleOpen?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  mandate?: InputMaybe<Mandate_Obj_Rel_Insert_Input>;
  /** The number of visit per slot */
  maxVisitPerSlot?: InputMaybe<Scalars['numeric']['input']>;
  missionHeadId?: InputMaybe<Scalars['uuid']['input']>;
  mission_head?: InputMaybe<Agency_Member_Obj_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  publicLatitude?: InputMaybe<Scalars['numeric']['input']>;
  publicLongitude?: InputMaybe<Scalars['numeric']['input']>;
  publicationDescription?: InputMaybe<Scalars['String']['input']>;
  publicationMention?: InputMaybe<Scalars['String']['input']>;
  publicationTitle?: InputMaybe<Scalars['String']['input']>;
  reservePrice?: InputMaybe<Scalars['Int']['input']>;
  seller?: InputMaybe<Seller_Obj_Rel_Insert_Input>;
  sellerData?: InputMaybe<Scalars['jsonb']['input']>;
  sellerId?: InputMaybe<Scalars['uuid']['input']>;
  servicesAndConditions?: InputMaybe<Scalars['jsonb']['input']>;
  startEstimate?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Estate_Type_Enum>;
  virtualVisits?: InputMaybe<Scalars['jsonb']['input']>;
  /** The duration of a visit, used to sub-divide VisitSpans in slots, in minutes */
  visitSlotDuration?: InputMaybe<Scalars['numeric']['input']>;
  visit_spans?: InputMaybe<Visit_Span_Arr_Rel_Insert_Input>;
  visits?: InputMaybe<Visit_Arr_Rel_Insert_Input>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** publication link  */
export type Estate_Link = {
  __typename?: 'estate_link';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  estate: Estate;
  estateId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "estate_link" */
export type Estate_Link_Aggregate = {
  __typename?: 'estate_link_aggregate';
  aggregate?: Maybe<Estate_Link_Aggregate_Fields>;
  nodes: Array<Estate_Link>;
};

export type Estate_Link_Aggregate_Bool_Exp = {
  count?: InputMaybe<Estate_Link_Aggregate_Bool_Exp_Count>;
};

export type Estate_Link_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Estate_Link_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Estate_Link_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "estate_link" */
export type Estate_Link_Aggregate_Fields = {
  __typename?: 'estate_link_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Estate_Link_Max_Fields>;
  min?: Maybe<Estate_Link_Min_Fields>;
};


/** aggregate fields of "estate_link" */
export type Estate_Link_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Estate_Link_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "estate_link" */
export type Estate_Link_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Estate_Link_Max_Order_By>;
  min?: InputMaybe<Estate_Link_Min_Order_By>;
};

/** input type for inserting array relation for remote table "estate_link" */
export type Estate_Link_Arr_Rel_Insert_Input = {
  data: Array<Estate_Link_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Estate_Link_On_Conflict>;
};

/** Boolean expression to filter rows from the table "estate_link". All fields are combined with a logical 'AND'. */
export type Estate_Link_Bool_Exp = {
  _and?: InputMaybe<Array<Estate_Link_Bool_Exp>>;
  _not?: InputMaybe<Estate_Link_Bool_Exp>;
  _or?: InputMaybe<Array<Estate_Link_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  estate?: InputMaybe<Estate_Bool_Exp>;
  estateId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "estate_link" */
export enum Estate_Link_Constraint {
  /** unique or primary key constraint on columns "id" */
  EstateLinkPkey = 'estate_link_pkey'
}

/** input type for inserting data into table "estate_link" */
export type Estate_Link_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  estate?: InputMaybe<Estate_Obj_Rel_Insert_Input>;
  estateId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Estate_Link_Max_Fields = {
  __typename?: 'estate_link_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  estateId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "estate_link" */
export type Estate_Link_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  estateId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Estate_Link_Min_Fields = {
  __typename?: 'estate_link_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  estateId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "estate_link" */
export type Estate_Link_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  estateId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "estate_link" */
export type Estate_Link_Mutation_Response = {
  __typename?: 'estate_link_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Estate_Link>;
};

/** on_conflict condition type for table "estate_link" */
export type Estate_Link_On_Conflict = {
  constraint: Estate_Link_Constraint;
  update_columns?: Array<Estate_Link_Update_Column>;
  where?: InputMaybe<Estate_Link_Bool_Exp>;
};

/** Ordering options when selecting data from "estate_link". */
export type Estate_Link_Order_By = {
  created_at?: InputMaybe<Order_By>;
  estate?: InputMaybe<Estate_Order_By>;
  estateId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: estate_link */
export type Estate_Link_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "estate_link" */
export enum Estate_Link_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EstateId = 'estateId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "estate_link" */
export type Estate_Link_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  estateId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "estate_link" */
export type Estate_Link_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Estate_Link_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Estate_Link_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  estateId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "estate_link" */
export enum Estate_Link_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EstateId = 'estateId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Url = 'url'
}

export type Estate_Link_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Estate_Link_Set_Input>;
  /** filter the rows which have to be updated */
  where: Estate_Link_Bool_Exp;
};

/** aggregate max on columns */
export type Estate_Max_Fields = {
  __typename?: 'estate_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  applicationAcceptedDate?: Maybe<Scalars['timestamptz']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  /** Current round based on round number. There should alway be a current round (as one is created right away) */
  currentRoundId?: Maybe<Scalars['uuid']['output']>;
  endEstimate?: Maybe<Scalars['Int']['output']>;
  estimationAskedBySellerMemberId?: Maybe<Scalars['uuid']['output']>;
  estimationAskedDate?: Maybe<Scalars['timestamptz']['output']>;
  estimationPublishedDate?: Maybe<Scalars['timestamptz']['output']>;
  firstPrice?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  /** The number of visit per slot */
  maxVisitPerSlot?: Maybe<Scalars['numeric']['output']>;
  missionHeadId?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  publicLatitude?: Maybe<Scalars['numeric']['output']>;
  publicLongitude?: Maybe<Scalars['numeric']['output']>;
  publicationDescription?: Maybe<Scalars['String']['output']>;
  publicationMention?: Maybe<Scalars['String']['output']>;
  publicationTitle?: Maybe<Scalars['String']['output']>;
  reservePrice?: Maybe<Scalars['Int']['output']>;
  sellerId?: Maybe<Scalars['uuid']['output']>;
  startEstimate?: Maybe<Scalars['Int']['output']>;
  /** The duration of a visit, used to sub-divide VisitSpans in slots, in minutes */
  visitSlotDuration?: Maybe<Scalars['numeric']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "estate" */
export type Estate_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  applicationAcceptedDate?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  endEstimate?: InputMaybe<Order_By>;
  estimationAskedBySellerMemberId?: InputMaybe<Order_By>;
  estimationAskedDate?: InputMaybe<Order_By>;
  estimationPublishedDate?: InputMaybe<Order_By>;
  firstPrice?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  /** The number of visit per slot */
  maxVisitPerSlot?: InputMaybe<Order_By>;
  missionHeadId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  publicLatitude?: InputMaybe<Order_By>;
  publicLongitude?: InputMaybe<Order_By>;
  publicationDescription?: InputMaybe<Order_By>;
  publicationMention?: InputMaybe<Order_By>;
  publicationTitle?: InputMaybe<Order_By>;
  reservePrice?: InputMaybe<Order_By>;
  sellerId?: InputMaybe<Order_By>;
  startEstimate?: InputMaybe<Order_By>;
  /** The duration of a visit, used to sub-divide VisitSpans in slots, in minutes */
  visitSlotDuration?: InputMaybe<Order_By>;
  zipCode?: InputMaybe<Order_By>;
};

/** columns and relationships of "estate_media" */
export type Estate_Media = {
  __typename?: 'estate_media';
  /** An object relationship */
  censoredVersion?: Maybe<Estate_Media>;
  /** An object relationship */
  estate: Estate;
  estateId: Scalars['uuid']['output'];
  /** An object relationship */
  file: Files;
  fileId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  isCensored: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  originalVersion?: Maybe<Estate_Media>;
  originalVersionId?: Maybe<Scalars['uuid']['output']>;
  position: Scalars['Int']['output'];
  /** An object relationship */
  type: Estate_Media_Type;
  typeId: Scalars['uuid']['output'];
};

/** aggregated selection of "estate_media" */
export type Estate_Media_Aggregate = {
  __typename?: 'estate_media_aggregate';
  aggregate?: Maybe<Estate_Media_Aggregate_Fields>;
  nodes: Array<Estate_Media>;
};

export type Estate_Media_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Estate_Media_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Estate_Media_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Estate_Media_Aggregate_Bool_Exp_Count>;
};

export type Estate_Media_Aggregate_Bool_Exp_Bool_And = {
  arguments: Estate_Media_Select_Column_Estate_Media_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Estate_Media_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Estate_Media_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Estate_Media_Select_Column_Estate_Media_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Estate_Media_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Estate_Media_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Estate_Media_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Estate_Media_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "estate_media" */
export type Estate_Media_Aggregate_Fields = {
  __typename?: 'estate_media_aggregate_fields';
  avg?: Maybe<Estate_Media_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Estate_Media_Max_Fields>;
  min?: Maybe<Estate_Media_Min_Fields>;
  stddev?: Maybe<Estate_Media_Stddev_Fields>;
  stddev_pop?: Maybe<Estate_Media_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Estate_Media_Stddev_Samp_Fields>;
  sum?: Maybe<Estate_Media_Sum_Fields>;
  var_pop?: Maybe<Estate_Media_Var_Pop_Fields>;
  var_samp?: Maybe<Estate_Media_Var_Samp_Fields>;
  variance?: Maybe<Estate_Media_Variance_Fields>;
};


/** aggregate fields of "estate_media" */
export type Estate_Media_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Estate_Media_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "estate_media" */
export type Estate_Media_Aggregate_Order_By = {
  avg?: InputMaybe<Estate_Media_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Estate_Media_Max_Order_By>;
  min?: InputMaybe<Estate_Media_Min_Order_By>;
  stddev?: InputMaybe<Estate_Media_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Estate_Media_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Estate_Media_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Estate_Media_Sum_Order_By>;
  var_pop?: InputMaybe<Estate_Media_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Estate_Media_Var_Samp_Order_By>;
  variance?: InputMaybe<Estate_Media_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "estate_media" */
export type Estate_Media_Arr_Rel_Insert_Input = {
  data: Array<Estate_Media_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Estate_Media_On_Conflict>;
};

/** aggregate avg on columns */
export type Estate_Media_Avg_Fields = {
  __typename?: 'estate_media_avg_fields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "estate_media" */
export type Estate_Media_Avg_Order_By = {
  position?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "estate_media". All fields are combined with a logical 'AND'. */
export type Estate_Media_Bool_Exp = {
  _and?: InputMaybe<Array<Estate_Media_Bool_Exp>>;
  _not?: InputMaybe<Estate_Media_Bool_Exp>;
  _or?: InputMaybe<Array<Estate_Media_Bool_Exp>>;
  censoredVersion?: InputMaybe<Estate_Media_Bool_Exp>;
  estate?: InputMaybe<Estate_Bool_Exp>;
  estateId?: InputMaybe<Uuid_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  fileId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isCensored?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  originalVersion?: InputMaybe<Estate_Media_Bool_Exp>;
  originalVersionId?: InputMaybe<Uuid_Comparison_Exp>;
  position?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<Estate_Media_Type_Bool_Exp>;
  typeId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "estate_media" */
export enum Estate_Media_Constraint {
  /** unique or primary key constraint on columns "estateId", "typeId", "position" */
  EstateMediaEstateTypePositionUnique = 'estate_media_estate_type_position_unique',
  /** unique or primary key constraint on columns "id" */
  EstateMediaPkey = 'estate_media_pkey'
}

/** input type for incrementing numeric columns in table "estate_media" */
export type Estate_Media_Inc_Input = {
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "estate_media" */
export type Estate_Media_Insert_Input = {
  censoredVersion?: InputMaybe<Estate_Media_Obj_Rel_Insert_Input>;
  estate?: InputMaybe<Estate_Obj_Rel_Insert_Input>;
  estateId?: InputMaybe<Scalars['uuid']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isCensored?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  originalVersion?: InputMaybe<Estate_Media_Obj_Rel_Insert_Input>;
  originalVersionId?: InputMaybe<Scalars['uuid']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Estate_Media_Type_Obj_Rel_Insert_Input>;
  typeId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Estate_Media_Max_Fields = {
  __typename?: 'estate_media_max_fields';
  estateId?: Maybe<Scalars['uuid']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  originalVersionId?: Maybe<Scalars['uuid']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  typeId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "estate_media" */
export type Estate_Media_Max_Order_By = {
  estateId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  originalVersionId?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  typeId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Estate_Media_Min_Fields = {
  __typename?: 'estate_media_min_fields';
  estateId?: Maybe<Scalars['uuid']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  originalVersionId?: Maybe<Scalars['uuid']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  typeId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "estate_media" */
export type Estate_Media_Min_Order_By = {
  estateId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  originalVersionId?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  typeId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "estate_media" */
export type Estate_Media_Mutation_Response = {
  __typename?: 'estate_media_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Estate_Media>;
};

/** input type for inserting object relation for remote table "estate_media" */
export type Estate_Media_Obj_Rel_Insert_Input = {
  data: Estate_Media_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Estate_Media_On_Conflict>;
};

/** on_conflict condition type for table "estate_media" */
export type Estate_Media_On_Conflict = {
  constraint: Estate_Media_Constraint;
  update_columns?: Array<Estate_Media_Update_Column>;
  where?: InputMaybe<Estate_Media_Bool_Exp>;
};

/** Ordering options when selecting data from "estate_media". */
export type Estate_Media_Order_By = {
  censoredVersion?: InputMaybe<Estate_Media_Order_By>;
  estate?: InputMaybe<Estate_Order_By>;
  estateId?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isCensored?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  originalVersion?: InputMaybe<Estate_Media_Order_By>;
  originalVersionId?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  type?: InputMaybe<Estate_Media_Type_Order_By>;
  typeId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: estate_media */
export type Estate_Media_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "estate_media" */
export enum Estate_Media_Select_Column {
  /** column name */
  EstateId = 'estateId',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Id = 'id',
  /** column name */
  IsCensored = 'isCensored',
  /** column name */
  Name = 'name',
  /** column name */
  OriginalVersionId = 'originalVersionId',
  /** column name */
  Position = 'position',
  /** column name */
  TypeId = 'typeId'
}

/** select "estate_media_aggregate_bool_exp_bool_and_arguments_columns" columns of table "estate_media" */
export enum Estate_Media_Select_Column_Estate_Media_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsCensored = 'isCensored'
}

/** select "estate_media_aggregate_bool_exp_bool_or_arguments_columns" columns of table "estate_media" */
export enum Estate_Media_Select_Column_Estate_Media_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsCensored = 'isCensored'
}

/** input type for updating data in table "estate_media" */
export type Estate_Media_Set_Input = {
  estateId?: InputMaybe<Scalars['uuid']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isCensored?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  originalVersionId?: InputMaybe<Scalars['uuid']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  typeId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Estate_Media_Stddev_Fields = {
  __typename?: 'estate_media_stddev_fields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "estate_media" */
export type Estate_Media_Stddev_Order_By = {
  position?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Estate_Media_Stddev_Pop_Fields = {
  __typename?: 'estate_media_stddev_pop_fields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "estate_media" */
export type Estate_Media_Stddev_Pop_Order_By = {
  position?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Estate_Media_Stddev_Samp_Fields = {
  __typename?: 'estate_media_stddev_samp_fields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "estate_media" */
export type Estate_Media_Stddev_Samp_Order_By = {
  position?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "estate_media" */
export type Estate_Media_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Estate_Media_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Estate_Media_Stream_Cursor_Value_Input = {
  estateId?: InputMaybe<Scalars['uuid']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isCensored?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  originalVersionId?: InputMaybe<Scalars['uuid']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  typeId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Estate_Media_Sum_Fields = {
  __typename?: 'estate_media_sum_fields';
  position?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "estate_media" */
export type Estate_Media_Sum_Order_By = {
  position?: InputMaybe<Order_By>;
};

/** columns and relationships of "estate_media_type" */
export type Estate_Media_Type = {
  __typename?: 'estate_media_type';
  group: Estate_Media_Type_Group_Enum;
  hasCensoredVersion: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  name: Estate_Media_Type_Name_Enum;
  needVisitDone: Scalars['Boolean']['output'];
};

/** aggregated selection of "estate_media_type" */
export type Estate_Media_Type_Aggregate = {
  __typename?: 'estate_media_type_aggregate';
  aggregate?: Maybe<Estate_Media_Type_Aggregate_Fields>;
  nodes: Array<Estate_Media_Type>;
};

/** aggregate fields of "estate_media_type" */
export type Estate_Media_Type_Aggregate_Fields = {
  __typename?: 'estate_media_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Estate_Media_Type_Max_Fields>;
  min?: Maybe<Estate_Media_Type_Min_Fields>;
};


/** aggregate fields of "estate_media_type" */
export type Estate_Media_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Estate_Media_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "estate_media_type". All fields are combined with a logical 'AND'. */
export type Estate_Media_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Estate_Media_Type_Bool_Exp>>;
  _not?: InputMaybe<Estate_Media_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Estate_Media_Type_Bool_Exp>>;
  group?: InputMaybe<Estate_Media_Type_Group_Enum_Comparison_Exp>;
  hasCensoredVersion?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<Estate_Media_Type_Name_Enum_Comparison_Exp>;
  needVisitDone?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "estate_media_type" */
export enum Estate_Media_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  EstateMediaTypePkey = 'estate_media_type_pkey'
}

/** columns and relationships of "estate_media_type_group" */
export type Estate_Media_Type_Group = {
  __typename?: 'estate_media_type_group';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "estate_media_type_group" */
export type Estate_Media_Type_Group_Aggregate = {
  __typename?: 'estate_media_type_group_aggregate';
  aggregate?: Maybe<Estate_Media_Type_Group_Aggregate_Fields>;
  nodes: Array<Estate_Media_Type_Group>;
};

/** aggregate fields of "estate_media_type_group" */
export type Estate_Media_Type_Group_Aggregate_Fields = {
  __typename?: 'estate_media_type_group_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Estate_Media_Type_Group_Max_Fields>;
  min?: Maybe<Estate_Media_Type_Group_Min_Fields>;
};


/** aggregate fields of "estate_media_type_group" */
export type Estate_Media_Type_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Estate_Media_Type_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "estate_media_type_group". All fields are combined with a logical 'AND'. */
export type Estate_Media_Type_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Estate_Media_Type_Group_Bool_Exp>>;
  _not?: InputMaybe<Estate_Media_Type_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Estate_Media_Type_Group_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "estate_media_type_group" */
export enum Estate_Media_Type_Group_Constraint {
  /** unique or primary key constraint on columns "value" */
  EstateMediaTypeGroupPkey = 'estate_media_type_group_pkey'
}

export enum Estate_Media_Type_Group_Enum {
  Coownership = 'Coownership',
  Diagnostics = 'Diagnostics',
  Estate = 'Estate',
  Media = 'Media',
  Other = 'Other'
}

/** Boolean expression to compare columns of type "estate_media_type_group_enum". All fields are combined with logical 'AND'. */
export type Estate_Media_Type_Group_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Estate_Media_Type_Group_Enum>;
  _in?: InputMaybe<Array<Estate_Media_Type_Group_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Estate_Media_Type_Group_Enum>;
  _nin?: InputMaybe<Array<Estate_Media_Type_Group_Enum>>;
};

/** input type for inserting data into table "estate_media_type_group" */
export type Estate_Media_Type_Group_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Estate_Media_Type_Group_Max_Fields = {
  __typename?: 'estate_media_type_group_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Estate_Media_Type_Group_Min_Fields = {
  __typename?: 'estate_media_type_group_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "estate_media_type_group" */
export type Estate_Media_Type_Group_Mutation_Response = {
  __typename?: 'estate_media_type_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Estate_Media_Type_Group>;
};

/** on_conflict condition type for table "estate_media_type_group" */
export type Estate_Media_Type_Group_On_Conflict = {
  constraint: Estate_Media_Type_Group_Constraint;
  update_columns?: Array<Estate_Media_Type_Group_Update_Column>;
  where?: InputMaybe<Estate_Media_Type_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "estate_media_type_group". */
export type Estate_Media_Type_Group_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: estate_media_type_group */
export type Estate_Media_Type_Group_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "estate_media_type_group" */
export enum Estate_Media_Type_Group_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "estate_media_type_group" */
export type Estate_Media_Type_Group_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "estate_media_type_group" */
export type Estate_Media_Type_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Estate_Media_Type_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Estate_Media_Type_Group_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "estate_media_type_group" */
export enum Estate_Media_Type_Group_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Estate_Media_Type_Group_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Estate_Media_Type_Group_Set_Input>;
  /** filter the rows which have to be updated */
  where: Estate_Media_Type_Group_Bool_Exp;
};

/** input type for inserting data into table "estate_media_type" */
export type Estate_Media_Type_Insert_Input = {
  group?: InputMaybe<Estate_Media_Type_Group_Enum>;
  hasCensoredVersion?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Estate_Media_Type_Name_Enum>;
  needVisitDone?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Estate_Media_Type_Max_Fields = {
  __typename?: 'estate_media_type_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Estate_Media_Type_Min_Fields = {
  __typename?: 'estate_media_type_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "estate_media_type" */
export type Estate_Media_Type_Mutation_Response = {
  __typename?: 'estate_media_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Estate_Media_Type>;
};

/** columns and relationships of "estate_media_type_name" */
export type Estate_Media_Type_Name = {
  __typename?: 'estate_media_type_name';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "estate_media_type_name" */
export type Estate_Media_Type_Name_Aggregate = {
  __typename?: 'estate_media_type_name_aggregate';
  aggregate?: Maybe<Estate_Media_Type_Name_Aggregate_Fields>;
  nodes: Array<Estate_Media_Type_Name>;
};

/** aggregate fields of "estate_media_type_name" */
export type Estate_Media_Type_Name_Aggregate_Fields = {
  __typename?: 'estate_media_type_name_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Estate_Media_Type_Name_Max_Fields>;
  min?: Maybe<Estate_Media_Type_Name_Min_Fields>;
};


/** aggregate fields of "estate_media_type_name" */
export type Estate_Media_Type_Name_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Estate_Media_Type_Name_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "estate_media_type_name". All fields are combined with a logical 'AND'. */
export type Estate_Media_Type_Name_Bool_Exp = {
  _and?: InputMaybe<Array<Estate_Media_Type_Name_Bool_Exp>>;
  _not?: InputMaybe<Estate_Media_Type_Name_Bool_Exp>;
  _or?: InputMaybe<Array<Estate_Media_Type_Name_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "estate_media_type_name" */
export enum Estate_Media_Type_Name_Constraint {
  /** unique or primary key constraint on columns "value" */
  EstateMediaTypeNamePkey = 'estate_media_type_name_pkey'
}

export enum Estate_Media_Type_Name_Enum {
  AuthenticatedDeed = 'AuthenticatedDeed',
  BuildingMaintenanceLog = 'BuildingMaintenanceLog',
  CadastralPlan = 'CadastralPlan',
  CommonAreaDiagnostics = 'CommonAreaDiagnostics',
  CoownershipEpc = 'CoownershipEPC',
  CoownershipRegulation = 'CoownershipRegulation',
  CoownershipSummarySheet = 'CoownershipSummarySheet',
  DatedPreState = 'DatedPreState',
  DatedState = 'DatedState',
  DraftCompromise = 'DraftCompromise',
  FundCalls = 'FundCalls',
  GeneralMeetingMinutes = 'GeneralMeetingMinutes',
  InsuranceCertificate = 'InsuranceCertificate',
  LotsPlan = 'LotsPlan',
  Other = 'Other',
  Photo = 'Photo',
  Plans = 'Plans',
  PropertyTax = 'PropertyTax',
  ResidenceOrEmptyPropertyTax = 'ResidenceOrEmptyPropertyTax',
  Title = 'Title',
  UrbanismNotice = 'UrbanismNotice',
  Video = 'Video',
  VirtualVisit = 'VirtualVisit'
}

/** Boolean expression to compare columns of type "estate_media_type_name_enum". All fields are combined with logical 'AND'. */
export type Estate_Media_Type_Name_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Estate_Media_Type_Name_Enum>;
  _in?: InputMaybe<Array<Estate_Media_Type_Name_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Estate_Media_Type_Name_Enum>;
  _nin?: InputMaybe<Array<Estate_Media_Type_Name_Enum>>;
};

/** input type for inserting data into table "estate_media_type_name" */
export type Estate_Media_Type_Name_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Estate_Media_Type_Name_Max_Fields = {
  __typename?: 'estate_media_type_name_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Estate_Media_Type_Name_Min_Fields = {
  __typename?: 'estate_media_type_name_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "estate_media_type_name" */
export type Estate_Media_Type_Name_Mutation_Response = {
  __typename?: 'estate_media_type_name_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Estate_Media_Type_Name>;
};

/** on_conflict condition type for table "estate_media_type_name" */
export type Estate_Media_Type_Name_On_Conflict = {
  constraint: Estate_Media_Type_Name_Constraint;
  update_columns?: Array<Estate_Media_Type_Name_Update_Column>;
  where?: InputMaybe<Estate_Media_Type_Name_Bool_Exp>;
};

/** Ordering options when selecting data from "estate_media_type_name". */
export type Estate_Media_Type_Name_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: estate_media_type_name */
export type Estate_Media_Type_Name_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "estate_media_type_name" */
export enum Estate_Media_Type_Name_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "estate_media_type_name" */
export type Estate_Media_Type_Name_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "estate_media_type_name" */
export type Estate_Media_Type_Name_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Estate_Media_Type_Name_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Estate_Media_Type_Name_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "estate_media_type_name" */
export enum Estate_Media_Type_Name_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Estate_Media_Type_Name_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Estate_Media_Type_Name_Set_Input>;
  /** filter the rows which have to be updated */
  where: Estate_Media_Type_Name_Bool_Exp;
};

/** input type for inserting object relation for remote table "estate_media_type" */
export type Estate_Media_Type_Obj_Rel_Insert_Input = {
  data: Estate_Media_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Estate_Media_Type_On_Conflict>;
};

/** on_conflict condition type for table "estate_media_type" */
export type Estate_Media_Type_On_Conflict = {
  constraint: Estate_Media_Type_Constraint;
  update_columns?: Array<Estate_Media_Type_Update_Column>;
  where?: InputMaybe<Estate_Media_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "estate_media_type". */
export type Estate_Media_Type_Order_By = {
  group?: InputMaybe<Order_By>;
  hasCensoredVersion?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  needVisitDone?: InputMaybe<Order_By>;
};

/** primary key columns input for table: estate_media_type */
export type Estate_Media_Type_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "estate_media_type" */
export enum Estate_Media_Type_Select_Column {
  /** column name */
  Group = 'group',
  /** column name */
  HasCensoredVersion = 'hasCensoredVersion',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NeedVisitDone = 'needVisitDone'
}

/** input type for updating data in table "estate_media_type" */
export type Estate_Media_Type_Set_Input = {
  group?: InputMaybe<Estate_Media_Type_Group_Enum>;
  hasCensoredVersion?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Estate_Media_Type_Name_Enum>;
  needVisitDone?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "estate_media_type" */
export type Estate_Media_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Estate_Media_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Estate_Media_Type_Stream_Cursor_Value_Input = {
  group?: InputMaybe<Estate_Media_Type_Group_Enum>;
  hasCensoredVersion?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Estate_Media_Type_Name_Enum>;
  needVisitDone?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "estate_media_type" */
export enum Estate_Media_Type_Update_Column {
  /** column name */
  Group = 'group',
  /** column name */
  HasCensoredVersion = 'hasCensoredVersion',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NeedVisitDone = 'needVisitDone'
}

export type Estate_Media_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Estate_Media_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Estate_Media_Type_Bool_Exp;
};

/** update columns of table "estate_media" */
export enum Estate_Media_Update_Column {
  /** column name */
  EstateId = 'estateId',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Id = 'id',
  /** column name */
  IsCensored = 'isCensored',
  /** column name */
  Name = 'name',
  /** column name */
  OriginalVersionId = 'originalVersionId',
  /** column name */
  Position = 'position',
  /** column name */
  TypeId = 'typeId'
}

export type Estate_Media_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Estate_Media_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Estate_Media_Set_Input>;
  /** filter the rows which have to be updated */
  where: Estate_Media_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Estate_Media_Var_Pop_Fields = {
  __typename?: 'estate_media_var_pop_fields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "estate_media" */
export type Estate_Media_Var_Pop_Order_By = {
  position?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Estate_Media_Var_Samp_Fields = {
  __typename?: 'estate_media_var_samp_fields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "estate_media" */
export type Estate_Media_Var_Samp_Order_By = {
  position?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Estate_Media_Variance_Fields = {
  __typename?: 'estate_media_variance_fields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "estate_media" */
export type Estate_Media_Variance_Order_By = {
  position?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Estate_Min_Fields = {
  __typename?: 'estate_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  applicationAcceptedDate?: Maybe<Scalars['timestamptz']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  /** Current round based on round number. There should alway be a current round (as one is created right away) */
  currentRoundId?: Maybe<Scalars['uuid']['output']>;
  endEstimate?: Maybe<Scalars['Int']['output']>;
  estimationAskedBySellerMemberId?: Maybe<Scalars['uuid']['output']>;
  estimationAskedDate?: Maybe<Scalars['timestamptz']['output']>;
  estimationPublishedDate?: Maybe<Scalars['timestamptz']['output']>;
  firstPrice?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  /** The number of visit per slot */
  maxVisitPerSlot?: Maybe<Scalars['numeric']['output']>;
  missionHeadId?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  publicLatitude?: Maybe<Scalars['numeric']['output']>;
  publicLongitude?: Maybe<Scalars['numeric']['output']>;
  publicationDescription?: Maybe<Scalars['String']['output']>;
  publicationMention?: Maybe<Scalars['String']['output']>;
  publicationTitle?: Maybe<Scalars['String']['output']>;
  reservePrice?: Maybe<Scalars['Int']['output']>;
  sellerId?: Maybe<Scalars['uuid']['output']>;
  startEstimate?: Maybe<Scalars['Int']['output']>;
  /** The duration of a visit, used to sub-divide VisitSpans in slots, in minutes */
  visitSlotDuration?: Maybe<Scalars['numeric']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "estate" */
export type Estate_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  applicationAcceptedDate?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  endEstimate?: InputMaybe<Order_By>;
  estimationAskedBySellerMemberId?: InputMaybe<Order_By>;
  estimationAskedDate?: InputMaybe<Order_By>;
  estimationPublishedDate?: InputMaybe<Order_By>;
  firstPrice?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  /** The number of visit per slot */
  maxVisitPerSlot?: InputMaybe<Order_By>;
  missionHeadId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  publicLatitude?: InputMaybe<Order_By>;
  publicLongitude?: InputMaybe<Order_By>;
  publicationDescription?: InputMaybe<Order_By>;
  publicationMention?: InputMaybe<Order_By>;
  publicationTitle?: InputMaybe<Order_By>;
  reservePrice?: InputMaybe<Order_By>;
  sellerId?: InputMaybe<Order_By>;
  startEstimate?: InputMaybe<Order_By>;
  /** The duration of a visit, used to sub-divide VisitSpans in slots, in minutes */
  visitSlotDuration?: InputMaybe<Order_By>;
  zipCode?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "estate" */
export type Estate_Mutation_Response = {
  __typename?: 'estate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Estate>;
};

/** input type for inserting object relation for remote table "estate" */
export type Estate_Obj_Rel_Insert_Input = {
  data: Estate_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Estate_On_Conflict>;
};

/** on_conflict condition type for table "estate" */
export type Estate_On_Conflict = {
  constraint: Estate_Constraint;
  update_columns?: Array<Estate_Update_Column>;
  where?: InputMaybe<Estate_Bool_Exp>;
};

/** Ordering options when selecting data from "estate". */
export type Estate_Order_By = {
  address?: InputMaybe<Order_By>;
  applicationAcceptedDate?: InputMaybe<Order_By>;
  applications_aggregate?: InputMaybe<Application_Aggregate_Order_By>;
  archived?: InputMaybe<Order_By>;
  canConnectedBuyerSeeAddress?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  coownership?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentRoundId?: InputMaybe<Order_By>;
  diagnosticsData?: InputMaybe<Order_By>;
  endEstimate?: InputMaybe<Order_By>;
  estateRounds_aggregate?: InputMaybe<Estate_Round_Aggregate_Order_By>;
  estate_links_aggregate?: InputMaybe<Estate_Link_Aggregate_Order_By>;
  estate_media_aggregate?: InputMaybe<Estate_Media_Aggregate_Order_By>;
  estate_sellers_aggregate?: InputMaybe<Estate_Seller_Aggregate_Order_By>;
  estate_type?: InputMaybe<Estate_Type_Order_By>;
  estimationAskedBy?: InputMaybe<Seller_Member_Order_By>;
  estimationAskedBySellerMemberId?: InputMaybe<Order_By>;
  estimationAskedDate?: InputMaybe<Order_By>;
  estimationPublishedDate?: InputMaybe<Order_By>;
  features?: InputMaybe<Order_By>;
  firstPrice?: InputMaybe<Order_By>;
  flags?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isPublished?: InputMaybe<Order_By>;
  isSaleOpen?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  mandate?: InputMaybe<Mandate_Order_By>;
  maxVisitPerSlot?: InputMaybe<Order_By>;
  missionHeadId?: InputMaybe<Order_By>;
  mission_head?: InputMaybe<Agency_Member_Order_By>;
  name?: InputMaybe<Order_By>;
  publicLatitude?: InputMaybe<Order_By>;
  publicLongitude?: InputMaybe<Order_By>;
  publicationDescription?: InputMaybe<Order_By>;
  publicationMention?: InputMaybe<Order_By>;
  publicationTitle?: InputMaybe<Order_By>;
  reservePrice?: InputMaybe<Order_By>;
  seller?: InputMaybe<Seller_Order_By>;
  sellerData?: InputMaybe<Order_By>;
  sellerId?: InputMaybe<Order_By>;
  servicesAndConditions?: InputMaybe<Order_By>;
  startEstimate?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  virtualVisits?: InputMaybe<Order_By>;
  visitSlotDuration?: InputMaybe<Order_By>;
  visit_spans_aggregate?: InputMaybe<Visit_Span_Aggregate_Order_By>;
  visits_aggregate?: InputMaybe<Visit_Aggregate_Order_By>;
  zipCode?: InputMaybe<Order_By>;
};

/** primary key columns input for table: estate */
export type Estate_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Estate_Prepend_Input = {
  coownership?: InputMaybe<Scalars['jsonb']['input']>;
  diagnosticsData?: InputMaybe<Scalars['jsonb']['input']>;
  features?: InputMaybe<Scalars['jsonb']['input']>;
  flags?: InputMaybe<Scalars['jsonb']['input']>;
  sellerData?: InputMaybe<Scalars['jsonb']['input']>;
  servicesAndConditions?: InputMaybe<Scalars['jsonb']['input']>;
  virtualVisits?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "estate_round" */
export type Estate_Round = {
  __typename?: 'estate_round';
  closingEmailSent: Scalars['Boolean']['output'];
  createdAt: Scalars['timestamptz']['output'];
  endDate: Scalars['timestamptz']['output'];
  /** An object relationship */
  estate: Estate;
  estateId: Scalars['uuid']['output'];
  /** An array relationship */
  estateRoundBuyerMembers: Array<Estate_Round_Buyer_Member>;
  /** An aggregate relationship */
  estateRoundBuyerMembers_aggregate: Estate_Round_Buyer_Member_Aggregate;
  id: Scalars['uuid']['output'];
  isPublic: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  opt_blindRound: Scalars['Boolean']['output'];
  opt_enforceOfferGap: Scalars['Boolean']['output'];
  opt_minOfferGap?: Maybe<Scalars['numeric']['output']>;
  startDate: Scalars['timestamptz']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "estate_round" */
export type Estate_RoundEstateRoundBuyerMembersArgs = {
  distinct_on?: InputMaybe<Array<Estate_Round_Buyer_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Round_Buyer_Member_Order_By>>;
  where?: InputMaybe<Estate_Round_Buyer_Member_Bool_Exp>;
};


/** columns and relationships of "estate_round" */
export type Estate_RoundEstateRoundBuyerMembers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Round_Buyer_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Round_Buyer_Member_Order_By>>;
  where?: InputMaybe<Estate_Round_Buyer_Member_Bool_Exp>;
};

/** aggregated selection of "estate_round" */
export type Estate_Round_Aggregate = {
  __typename?: 'estate_round_aggregate';
  aggregate?: Maybe<Estate_Round_Aggregate_Fields>;
  nodes: Array<Estate_Round>;
};

export type Estate_Round_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Estate_Round_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Estate_Round_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Estate_Round_Aggregate_Bool_Exp_Count>;
};

export type Estate_Round_Aggregate_Bool_Exp_Bool_And = {
  arguments: Estate_Round_Select_Column_Estate_Round_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Estate_Round_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Estate_Round_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Estate_Round_Select_Column_Estate_Round_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Estate_Round_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Estate_Round_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Estate_Round_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Estate_Round_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "estate_round" */
export type Estate_Round_Aggregate_Fields = {
  __typename?: 'estate_round_aggregate_fields';
  avg?: Maybe<Estate_Round_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Estate_Round_Max_Fields>;
  min?: Maybe<Estate_Round_Min_Fields>;
  stddev?: Maybe<Estate_Round_Stddev_Fields>;
  stddev_pop?: Maybe<Estate_Round_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Estate_Round_Stddev_Samp_Fields>;
  sum?: Maybe<Estate_Round_Sum_Fields>;
  var_pop?: Maybe<Estate_Round_Var_Pop_Fields>;
  var_samp?: Maybe<Estate_Round_Var_Samp_Fields>;
  variance?: Maybe<Estate_Round_Variance_Fields>;
};


/** aggregate fields of "estate_round" */
export type Estate_Round_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Estate_Round_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "estate_round" */
export type Estate_Round_Aggregate_Order_By = {
  avg?: InputMaybe<Estate_Round_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Estate_Round_Max_Order_By>;
  min?: InputMaybe<Estate_Round_Min_Order_By>;
  stddev?: InputMaybe<Estate_Round_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Estate_Round_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Estate_Round_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Estate_Round_Sum_Order_By>;
  var_pop?: InputMaybe<Estate_Round_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Estate_Round_Var_Samp_Order_By>;
  variance?: InputMaybe<Estate_Round_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "estate_round" */
export type Estate_Round_Arr_Rel_Insert_Input = {
  data: Array<Estate_Round_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Estate_Round_On_Conflict>;
};

/** aggregate avg on columns */
export type Estate_Round_Avg_Fields = {
  __typename?: 'estate_round_avg_fields';
  number?: Maybe<Scalars['Float']['output']>;
  opt_minOfferGap?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "estate_round" */
export type Estate_Round_Avg_Order_By = {
  number?: InputMaybe<Order_By>;
  opt_minOfferGap?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "estate_round". All fields are combined with a logical 'AND'. */
export type Estate_Round_Bool_Exp = {
  _and?: InputMaybe<Array<Estate_Round_Bool_Exp>>;
  _not?: InputMaybe<Estate_Round_Bool_Exp>;
  _or?: InputMaybe<Array<Estate_Round_Bool_Exp>>;
  closingEmailSent?: InputMaybe<Boolean_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  endDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  estate?: InputMaybe<Estate_Bool_Exp>;
  estateId?: InputMaybe<Uuid_Comparison_Exp>;
  estateRoundBuyerMembers?: InputMaybe<Estate_Round_Buyer_Member_Bool_Exp>;
  estateRoundBuyerMembers_aggregate?: InputMaybe<Estate_Round_Buyer_Member_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isPublic?: InputMaybe<Boolean_Comparison_Exp>;
  number?: InputMaybe<Int_Comparison_Exp>;
  opt_blindRound?: InputMaybe<Boolean_Comparison_Exp>;
  opt_enforceOfferGap?: InputMaybe<Boolean_Comparison_Exp>;
  opt_minOfferGap?: InputMaybe<Numeric_Comparison_Exp>;
  startDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "estate_round_buyer_member" */
export type Estate_Round_Buyer_Member = {
  __typename?: 'estate_round_buyer_member';
  /** An object relationship */
  buyerMember: Buyer_Member;
  buyerMemberId: Scalars['uuid']['output'];
  /** An object relationship */
  estateRound: Estate_Round;
  estateRoundId: Scalars['uuid']['output'];
};

/** aggregated selection of "estate_round_buyer_member" */
export type Estate_Round_Buyer_Member_Aggregate = {
  __typename?: 'estate_round_buyer_member_aggregate';
  aggregate?: Maybe<Estate_Round_Buyer_Member_Aggregate_Fields>;
  nodes: Array<Estate_Round_Buyer_Member>;
};

export type Estate_Round_Buyer_Member_Aggregate_Bool_Exp = {
  count?: InputMaybe<Estate_Round_Buyer_Member_Aggregate_Bool_Exp_Count>;
};

export type Estate_Round_Buyer_Member_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Estate_Round_Buyer_Member_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Estate_Round_Buyer_Member_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "estate_round_buyer_member" */
export type Estate_Round_Buyer_Member_Aggregate_Fields = {
  __typename?: 'estate_round_buyer_member_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Estate_Round_Buyer_Member_Max_Fields>;
  min?: Maybe<Estate_Round_Buyer_Member_Min_Fields>;
};


/** aggregate fields of "estate_round_buyer_member" */
export type Estate_Round_Buyer_Member_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Estate_Round_Buyer_Member_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "estate_round_buyer_member" */
export type Estate_Round_Buyer_Member_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Estate_Round_Buyer_Member_Max_Order_By>;
  min?: InputMaybe<Estate_Round_Buyer_Member_Min_Order_By>;
};

/** input type for inserting array relation for remote table "estate_round_buyer_member" */
export type Estate_Round_Buyer_Member_Arr_Rel_Insert_Input = {
  data: Array<Estate_Round_Buyer_Member_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Estate_Round_Buyer_Member_On_Conflict>;
};

/** Boolean expression to filter rows from the table "estate_round_buyer_member". All fields are combined with a logical 'AND'. */
export type Estate_Round_Buyer_Member_Bool_Exp = {
  _and?: InputMaybe<Array<Estate_Round_Buyer_Member_Bool_Exp>>;
  _not?: InputMaybe<Estate_Round_Buyer_Member_Bool_Exp>;
  _or?: InputMaybe<Array<Estate_Round_Buyer_Member_Bool_Exp>>;
  buyerMember?: InputMaybe<Buyer_Member_Bool_Exp>;
  buyerMemberId?: InputMaybe<Uuid_Comparison_Exp>;
  estateRound?: InputMaybe<Estate_Round_Bool_Exp>;
  estateRoundId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "estate_round_buyer_member" */
export enum Estate_Round_Buyer_Member_Constraint {
  /** unique or primary key constraint on columns "buyerMemberId", "estateRoundId" */
  EstateRoundBuyerMemberPkey = 'estate_round_buyer_member_pkey'
}

/** input type for inserting data into table "estate_round_buyer_member" */
export type Estate_Round_Buyer_Member_Insert_Input = {
  buyerMember?: InputMaybe<Buyer_Member_Obj_Rel_Insert_Input>;
  buyerMemberId?: InputMaybe<Scalars['uuid']['input']>;
  estateRound?: InputMaybe<Estate_Round_Obj_Rel_Insert_Input>;
  estateRoundId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Estate_Round_Buyer_Member_Max_Fields = {
  __typename?: 'estate_round_buyer_member_max_fields';
  buyerMemberId?: Maybe<Scalars['uuid']['output']>;
  estateRoundId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "estate_round_buyer_member" */
export type Estate_Round_Buyer_Member_Max_Order_By = {
  buyerMemberId?: InputMaybe<Order_By>;
  estateRoundId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Estate_Round_Buyer_Member_Min_Fields = {
  __typename?: 'estate_round_buyer_member_min_fields';
  buyerMemberId?: Maybe<Scalars['uuid']['output']>;
  estateRoundId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "estate_round_buyer_member" */
export type Estate_Round_Buyer_Member_Min_Order_By = {
  buyerMemberId?: InputMaybe<Order_By>;
  estateRoundId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "estate_round_buyer_member" */
export type Estate_Round_Buyer_Member_Mutation_Response = {
  __typename?: 'estate_round_buyer_member_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Estate_Round_Buyer_Member>;
};

/** on_conflict condition type for table "estate_round_buyer_member" */
export type Estate_Round_Buyer_Member_On_Conflict = {
  constraint: Estate_Round_Buyer_Member_Constraint;
  update_columns?: Array<Estate_Round_Buyer_Member_Update_Column>;
  where?: InputMaybe<Estate_Round_Buyer_Member_Bool_Exp>;
};

/** Ordering options when selecting data from "estate_round_buyer_member". */
export type Estate_Round_Buyer_Member_Order_By = {
  buyerMember?: InputMaybe<Buyer_Member_Order_By>;
  buyerMemberId?: InputMaybe<Order_By>;
  estateRound?: InputMaybe<Estate_Round_Order_By>;
  estateRoundId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: estate_round_buyer_member */
export type Estate_Round_Buyer_Member_Pk_Columns_Input = {
  buyerMemberId: Scalars['uuid']['input'];
  estateRoundId: Scalars['uuid']['input'];
};

/** select columns of table "estate_round_buyer_member" */
export enum Estate_Round_Buyer_Member_Select_Column {
  /** column name */
  BuyerMemberId = 'buyerMemberId',
  /** column name */
  EstateRoundId = 'estateRoundId'
}

/** input type for updating data in table "estate_round_buyer_member" */
export type Estate_Round_Buyer_Member_Set_Input = {
  buyerMemberId?: InputMaybe<Scalars['uuid']['input']>;
  estateRoundId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "estate_round_buyer_member" */
export type Estate_Round_Buyer_Member_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Estate_Round_Buyer_Member_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Estate_Round_Buyer_Member_Stream_Cursor_Value_Input = {
  buyerMemberId?: InputMaybe<Scalars['uuid']['input']>;
  estateRoundId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "estate_round_buyer_member" */
export enum Estate_Round_Buyer_Member_Update_Column {
  /** column name */
  BuyerMemberId = 'buyerMemberId',
  /** column name */
  EstateRoundId = 'estateRoundId'
}

export type Estate_Round_Buyer_Member_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Estate_Round_Buyer_Member_Set_Input>;
  /** filter the rows which have to be updated */
  where: Estate_Round_Buyer_Member_Bool_Exp;
};

/** unique or primary key constraints on table "estate_round" */
export enum Estate_Round_Constraint {
  /** unique or primary key constraint on columns "id" */
  EstateRoundPkey = 'estate_round_pkey'
}

/** input type for incrementing numeric columns in table "estate_round" */
export type Estate_Round_Inc_Input = {
  number?: InputMaybe<Scalars['Int']['input']>;
  opt_minOfferGap?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "estate_round" */
export type Estate_Round_Insert_Input = {
  closingEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  estate?: InputMaybe<Estate_Obj_Rel_Insert_Input>;
  estateId?: InputMaybe<Scalars['uuid']['input']>;
  estateRoundBuyerMembers?: InputMaybe<Estate_Round_Buyer_Member_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  opt_blindRound?: InputMaybe<Scalars['Boolean']['input']>;
  opt_enforceOfferGap?: InputMaybe<Scalars['Boolean']['input']>;
  opt_minOfferGap?: InputMaybe<Scalars['numeric']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Estate_Round_Max_Fields = {
  __typename?: 'estate_round_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  endDate?: Maybe<Scalars['timestamptz']['output']>;
  estateId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  opt_minOfferGap?: Maybe<Scalars['numeric']['output']>;
  startDate?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "estate_round" */
export type Estate_Round_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  endDate?: InputMaybe<Order_By>;
  estateId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  opt_minOfferGap?: InputMaybe<Order_By>;
  startDate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Estate_Round_Min_Fields = {
  __typename?: 'estate_round_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  endDate?: Maybe<Scalars['timestamptz']['output']>;
  estateId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  opt_minOfferGap?: Maybe<Scalars['numeric']['output']>;
  startDate?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "estate_round" */
export type Estate_Round_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  endDate?: InputMaybe<Order_By>;
  estateId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  opt_minOfferGap?: InputMaybe<Order_By>;
  startDate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "estate_round" */
export type Estate_Round_Mutation_Response = {
  __typename?: 'estate_round_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Estate_Round>;
};

/** input type for inserting object relation for remote table "estate_round" */
export type Estate_Round_Obj_Rel_Insert_Input = {
  data: Estate_Round_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Estate_Round_On_Conflict>;
};

/** on_conflict condition type for table "estate_round" */
export type Estate_Round_On_Conflict = {
  constraint: Estate_Round_Constraint;
  update_columns?: Array<Estate_Round_Update_Column>;
  where?: InputMaybe<Estate_Round_Bool_Exp>;
};

/** Ordering options when selecting data from "estate_round". */
export type Estate_Round_Order_By = {
  closingEmailSent?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  endDate?: InputMaybe<Order_By>;
  estate?: InputMaybe<Estate_Order_By>;
  estateId?: InputMaybe<Order_By>;
  estateRoundBuyerMembers_aggregate?: InputMaybe<Estate_Round_Buyer_Member_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  isPublic?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  opt_blindRound?: InputMaybe<Order_By>;
  opt_enforceOfferGap?: InputMaybe<Order_By>;
  opt_minOfferGap?: InputMaybe<Order_By>;
  startDate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: estate_round */
export type Estate_Round_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "estate_round" */
export enum Estate_Round_Select_Column {
  /** column name */
  ClosingEmailSent = 'closingEmailSent',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  EstateId = 'estateId',
  /** column name */
  Id = 'id',
  /** column name */
  IsPublic = 'isPublic',
  /** column name */
  Number = 'number',
  /** column name */
  OptBlindRound = 'opt_blindRound',
  /** column name */
  OptEnforceOfferGap = 'opt_enforceOfferGap',
  /** column name */
  OptMinOfferGap = 'opt_minOfferGap',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "estate_round_aggregate_bool_exp_bool_and_arguments_columns" columns of table "estate_round" */
export enum Estate_Round_Select_Column_Estate_Round_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ClosingEmailSent = 'closingEmailSent',
  /** column name */
  IsPublic = 'isPublic',
  /** column name */
  OptBlindRound = 'opt_blindRound',
  /** column name */
  OptEnforceOfferGap = 'opt_enforceOfferGap'
}

/** select "estate_round_aggregate_bool_exp_bool_or_arguments_columns" columns of table "estate_round" */
export enum Estate_Round_Select_Column_Estate_Round_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ClosingEmailSent = 'closingEmailSent',
  /** column name */
  IsPublic = 'isPublic',
  /** column name */
  OptBlindRound = 'opt_blindRound',
  /** column name */
  OptEnforceOfferGap = 'opt_enforceOfferGap'
}

/** input type for updating data in table "estate_round" */
export type Estate_Round_Set_Input = {
  closingEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  estateId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  opt_blindRound?: InputMaybe<Scalars['Boolean']['input']>;
  opt_enforceOfferGap?: InputMaybe<Scalars['Boolean']['input']>;
  opt_minOfferGap?: InputMaybe<Scalars['numeric']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Estate_Round_Stddev_Fields = {
  __typename?: 'estate_round_stddev_fields';
  number?: Maybe<Scalars['Float']['output']>;
  opt_minOfferGap?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "estate_round" */
export type Estate_Round_Stddev_Order_By = {
  number?: InputMaybe<Order_By>;
  opt_minOfferGap?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Estate_Round_Stddev_Pop_Fields = {
  __typename?: 'estate_round_stddev_pop_fields';
  number?: Maybe<Scalars['Float']['output']>;
  opt_minOfferGap?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "estate_round" */
export type Estate_Round_Stddev_Pop_Order_By = {
  number?: InputMaybe<Order_By>;
  opt_minOfferGap?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Estate_Round_Stddev_Samp_Fields = {
  __typename?: 'estate_round_stddev_samp_fields';
  number?: Maybe<Scalars['Float']['output']>;
  opt_minOfferGap?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "estate_round" */
export type Estate_Round_Stddev_Samp_Order_By = {
  number?: InputMaybe<Order_By>;
  opt_minOfferGap?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "estate_round" */
export type Estate_Round_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Estate_Round_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Estate_Round_Stream_Cursor_Value_Input = {
  closingEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  estateId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  opt_blindRound?: InputMaybe<Scalars['Boolean']['input']>;
  opt_enforceOfferGap?: InputMaybe<Scalars['Boolean']['input']>;
  opt_minOfferGap?: InputMaybe<Scalars['numeric']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Estate_Round_Sum_Fields = {
  __typename?: 'estate_round_sum_fields';
  number?: Maybe<Scalars['Int']['output']>;
  opt_minOfferGap?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "estate_round" */
export type Estate_Round_Sum_Order_By = {
  number?: InputMaybe<Order_By>;
  opt_minOfferGap?: InputMaybe<Order_By>;
};

/** update columns of table "estate_round" */
export enum Estate_Round_Update_Column {
  /** column name */
  ClosingEmailSent = 'closingEmailSent',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  EstateId = 'estateId',
  /** column name */
  Id = 'id',
  /** column name */
  IsPublic = 'isPublic',
  /** column name */
  Number = 'number',
  /** column name */
  OptBlindRound = 'opt_blindRound',
  /** column name */
  OptEnforceOfferGap = 'opt_enforceOfferGap',
  /** column name */
  OptMinOfferGap = 'opt_minOfferGap',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Estate_Round_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Estate_Round_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Estate_Round_Set_Input>;
  /** filter the rows which have to be updated */
  where: Estate_Round_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Estate_Round_Var_Pop_Fields = {
  __typename?: 'estate_round_var_pop_fields';
  number?: Maybe<Scalars['Float']['output']>;
  opt_minOfferGap?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "estate_round" */
export type Estate_Round_Var_Pop_Order_By = {
  number?: InputMaybe<Order_By>;
  opt_minOfferGap?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Estate_Round_Var_Samp_Fields = {
  __typename?: 'estate_round_var_samp_fields';
  number?: Maybe<Scalars['Float']['output']>;
  opt_minOfferGap?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "estate_round" */
export type Estate_Round_Var_Samp_Order_By = {
  number?: InputMaybe<Order_By>;
  opt_minOfferGap?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Estate_Round_Variance_Fields = {
  __typename?: 'estate_round_variance_fields';
  number?: Maybe<Scalars['Float']['output']>;
  opt_minOfferGap?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "estate_round" */
export type Estate_Round_Variance_Order_By = {
  number?: InputMaybe<Order_By>;
  opt_minOfferGap?: InputMaybe<Order_By>;
};

/** select columns of table "estate" */
export enum Estate_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  ApplicationAcceptedDate = 'applicationAcceptedDate',
  /** column name */
  Archived = 'archived',
  /** column name */
  CanConnectedBuyerSeeAddress = 'canConnectedBuyerSeeAddress',
  /** column name */
  City = 'city',
  /** column name */
  Coownership = 'coownership',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DiagnosticsData = 'diagnosticsData',
  /** column name */
  EndEstimate = 'endEstimate',
  /** column name */
  EstimationAskedBySellerMemberId = 'estimationAskedBySellerMemberId',
  /** column name */
  EstimationAskedDate = 'estimationAskedDate',
  /** column name */
  EstimationPublishedDate = 'estimationPublishedDate',
  /** column name */
  Features = 'features',
  /** column name */
  FirstPrice = 'firstPrice',
  /** column name */
  Flags = 'flags',
  /** column name */
  Id = 'id',
  /** column name */
  IsPublished = 'isPublished',
  /** column name */
  IsSaleOpen = 'isSaleOpen',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  MaxVisitPerSlot = 'maxVisitPerSlot',
  /** column name */
  MissionHeadId = 'missionHeadId',
  /** column name */
  Name = 'name',
  /** column name */
  PublicLatitude = 'publicLatitude',
  /** column name */
  PublicLongitude = 'publicLongitude',
  /** column name */
  PublicationDescription = 'publicationDescription',
  /** column name */
  PublicationMention = 'publicationMention',
  /** column name */
  PublicationTitle = 'publicationTitle',
  /** column name */
  ReservePrice = 'reservePrice',
  /** column name */
  SellerData = 'sellerData',
  /** column name */
  SellerId = 'sellerId',
  /** column name */
  ServicesAndConditions = 'servicesAndConditions',
  /** column name */
  StartEstimate = 'startEstimate',
  /** column name */
  Type = 'type',
  /** column name */
  VirtualVisits = 'virtualVisits',
  /** column name */
  VisitSlotDuration = 'visitSlotDuration',
  /** column name */
  ZipCode = 'zipCode'
}

/** select "estate_aggregate_bool_exp_bool_and_arguments_columns" columns of table "estate" */
export enum Estate_Select_Column_Estate_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Archived = 'archived',
  /** column name */
  CanConnectedBuyerSeeAddress = 'canConnectedBuyerSeeAddress',
  /** column name */
  IsPublished = 'isPublished',
  /** column name */
  IsSaleOpen = 'isSaleOpen'
}

/** select "estate_aggregate_bool_exp_bool_or_arguments_columns" columns of table "estate" */
export enum Estate_Select_Column_Estate_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Archived = 'archived',
  /** column name */
  CanConnectedBuyerSeeAddress = 'canConnectedBuyerSeeAddress',
  /** column name */
  IsPublished = 'isPublished',
  /** column name */
  IsSaleOpen = 'isSaleOpen'
}

/** columns and relationships of "estate_seller" */
export type Estate_Seller = {
  __typename?: 'estate_seller';
  /** An object relationship */
  estate: Estate;
  estateId: Scalars['uuid']['output'];
  ownershipShare: Scalars['numeric']['output'];
  /** An object relationship */
  seller: Seller;
  sellerId: Scalars['uuid']['output'];
};

/** aggregated selection of "estate_seller" */
export type Estate_Seller_Aggregate = {
  __typename?: 'estate_seller_aggregate';
  aggregate?: Maybe<Estate_Seller_Aggregate_Fields>;
  nodes: Array<Estate_Seller>;
};

export type Estate_Seller_Aggregate_Bool_Exp = {
  count?: InputMaybe<Estate_Seller_Aggregate_Bool_Exp_Count>;
};

export type Estate_Seller_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Estate_Seller_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Estate_Seller_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "estate_seller" */
export type Estate_Seller_Aggregate_Fields = {
  __typename?: 'estate_seller_aggregate_fields';
  avg?: Maybe<Estate_Seller_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Estate_Seller_Max_Fields>;
  min?: Maybe<Estate_Seller_Min_Fields>;
  stddev?: Maybe<Estate_Seller_Stddev_Fields>;
  stddev_pop?: Maybe<Estate_Seller_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Estate_Seller_Stddev_Samp_Fields>;
  sum?: Maybe<Estate_Seller_Sum_Fields>;
  var_pop?: Maybe<Estate_Seller_Var_Pop_Fields>;
  var_samp?: Maybe<Estate_Seller_Var_Samp_Fields>;
  variance?: Maybe<Estate_Seller_Variance_Fields>;
};


/** aggregate fields of "estate_seller" */
export type Estate_Seller_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Estate_Seller_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "estate_seller" */
export type Estate_Seller_Aggregate_Order_By = {
  avg?: InputMaybe<Estate_Seller_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Estate_Seller_Max_Order_By>;
  min?: InputMaybe<Estate_Seller_Min_Order_By>;
  stddev?: InputMaybe<Estate_Seller_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Estate_Seller_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Estate_Seller_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Estate_Seller_Sum_Order_By>;
  var_pop?: InputMaybe<Estate_Seller_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Estate_Seller_Var_Samp_Order_By>;
  variance?: InputMaybe<Estate_Seller_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "estate_seller" */
export type Estate_Seller_Arr_Rel_Insert_Input = {
  data: Array<Estate_Seller_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Estate_Seller_On_Conflict>;
};

/** aggregate avg on columns */
export type Estate_Seller_Avg_Fields = {
  __typename?: 'estate_seller_avg_fields';
  ownershipShare?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "estate_seller" */
export type Estate_Seller_Avg_Order_By = {
  ownershipShare?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "estate_seller". All fields are combined with a logical 'AND'. */
export type Estate_Seller_Bool_Exp = {
  _and?: InputMaybe<Array<Estate_Seller_Bool_Exp>>;
  _not?: InputMaybe<Estate_Seller_Bool_Exp>;
  _or?: InputMaybe<Array<Estate_Seller_Bool_Exp>>;
  estate?: InputMaybe<Estate_Bool_Exp>;
  estateId?: InputMaybe<Uuid_Comparison_Exp>;
  ownershipShare?: InputMaybe<Numeric_Comparison_Exp>;
  seller?: InputMaybe<Seller_Bool_Exp>;
  sellerId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "estate_seller" */
export enum Estate_Seller_Constraint {
  /** unique or primary key constraint on columns "estateId", "sellerId" */
  EstateSellerPkey = 'estate_seller_pkey'
}

/** input type for incrementing numeric columns in table "estate_seller" */
export type Estate_Seller_Inc_Input = {
  ownershipShare?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "estate_seller" */
export type Estate_Seller_Insert_Input = {
  estate?: InputMaybe<Estate_Obj_Rel_Insert_Input>;
  estateId?: InputMaybe<Scalars['uuid']['input']>;
  ownershipShare?: InputMaybe<Scalars['numeric']['input']>;
  seller?: InputMaybe<Seller_Obj_Rel_Insert_Input>;
  sellerId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Estate_Seller_Max_Fields = {
  __typename?: 'estate_seller_max_fields';
  estateId?: Maybe<Scalars['uuid']['output']>;
  ownershipShare?: Maybe<Scalars['numeric']['output']>;
  sellerId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "estate_seller" */
export type Estate_Seller_Max_Order_By = {
  estateId?: InputMaybe<Order_By>;
  ownershipShare?: InputMaybe<Order_By>;
  sellerId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Estate_Seller_Min_Fields = {
  __typename?: 'estate_seller_min_fields';
  estateId?: Maybe<Scalars['uuid']['output']>;
  ownershipShare?: Maybe<Scalars['numeric']['output']>;
  sellerId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "estate_seller" */
export type Estate_Seller_Min_Order_By = {
  estateId?: InputMaybe<Order_By>;
  ownershipShare?: InputMaybe<Order_By>;
  sellerId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "estate_seller" */
export type Estate_Seller_Mutation_Response = {
  __typename?: 'estate_seller_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Estate_Seller>;
};

/** on_conflict condition type for table "estate_seller" */
export type Estate_Seller_On_Conflict = {
  constraint: Estate_Seller_Constraint;
  update_columns?: Array<Estate_Seller_Update_Column>;
  where?: InputMaybe<Estate_Seller_Bool_Exp>;
};

/** Ordering options when selecting data from "estate_seller". */
export type Estate_Seller_Order_By = {
  estate?: InputMaybe<Estate_Order_By>;
  estateId?: InputMaybe<Order_By>;
  ownershipShare?: InputMaybe<Order_By>;
  seller?: InputMaybe<Seller_Order_By>;
  sellerId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: estate_seller */
export type Estate_Seller_Pk_Columns_Input = {
  estateId: Scalars['uuid']['input'];
  sellerId: Scalars['uuid']['input'];
};

/** select columns of table "estate_seller" */
export enum Estate_Seller_Select_Column {
  /** column name */
  EstateId = 'estateId',
  /** column name */
  OwnershipShare = 'ownershipShare',
  /** column name */
  SellerId = 'sellerId'
}

/** input type for updating data in table "estate_seller" */
export type Estate_Seller_Set_Input = {
  estateId?: InputMaybe<Scalars['uuid']['input']>;
  ownershipShare?: InputMaybe<Scalars['numeric']['input']>;
  sellerId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Estate_Seller_Stddev_Fields = {
  __typename?: 'estate_seller_stddev_fields';
  ownershipShare?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "estate_seller" */
export type Estate_Seller_Stddev_Order_By = {
  ownershipShare?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Estate_Seller_Stddev_Pop_Fields = {
  __typename?: 'estate_seller_stddev_pop_fields';
  ownershipShare?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "estate_seller" */
export type Estate_Seller_Stddev_Pop_Order_By = {
  ownershipShare?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Estate_Seller_Stddev_Samp_Fields = {
  __typename?: 'estate_seller_stddev_samp_fields';
  ownershipShare?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "estate_seller" */
export type Estate_Seller_Stddev_Samp_Order_By = {
  ownershipShare?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "estate_seller" */
export type Estate_Seller_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Estate_Seller_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Estate_Seller_Stream_Cursor_Value_Input = {
  estateId?: InputMaybe<Scalars['uuid']['input']>;
  ownershipShare?: InputMaybe<Scalars['numeric']['input']>;
  sellerId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Estate_Seller_Sum_Fields = {
  __typename?: 'estate_seller_sum_fields';
  ownershipShare?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "estate_seller" */
export type Estate_Seller_Sum_Order_By = {
  ownershipShare?: InputMaybe<Order_By>;
};

/** update columns of table "estate_seller" */
export enum Estate_Seller_Update_Column {
  /** column name */
  EstateId = 'estateId',
  /** column name */
  OwnershipShare = 'ownershipShare',
  /** column name */
  SellerId = 'sellerId'
}

export type Estate_Seller_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Estate_Seller_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Estate_Seller_Set_Input>;
  /** filter the rows which have to be updated */
  where: Estate_Seller_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Estate_Seller_Var_Pop_Fields = {
  __typename?: 'estate_seller_var_pop_fields';
  ownershipShare?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "estate_seller" */
export type Estate_Seller_Var_Pop_Order_By = {
  ownershipShare?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Estate_Seller_Var_Samp_Fields = {
  __typename?: 'estate_seller_var_samp_fields';
  ownershipShare?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "estate_seller" */
export type Estate_Seller_Var_Samp_Order_By = {
  ownershipShare?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Estate_Seller_Variance_Fields = {
  __typename?: 'estate_seller_variance_fields';
  ownershipShare?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "estate_seller" */
export type Estate_Seller_Variance_Order_By = {
  ownershipShare?: InputMaybe<Order_By>;
};

/** input type for updating data in table "estate" */
export type Estate_Set_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  applicationAcceptedDate?: InputMaybe<Scalars['timestamptz']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  canConnectedBuyerSeeAddress?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  coownership?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  diagnosticsData?: InputMaybe<Scalars['jsonb']['input']>;
  endEstimate?: InputMaybe<Scalars['Int']['input']>;
  estimationAskedBySellerMemberId?: InputMaybe<Scalars['uuid']['input']>;
  estimationAskedDate?: InputMaybe<Scalars['timestamptz']['input']>;
  estimationPublishedDate?: InputMaybe<Scalars['timestamptz']['input']>;
  features?: InputMaybe<Scalars['jsonb']['input']>;
  firstPrice?: InputMaybe<Scalars['Int']['input']>;
  flags?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isSaleOpen?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  /** The number of visit per slot */
  maxVisitPerSlot?: InputMaybe<Scalars['numeric']['input']>;
  missionHeadId?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publicLatitude?: InputMaybe<Scalars['numeric']['input']>;
  publicLongitude?: InputMaybe<Scalars['numeric']['input']>;
  publicationDescription?: InputMaybe<Scalars['String']['input']>;
  publicationMention?: InputMaybe<Scalars['String']['input']>;
  publicationTitle?: InputMaybe<Scalars['String']['input']>;
  reservePrice?: InputMaybe<Scalars['Int']['input']>;
  sellerData?: InputMaybe<Scalars['jsonb']['input']>;
  sellerId?: InputMaybe<Scalars['uuid']['input']>;
  servicesAndConditions?: InputMaybe<Scalars['jsonb']['input']>;
  startEstimate?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Estate_Type_Enum>;
  virtualVisits?: InputMaybe<Scalars['jsonb']['input']>;
  /** The duration of a visit, used to sub-divide VisitSpans in slots, in minutes */
  visitSlotDuration?: InputMaybe<Scalars['numeric']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Estate_Stddev_Fields = {
  __typename?: 'estate_stddev_fields';
  endEstimate?: Maybe<Scalars['Float']['output']>;
  firstPrice?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The number of visit per slot */
  maxVisitPerSlot?: Maybe<Scalars['Float']['output']>;
  publicLatitude?: Maybe<Scalars['Float']['output']>;
  publicLongitude?: Maybe<Scalars['Float']['output']>;
  reservePrice?: Maybe<Scalars['Float']['output']>;
  startEstimate?: Maybe<Scalars['Float']['output']>;
  /** The duration of a visit, used to sub-divide VisitSpans in slots, in minutes */
  visitSlotDuration?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "estate" */
export type Estate_Stddev_Order_By = {
  endEstimate?: InputMaybe<Order_By>;
  firstPrice?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  /** The number of visit per slot */
  maxVisitPerSlot?: InputMaybe<Order_By>;
  publicLatitude?: InputMaybe<Order_By>;
  publicLongitude?: InputMaybe<Order_By>;
  reservePrice?: InputMaybe<Order_By>;
  startEstimate?: InputMaybe<Order_By>;
  /** The duration of a visit, used to sub-divide VisitSpans in slots, in minutes */
  visitSlotDuration?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Estate_Stddev_Pop_Fields = {
  __typename?: 'estate_stddev_pop_fields';
  endEstimate?: Maybe<Scalars['Float']['output']>;
  firstPrice?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The number of visit per slot */
  maxVisitPerSlot?: Maybe<Scalars['Float']['output']>;
  publicLatitude?: Maybe<Scalars['Float']['output']>;
  publicLongitude?: Maybe<Scalars['Float']['output']>;
  reservePrice?: Maybe<Scalars['Float']['output']>;
  startEstimate?: Maybe<Scalars['Float']['output']>;
  /** The duration of a visit, used to sub-divide VisitSpans in slots, in minutes */
  visitSlotDuration?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "estate" */
export type Estate_Stddev_Pop_Order_By = {
  endEstimate?: InputMaybe<Order_By>;
  firstPrice?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  /** The number of visit per slot */
  maxVisitPerSlot?: InputMaybe<Order_By>;
  publicLatitude?: InputMaybe<Order_By>;
  publicLongitude?: InputMaybe<Order_By>;
  reservePrice?: InputMaybe<Order_By>;
  startEstimate?: InputMaybe<Order_By>;
  /** The duration of a visit, used to sub-divide VisitSpans in slots, in minutes */
  visitSlotDuration?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Estate_Stddev_Samp_Fields = {
  __typename?: 'estate_stddev_samp_fields';
  endEstimate?: Maybe<Scalars['Float']['output']>;
  firstPrice?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The number of visit per slot */
  maxVisitPerSlot?: Maybe<Scalars['Float']['output']>;
  publicLatitude?: Maybe<Scalars['Float']['output']>;
  publicLongitude?: Maybe<Scalars['Float']['output']>;
  reservePrice?: Maybe<Scalars['Float']['output']>;
  startEstimate?: Maybe<Scalars['Float']['output']>;
  /** The duration of a visit, used to sub-divide VisitSpans in slots, in minutes */
  visitSlotDuration?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "estate" */
export type Estate_Stddev_Samp_Order_By = {
  endEstimate?: InputMaybe<Order_By>;
  firstPrice?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  /** The number of visit per slot */
  maxVisitPerSlot?: InputMaybe<Order_By>;
  publicLatitude?: InputMaybe<Order_By>;
  publicLongitude?: InputMaybe<Order_By>;
  reservePrice?: InputMaybe<Order_By>;
  startEstimate?: InputMaybe<Order_By>;
  /** The duration of a visit, used to sub-divide VisitSpans in slots, in minutes */
  visitSlotDuration?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "estate" */
export type Estate_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Estate_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Estate_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  applicationAcceptedDate?: InputMaybe<Scalars['timestamptz']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  canConnectedBuyerSeeAddress?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  coownership?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  diagnosticsData?: InputMaybe<Scalars['jsonb']['input']>;
  endEstimate?: InputMaybe<Scalars['Int']['input']>;
  estimationAskedBySellerMemberId?: InputMaybe<Scalars['uuid']['input']>;
  estimationAskedDate?: InputMaybe<Scalars['timestamptz']['input']>;
  estimationPublishedDate?: InputMaybe<Scalars['timestamptz']['input']>;
  features?: InputMaybe<Scalars['jsonb']['input']>;
  firstPrice?: InputMaybe<Scalars['Int']['input']>;
  flags?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isSaleOpen?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  /** The number of visit per slot */
  maxVisitPerSlot?: InputMaybe<Scalars['numeric']['input']>;
  missionHeadId?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publicLatitude?: InputMaybe<Scalars['numeric']['input']>;
  publicLongitude?: InputMaybe<Scalars['numeric']['input']>;
  publicationDescription?: InputMaybe<Scalars['String']['input']>;
  publicationMention?: InputMaybe<Scalars['String']['input']>;
  publicationTitle?: InputMaybe<Scalars['String']['input']>;
  reservePrice?: InputMaybe<Scalars['Int']['input']>;
  sellerData?: InputMaybe<Scalars['jsonb']['input']>;
  sellerId?: InputMaybe<Scalars['uuid']['input']>;
  servicesAndConditions?: InputMaybe<Scalars['jsonb']['input']>;
  startEstimate?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Estate_Type_Enum>;
  virtualVisits?: InputMaybe<Scalars['jsonb']['input']>;
  /** The duration of a visit, used to sub-divide VisitSpans in slots, in minutes */
  visitSlotDuration?: InputMaybe<Scalars['numeric']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Estate_Sum_Fields = {
  __typename?: 'estate_sum_fields';
  endEstimate?: Maybe<Scalars['Int']['output']>;
  firstPrice?: Maybe<Scalars['Int']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  /** The number of visit per slot */
  maxVisitPerSlot?: Maybe<Scalars['numeric']['output']>;
  publicLatitude?: Maybe<Scalars['numeric']['output']>;
  publicLongitude?: Maybe<Scalars['numeric']['output']>;
  reservePrice?: Maybe<Scalars['Int']['output']>;
  startEstimate?: Maybe<Scalars['Int']['output']>;
  /** The duration of a visit, used to sub-divide VisitSpans in slots, in minutes */
  visitSlotDuration?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "estate" */
export type Estate_Sum_Order_By = {
  endEstimate?: InputMaybe<Order_By>;
  firstPrice?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  /** The number of visit per slot */
  maxVisitPerSlot?: InputMaybe<Order_By>;
  publicLatitude?: InputMaybe<Order_By>;
  publicLongitude?: InputMaybe<Order_By>;
  reservePrice?: InputMaybe<Order_By>;
  startEstimate?: InputMaybe<Order_By>;
  /** The duration of a visit, used to sub-divide VisitSpans in slots, in minutes */
  visitSlotDuration?: InputMaybe<Order_By>;
};

/** columns and relationships of "estate_type" */
export type Estate_Type = {
  __typename?: 'estate_type';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "estate_type" */
export type Estate_Type_Aggregate = {
  __typename?: 'estate_type_aggregate';
  aggregate?: Maybe<Estate_Type_Aggregate_Fields>;
  nodes: Array<Estate_Type>;
};

/** aggregate fields of "estate_type" */
export type Estate_Type_Aggregate_Fields = {
  __typename?: 'estate_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Estate_Type_Max_Fields>;
  min?: Maybe<Estate_Type_Min_Fields>;
};


/** aggregate fields of "estate_type" */
export type Estate_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Estate_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "estate_type". All fields are combined with a logical 'AND'. */
export type Estate_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Estate_Type_Bool_Exp>>;
  _not?: InputMaybe<Estate_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Estate_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "estate_type" */
export enum Estate_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  EstateTypePkey = 'estate_type_pkey'
}

export enum Estate_Type_Enum {
  Apartment = 'Apartment',
  Block = 'Block',
  Building = 'Building',
  Castle = 'Castle',
  Commercial = 'Commercial',
  House = 'House',
  Land = 'Land',
  Loft = 'Loft',
  Mansion = 'Mansion',
  Office = 'Office',
  Other = 'Other',
  Parking = 'Parking',
  Shop = 'Shop'
}

/** Boolean expression to compare columns of type "estate_type_enum". All fields are combined with logical 'AND'. */
export type Estate_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Estate_Type_Enum>;
  _in?: InputMaybe<Array<Estate_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Estate_Type_Enum>;
  _nin?: InputMaybe<Array<Estate_Type_Enum>>;
};

/** input type for inserting data into table "estate_type" */
export type Estate_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Estate_Type_Max_Fields = {
  __typename?: 'estate_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Estate_Type_Min_Fields = {
  __typename?: 'estate_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "estate_type" */
export type Estate_Type_Mutation_Response = {
  __typename?: 'estate_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Estate_Type>;
};

/** input type for inserting object relation for remote table "estate_type" */
export type Estate_Type_Obj_Rel_Insert_Input = {
  data: Estate_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Estate_Type_On_Conflict>;
};

/** on_conflict condition type for table "estate_type" */
export type Estate_Type_On_Conflict = {
  constraint: Estate_Type_Constraint;
  update_columns?: Array<Estate_Type_Update_Column>;
  where?: InputMaybe<Estate_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "estate_type". */
export type Estate_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: estate_type */
export type Estate_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "estate_type" */
export enum Estate_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "estate_type" */
export type Estate_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "estate_type" */
export type Estate_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Estate_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Estate_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "estate_type" */
export enum Estate_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Estate_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Estate_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Estate_Type_Bool_Exp;
};

/** update columns of table "estate" */
export enum Estate_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  ApplicationAcceptedDate = 'applicationAcceptedDate',
  /** column name */
  Archived = 'archived',
  /** column name */
  CanConnectedBuyerSeeAddress = 'canConnectedBuyerSeeAddress',
  /** column name */
  City = 'city',
  /** column name */
  Coownership = 'coownership',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DiagnosticsData = 'diagnosticsData',
  /** column name */
  EndEstimate = 'endEstimate',
  /** column name */
  EstimationAskedBySellerMemberId = 'estimationAskedBySellerMemberId',
  /** column name */
  EstimationAskedDate = 'estimationAskedDate',
  /** column name */
  EstimationPublishedDate = 'estimationPublishedDate',
  /** column name */
  Features = 'features',
  /** column name */
  FirstPrice = 'firstPrice',
  /** column name */
  Flags = 'flags',
  /** column name */
  Id = 'id',
  /** column name */
  IsPublished = 'isPublished',
  /** column name */
  IsSaleOpen = 'isSaleOpen',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  MaxVisitPerSlot = 'maxVisitPerSlot',
  /** column name */
  MissionHeadId = 'missionHeadId',
  /** column name */
  Name = 'name',
  /** column name */
  PublicLatitude = 'publicLatitude',
  /** column name */
  PublicLongitude = 'publicLongitude',
  /** column name */
  PublicationDescription = 'publicationDescription',
  /** column name */
  PublicationMention = 'publicationMention',
  /** column name */
  PublicationTitle = 'publicationTitle',
  /** column name */
  ReservePrice = 'reservePrice',
  /** column name */
  SellerData = 'sellerData',
  /** column name */
  SellerId = 'sellerId',
  /** column name */
  ServicesAndConditions = 'servicesAndConditions',
  /** column name */
  StartEstimate = 'startEstimate',
  /** column name */
  Type = 'type',
  /** column name */
  VirtualVisits = 'virtualVisits',
  /** column name */
  VisitSlotDuration = 'visitSlotDuration',
  /** column name */
  ZipCode = 'zipCode'
}

export type Estate_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Estate_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Estate_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Estate_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Estate_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Estate_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Estate_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Estate_Set_Input>;
  /** filter the rows which have to be updated */
  where: Estate_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Estate_Var_Pop_Fields = {
  __typename?: 'estate_var_pop_fields';
  endEstimate?: Maybe<Scalars['Float']['output']>;
  firstPrice?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The number of visit per slot */
  maxVisitPerSlot?: Maybe<Scalars['Float']['output']>;
  publicLatitude?: Maybe<Scalars['Float']['output']>;
  publicLongitude?: Maybe<Scalars['Float']['output']>;
  reservePrice?: Maybe<Scalars['Float']['output']>;
  startEstimate?: Maybe<Scalars['Float']['output']>;
  /** The duration of a visit, used to sub-divide VisitSpans in slots, in minutes */
  visitSlotDuration?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "estate" */
export type Estate_Var_Pop_Order_By = {
  endEstimate?: InputMaybe<Order_By>;
  firstPrice?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  /** The number of visit per slot */
  maxVisitPerSlot?: InputMaybe<Order_By>;
  publicLatitude?: InputMaybe<Order_By>;
  publicLongitude?: InputMaybe<Order_By>;
  reservePrice?: InputMaybe<Order_By>;
  startEstimate?: InputMaybe<Order_By>;
  /** The duration of a visit, used to sub-divide VisitSpans in slots, in minutes */
  visitSlotDuration?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Estate_Var_Samp_Fields = {
  __typename?: 'estate_var_samp_fields';
  endEstimate?: Maybe<Scalars['Float']['output']>;
  firstPrice?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The number of visit per slot */
  maxVisitPerSlot?: Maybe<Scalars['Float']['output']>;
  publicLatitude?: Maybe<Scalars['Float']['output']>;
  publicLongitude?: Maybe<Scalars['Float']['output']>;
  reservePrice?: Maybe<Scalars['Float']['output']>;
  startEstimate?: Maybe<Scalars['Float']['output']>;
  /** The duration of a visit, used to sub-divide VisitSpans in slots, in minutes */
  visitSlotDuration?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "estate" */
export type Estate_Var_Samp_Order_By = {
  endEstimate?: InputMaybe<Order_By>;
  firstPrice?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  /** The number of visit per slot */
  maxVisitPerSlot?: InputMaybe<Order_By>;
  publicLatitude?: InputMaybe<Order_By>;
  publicLongitude?: InputMaybe<Order_By>;
  reservePrice?: InputMaybe<Order_By>;
  startEstimate?: InputMaybe<Order_By>;
  /** The duration of a visit, used to sub-divide VisitSpans in slots, in minutes */
  visitSlotDuration?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Estate_Variance_Fields = {
  __typename?: 'estate_variance_fields';
  endEstimate?: Maybe<Scalars['Float']['output']>;
  firstPrice?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The number of visit per slot */
  maxVisitPerSlot?: Maybe<Scalars['Float']['output']>;
  publicLatitude?: Maybe<Scalars['Float']['output']>;
  publicLongitude?: Maybe<Scalars['Float']['output']>;
  reservePrice?: Maybe<Scalars['Float']['output']>;
  startEstimate?: Maybe<Scalars['Float']['output']>;
  /** The duration of a visit, used to sub-divide VisitSpans in slots, in minutes */
  visitSlotDuration?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "estate" */
export type Estate_Variance_Order_By = {
  endEstimate?: InputMaybe<Order_By>;
  firstPrice?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  /** The number of visit per slot */
  maxVisitPerSlot?: InputMaybe<Order_By>;
  publicLatitude?: InputMaybe<Order_By>;
  publicLongitude?: InputMaybe<Order_By>;
  reservePrice?: InputMaybe<Order_By>;
  startEstimate?: InputMaybe<Order_By>;
  /** The duration of a visit, used to sub-divide VisitSpans in slots, in minutes */
  visitSlotDuration?: InputMaybe<Order_By>;
};

/** columns and relationships of "storage.files" */
export type Files = {
  __typename?: 'files';
  /** An array relationship */
  application_media: Array<Application_Media>;
  /** An aggregate relationship */
  application_media_aggregate: Application_Media_Aggregate;
  /** An object relationship */
  bucket: Buckets;
  bucketId: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  estate_media: Array<Estate_Media>;
  /** An aggregate relationship */
  estate_media_aggregate: Estate_Media_Aggregate;
  etag?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isUploaded?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  seller_media: Array<Seller_Media>;
  /** An aggregate relationship */
  seller_media_aggregate: Seller_Media_Aggregate;
  size?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "storage.files" */
export type FilesApplication_MediaArgs = {
  distinct_on?: InputMaybe<Array<Application_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Media_Order_By>>;
  where?: InputMaybe<Application_Media_Bool_Exp>;
};


/** columns and relationships of "storage.files" */
export type FilesApplication_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Media_Order_By>>;
  where?: InputMaybe<Application_Media_Bool_Exp>;
};


/** columns and relationships of "storage.files" */
export type FilesEstate_MediaArgs = {
  distinct_on?: InputMaybe<Array<Estate_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Media_Order_By>>;
  where?: InputMaybe<Estate_Media_Bool_Exp>;
};


/** columns and relationships of "storage.files" */
export type FilesEstate_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Media_Order_By>>;
  where?: InputMaybe<Estate_Media_Bool_Exp>;
};


/** columns and relationships of "storage.files" */
export type FilesMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "storage.files" */
export type FilesSeller_MediaArgs = {
  distinct_on?: InputMaybe<Array<Seller_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Media_Order_By>>;
  where?: InputMaybe<Seller_Media_Bool_Exp>;
};


/** columns and relationships of "storage.files" */
export type FilesSeller_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seller_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Media_Order_By>>;
  where?: InputMaybe<Seller_Media_Bool_Exp>;
};

/** aggregated selection of "storage.files" */
export type Files_Aggregate = {
  __typename?: 'files_aggregate';
  aggregate?: Maybe<Files_Aggregate_Fields>;
  nodes: Array<Files>;
};

export type Files_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Files_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Files_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Files_Aggregate_Bool_Exp_Count>;
};

export type Files_Aggregate_Bool_Exp_Bool_And = {
  arguments: Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Files_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Files_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Files_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Files_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Files_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "storage.files" */
export type Files_Aggregate_Fields = {
  __typename?: 'files_aggregate_fields';
  avg?: Maybe<Files_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Files_Max_Fields>;
  min?: Maybe<Files_Min_Fields>;
  stddev?: Maybe<Files_Stddev_Fields>;
  stddev_pop?: Maybe<Files_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Files_Stddev_Samp_Fields>;
  sum?: Maybe<Files_Sum_Fields>;
  var_pop?: Maybe<Files_Var_Pop_Fields>;
  var_samp?: Maybe<Files_Var_Samp_Fields>;
  variance?: Maybe<Files_Variance_Fields>;
};


/** aggregate fields of "storage.files" */
export type Files_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "storage.files" */
export type Files_Aggregate_Order_By = {
  avg?: InputMaybe<Files_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Files_Max_Order_By>;
  min?: InputMaybe<Files_Min_Order_By>;
  stddev?: InputMaybe<Files_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Files_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Files_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Files_Sum_Order_By>;
  var_pop?: InputMaybe<Files_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Files_Var_Samp_Order_By>;
  variance?: InputMaybe<Files_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Files_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "storage.files" */
export type Files_Arr_Rel_Insert_Input = {
  data: Array<Files_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>;
};

/** aggregate avg on columns */
export type Files_Avg_Fields = {
  __typename?: 'files_avg_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "storage.files" */
export type Files_Avg_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "storage.files". All fields are combined with a logical 'AND'. */
export type Files_Bool_Exp = {
  _and?: InputMaybe<Array<Files_Bool_Exp>>;
  _not?: InputMaybe<Files_Bool_Exp>;
  _or?: InputMaybe<Array<Files_Bool_Exp>>;
  application_media?: InputMaybe<Application_Media_Bool_Exp>;
  application_media_aggregate?: InputMaybe<Application_Media_Aggregate_Bool_Exp>;
  bucket?: InputMaybe<Buckets_Bool_Exp>;
  bucketId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  estate_media?: InputMaybe<Estate_Media_Bool_Exp>;
  estate_media_aggregate?: InputMaybe<Estate_Media_Aggregate_Bool_Exp>;
  etag?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isUploaded?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mimeType?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  seller_media?: InputMaybe<Seller_Media_Bool_Exp>;
  seller_media_aggregate?: InputMaybe<Seller_Media_Aggregate_Bool_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploadedByUserId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "storage.files" */
export enum Files_Constraint {
  /** unique or primary key constraint on columns "id" */
  FilesPkey = 'files_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Files_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Files_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Files_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "storage.files" */
export type Files_Inc_Input = {
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "storage.files" */
export type Files_Insert_Input = {
  application_media?: InputMaybe<Application_Media_Arr_Rel_Insert_Input>;
  bucket?: InputMaybe<Buckets_Obj_Rel_Insert_Input>;
  bucketId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  estate_media?: InputMaybe<Estate_Media_Arr_Rel_Insert_Input>;
  etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  seller_media?: InputMaybe<Seller_Media_Arr_Rel_Insert_Input>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Files_Max_Fields = {
  __typename?: 'files_max_fields';
  bucketId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "storage.files" */
export type Files_Max_Order_By = {
  bucketId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  etag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedByUserId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Files_Min_Fields = {
  __typename?: 'files_min_fields';
  bucketId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "storage.files" */
export type Files_Min_Order_By = {
  bucketId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  etag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedByUserId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "storage.files" */
export type Files_Mutation_Response = {
  __typename?: 'files_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Files>;
};

/** input type for inserting object relation for remote table "storage.files" */
export type Files_Obj_Rel_Insert_Input = {
  data: Files_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>;
};

/** on_conflict condition type for table "storage.files" */
export type Files_On_Conflict = {
  constraint: Files_Constraint;
  update_columns?: Array<Files_Update_Column>;
  where?: InputMaybe<Files_Bool_Exp>;
};

/** Ordering options when selecting data from "storage.files". */
export type Files_Order_By = {
  application_media_aggregate?: InputMaybe<Application_Media_Aggregate_Order_By>;
  bucket?: InputMaybe<Buckets_Order_By>;
  bucketId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  estate_media_aggregate?: InputMaybe<Estate_Media_Aggregate_Order_By>;
  etag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isUploaded?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  seller_media_aggregate?: InputMaybe<Seller_Media_Aggregate_Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedByUserId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storage.files */
export type Files_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Files_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "storage.files" */
export enum Files_Select_Column {
  /** column name */
  BucketId = 'bucketId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Etag = 'etag',
  /** column name */
  Id = 'id',
  /** column name */
  IsUploaded = 'isUploaded',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MimeType = 'mimeType',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadedByUserId = 'uploadedByUserId'
}

/** select "files_aggregate_bool_exp_bool_and_arguments_columns" columns of table "storage.files" */
export enum Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsUploaded = 'isUploaded'
}

/** select "files_aggregate_bool_exp_bool_or_arguments_columns" columns of table "storage.files" */
export enum Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsUploaded = 'isUploaded'
}

/** input type for updating data in table "storage.files" */
export type Files_Set_Input = {
  bucketId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Files_Stddev_Fields = {
  __typename?: 'files_stddev_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "storage.files" */
export type Files_Stddev_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Files_Stddev_Pop_Fields = {
  __typename?: 'files_stddev_pop_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "storage.files" */
export type Files_Stddev_Pop_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Files_Stddev_Samp_Fields = {
  __typename?: 'files_stddev_samp_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "storage.files" */
export type Files_Stddev_Samp_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "files" */
export type Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Files_Stream_Cursor_Value_Input = {
  bucketId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Files_Sum_Fields = {
  __typename?: 'files_sum_fields';
  size?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "storage.files" */
export type Files_Sum_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** update columns of table "storage.files" */
export enum Files_Update_Column {
  /** column name */
  BucketId = 'bucketId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Etag = 'etag',
  /** column name */
  Id = 'id',
  /** column name */
  IsUploaded = 'isUploaded',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MimeType = 'mimeType',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadedByUserId = 'uploadedByUserId'
}

export type Files_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Files_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Files_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Files_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Files_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Files_Set_Input>;
  /** filter the rows which have to be updated */
  where: Files_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Files_Var_Pop_Fields = {
  __typename?: 'files_var_pop_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "storage.files" */
export type Files_Var_Pop_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Files_Var_Samp_Fields = {
  __typename?: 'files_var_samp_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "storage.files" */
export type Files_Var_Samp_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Files_Variance_Fields = {
  __typename?: 'files_variance_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "storage.files" */
export type Files_Variance_Order_By = {
  size?: InputMaybe<Order_By>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "mandate" */
export type Mandate = {
  __typename?: 'mandate';
  amendmentNumber?: Maybe<Scalars['String']['output']>;
  cancellationDate?: Maybe<Scalars['timestamptz']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  earnedMoney?: Maybe<Scalars['Int']['output']>;
  earnedMoneyPaid?: Maybe<Scalars['Int']['output']>;
  effectiveCancellationDate?: Maybe<Scalars['timestamptz']['output']>;
  effectiveDate?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  estate: Estate;
  estateId: Scalars['uuid']['output'];
  feePerson?: Maybe<Mandate_Fee_Person_Enum>;
  feeVATRate: Scalars['numeric']['output'];
  firstPrice?: Maybe<Scalars['String']['output']>;
  fixedFee: Scalars['Int']['output'];
  fixedFeeThreshold: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  initialDuration: Scalars['Int']['output'];
  mainSignDate?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  mandate_media: Array<Mandate_Media>;
  /** An aggregate relationship */
  mandate_media_aggregate: Mandate_Media_Aggregate;
  /** An object relationship */
  mandate_registry?: Maybe<Mandate_Registry>;
  maxRenewal: Scalars['Int']['output'];
  particularConditions?: Maybe<Scalars['String']['output']>;
  precontractualDate?: Maybe<Scalars['timestamptz']['output']>;
  proportionalFeesRate: Scalars['numeric']['output'];
  renewalDuration: Scalars['Int']['output'];
  reservePrice?: Maybe<Scalars['String']['output']>;
  status: Mandate_Status_Enum;
  type: Mandate_Type_Enum;
};


/** columns and relationships of "mandate" */
export type MandateMandate_MediaArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Media_Order_By>>;
  where?: InputMaybe<Mandate_Media_Bool_Exp>;
};


/** columns and relationships of "mandate" */
export type MandateMandate_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Media_Order_By>>;
  where?: InputMaybe<Mandate_Media_Bool_Exp>;
};

/** aggregated selection of "mandate" */
export type Mandate_Aggregate = {
  __typename?: 'mandate_aggregate';
  aggregate?: Maybe<Mandate_Aggregate_Fields>;
  nodes: Array<Mandate>;
};

/** aggregate fields of "mandate" */
export type Mandate_Aggregate_Fields = {
  __typename?: 'mandate_aggregate_fields';
  avg?: Maybe<Mandate_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mandate_Max_Fields>;
  min?: Maybe<Mandate_Min_Fields>;
  stddev?: Maybe<Mandate_Stddev_Fields>;
  stddev_pop?: Maybe<Mandate_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mandate_Stddev_Samp_Fields>;
  sum?: Maybe<Mandate_Sum_Fields>;
  var_pop?: Maybe<Mandate_Var_Pop_Fields>;
  var_samp?: Maybe<Mandate_Var_Samp_Fields>;
  variance?: Maybe<Mandate_Variance_Fields>;
};


/** aggregate fields of "mandate" */
export type Mandate_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mandate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mandate_Avg_Fields = {
  __typename?: 'mandate_avg_fields';
  earnedMoney?: Maybe<Scalars['Float']['output']>;
  earnedMoneyPaid?: Maybe<Scalars['Float']['output']>;
  feeVATRate?: Maybe<Scalars['Float']['output']>;
  fixedFee?: Maybe<Scalars['Float']['output']>;
  fixedFeeThreshold?: Maybe<Scalars['Float']['output']>;
  initialDuration?: Maybe<Scalars['Float']['output']>;
  maxRenewal?: Maybe<Scalars['Float']['output']>;
  proportionalFeesRate?: Maybe<Scalars['Float']['output']>;
  renewalDuration?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mandate". All fields are combined with a logical 'AND'. */
export type Mandate_Bool_Exp = {
  _and?: InputMaybe<Array<Mandate_Bool_Exp>>;
  _not?: InputMaybe<Mandate_Bool_Exp>;
  _or?: InputMaybe<Array<Mandate_Bool_Exp>>;
  amendmentNumber?: InputMaybe<String_Comparison_Exp>;
  cancellationDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  earnedMoney?: InputMaybe<Int_Comparison_Exp>;
  earnedMoneyPaid?: InputMaybe<Int_Comparison_Exp>;
  effectiveCancellationDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  estate?: InputMaybe<Estate_Bool_Exp>;
  estateId?: InputMaybe<Uuid_Comparison_Exp>;
  feePerson?: InputMaybe<Mandate_Fee_Person_Enum_Comparison_Exp>;
  feeVATRate?: InputMaybe<Numeric_Comparison_Exp>;
  firstPrice?: InputMaybe<String_Comparison_Exp>;
  fixedFee?: InputMaybe<Int_Comparison_Exp>;
  fixedFeeThreshold?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  initialDuration?: InputMaybe<Int_Comparison_Exp>;
  mainSignDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  mandate_media?: InputMaybe<Mandate_Media_Bool_Exp>;
  mandate_media_aggregate?: InputMaybe<Mandate_Media_Aggregate_Bool_Exp>;
  mandate_registry?: InputMaybe<Mandate_Registry_Bool_Exp>;
  maxRenewal?: InputMaybe<Int_Comparison_Exp>;
  particularConditions?: InputMaybe<String_Comparison_Exp>;
  precontractualDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  proportionalFeesRate?: InputMaybe<Numeric_Comparison_Exp>;
  renewalDuration?: InputMaybe<Int_Comparison_Exp>;
  reservePrice?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Mandate_Status_Enum_Comparison_Exp>;
  type?: InputMaybe<Mandate_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "mandate" */
export enum Mandate_Constraint {
  /** unique or primary key constraint on columns "estateId" */
  MandateEstateIdKey = 'mandate_estateId_key',
  /** unique or primary key constraint on columns "id" */
  MandatePkey = 'mandate_pkey'
}

/** columns and relationships of "mandate_fee_person" */
export type Mandate_Fee_Person = {
  __typename?: 'mandate_fee_person';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "mandate_fee_person" */
export type Mandate_Fee_Person_Aggregate = {
  __typename?: 'mandate_fee_person_aggregate';
  aggregate?: Maybe<Mandate_Fee_Person_Aggregate_Fields>;
  nodes: Array<Mandate_Fee_Person>;
};

/** aggregate fields of "mandate_fee_person" */
export type Mandate_Fee_Person_Aggregate_Fields = {
  __typename?: 'mandate_fee_person_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Mandate_Fee_Person_Max_Fields>;
  min?: Maybe<Mandate_Fee_Person_Min_Fields>;
};


/** aggregate fields of "mandate_fee_person" */
export type Mandate_Fee_Person_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mandate_Fee_Person_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "mandate_fee_person". All fields are combined with a logical 'AND'. */
export type Mandate_Fee_Person_Bool_Exp = {
  _and?: InputMaybe<Array<Mandate_Fee_Person_Bool_Exp>>;
  _not?: InputMaybe<Mandate_Fee_Person_Bool_Exp>;
  _or?: InputMaybe<Array<Mandate_Fee_Person_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "mandate_fee_person" */
export enum Mandate_Fee_Person_Constraint {
  /** unique or primary key constraint on columns "value" */
  MandateFeePersonPkey = 'mandate_fee_person_pkey'
}

export enum Mandate_Fee_Person_Enum {
  Buyer = 'Buyer',
  Seller = 'Seller'
}

/** Boolean expression to compare columns of type "mandate_fee_person_enum". All fields are combined with logical 'AND'. */
export type Mandate_Fee_Person_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Mandate_Fee_Person_Enum>;
  _in?: InputMaybe<Array<Mandate_Fee_Person_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Mandate_Fee_Person_Enum>;
  _nin?: InputMaybe<Array<Mandate_Fee_Person_Enum>>;
};

/** input type for inserting data into table "mandate_fee_person" */
export type Mandate_Fee_Person_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Mandate_Fee_Person_Max_Fields = {
  __typename?: 'mandate_fee_person_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Mandate_Fee_Person_Min_Fields = {
  __typename?: 'mandate_fee_person_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "mandate_fee_person" */
export type Mandate_Fee_Person_Mutation_Response = {
  __typename?: 'mandate_fee_person_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mandate_Fee_Person>;
};

/** on_conflict condition type for table "mandate_fee_person" */
export type Mandate_Fee_Person_On_Conflict = {
  constraint: Mandate_Fee_Person_Constraint;
  update_columns?: Array<Mandate_Fee_Person_Update_Column>;
  where?: InputMaybe<Mandate_Fee_Person_Bool_Exp>;
};

/** Ordering options when selecting data from "mandate_fee_person". */
export type Mandate_Fee_Person_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mandate_fee_person */
export type Mandate_Fee_Person_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "mandate_fee_person" */
export enum Mandate_Fee_Person_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "mandate_fee_person" */
export type Mandate_Fee_Person_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "mandate_fee_person" */
export type Mandate_Fee_Person_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mandate_Fee_Person_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mandate_Fee_Person_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "mandate_fee_person" */
export enum Mandate_Fee_Person_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Mandate_Fee_Person_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mandate_Fee_Person_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mandate_Fee_Person_Bool_Exp;
};

/** input type for incrementing numeric columns in table "mandate" */
export type Mandate_Inc_Input = {
  earnedMoney?: InputMaybe<Scalars['Int']['input']>;
  earnedMoneyPaid?: InputMaybe<Scalars['Int']['input']>;
  feeVATRate?: InputMaybe<Scalars['numeric']['input']>;
  fixedFee?: InputMaybe<Scalars['Int']['input']>;
  fixedFeeThreshold?: InputMaybe<Scalars['Int']['input']>;
  initialDuration?: InputMaybe<Scalars['Int']['input']>;
  maxRenewal?: InputMaybe<Scalars['Int']['input']>;
  proportionalFeesRate?: InputMaybe<Scalars['numeric']['input']>;
  renewalDuration?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "mandate" */
export type Mandate_Insert_Input = {
  amendmentNumber?: InputMaybe<Scalars['String']['input']>;
  cancellationDate?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  earnedMoney?: InputMaybe<Scalars['Int']['input']>;
  earnedMoneyPaid?: InputMaybe<Scalars['Int']['input']>;
  effectiveCancellationDate?: InputMaybe<Scalars['timestamptz']['input']>;
  effectiveDate?: InputMaybe<Scalars['timestamptz']['input']>;
  estate?: InputMaybe<Estate_Obj_Rel_Insert_Input>;
  estateId?: InputMaybe<Scalars['uuid']['input']>;
  feePerson?: InputMaybe<Mandate_Fee_Person_Enum>;
  feeVATRate?: InputMaybe<Scalars['numeric']['input']>;
  firstPrice?: InputMaybe<Scalars['String']['input']>;
  fixedFee?: InputMaybe<Scalars['Int']['input']>;
  fixedFeeThreshold?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  initialDuration?: InputMaybe<Scalars['Int']['input']>;
  mainSignDate?: InputMaybe<Scalars['timestamptz']['input']>;
  mandate_media?: InputMaybe<Mandate_Media_Arr_Rel_Insert_Input>;
  mandate_registry?: InputMaybe<Mandate_Registry_Obj_Rel_Insert_Input>;
  maxRenewal?: InputMaybe<Scalars['Int']['input']>;
  particularConditions?: InputMaybe<Scalars['String']['input']>;
  precontractualDate?: InputMaybe<Scalars['timestamptz']['input']>;
  proportionalFeesRate?: InputMaybe<Scalars['numeric']['input']>;
  renewalDuration?: InputMaybe<Scalars['Int']['input']>;
  reservePrice?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Mandate_Status_Enum>;
  type?: InputMaybe<Mandate_Type_Enum>;
};

/** aggregate max on columns */
export type Mandate_Max_Fields = {
  __typename?: 'mandate_max_fields';
  amendmentNumber?: Maybe<Scalars['String']['output']>;
  cancellationDate?: Maybe<Scalars['timestamptz']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  earnedMoney?: Maybe<Scalars['Int']['output']>;
  earnedMoneyPaid?: Maybe<Scalars['Int']['output']>;
  effectiveCancellationDate?: Maybe<Scalars['timestamptz']['output']>;
  effectiveDate?: Maybe<Scalars['timestamptz']['output']>;
  estateId?: Maybe<Scalars['uuid']['output']>;
  feeVATRate?: Maybe<Scalars['numeric']['output']>;
  firstPrice?: Maybe<Scalars['String']['output']>;
  fixedFee?: Maybe<Scalars['Int']['output']>;
  fixedFeeThreshold?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  initialDuration?: Maybe<Scalars['Int']['output']>;
  mainSignDate?: Maybe<Scalars['timestamptz']['output']>;
  maxRenewal?: Maybe<Scalars['Int']['output']>;
  particularConditions?: Maybe<Scalars['String']['output']>;
  precontractualDate?: Maybe<Scalars['timestamptz']['output']>;
  proportionalFeesRate?: Maybe<Scalars['numeric']['output']>;
  renewalDuration?: Maybe<Scalars['Int']['output']>;
  reservePrice?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "mandate_media" */
export type Mandate_Media = {
  __typename?: 'mandate_media';
  created_at: Scalars['timestamptz']['output'];
  fileId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  mandate: Mandate;
  mandateId: Scalars['uuid']['output'];
};

/** aggregated selection of "mandate_media" */
export type Mandate_Media_Aggregate = {
  __typename?: 'mandate_media_aggregate';
  aggregate?: Maybe<Mandate_Media_Aggregate_Fields>;
  nodes: Array<Mandate_Media>;
};

export type Mandate_Media_Aggregate_Bool_Exp = {
  count?: InputMaybe<Mandate_Media_Aggregate_Bool_Exp_Count>;
};

export type Mandate_Media_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Mandate_Media_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mandate_Media_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "mandate_media" */
export type Mandate_Media_Aggregate_Fields = {
  __typename?: 'mandate_media_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Mandate_Media_Max_Fields>;
  min?: Maybe<Mandate_Media_Min_Fields>;
};


/** aggregate fields of "mandate_media" */
export type Mandate_Media_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mandate_Media_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "mandate_media" */
export type Mandate_Media_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mandate_Media_Max_Order_By>;
  min?: InputMaybe<Mandate_Media_Min_Order_By>;
};

/** input type for inserting array relation for remote table "mandate_media" */
export type Mandate_Media_Arr_Rel_Insert_Input = {
  data: Array<Mandate_Media_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mandate_Media_On_Conflict>;
};

/** Boolean expression to filter rows from the table "mandate_media". All fields are combined with a logical 'AND'. */
export type Mandate_Media_Bool_Exp = {
  _and?: InputMaybe<Array<Mandate_Media_Bool_Exp>>;
  _not?: InputMaybe<Mandate_Media_Bool_Exp>;
  _or?: InputMaybe<Array<Mandate_Media_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fileId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mandate?: InputMaybe<Mandate_Bool_Exp>;
  mandateId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "mandate_media" */
export enum Mandate_Media_Constraint {
  /** unique or primary key constraint on columns "id" */
  MandateMediaPkey = 'mandate_media_pkey'
}

/** input type for inserting data into table "mandate_media" */
export type Mandate_Media_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mandate?: InputMaybe<Mandate_Obj_Rel_Insert_Input>;
  mandateId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Mandate_Media_Max_Fields = {
  __typename?: 'mandate_media_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mandateId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "mandate_media" */
export type Mandate_Media_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mandateId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mandate_Media_Min_Fields = {
  __typename?: 'mandate_media_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mandateId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "mandate_media" */
export type Mandate_Media_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mandateId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mandate_media" */
export type Mandate_Media_Mutation_Response = {
  __typename?: 'mandate_media_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mandate_Media>;
};

/** on_conflict condition type for table "mandate_media" */
export type Mandate_Media_On_Conflict = {
  constraint: Mandate_Media_Constraint;
  update_columns?: Array<Mandate_Media_Update_Column>;
  where?: InputMaybe<Mandate_Media_Bool_Exp>;
};

/** Ordering options when selecting data from "mandate_media". */
export type Mandate_Media_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mandate?: InputMaybe<Mandate_Order_By>;
  mandateId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mandate_media */
export type Mandate_Media_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "mandate_media" */
export enum Mandate_Media_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Id = 'id',
  /** column name */
  MandateId = 'mandateId'
}

/** input type for updating data in table "mandate_media" */
export type Mandate_Media_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mandateId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "mandate_media" */
export type Mandate_Media_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mandate_Media_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mandate_Media_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mandateId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "mandate_media" */
export enum Mandate_Media_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Id = 'id',
  /** column name */
  MandateId = 'mandateId'
}

export type Mandate_Media_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mandate_Media_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mandate_Media_Bool_Exp;
};

/** aggregate min on columns */
export type Mandate_Min_Fields = {
  __typename?: 'mandate_min_fields';
  amendmentNumber?: Maybe<Scalars['String']['output']>;
  cancellationDate?: Maybe<Scalars['timestamptz']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  earnedMoney?: Maybe<Scalars['Int']['output']>;
  earnedMoneyPaid?: Maybe<Scalars['Int']['output']>;
  effectiveCancellationDate?: Maybe<Scalars['timestamptz']['output']>;
  effectiveDate?: Maybe<Scalars['timestamptz']['output']>;
  estateId?: Maybe<Scalars['uuid']['output']>;
  feeVATRate?: Maybe<Scalars['numeric']['output']>;
  firstPrice?: Maybe<Scalars['String']['output']>;
  fixedFee?: Maybe<Scalars['Int']['output']>;
  fixedFeeThreshold?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  initialDuration?: Maybe<Scalars['Int']['output']>;
  mainSignDate?: Maybe<Scalars['timestamptz']['output']>;
  maxRenewal?: Maybe<Scalars['Int']['output']>;
  particularConditions?: Maybe<Scalars['String']['output']>;
  precontractualDate?: Maybe<Scalars['timestamptz']['output']>;
  proportionalFeesRate?: Maybe<Scalars['numeric']['output']>;
  renewalDuration?: Maybe<Scalars['Int']['output']>;
  reservePrice?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "mandate" */
export type Mandate_Mutation_Response = {
  __typename?: 'mandate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mandate>;
};

/** input type for inserting object relation for remote table "mandate" */
export type Mandate_Obj_Rel_Insert_Input = {
  data: Mandate_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Mandate_On_Conflict>;
};

/** on_conflict condition type for table "mandate" */
export type Mandate_On_Conflict = {
  constraint: Mandate_Constraint;
  update_columns?: Array<Mandate_Update_Column>;
  where?: InputMaybe<Mandate_Bool_Exp>;
};

/** Ordering options when selecting data from "mandate". */
export type Mandate_Order_By = {
  amendmentNumber?: InputMaybe<Order_By>;
  cancellationDate?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  earnedMoney?: InputMaybe<Order_By>;
  earnedMoneyPaid?: InputMaybe<Order_By>;
  effectiveCancellationDate?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  estate?: InputMaybe<Estate_Order_By>;
  estateId?: InputMaybe<Order_By>;
  feePerson?: InputMaybe<Order_By>;
  feeVATRate?: InputMaybe<Order_By>;
  firstPrice?: InputMaybe<Order_By>;
  fixedFee?: InputMaybe<Order_By>;
  fixedFeeThreshold?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initialDuration?: InputMaybe<Order_By>;
  mainSignDate?: InputMaybe<Order_By>;
  mandate_media_aggregate?: InputMaybe<Mandate_Media_Aggregate_Order_By>;
  mandate_registry?: InputMaybe<Mandate_Registry_Order_By>;
  maxRenewal?: InputMaybe<Order_By>;
  particularConditions?: InputMaybe<Order_By>;
  precontractualDate?: InputMaybe<Order_By>;
  proportionalFeesRate?: InputMaybe<Order_By>;
  renewalDuration?: InputMaybe<Order_By>;
  reservePrice?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mandate */
export type Mandate_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "mandate_registry" */
export type Mandate_Registry = {
  __typename?: 'mandate_registry';
  estateLabel: Scalars['String']['output'];
  generatedAt: Scalars['timestamptz']['output'];
  /** Only used for auditing */
  id: Scalars['uuid']['output'];
  /** An object relationship */
  mandate: Mandate;
  mandateId: Scalars['uuid']['output'];
  numeroDeRegistreRepertoire?: Maybe<Scalars['String']['output']>;
  objectLabel: Scalars['String']['output'];
  observations?: Maybe<Scalars['String']['output']>;
  orderNumber: Scalars['String']['output'];
  representativesAddress: Scalars['String']['output'];
  representativesNames: Scalars['String']['output'];
};

/** aggregated selection of "mandate_registry" */
export type Mandate_Registry_Aggregate = {
  __typename?: 'mandate_registry_aggregate';
  aggregate?: Maybe<Mandate_Registry_Aggregate_Fields>;
  nodes: Array<Mandate_Registry>;
};

/** aggregate fields of "mandate_registry" */
export type Mandate_Registry_Aggregate_Fields = {
  __typename?: 'mandate_registry_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Mandate_Registry_Max_Fields>;
  min?: Maybe<Mandate_Registry_Min_Fields>;
};


/** aggregate fields of "mandate_registry" */
export type Mandate_Registry_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mandate_Registry_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "mandate_registry". All fields are combined with a logical 'AND'. */
export type Mandate_Registry_Bool_Exp = {
  _and?: InputMaybe<Array<Mandate_Registry_Bool_Exp>>;
  _not?: InputMaybe<Mandate_Registry_Bool_Exp>;
  _or?: InputMaybe<Array<Mandate_Registry_Bool_Exp>>;
  estateLabel?: InputMaybe<String_Comparison_Exp>;
  generatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mandate?: InputMaybe<Mandate_Bool_Exp>;
  mandateId?: InputMaybe<Uuid_Comparison_Exp>;
  numeroDeRegistreRepertoire?: InputMaybe<String_Comparison_Exp>;
  objectLabel?: InputMaybe<String_Comparison_Exp>;
  observations?: InputMaybe<String_Comparison_Exp>;
  orderNumber?: InputMaybe<String_Comparison_Exp>;
  representativesAddress?: InputMaybe<String_Comparison_Exp>;
  representativesNames?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "mandate_registry" */
export enum Mandate_Registry_Constraint {
  /** unique or primary key constraint on columns "id" */
  MandateRegistryIdKey = 'mandate_registry_id_key',
  /** unique or primary key constraint on columns "mandateId" */
  MandateRegistryMandateIdUnique = 'mandate_registry_mandateId_unique',
  /** unique or primary key constraint on columns "orderNumber" */
  MandateRegistryPkey = 'mandate_registry_pkey'
}

/** input type for inserting data into table "mandate_registry" */
export type Mandate_Registry_Insert_Input = {
  estateLabel?: InputMaybe<Scalars['String']['input']>;
  generatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Only used for auditing */
  id?: InputMaybe<Scalars['uuid']['input']>;
  mandate?: InputMaybe<Mandate_Obj_Rel_Insert_Input>;
  mandateId?: InputMaybe<Scalars['uuid']['input']>;
  numeroDeRegistreRepertoire?: InputMaybe<Scalars['String']['input']>;
  objectLabel?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  representativesAddress?: InputMaybe<Scalars['String']['input']>;
  representativesNames?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Mandate_Registry_Max_Fields = {
  __typename?: 'mandate_registry_max_fields';
  estateLabel?: Maybe<Scalars['String']['output']>;
  generatedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** Only used for auditing */
  id?: Maybe<Scalars['uuid']['output']>;
  mandateId?: Maybe<Scalars['uuid']['output']>;
  numeroDeRegistreRepertoire?: Maybe<Scalars['String']['output']>;
  objectLabel?: Maybe<Scalars['String']['output']>;
  observations?: Maybe<Scalars['String']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  representativesAddress?: Maybe<Scalars['String']['output']>;
  representativesNames?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Mandate_Registry_Min_Fields = {
  __typename?: 'mandate_registry_min_fields';
  estateLabel?: Maybe<Scalars['String']['output']>;
  generatedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** Only used for auditing */
  id?: Maybe<Scalars['uuid']['output']>;
  mandateId?: Maybe<Scalars['uuid']['output']>;
  numeroDeRegistreRepertoire?: Maybe<Scalars['String']['output']>;
  objectLabel?: Maybe<Scalars['String']['output']>;
  observations?: Maybe<Scalars['String']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  representativesAddress?: Maybe<Scalars['String']['output']>;
  representativesNames?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "mandate_registry" */
export type Mandate_Registry_Mutation_Response = {
  __typename?: 'mandate_registry_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mandate_Registry>;
};

/** columns and relationships of "mandate_registry_number_lock" */
export type Mandate_Registry_Number_Lock = {
  __typename?: 'mandate_registry_number_lock';
  key_name: Scalars['String']['output'];
  last_number: Scalars['Int']['output'];
};

/** aggregated selection of "mandate_registry_number_lock" */
export type Mandate_Registry_Number_Lock_Aggregate = {
  __typename?: 'mandate_registry_number_lock_aggregate';
  aggregate?: Maybe<Mandate_Registry_Number_Lock_Aggregate_Fields>;
  nodes: Array<Mandate_Registry_Number_Lock>;
};

/** aggregate fields of "mandate_registry_number_lock" */
export type Mandate_Registry_Number_Lock_Aggregate_Fields = {
  __typename?: 'mandate_registry_number_lock_aggregate_fields';
  avg?: Maybe<Mandate_Registry_Number_Lock_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mandate_Registry_Number_Lock_Max_Fields>;
  min?: Maybe<Mandate_Registry_Number_Lock_Min_Fields>;
  stddev?: Maybe<Mandate_Registry_Number_Lock_Stddev_Fields>;
  stddev_pop?: Maybe<Mandate_Registry_Number_Lock_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mandate_Registry_Number_Lock_Stddev_Samp_Fields>;
  sum?: Maybe<Mandate_Registry_Number_Lock_Sum_Fields>;
  var_pop?: Maybe<Mandate_Registry_Number_Lock_Var_Pop_Fields>;
  var_samp?: Maybe<Mandate_Registry_Number_Lock_Var_Samp_Fields>;
  variance?: Maybe<Mandate_Registry_Number_Lock_Variance_Fields>;
};


/** aggregate fields of "mandate_registry_number_lock" */
export type Mandate_Registry_Number_Lock_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mandate_Registry_Number_Lock_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mandate_Registry_Number_Lock_Avg_Fields = {
  __typename?: 'mandate_registry_number_lock_avg_fields';
  last_number?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mandate_registry_number_lock". All fields are combined with a logical 'AND'. */
export type Mandate_Registry_Number_Lock_Bool_Exp = {
  _and?: InputMaybe<Array<Mandate_Registry_Number_Lock_Bool_Exp>>;
  _not?: InputMaybe<Mandate_Registry_Number_Lock_Bool_Exp>;
  _or?: InputMaybe<Array<Mandate_Registry_Number_Lock_Bool_Exp>>;
  key_name?: InputMaybe<String_Comparison_Exp>;
  last_number?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "mandate_registry_number_lock" */
export enum Mandate_Registry_Number_Lock_Constraint {
  /** unique or primary key constraint on columns "key_name" */
  MandateRegistryNumberLockPkey = 'mandate_registry_number_lock_pkey'
}

/** input type for incrementing numeric columns in table "mandate_registry_number_lock" */
export type Mandate_Registry_Number_Lock_Inc_Input = {
  last_number?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "mandate_registry_number_lock" */
export type Mandate_Registry_Number_Lock_Insert_Input = {
  key_name?: InputMaybe<Scalars['String']['input']>;
  last_number?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Mandate_Registry_Number_Lock_Max_Fields = {
  __typename?: 'mandate_registry_number_lock_max_fields';
  key_name?: Maybe<Scalars['String']['output']>;
  last_number?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Mandate_Registry_Number_Lock_Min_Fields = {
  __typename?: 'mandate_registry_number_lock_min_fields';
  key_name?: Maybe<Scalars['String']['output']>;
  last_number?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "mandate_registry_number_lock" */
export type Mandate_Registry_Number_Lock_Mutation_Response = {
  __typename?: 'mandate_registry_number_lock_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mandate_Registry_Number_Lock>;
};

/** on_conflict condition type for table "mandate_registry_number_lock" */
export type Mandate_Registry_Number_Lock_On_Conflict = {
  constraint: Mandate_Registry_Number_Lock_Constraint;
  update_columns?: Array<Mandate_Registry_Number_Lock_Update_Column>;
  where?: InputMaybe<Mandate_Registry_Number_Lock_Bool_Exp>;
};

/** Ordering options when selecting data from "mandate_registry_number_lock". */
export type Mandate_Registry_Number_Lock_Order_By = {
  key_name?: InputMaybe<Order_By>;
  last_number?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mandate_registry_number_lock */
export type Mandate_Registry_Number_Lock_Pk_Columns_Input = {
  key_name: Scalars['String']['input'];
};

/** select columns of table "mandate_registry_number_lock" */
export enum Mandate_Registry_Number_Lock_Select_Column {
  /** column name */
  KeyName = 'key_name',
  /** column name */
  LastNumber = 'last_number'
}

/** input type for updating data in table "mandate_registry_number_lock" */
export type Mandate_Registry_Number_Lock_Set_Input = {
  key_name?: InputMaybe<Scalars['String']['input']>;
  last_number?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Mandate_Registry_Number_Lock_Stddev_Fields = {
  __typename?: 'mandate_registry_number_lock_stddev_fields';
  last_number?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mandate_Registry_Number_Lock_Stddev_Pop_Fields = {
  __typename?: 'mandate_registry_number_lock_stddev_pop_fields';
  last_number?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mandate_Registry_Number_Lock_Stddev_Samp_Fields = {
  __typename?: 'mandate_registry_number_lock_stddev_samp_fields';
  last_number?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mandate_registry_number_lock" */
export type Mandate_Registry_Number_Lock_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mandate_Registry_Number_Lock_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mandate_Registry_Number_Lock_Stream_Cursor_Value_Input = {
  key_name?: InputMaybe<Scalars['String']['input']>;
  last_number?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Mandate_Registry_Number_Lock_Sum_Fields = {
  __typename?: 'mandate_registry_number_lock_sum_fields';
  last_number?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "mandate_registry_number_lock" */
export enum Mandate_Registry_Number_Lock_Update_Column {
  /** column name */
  KeyName = 'key_name',
  /** column name */
  LastNumber = 'last_number'
}

export type Mandate_Registry_Number_Lock_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mandate_Registry_Number_Lock_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mandate_Registry_Number_Lock_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mandate_Registry_Number_Lock_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mandate_Registry_Number_Lock_Var_Pop_Fields = {
  __typename?: 'mandate_registry_number_lock_var_pop_fields';
  last_number?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mandate_Registry_Number_Lock_Var_Samp_Fields = {
  __typename?: 'mandate_registry_number_lock_var_samp_fields';
  last_number?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mandate_Registry_Number_Lock_Variance_Fields = {
  __typename?: 'mandate_registry_number_lock_variance_fields';
  last_number?: Maybe<Scalars['Float']['output']>;
};

/** input type for inserting object relation for remote table "mandate_registry" */
export type Mandate_Registry_Obj_Rel_Insert_Input = {
  data: Mandate_Registry_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Mandate_Registry_On_Conflict>;
};

/** on_conflict condition type for table "mandate_registry" */
export type Mandate_Registry_On_Conflict = {
  constraint: Mandate_Registry_Constraint;
  update_columns?: Array<Mandate_Registry_Update_Column>;
  where?: InputMaybe<Mandate_Registry_Bool_Exp>;
};

/** Ordering options when selecting data from "mandate_registry". */
export type Mandate_Registry_Order_By = {
  estateLabel?: InputMaybe<Order_By>;
  generatedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mandate?: InputMaybe<Mandate_Order_By>;
  mandateId?: InputMaybe<Order_By>;
  numeroDeRegistreRepertoire?: InputMaybe<Order_By>;
  objectLabel?: InputMaybe<Order_By>;
  observations?: InputMaybe<Order_By>;
  orderNumber?: InputMaybe<Order_By>;
  representativesAddress?: InputMaybe<Order_By>;
  representativesNames?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mandate_registry */
export type Mandate_Registry_Pk_Columns_Input = {
  orderNumber: Scalars['String']['input'];
};

/** select columns of table "mandate_registry" */
export enum Mandate_Registry_Select_Column {
  /** column name */
  EstateLabel = 'estateLabel',
  /** column name */
  GeneratedAt = 'generatedAt',
  /** column name */
  Id = 'id',
  /** column name */
  MandateId = 'mandateId',
  /** column name */
  NumeroDeRegistreRepertoire = 'numeroDeRegistreRepertoire',
  /** column name */
  ObjectLabel = 'objectLabel',
  /** column name */
  Observations = 'observations',
  /** column name */
  OrderNumber = 'orderNumber',
  /** column name */
  RepresentativesAddress = 'representativesAddress',
  /** column name */
  RepresentativesNames = 'representativesNames'
}

/** input type for updating data in table "mandate_registry" */
export type Mandate_Registry_Set_Input = {
  estateLabel?: InputMaybe<Scalars['String']['input']>;
  generatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Only used for auditing */
  id?: InputMaybe<Scalars['uuid']['input']>;
  mandateId?: InputMaybe<Scalars['uuid']['input']>;
  numeroDeRegistreRepertoire?: InputMaybe<Scalars['String']['input']>;
  objectLabel?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  representativesAddress?: InputMaybe<Scalars['String']['input']>;
  representativesNames?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "mandate_registry" */
export type Mandate_Registry_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mandate_Registry_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mandate_Registry_Stream_Cursor_Value_Input = {
  estateLabel?: InputMaybe<Scalars['String']['input']>;
  generatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Only used for auditing */
  id?: InputMaybe<Scalars['uuid']['input']>;
  mandateId?: InputMaybe<Scalars['uuid']['input']>;
  numeroDeRegistreRepertoire?: InputMaybe<Scalars['String']['input']>;
  objectLabel?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  representativesAddress?: InputMaybe<Scalars['String']['input']>;
  representativesNames?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "mandate_registry" */
export enum Mandate_Registry_Update_Column {
  /** column name */
  EstateLabel = 'estateLabel',
  /** column name */
  GeneratedAt = 'generatedAt',
  /** column name */
  Id = 'id',
  /** column name */
  MandateId = 'mandateId',
  /** column name */
  NumeroDeRegistreRepertoire = 'numeroDeRegistreRepertoire',
  /** column name */
  ObjectLabel = 'objectLabel',
  /** column name */
  Observations = 'observations',
  /** column name */
  OrderNumber = 'orderNumber',
  /** column name */
  RepresentativesAddress = 'representativesAddress',
  /** column name */
  RepresentativesNames = 'representativesNames'
}

export type Mandate_Registry_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mandate_Registry_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mandate_Registry_Bool_Exp;
};

/** select columns of table "mandate" */
export enum Mandate_Select_Column {
  /** column name */
  AmendmentNumber = 'amendmentNumber',
  /** column name */
  CancellationDate = 'cancellationDate',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EarnedMoney = 'earnedMoney',
  /** column name */
  EarnedMoneyPaid = 'earnedMoneyPaid',
  /** column name */
  EffectiveCancellationDate = 'effectiveCancellationDate',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  EstateId = 'estateId',
  /** column name */
  FeePerson = 'feePerson',
  /** column name */
  FeeVatRate = 'feeVATRate',
  /** column name */
  FirstPrice = 'firstPrice',
  /** column name */
  FixedFee = 'fixedFee',
  /** column name */
  FixedFeeThreshold = 'fixedFeeThreshold',
  /** column name */
  Id = 'id',
  /** column name */
  InitialDuration = 'initialDuration',
  /** column name */
  MainSignDate = 'mainSignDate',
  /** column name */
  MaxRenewal = 'maxRenewal',
  /** column name */
  ParticularConditions = 'particularConditions',
  /** column name */
  PrecontractualDate = 'precontractualDate',
  /** column name */
  ProportionalFeesRate = 'proportionalFeesRate',
  /** column name */
  RenewalDuration = 'renewalDuration',
  /** column name */
  ReservePrice = 'reservePrice',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "mandate" */
export type Mandate_Set_Input = {
  amendmentNumber?: InputMaybe<Scalars['String']['input']>;
  cancellationDate?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  earnedMoney?: InputMaybe<Scalars['Int']['input']>;
  earnedMoneyPaid?: InputMaybe<Scalars['Int']['input']>;
  effectiveCancellationDate?: InputMaybe<Scalars['timestamptz']['input']>;
  effectiveDate?: InputMaybe<Scalars['timestamptz']['input']>;
  estateId?: InputMaybe<Scalars['uuid']['input']>;
  feePerson?: InputMaybe<Mandate_Fee_Person_Enum>;
  feeVATRate?: InputMaybe<Scalars['numeric']['input']>;
  firstPrice?: InputMaybe<Scalars['String']['input']>;
  fixedFee?: InputMaybe<Scalars['Int']['input']>;
  fixedFeeThreshold?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  initialDuration?: InputMaybe<Scalars['Int']['input']>;
  mainSignDate?: InputMaybe<Scalars['timestamptz']['input']>;
  maxRenewal?: InputMaybe<Scalars['Int']['input']>;
  particularConditions?: InputMaybe<Scalars['String']['input']>;
  precontractualDate?: InputMaybe<Scalars['timestamptz']['input']>;
  proportionalFeesRate?: InputMaybe<Scalars['numeric']['input']>;
  renewalDuration?: InputMaybe<Scalars['Int']['input']>;
  reservePrice?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Mandate_Status_Enum>;
  type?: InputMaybe<Mandate_Type_Enum>;
};

/** columns and relationships of "mandate_status" */
export type Mandate_Status = {
  __typename?: 'mandate_status';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "mandate_status" */
export type Mandate_Status_Aggregate = {
  __typename?: 'mandate_status_aggregate';
  aggregate?: Maybe<Mandate_Status_Aggregate_Fields>;
  nodes: Array<Mandate_Status>;
};

/** aggregate fields of "mandate_status" */
export type Mandate_Status_Aggregate_Fields = {
  __typename?: 'mandate_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Mandate_Status_Max_Fields>;
  min?: Maybe<Mandate_Status_Min_Fields>;
};


/** aggregate fields of "mandate_status" */
export type Mandate_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mandate_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "mandate_status". All fields are combined with a logical 'AND'. */
export type Mandate_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Mandate_Status_Bool_Exp>>;
  _not?: InputMaybe<Mandate_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Mandate_Status_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "mandate_status" */
export enum Mandate_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  MandateStatusPkey = 'mandate_status_pkey'
}

export enum Mandate_Status_Enum {
  Active = 'Active',
  Available = 'Available',
  Draft = 'Draft'
}

/** Boolean expression to compare columns of type "mandate_status_enum". All fields are combined with logical 'AND'. */
export type Mandate_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Mandate_Status_Enum>;
  _in?: InputMaybe<Array<Mandate_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Mandate_Status_Enum>;
  _nin?: InputMaybe<Array<Mandate_Status_Enum>>;
};

/** input type for inserting data into table "mandate_status" */
export type Mandate_Status_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Mandate_Status_Max_Fields = {
  __typename?: 'mandate_status_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Mandate_Status_Min_Fields = {
  __typename?: 'mandate_status_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "mandate_status" */
export type Mandate_Status_Mutation_Response = {
  __typename?: 'mandate_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mandate_Status>;
};

/** on_conflict condition type for table "mandate_status" */
export type Mandate_Status_On_Conflict = {
  constraint: Mandate_Status_Constraint;
  update_columns?: Array<Mandate_Status_Update_Column>;
  where?: InputMaybe<Mandate_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "mandate_status". */
export type Mandate_Status_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mandate_status */
export type Mandate_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "mandate_status" */
export enum Mandate_Status_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "mandate_status" */
export type Mandate_Status_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "mandate_status" */
export type Mandate_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mandate_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mandate_Status_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "mandate_status" */
export enum Mandate_Status_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Mandate_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mandate_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mandate_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Mandate_Stddev_Fields = {
  __typename?: 'mandate_stddev_fields';
  earnedMoney?: Maybe<Scalars['Float']['output']>;
  earnedMoneyPaid?: Maybe<Scalars['Float']['output']>;
  feeVATRate?: Maybe<Scalars['Float']['output']>;
  fixedFee?: Maybe<Scalars['Float']['output']>;
  fixedFeeThreshold?: Maybe<Scalars['Float']['output']>;
  initialDuration?: Maybe<Scalars['Float']['output']>;
  maxRenewal?: Maybe<Scalars['Float']['output']>;
  proportionalFeesRate?: Maybe<Scalars['Float']['output']>;
  renewalDuration?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mandate_Stddev_Pop_Fields = {
  __typename?: 'mandate_stddev_pop_fields';
  earnedMoney?: Maybe<Scalars['Float']['output']>;
  earnedMoneyPaid?: Maybe<Scalars['Float']['output']>;
  feeVATRate?: Maybe<Scalars['Float']['output']>;
  fixedFee?: Maybe<Scalars['Float']['output']>;
  fixedFeeThreshold?: Maybe<Scalars['Float']['output']>;
  initialDuration?: Maybe<Scalars['Float']['output']>;
  maxRenewal?: Maybe<Scalars['Float']['output']>;
  proportionalFeesRate?: Maybe<Scalars['Float']['output']>;
  renewalDuration?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mandate_Stddev_Samp_Fields = {
  __typename?: 'mandate_stddev_samp_fields';
  earnedMoney?: Maybe<Scalars['Float']['output']>;
  earnedMoneyPaid?: Maybe<Scalars['Float']['output']>;
  feeVATRate?: Maybe<Scalars['Float']['output']>;
  fixedFee?: Maybe<Scalars['Float']['output']>;
  fixedFeeThreshold?: Maybe<Scalars['Float']['output']>;
  initialDuration?: Maybe<Scalars['Float']['output']>;
  maxRenewal?: Maybe<Scalars['Float']['output']>;
  proportionalFeesRate?: Maybe<Scalars['Float']['output']>;
  renewalDuration?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mandate" */
export type Mandate_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mandate_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mandate_Stream_Cursor_Value_Input = {
  amendmentNumber?: InputMaybe<Scalars['String']['input']>;
  cancellationDate?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  earnedMoney?: InputMaybe<Scalars['Int']['input']>;
  earnedMoneyPaid?: InputMaybe<Scalars['Int']['input']>;
  effectiveCancellationDate?: InputMaybe<Scalars['timestamptz']['input']>;
  effectiveDate?: InputMaybe<Scalars['timestamptz']['input']>;
  estateId?: InputMaybe<Scalars['uuid']['input']>;
  feePerson?: InputMaybe<Mandate_Fee_Person_Enum>;
  feeVATRate?: InputMaybe<Scalars['numeric']['input']>;
  firstPrice?: InputMaybe<Scalars['String']['input']>;
  fixedFee?: InputMaybe<Scalars['Int']['input']>;
  fixedFeeThreshold?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  initialDuration?: InputMaybe<Scalars['Int']['input']>;
  mainSignDate?: InputMaybe<Scalars['timestamptz']['input']>;
  maxRenewal?: InputMaybe<Scalars['Int']['input']>;
  particularConditions?: InputMaybe<Scalars['String']['input']>;
  precontractualDate?: InputMaybe<Scalars['timestamptz']['input']>;
  proportionalFeesRate?: InputMaybe<Scalars['numeric']['input']>;
  renewalDuration?: InputMaybe<Scalars['Int']['input']>;
  reservePrice?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Mandate_Status_Enum>;
  type?: InputMaybe<Mandate_Type_Enum>;
};

/** aggregate sum on columns */
export type Mandate_Sum_Fields = {
  __typename?: 'mandate_sum_fields';
  earnedMoney?: Maybe<Scalars['Int']['output']>;
  earnedMoneyPaid?: Maybe<Scalars['Int']['output']>;
  feeVATRate?: Maybe<Scalars['numeric']['output']>;
  fixedFee?: Maybe<Scalars['Int']['output']>;
  fixedFeeThreshold?: Maybe<Scalars['Int']['output']>;
  initialDuration?: Maybe<Scalars['Int']['output']>;
  maxRenewal?: Maybe<Scalars['Int']['output']>;
  proportionalFeesRate?: Maybe<Scalars['numeric']['output']>;
  renewalDuration?: Maybe<Scalars['Int']['output']>;
};

/** columns and relationships of "mandate_type" */
export type Mandate_Type = {
  __typename?: 'mandate_type';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "mandate_type" */
export type Mandate_Type_Aggregate = {
  __typename?: 'mandate_type_aggregate';
  aggregate?: Maybe<Mandate_Type_Aggregate_Fields>;
  nodes: Array<Mandate_Type>;
};

/** aggregate fields of "mandate_type" */
export type Mandate_Type_Aggregate_Fields = {
  __typename?: 'mandate_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Mandate_Type_Max_Fields>;
  min?: Maybe<Mandate_Type_Min_Fields>;
};


/** aggregate fields of "mandate_type" */
export type Mandate_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mandate_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "mandate_type". All fields are combined with a logical 'AND'. */
export type Mandate_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Mandate_Type_Bool_Exp>>;
  _not?: InputMaybe<Mandate_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Mandate_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "mandate_type" */
export enum Mandate_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  MandateTypePkey = 'mandate_type_pkey'
}

export enum Mandate_Type_Enum {
  Exclusive = 'Exclusive',
  Other = 'Other',
  Simple = 'Simple'
}

/** Boolean expression to compare columns of type "mandate_type_enum". All fields are combined with logical 'AND'. */
export type Mandate_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Mandate_Type_Enum>;
  _in?: InputMaybe<Array<Mandate_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Mandate_Type_Enum>;
  _nin?: InputMaybe<Array<Mandate_Type_Enum>>;
};

/** input type for inserting data into table "mandate_type" */
export type Mandate_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Mandate_Type_Max_Fields = {
  __typename?: 'mandate_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Mandate_Type_Min_Fields = {
  __typename?: 'mandate_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "mandate_type" */
export type Mandate_Type_Mutation_Response = {
  __typename?: 'mandate_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mandate_Type>;
};

/** on_conflict condition type for table "mandate_type" */
export type Mandate_Type_On_Conflict = {
  constraint: Mandate_Type_Constraint;
  update_columns?: Array<Mandate_Type_Update_Column>;
  where?: InputMaybe<Mandate_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "mandate_type". */
export type Mandate_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mandate_type */
export type Mandate_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "mandate_type" */
export enum Mandate_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "mandate_type" */
export type Mandate_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "mandate_type" */
export type Mandate_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mandate_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mandate_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "mandate_type" */
export enum Mandate_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Mandate_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mandate_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mandate_Type_Bool_Exp;
};

/** update columns of table "mandate" */
export enum Mandate_Update_Column {
  /** column name */
  AmendmentNumber = 'amendmentNumber',
  /** column name */
  CancellationDate = 'cancellationDate',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EarnedMoney = 'earnedMoney',
  /** column name */
  EarnedMoneyPaid = 'earnedMoneyPaid',
  /** column name */
  EffectiveCancellationDate = 'effectiveCancellationDate',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  EstateId = 'estateId',
  /** column name */
  FeePerson = 'feePerson',
  /** column name */
  FeeVatRate = 'feeVATRate',
  /** column name */
  FirstPrice = 'firstPrice',
  /** column name */
  FixedFee = 'fixedFee',
  /** column name */
  FixedFeeThreshold = 'fixedFeeThreshold',
  /** column name */
  Id = 'id',
  /** column name */
  InitialDuration = 'initialDuration',
  /** column name */
  MainSignDate = 'mainSignDate',
  /** column name */
  MaxRenewal = 'maxRenewal',
  /** column name */
  ParticularConditions = 'particularConditions',
  /** column name */
  PrecontractualDate = 'precontractualDate',
  /** column name */
  ProportionalFeesRate = 'proportionalFeesRate',
  /** column name */
  RenewalDuration = 'renewalDuration',
  /** column name */
  ReservePrice = 'reservePrice',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type'
}

export type Mandate_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mandate_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mandate_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mandate_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mandate_Var_Pop_Fields = {
  __typename?: 'mandate_var_pop_fields';
  earnedMoney?: Maybe<Scalars['Float']['output']>;
  earnedMoneyPaid?: Maybe<Scalars['Float']['output']>;
  feeVATRate?: Maybe<Scalars['Float']['output']>;
  fixedFee?: Maybe<Scalars['Float']['output']>;
  fixedFeeThreshold?: Maybe<Scalars['Float']['output']>;
  initialDuration?: Maybe<Scalars['Float']['output']>;
  maxRenewal?: Maybe<Scalars['Float']['output']>;
  proportionalFeesRate?: Maybe<Scalars['Float']['output']>;
  renewalDuration?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mandate_Var_Samp_Fields = {
  __typename?: 'mandate_var_samp_fields';
  earnedMoney?: Maybe<Scalars['Float']['output']>;
  earnedMoneyPaid?: Maybe<Scalars['Float']['output']>;
  feeVATRate?: Maybe<Scalars['Float']['output']>;
  fixedFee?: Maybe<Scalars['Float']['output']>;
  fixedFeeThreshold?: Maybe<Scalars['Float']['output']>;
  initialDuration?: Maybe<Scalars['Float']['output']>;
  maxRenewal?: Maybe<Scalars['Float']['output']>;
  proportionalFeesRate?: Maybe<Scalars['Float']['output']>;
  renewalDuration?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mandate_Variance_Fields = {
  __typename?: 'mandate_variance_fields';
  earnedMoney?: Maybe<Scalars['Float']['output']>;
  earnedMoneyPaid?: Maybe<Scalars['Float']['output']>;
  feeVATRate?: Maybe<Scalars['Float']['output']>;
  fixedFee?: Maybe<Scalars['Float']['output']>;
  fixedFeeThreshold?: Maybe<Scalars['Float']['output']>;
  initialDuration?: Maybe<Scalars['Float']['output']>;
  maxRenewal?: Maybe<Scalars['Float']['output']>;
  proportionalFeesRate?: Maybe<Scalars['Float']['output']>;
  renewalDuration?: Maybe<Scalars['Float']['output']>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete single row from the table: "auth.providers" */
  deleteAuthProvider?: Maybe<AuthProviders>;
  /** delete single row from the table: "auth.provider_requests" */
  deleteAuthProviderRequest?: Maybe<AuthProviderRequests>;
  /** delete data from the table: "auth.provider_requests" */
  deleteAuthProviderRequests?: Maybe<AuthProviderRequests_Mutation_Response>;
  /** delete data from the table: "auth.providers" */
  deleteAuthProviders?: Maybe<AuthProviders_Mutation_Response>;
  /** delete single row from the table: "auth.refresh_tokens" */
  deleteAuthRefreshToken?: Maybe<AuthRefreshTokens>;
  /** delete single row from the table: "auth.refresh_token_types" */
  deleteAuthRefreshTokenType?: Maybe<AuthRefreshTokenTypes>;
  /** delete data from the table: "auth.refresh_token_types" */
  deleteAuthRefreshTokenTypes?: Maybe<AuthRefreshTokenTypes_Mutation_Response>;
  /** delete data from the table: "auth.refresh_tokens" */
  deleteAuthRefreshTokens?: Maybe<AuthRefreshTokens_Mutation_Response>;
  /** delete single row from the table: "auth.roles" */
  deleteAuthRole?: Maybe<AuthRoles>;
  /** delete data from the table: "auth.roles" */
  deleteAuthRoles?: Maybe<AuthRoles_Mutation_Response>;
  /** delete single row from the table: "auth.user_providers" */
  deleteAuthUserProvider?: Maybe<AuthUserProviders>;
  /** delete data from the table: "auth.user_providers" */
  deleteAuthUserProviders?: Maybe<AuthUserProviders_Mutation_Response>;
  /** delete single row from the table: "auth.user_roles" */
  deleteAuthUserRole?: Maybe<AuthUserRoles>;
  /** delete data from the table: "auth.user_roles" */
  deleteAuthUserRoles?: Maybe<AuthUserRoles_Mutation_Response>;
  /** delete single row from the table: "auth.user_security_keys" */
  deleteAuthUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** delete data from the table: "auth.user_security_keys" */
  deleteAuthUserSecurityKeys?: Maybe<AuthUserSecurityKeys_Mutation_Response>;
  /** delete single row from the table: "storage.buckets" */
  deleteBucket?: Maybe<Buckets>;
  /** delete data from the table: "storage.buckets" */
  deleteBuckets?: Maybe<Buckets_Mutation_Response>;
  /** delete single row from the table: "storage.files" */
  deleteFile?: Maybe<Files>;
  /** delete data from the table: "storage.files" */
  deleteFiles?: Maybe<Files_Mutation_Response>;
  /** delete single row from the table: "auth.users" */
  deleteUser?: Maybe<Users>;
  /** delete data from the table: "auth.users" */
  deleteUsers?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "storage.virus" */
  deleteVirus?: Maybe<Virus>;
  /** delete data from the table: "storage.virus" */
  deleteViruses?: Maybe<Virus_Mutation_Response>;
  /** delete data from the table: "agency" */
  delete_agency?: Maybe<Agency_Mutation_Response>;
  /** delete single row from the table: "agency" */
  delete_agency_by_pk?: Maybe<Agency>;
  /** delete data from the table: "agency_member" */
  delete_agency_member?: Maybe<Agency_Member_Mutation_Response>;
  /** delete single row from the table: "agency_member" */
  delete_agency_member_by_pk?: Maybe<Agency_Member>;
  /** delete data from the table: "application" */
  delete_application?: Maybe<Application_Mutation_Response>;
  /** delete single row from the table: "application" */
  delete_application_by_pk?: Maybe<Application>;
  /** delete data from the table: "application_media" */
  delete_application_media?: Maybe<Application_Media_Mutation_Response>;
  /** delete single row from the table: "application_media" */
  delete_application_media_by_pk?: Maybe<Application_Media>;
  /** delete data from the table: "application_media_type" */
  delete_application_media_type?: Maybe<Application_Media_Type_Mutation_Response>;
  /** delete single row from the table: "application_media_type" */
  delete_application_media_type_by_pk?: Maybe<Application_Media_Type>;
  /** delete data from the table: "application_status" */
  delete_application_status?: Maybe<Application_Status_Mutation_Response>;
  /** delete single row from the table: "application_status" */
  delete_application_status_by_pk?: Maybe<Application_Status>;
  /** delete data from the table: "buyer_member" */
  delete_buyer_member?: Maybe<Buyer_Member_Mutation_Response>;
  /** delete single row from the table: "buyer_member" */
  delete_buyer_member_by_pk?: Maybe<Buyer_Member>;
  /** delete data from the table: "buyer_member_folder" */
  delete_buyer_member_folder?: Maybe<Buyer_Member_Folder_Mutation_Response>;
  /** delete single row from the table: "buyer_member_folder" */
  delete_buyer_member_folder_by_pk?: Maybe<Buyer_Member_Folder>;
  /** delete data from the table: "civility" */
  delete_civility?: Maybe<Civility_Mutation_Response>;
  /** delete single row from the table: "civility" */
  delete_civility_by_pk?: Maybe<Civility>;
  /** delete data from the table: "estate" */
  delete_estate?: Maybe<Estate_Mutation_Response>;
  /** delete single row from the table: "estate" */
  delete_estate_by_pk?: Maybe<Estate>;
  /** delete data from the table: "estate_link" */
  delete_estate_link?: Maybe<Estate_Link_Mutation_Response>;
  /** delete single row from the table: "estate_link" */
  delete_estate_link_by_pk?: Maybe<Estate_Link>;
  /** delete data from the table: "estate_media" */
  delete_estate_media?: Maybe<Estate_Media_Mutation_Response>;
  /** delete single row from the table: "estate_media" */
  delete_estate_media_by_pk?: Maybe<Estate_Media>;
  /** delete data from the table: "estate_media_type" */
  delete_estate_media_type?: Maybe<Estate_Media_Type_Mutation_Response>;
  /** delete single row from the table: "estate_media_type" */
  delete_estate_media_type_by_pk?: Maybe<Estate_Media_Type>;
  /** delete data from the table: "estate_media_type_group" */
  delete_estate_media_type_group?: Maybe<Estate_Media_Type_Group_Mutation_Response>;
  /** delete single row from the table: "estate_media_type_group" */
  delete_estate_media_type_group_by_pk?: Maybe<Estate_Media_Type_Group>;
  /** delete data from the table: "estate_media_type_name" */
  delete_estate_media_type_name?: Maybe<Estate_Media_Type_Name_Mutation_Response>;
  /** delete single row from the table: "estate_media_type_name" */
  delete_estate_media_type_name_by_pk?: Maybe<Estate_Media_Type_Name>;
  /** delete data from the table: "estate_round" */
  delete_estate_round?: Maybe<Estate_Round_Mutation_Response>;
  /** delete data from the table: "estate_round_buyer_member" */
  delete_estate_round_buyer_member?: Maybe<Estate_Round_Buyer_Member_Mutation_Response>;
  /** delete single row from the table: "estate_round_buyer_member" */
  delete_estate_round_buyer_member_by_pk?: Maybe<Estate_Round_Buyer_Member>;
  /** delete single row from the table: "estate_round" */
  delete_estate_round_by_pk?: Maybe<Estate_Round>;
  /** delete data from the table: "estate_seller" */
  delete_estate_seller?: Maybe<Estate_Seller_Mutation_Response>;
  /** delete single row from the table: "estate_seller" */
  delete_estate_seller_by_pk?: Maybe<Estate_Seller>;
  /** delete data from the table: "estate_type" */
  delete_estate_type?: Maybe<Estate_Type_Mutation_Response>;
  /** delete single row from the table: "estate_type" */
  delete_estate_type_by_pk?: Maybe<Estate_Type>;
  /** delete data from the table: "mandate" */
  delete_mandate?: Maybe<Mandate_Mutation_Response>;
  /** delete single row from the table: "mandate" */
  delete_mandate_by_pk?: Maybe<Mandate>;
  /** delete data from the table: "mandate_fee_person" */
  delete_mandate_fee_person?: Maybe<Mandate_Fee_Person_Mutation_Response>;
  /** delete single row from the table: "mandate_fee_person" */
  delete_mandate_fee_person_by_pk?: Maybe<Mandate_Fee_Person>;
  /** delete data from the table: "mandate_media" */
  delete_mandate_media?: Maybe<Mandate_Media_Mutation_Response>;
  /** delete single row from the table: "mandate_media" */
  delete_mandate_media_by_pk?: Maybe<Mandate_Media>;
  /** delete data from the table: "mandate_registry" */
  delete_mandate_registry?: Maybe<Mandate_Registry_Mutation_Response>;
  /** delete single row from the table: "mandate_registry" */
  delete_mandate_registry_by_pk?: Maybe<Mandate_Registry>;
  /** delete data from the table: "mandate_registry_number_lock" */
  delete_mandate_registry_number_lock?: Maybe<Mandate_Registry_Number_Lock_Mutation_Response>;
  /** delete single row from the table: "mandate_registry_number_lock" */
  delete_mandate_registry_number_lock_by_pk?: Maybe<Mandate_Registry_Number_Lock>;
  /** delete data from the table: "mandate_status" */
  delete_mandate_status?: Maybe<Mandate_Status_Mutation_Response>;
  /** delete single row from the table: "mandate_status" */
  delete_mandate_status_by_pk?: Maybe<Mandate_Status>;
  /** delete data from the table: "mandate_type" */
  delete_mandate_type?: Maybe<Mandate_Type_Mutation_Response>;
  /** delete single row from the table: "mandate_type" */
  delete_mandate_type_by_pk?: Maybe<Mandate_Type>;
  /** delete data from the table: "seller" */
  delete_seller?: Maybe<Seller_Mutation_Response>;
  /** delete single row from the table: "seller" */
  delete_seller_by_pk?: Maybe<Seller>;
  /** delete data from the table: "seller_legal_status" */
  delete_seller_legal_status?: Maybe<Seller_Legal_Status_Mutation_Response>;
  /** delete single row from the table: "seller_legal_status" */
  delete_seller_legal_status_by_pk?: Maybe<Seller_Legal_Status>;
  /** delete data from the table: "seller_marital_status" */
  delete_seller_marital_status?: Maybe<Seller_Marital_Status_Mutation_Response>;
  /** delete single row from the table: "seller_marital_status" */
  delete_seller_marital_status_by_pk?: Maybe<Seller_Marital_Status>;
  /** delete data from the table: "seller_media" */
  delete_seller_media?: Maybe<Seller_Media_Mutation_Response>;
  /** delete single row from the table: "seller_media" */
  delete_seller_media_by_pk?: Maybe<Seller_Media>;
  /** delete data from the table: "seller_member" */
  delete_seller_member?: Maybe<Seller_Member_Mutation_Response>;
  /** delete single row from the table: "seller_member" */
  delete_seller_member_by_pk?: Maybe<Seller_Member>;
  /** delete data from the table: "seller_tax_system" */
  delete_seller_tax_system?: Maybe<Seller_Tax_System_Mutation_Response>;
  /** delete single row from the table: "seller_tax_system" */
  delete_seller_tax_system_by_pk?: Maybe<Seller_Tax_System>;
  /** delete data from the table: "seller_type" */
  delete_seller_type?: Maybe<Seller_Type_Mutation_Response>;
  /** delete single row from the table: "seller_type" */
  delete_seller_type_by_pk?: Maybe<Seller_Type>;
  /** delete data from the table: "visit" */
  delete_visit?: Maybe<Visit_Mutation_Response>;
  /** delete single row from the table: "visit" */
  delete_visit_by_pk?: Maybe<Visit>;
  /** delete data from the table: "visit_span" */
  delete_visit_span?: Maybe<Visit_Span_Mutation_Response>;
  /** delete single row from the table: "visit_span" */
  delete_visit_span_by_pk?: Maybe<Visit_Span>;
  /** insert a single row into the table: "auth.providers" */
  insertAuthProvider?: Maybe<AuthProviders>;
  /** insert a single row into the table: "auth.provider_requests" */
  insertAuthProviderRequest?: Maybe<AuthProviderRequests>;
  /** insert data into the table: "auth.provider_requests" */
  insertAuthProviderRequests?: Maybe<AuthProviderRequests_Mutation_Response>;
  /** insert data into the table: "auth.providers" */
  insertAuthProviders?: Maybe<AuthProviders_Mutation_Response>;
  /** insert a single row into the table: "auth.refresh_tokens" */
  insertAuthRefreshToken?: Maybe<AuthRefreshTokens>;
  /** insert a single row into the table: "auth.refresh_token_types" */
  insertAuthRefreshTokenType?: Maybe<AuthRefreshTokenTypes>;
  /** insert data into the table: "auth.refresh_token_types" */
  insertAuthRefreshTokenTypes?: Maybe<AuthRefreshTokenTypes_Mutation_Response>;
  /** insert data into the table: "auth.refresh_tokens" */
  insertAuthRefreshTokens?: Maybe<AuthRefreshTokens_Mutation_Response>;
  /** insert a single row into the table: "auth.roles" */
  insertAuthRole?: Maybe<AuthRoles>;
  /** insert data into the table: "auth.roles" */
  insertAuthRoles?: Maybe<AuthRoles_Mutation_Response>;
  /** insert a single row into the table: "auth.user_providers" */
  insertAuthUserProvider?: Maybe<AuthUserProviders>;
  /** insert data into the table: "auth.user_providers" */
  insertAuthUserProviders?: Maybe<AuthUserProviders_Mutation_Response>;
  /** insert a single row into the table: "auth.user_roles" */
  insertAuthUserRole?: Maybe<AuthUserRoles>;
  /** insert data into the table: "auth.user_roles" */
  insertAuthUserRoles?: Maybe<AuthUserRoles_Mutation_Response>;
  /** insert a single row into the table: "auth.user_security_keys" */
  insertAuthUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** insert data into the table: "auth.user_security_keys" */
  insertAuthUserSecurityKeys?: Maybe<AuthUserSecurityKeys_Mutation_Response>;
  /** insert a single row into the table: "storage.buckets" */
  insertBucket?: Maybe<Buckets>;
  /** insert data into the table: "storage.buckets" */
  insertBuckets?: Maybe<Buckets_Mutation_Response>;
  /** insert a single row into the table: "storage.files" */
  insertFile?: Maybe<Files>;
  /** insert data into the table: "storage.files" */
  insertFiles?: Maybe<Files_Mutation_Response>;
  /** insert a single row into the table: "auth.users" */
  insertUser?: Maybe<Users>;
  /** insert data into the table: "auth.users" */
  insertUsers?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "storage.virus" */
  insertVirus?: Maybe<Virus>;
  /** insert data into the table: "storage.virus" */
  insertViruses?: Maybe<Virus_Mutation_Response>;
  /** insert data into the table: "agency" */
  insert_agency?: Maybe<Agency_Mutation_Response>;
  /** insert data into the table: "agency_member" */
  insert_agency_member?: Maybe<Agency_Member_Mutation_Response>;
  /** insert a single row into the table: "agency_member" */
  insert_agency_member_one?: Maybe<Agency_Member>;
  /** insert a single row into the table: "agency" */
  insert_agency_one?: Maybe<Agency>;
  /** insert data into the table: "application" */
  insert_application?: Maybe<Application_Mutation_Response>;
  /** insert data into the table: "application_media" */
  insert_application_media?: Maybe<Application_Media_Mutation_Response>;
  /** insert a single row into the table: "application_media" */
  insert_application_media_one?: Maybe<Application_Media>;
  /** insert data into the table: "application_media_type" */
  insert_application_media_type?: Maybe<Application_Media_Type_Mutation_Response>;
  /** insert a single row into the table: "application_media_type" */
  insert_application_media_type_one?: Maybe<Application_Media_Type>;
  /** insert a single row into the table: "application" */
  insert_application_one?: Maybe<Application>;
  /** insert data into the table: "application_status" */
  insert_application_status?: Maybe<Application_Status_Mutation_Response>;
  /** insert a single row into the table: "application_status" */
  insert_application_status_one?: Maybe<Application_Status>;
  /** insert data into the table: "buyer_member" */
  insert_buyer_member?: Maybe<Buyer_Member_Mutation_Response>;
  /** insert data into the table: "buyer_member_folder" */
  insert_buyer_member_folder?: Maybe<Buyer_Member_Folder_Mutation_Response>;
  /** insert a single row into the table: "buyer_member_folder" */
  insert_buyer_member_folder_one?: Maybe<Buyer_Member_Folder>;
  /** insert a single row into the table: "buyer_member" */
  insert_buyer_member_one?: Maybe<Buyer_Member>;
  /** insert data into the table: "civility" */
  insert_civility?: Maybe<Civility_Mutation_Response>;
  /** insert a single row into the table: "civility" */
  insert_civility_one?: Maybe<Civility>;
  /** insert data into the table: "estate" */
  insert_estate?: Maybe<Estate_Mutation_Response>;
  /** insert data into the table: "estate_link" */
  insert_estate_link?: Maybe<Estate_Link_Mutation_Response>;
  /** insert a single row into the table: "estate_link" */
  insert_estate_link_one?: Maybe<Estate_Link>;
  /** insert data into the table: "estate_media" */
  insert_estate_media?: Maybe<Estate_Media_Mutation_Response>;
  /** insert a single row into the table: "estate_media" */
  insert_estate_media_one?: Maybe<Estate_Media>;
  /** insert data into the table: "estate_media_type" */
  insert_estate_media_type?: Maybe<Estate_Media_Type_Mutation_Response>;
  /** insert data into the table: "estate_media_type_group" */
  insert_estate_media_type_group?: Maybe<Estate_Media_Type_Group_Mutation_Response>;
  /** insert a single row into the table: "estate_media_type_group" */
  insert_estate_media_type_group_one?: Maybe<Estate_Media_Type_Group>;
  /** insert data into the table: "estate_media_type_name" */
  insert_estate_media_type_name?: Maybe<Estate_Media_Type_Name_Mutation_Response>;
  /** insert a single row into the table: "estate_media_type_name" */
  insert_estate_media_type_name_one?: Maybe<Estate_Media_Type_Name>;
  /** insert a single row into the table: "estate_media_type" */
  insert_estate_media_type_one?: Maybe<Estate_Media_Type>;
  /** insert a single row into the table: "estate" */
  insert_estate_one?: Maybe<Estate>;
  /** insert data into the table: "estate_round" */
  insert_estate_round?: Maybe<Estate_Round_Mutation_Response>;
  /** insert data into the table: "estate_round_buyer_member" */
  insert_estate_round_buyer_member?: Maybe<Estate_Round_Buyer_Member_Mutation_Response>;
  /** insert a single row into the table: "estate_round_buyer_member" */
  insert_estate_round_buyer_member_one?: Maybe<Estate_Round_Buyer_Member>;
  /** insert a single row into the table: "estate_round" */
  insert_estate_round_one?: Maybe<Estate_Round>;
  /** insert data into the table: "estate_seller" */
  insert_estate_seller?: Maybe<Estate_Seller_Mutation_Response>;
  /** insert a single row into the table: "estate_seller" */
  insert_estate_seller_one?: Maybe<Estate_Seller>;
  /** insert data into the table: "estate_type" */
  insert_estate_type?: Maybe<Estate_Type_Mutation_Response>;
  /** insert a single row into the table: "estate_type" */
  insert_estate_type_one?: Maybe<Estate_Type>;
  /** insert data into the table: "mandate" */
  insert_mandate?: Maybe<Mandate_Mutation_Response>;
  /** insert data into the table: "mandate_fee_person" */
  insert_mandate_fee_person?: Maybe<Mandate_Fee_Person_Mutation_Response>;
  /** insert a single row into the table: "mandate_fee_person" */
  insert_mandate_fee_person_one?: Maybe<Mandate_Fee_Person>;
  /** insert data into the table: "mandate_media" */
  insert_mandate_media?: Maybe<Mandate_Media_Mutation_Response>;
  /** insert a single row into the table: "mandate_media" */
  insert_mandate_media_one?: Maybe<Mandate_Media>;
  /** insert a single row into the table: "mandate" */
  insert_mandate_one?: Maybe<Mandate>;
  /** insert data into the table: "mandate_registry" */
  insert_mandate_registry?: Maybe<Mandate_Registry_Mutation_Response>;
  /** insert data into the table: "mandate_registry_number_lock" */
  insert_mandate_registry_number_lock?: Maybe<Mandate_Registry_Number_Lock_Mutation_Response>;
  /** insert a single row into the table: "mandate_registry_number_lock" */
  insert_mandate_registry_number_lock_one?: Maybe<Mandate_Registry_Number_Lock>;
  /** insert a single row into the table: "mandate_registry" */
  insert_mandate_registry_one?: Maybe<Mandate_Registry>;
  /** insert data into the table: "mandate_status" */
  insert_mandate_status?: Maybe<Mandate_Status_Mutation_Response>;
  /** insert a single row into the table: "mandate_status" */
  insert_mandate_status_one?: Maybe<Mandate_Status>;
  /** insert data into the table: "mandate_type" */
  insert_mandate_type?: Maybe<Mandate_Type_Mutation_Response>;
  /** insert a single row into the table: "mandate_type" */
  insert_mandate_type_one?: Maybe<Mandate_Type>;
  /** insert data into the table: "seller" */
  insert_seller?: Maybe<Seller_Mutation_Response>;
  /** insert data into the table: "seller_legal_status" */
  insert_seller_legal_status?: Maybe<Seller_Legal_Status_Mutation_Response>;
  /** insert a single row into the table: "seller_legal_status" */
  insert_seller_legal_status_one?: Maybe<Seller_Legal_Status>;
  /** insert data into the table: "seller_marital_status" */
  insert_seller_marital_status?: Maybe<Seller_Marital_Status_Mutation_Response>;
  /** insert a single row into the table: "seller_marital_status" */
  insert_seller_marital_status_one?: Maybe<Seller_Marital_Status>;
  /** insert data into the table: "seller_media" */
  insert_seller_media?: Maybe<Seller_Media_Mutation_Response>;
  /** insert a single row into the table: "seller_media" */
  insert_seller_media_one?: Maybe<Seller_Media>;
  /** insert data into the table: "seller_member" */
  insert_seller_member?: Maybe<Seller_Member_Mutation_Response>;
  /** insert a single row into the table: "seller_member" */
  insert_seller_member_one?: Maybe<Seller_Member>;
  /** insert a single row into the table: "seller" */
  insert_seller_one?: Maybe<Seller>;
  /** insert data into the table: "seller_tax_system" */
  insert_seller_tax_system?: Maybe<Seller_Tax_System_Mutation_Response>;
  /** insert a single row into the table: "seller_tax_system" */
  insert_seller_tax_system_one?: Maybe<Seller_Tax_System>;
  /** insert data into the table: "seller_type" */
  insert_seller_type?: Maybe<Seller_Type_Mutation_Response>;
  /** insert a single row into the table: "seller_type" */
  insert_seller_type_one?: Maybe<Seller_Type>;
  /** insert data into the table: "visit" */
  insert_visit?: Maybe<Visit_Mutation_Response>;
  /** insert a single row into the table: "visit" */
  insert_visit_one?: Maybe<Visit>;
  /** insert data into the table: "visit_span" */
  insert_visit_span?: Maybe<Visit_Span_Mutation_Response>;
  /** insert a single row into the table: "visit_span" */
  insert_visit_span_one?: Maybe<Visit_Span>;
  /** update single row of the table: "auth.providers" */
  updateAuthProvider?: Maybe<AuthProviders>;
  /** update single row of the table: "auth.provider_requests" */
  updateAuthProviderRequest?: Maybe<AuthProviderRequests>;
  /** update data of the table: "auth.provider_requests" */
  updateAuthProviderRequests?: Maybe<AuthProviderRequests_Mutation_Response>;
  /** update data of the table: "auth.providers" */
  updateAuthProviders?: Maybe<AuthProviders_Mutation_Response>;
  /** update single row of the table: "auth.refresh_tokens" */
  updateAuthRefreshToken?: Maybe<AuthRefreshTokens>;
  /** update single row of the table: "auth.refresh_token_types" */
  updateAuthRefreshTokenType?: Maybe<AuthRefreshTokenTypes>;
  /** update data of the table: "auth.refresh_token_types" */
  updateAuthRefreshTokenTypes?: Maybe<AuthRefreshTokenTypes_Mutation_Response>;
  /** update data of the table: "auth.refresh_tokens" */
  updateAuthRefreshTokens?: Maybe<AuthRefreshTokens_Mutation_Response>;
  /** update single row of the table: "auth.roles" */
  updateAuthRole?: Maybe<AuthRoles>;
  /** update data of the table: "auth.roles" */
  updateAuthRoles?: Maybe<AuthRoles_Mutation_Response>;
  /** update single row of the table: "auth.user_providers" */
  updateAuthUserProvider?: Maybe<AuthUserProviders>;
  /** update data of the table: "auth.user_providers" */
  updateAuthUserProviders?: Maybe<AuthUserProviders_Mutation_Response>;
  /** update single row of the table: "auth.user_roles" */
  updateAuthUserRole?: Maybe<AuthUserRoles>;
  /** update data of the table: "auth.user_roles" */
  updateAuthUserRoles?: Maybe<AuthUserRoles_Mutation_Response>;
  /** update single row of the table: "auth.user_security_keys" */
  updateAuthUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** update data of the table: "auth.user_security_keys" */
  updateAuthUserSecurityKeys?: Maybe<AuthUserSecurityKeys_Mutation_Response>;
  /** update single row of the table: "storage.buckets" */
  updateBucket?: Maybe<Buckets>;
  /** update data of the table: "storage.buckets" */
  updateBuckets?: Maybe<Buckets_Mutation_Response>;
  /** update single row of the table: "storage.files" */
  updateFile?: Maybe<Files>;
  /** update data of the table: "storage.files" */
  updateFiles?: Maybe<Files_Mutation_Response>;
  /** update single row of the table: "auth.users" */
  updateUser?: Maybe<Users>;
  /** update data of the table: "auth.users" */
  updateUsers?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "storage.virus" */
  updateVirus?: Maybe<Virus>;
  /** update data of the table: "storage.virus" */
  updateViruses?: Maybe<Virus_Mutation_Response>;
  /** update data of the table: "agency" */
  update_agency?: Maybe<Agency_Mutation_Response>;
  /** update single row of the table: "agency" */
  update_agency_by_pk?: Maybe<Agency>;
  /** update multiples rows of table: "agency" */
  update_agency_many?: Maybe<Array<Maybe<Agency_Mutation_Response>>>;
  /** update data of the table: "agency_member" */
  update_agency_member?: Maybe<Agency_Member_Mutation_Response>;
  /** update single row of the table: "agency_member" */
  update_agency_member_by_pk?: Maybe<Agency_Member>;
  /** update multiples rows of table: "agency_member" */
  update_agency_member_many?: Maybe<Array<Maybe<Agency_Member_Mutation_Response>>>;
  /** update data of the table: "application" */
  update_application?: Maybe<Application_Mutation_Response>;
  /** update single row of the table: "application" */
  update_application_by_pk?: Maybe<Application>;
  /** update multiples rows of table: "application" */
  update_application_many?: Maybe<Array<Maybe<Application_Mutation_Response>>>;
  /** update data of the table: "application_media" */
  update_application_media?: Maybe<Application_Media_Mutation_Response>;
  /** update single row of the table: "application_media" */
  update_application_media_by_pk?: Maybe<Application_Media>;
  /** update multiples rows of table: "application_media" */
  update_application_media_many?: Maybe<Array<Maybe<Application_Media_Mutation_Response>>>;
  /** update data of the table: "application_media_type" */
  update_application_media_type?: Maybe<Application_Media_Type_Mutation_Response>;
  /** update single row of the table: "application_media_type" */
  update_application_media_type_by_pk?: Maybe<Application_Media_Type>;
  /** update multiples rows of table: "application_media_type" */
  update_application_media_type_many?: Maybe<Array<Maybe<Application_Media_Type_Mutation_Response>>>;
  /** update data of the table: "application_status" */
  update_application_status?: Maybe<Application_Status_Mutation_Response>;
  /** update single row of the table: "application_status" */
  update_application_status_by_pk?: Maybe<Application_Status>;
  /** update multiples rows of table: "application_status" */
  update_application_status_many?: Maybe<Array<Maybe<Application_Status_Mutation_Response>>>;
  /** update multiples rows of table: "auth.provider_requests" */
  update_authProviderRequests_many?: Maybe<Array<Maybe<AuthProviderRequests_Mutation_Response>>>;
  /** update multiples rows of table: "auth.providers" */
  update_authProviders_many?: Maybe<Array<Maybe<AuthProviders_Mutation_Response>>>;
  /** update multiples rows of table: "auth.refresh_token_types" */
  update_authRefreshTokenTypes_many?: Maybe<Array<Maybe<AuthRefreshTokenTypes_Mutation_Response>>>;
  /** update multiples rows of table: "auth.refresh_tokens" */
  update_authRefreshTokens_many?: Maybe<Array<Maybe<AuthRefreshTokens_Mutation_Response>>>;
  /** update multiples rows of table: "auth.roles" */
  update_authRoles_many?: Maybe<Array<Maybe<AuthRoles_Mutation_Response>>>;
  /** update multiples rows of table: "auth.user_providers" */
  update_authUserProviders_many?: Maybe<Array<Maybe<AuthUserProviders_Mutation_Response>>>;
  /** update multiples rows of table: "auth.user_roles" */
  update_authUserRoles_many?: Maybe<Array<Maybe<AuthUserRoles_Mutation_Response>>>;
  /** update multiples rows of table: "auth.user_security_keys" */
  update_authUserSecurityKeys_many?: Maybe<Array<Maybe<AuthUserSecurityKeys_Mutation_Response>>>;
  /** update multiples rows of table: "storage.buckets" */
  update_buckets_many?: Maybe<Array<Maybe<Buckets_Mutation_Response>>>;
  /** update data of the table: "buyer_member" */
  update_buyer_member?: Maybe<Buyer_Member_Mutation_Response>;
  /** update single row of the table: "buyer_member" */
  update_buyer_member_by_pk?: Maybe<Buyer_Member>;
  /** update data of the table: "buyer_member_folder" */
  update_buyer_member_folder?: Maybe<Buyer_Member_Folder_Mutation_Response>;
  /** update single row of the table: "buyer_member_folder" */
  update_buyer_member_folder_by_pk?: Maybe<Buyer_Member_Folder>;
  /** update multiples rows of table: "buyer_member_folder" */
  update_buyer_member_folder_many?: Maybe<Array<Maybe<Buyer_Member_Folder_Mutation_Response>>>;
  /** update multiples rows of table: "buyer_member" */
  update_buyer_member_many?: Maybe<Array<Maybe<Buyer_Member_Mutation_Response>>>;
  /** update data of the table: "civility" */
  update_civility?: Maybe<Civility_Mutation_Response>;
  /** update single row of the table: "civility" */
  update_civility_by_pk?: Maybe<Civility>;
  /** update multiples rows of table: "civility" */
  update_civility_many?: Maybe<Array<Maybe<Civility_Mutation_Response>>>;
  /** update data of the table: "estate" */
  update_estate?: Maybe<Estate_Mutation_Response>;
  /** update single row of the table: "estate" */
  update_estate_by_pk?: Maybe<Estate>;
  /** update data of the table: "estate_link" */
  update_estate_link?: Maybe<Estate_Link_Mutation_Response>;
  /** update single row of the table: "estate_link" */
  update_estate_link_by_pk?: Maybe<Estate_Link>;
  /** update multiples rows of table: "estate_link" */
  update_estate_link_many?: Maybe<Array<Maybe<Estate_Link_Mutation_Response>>>;
  /** update multiples rows of table: "estate" */
  update_estate_many?: Maybe<Array<Maybe<Estate_Mutation_Response>>>;
  /** update data of the table: "estate_media" */
  update_estate_media?: Maybe<Estate_Media_Mutation_Response>;
  /** update single row of the table: "estate_media" */
  update_estate_media_by_pk?: Maybe<Estate_Media>;
  /** update multiples rows of table: "estate_media" */
  update_estate_media_many?: Maybe<Array<Maybe<Estate_Media_Mutation_Response>>>;
  /** update data of the table: "estate_media_type" */
  update_estate_media_type?: Maybe<Estate_Media_Type_Mutation_Response>;
  /** update single row of the table: "estate_media_type" */
  update_estate_media_type_by_pk?: Maybe<Estate_Media_Type>;
  /** update data of the table: "estate_media_type_group" */
  update_estate_media_type_group?: Maybe<Estate_Media_Type_Group_Mutation_Response>;
  /** update single row of the table: "estate_media_type_group" */
  update_estate_media_type_group_by_pk?: Maybe<Estate_Media_Type_Group>;
  /** update multiples rows of table: "estate_media_type_group" */
  update_estate_media_type_group_many?: Maybe<Array<Maybe<Estate_Media_Type_Group_Mutation_Response>>>;
  /** update multiples rows of table: "estate_media_type" */
  update_estate_media_type_many?: Maybe<Array<Maybe<Estate_Media_Type_Mutation_Response>>>;
  /** update data of the table: "estate_media_type_name" */
  update_estate_media_type_name?: Maybe<Estate_Media_Type_Name_Mutation_Response>;
  /** update single row of the table: "estate_media_type_name" */
  update_estate_media_type_name_by_pk?: Maybe<Estate_Media_Type_Name>;
  /** update multiples rows of table: "estate_media_type_name" */
  update_estate_media_type_name_many?: Maybe<Array<Maybe<Estate_Media_Type_Name_Mutation_Response>>>;
  /** update data of the table: "estate_round" */
  update_estate_round?: Maybe<Estate_Round_Mutation_Response>;
  /** update data of the table: "estate_round_buyer_member" */
  update_estate_round_buyer_member?: Maybe<Estate_Round_Buyer_Member_Mutation_Response>;
  /** update single row of the table: "estate_round_buyer_member" */
  update_estate_round_buyer_member_by_pk?: Maybe<Estate_Round_Buyer_Member>;
  /** update multiples rows of table: "estate_round_buyer_member" */
  update_estate_round_buyer_member_many?: Maybe<Array<Maybe<Estate_Round_Buyer_Member_Mutation_Response>>>;
  /** update single row of the table: "estate_round" */
  update_estate_round_by_pk?: Maybe<Estate_Round>;
  /** update multiples rows of table: "estate_round" */
  update_estate_round_many?: Maybe<Array<Maybe<Estate_Round_Mutation_Response>>>;
  /** update data of the table: "estate_seller" */
  update_estate_seller?: Maybe<Estate_Seller_Mutation_Response>;
  /** update single row of the table: "estate_seller" */
  update_estate_seller_by_pk?: Maybe<Estate_Seller>;
  /** update multiples rows of table: "estate_seller" */
  update_estate_seller_many?: Maybe<Array<Maybe<Estate_Seller_Mutation_Response>>>;
  /** update data of the table: "estate_type" */
  update_estate_type?: Maybe<Estate_Type_Mutation_Response>;
  /** update single row of the table: "estate_type" */
  update_estate_type_by_pk?: Maybe<Estate_Type>;
  /** update multiples rows of table: "estate_type" */
  update_estate_type_many?: Maybe<Array<Maybe<Estate_Type_Mutation_Response>>>;
  /** update multiples rows of table: "storage.files" */
  update_files_many?: Maybe<Array<Maybe<Files_Mutation_Response>>>;
  /** update data of the table: "mandate" */
  update_mandate?: Maybe<Mandate_Mutation_Response>;
  /** update single row of the table: "mandate" */
  update_mandate_by_pk?: Maybe<Mandate>;
  /** update data of the table: "mandate_fee_person" */
  update_mandate_fee_person?: Maybe<Mandate_Fee_Person_Mutation_Response>;
  /** update single row of the table: "mandate_fee_person" */
  update_mandate_fee_person_by_pk?: Maybe<Mandate_Fee_Person>;
  /** update multiples rows of table: "mandate_fee_person" */
  update_mandate_fee_person_many?: Maybe<Array<Maybe<Mandate_Fee_Person_Mutation_Response>>>;
  /** update multiples rows of table: "mandate" */
  update_mandate_many?: Maybe<Array<Maybe<Mandate_Mutation_Response>>>;
  /** update data of the table: "mandate_media" */
  update_mandate_media?: Maybe<Mandate_Media_Mutation_Response>;
  /** update single row of the table: "mandate_media" */
  update_mandate_media_by_pk?: Maybe<Mandate_Media>;
  /** update multiples rows of table: "mandate_media" */
  update_mandate_media_many?: Maybe<Array<Maybe<Mandate_Media_Mutation_Response>>>;
  /** update data of the table: "mandate_registry" */
  update_mandate_registry?: Maybe<Mandate_Registry_Mutation_Response>;
  /** update single row of the table: "mandate_registry" */
  update_mandate_registry_by_pk?: Maybe<Mandate_Registry>;
  /** update multiples rows of table: "mandate_registry" */
  update_mandate_registry_many?: Maybe<Array<Maybe<Mandate_Registry_Mutation_Response>>>;
  /** update data of the table: "mandate_registry_number_lock" */
  update_mandate_registry_number_lock?: Maybe<Mandate_Registry_Number_Lock_Mutation_Response>;
  /** update single row of the table: "mandate_registry_number_lock" */
  update_mandate_registry_number_lock_by_pk?: Maybe<Mandate_Registry_Number_Lock>;
  /** update multiples rows of table: "mandate_registry_number_lock" */
  update_mandate_registry_number_lock_many?: Maybe<Array<Maybe<Mandate_Registry_Number_Lock_Mutation_Response>>>;
  /** update data of the table: "mandate_status" */
  update_mandate_status?: Maybe<Mandate_Status_Mutation_Response>;
  /** update single row of the table: "mandate_status" */
  update_mandate_status_by_pk?: Maybe<Mandate_Status>;
  /** update multiples rows of table: "mandate_status" */
  update_mandate_status_many?: Maybe<Array<Maybe<Mandate_Status_Mutation_Response>>>;
  /** update data of the table: "mandate_type" */
  update_mandate_type?: Maybe<Mandate_Type_Mutation_Response>;
  /** update single row of the table: "mandate_type" */
  update_mandate_type_by_pk?: Maybe<Mandate_Type>;
  /** update multiples rows of table: "mandate_type" */
  update_mandate_type_many?: Maybe<Array<Maybe<Mandate_Type_Mutation_Response>>>;
  /** update data of the table: "seller" */
  update_seller?: Maybe<Seller_Mutation_Response>;
  /** update single row of the table: "seller" */
  update_seller_by_pk?: Maybe<Seller>;
  /** update data of the table: "seller_legal_status" */
  update_seller_legal_status?: Maybe<Seller_Legal_Status_Mutation_Response>;
  /** update single row of the table: "seller_legal_status" */
  update_seller_legal_status_by_pk?: Maybe<Seller_Legal_Status>;
  /** update multiples rows of table: "seller_legal_status" */
  update_seller_legal_status_many?: Maybe<Array<Maybe<Seller_Legal_Status_Mutation_Response>>>;
  /** update multiples rows of table: "seller" */
  update_seller_many?: Maybe<Array<Maybe<Seller_Mutation_Response>>>;
  /** update data of the table: "seller_marital_status" */
  update_seller_marital_status?: Maybe<Seller_Marital_Status_Mutation_Response>;
  /** update single row of the table: "seller_marital_status" */
  update_seller_marital_status_by_pk?: Maybe<Seller_Marital_Status>;
  /** update multiples rows of table: "seller_marital_status" */
  update_seller_marital_status_many?: Maybe<Array<Maybe<Seller_Marital_Status_Mutation_Response>>>;
  /** update data of the table: "seller_media" */
  update_seller_media?: Maybe<Seller_Media_Mutation_Response>;
  /** update single row of the table: "seller_media" */
  update_seller_media_by_pk?: Maybe<Seller_Media>;
  /** update multiples rows of table: "seller_media" */
  update_seller_media_many?: Maybe<Array<Maybe<Seller_Media_Mutation_Response>>>;
  /** update data of the table: "seller_member" */
  update_seller_member?: Maybe<Seller_Member_Mutation_Response>;
  /** update single row of the table: "seller_member" */
  update_seller_member_by_pk?: Maybe<Seller_Member>;
  /** update multiples rows of table: "seller_member" */
  update_seller_member_many?: Maybe<Array<Maybe<Seller_Member_Mutation_Response>>>;
  /** update data of the table: "seller_tax_system" */
  update_seller_tax_system?: Maybe<Seller_Tax_System_Mutation_Response>;
  /** update single row of the table: "seller_tax_system" */
  update_seller_tax_system_by_pk?: Maybe<Seller_Tax_System>;
  /** update multiples rows of table: "seller_tax_system" */
  update_seller_tax_system_many?: Maybe<Array<Maybe<Seller_Tax_System_Mutation_Response>>>;
  /** update data of the table: "seller_type" */
  update_seller_type?: Maybe<Seller_Type_Mutation_Response>;
  /** update single row of the table: "seller_type" */
  update_seller_type_by_pk?: Maybe<Seller_Type>;
  /** update multiples rows of table: "seller_type" */
  update_seller_type_many?: Maybe<Array<Maybe<Seller_Type_Mutation_Response>>>;
  /** update multiples rows of table: "auth.users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  /** update multiples rows of table: "storage.virus" */
  update_virus_many?: Maybe<Array<Maybe<Virus_Mutation_Response>>>;
  /** update data of the table: "visit" */
  update_visit?: Maybe<Visit_Mutation_Response>;
  /** update single row of the table: "visit" */
  update_visit_by_pk?: Maybe<Visit>;
  /** update multiples rows of table: "visit" */
  update_visit_many?: Maybe<Array<Maybe<Visit_Mutation_Response>>>;
  /** update data of the table: "visit_span" */
  update_visit_span?: Maybe<Visit_Span_Mutation_Response>;
  /** update single row of the table: "visit_span" */
  update_visit_span_by_pk?: Maybe<Visit_Span>;
  /** update multiples rows of table: "visit_span" */
  update_visit_span_many?: Maybe<Array<Maybe<Visit_Span_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDeleteAuthProviderArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthProviderRequestArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthProviderRequestsArgs = {
  where: AuthProviderRequests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthProvidersArgs = {
  where: AuthProviders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokenArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokenTypeArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokenTypesArgs = {
  where: AuthRefreshTokenTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokensArgs = {
  where: AuthRefreshTokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthRoleArgs = {
  role: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthRolesArgs = {
  where: AuthRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthUserProviderArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthUserProvidersArgs = {
  where: AuthUserProviders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthUserRoleArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthUserRolesArgs = {
  where: AuthUserRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthUserSecurityKeyArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthUserSecurityKeysArgs = {
  where: AuthUserSecurityKeys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteBucketArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteBucketsArgs = {
  where: Buckets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteFileArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteFilesArgs = {
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteUserArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteUsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteVirusArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteVirusesArgs = {
  where: Virus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_AgencyArgs = {
  where: Agency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Agency_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Agency_MemberArgs = {
  where: Agency_Member_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Agency_Member_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ApplicationArgs = {
  where: Application_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Application_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Application_MediaArgs = {
  where: Application_Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Application_Media_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Application_Media_TypeArgs = {
  where: Application_Media_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Application_Media_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Application_StatusArgs = {
  where: Application_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Application_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Buyer_MemberArgs = {
  where: Buyer_Member_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Buyer_Member_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Buyer_Member_FolderArgs = {
  where: Buyer_Member_Folder_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Buyer_Member_Folder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CivilityArgs = {
  where: Civility_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Civility_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EstateArgs = {
  where: Estate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Estate_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Estate_LinkArgs = {
  where: Estate_Link_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Estate_Link_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Estate_MediaArgs = {
  where: Estate_Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Estate_Media_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Estate_Media_TypeArgs = {
  where: Estate_Media_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Estate_Media_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Estate_Media_Type_GroupArgs = {
  where: Estate_Media_Type_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Estate_Media_Type_Group_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Estate_Media_Type_NameArgs = {
  where: Estate_Media_Type_Name_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Estate_Media_Type_Name_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Estate_RoundArgs = {
  where: Estate_Round_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Estate_Round_Buyer_MemberArgs = {
  where: Estate_Round_Buyer_Member_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Estate_Round_Buyer_Member_By_PkArgs = {
  buyerMemberId: Scalars['uuid']['input'];
  estateRoundId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Estate_Round_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Estate_SellerArgs = {
  where: Estate_Seller_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Estate_Seller_By_PkArgs = {
  estateId: Scalars['uuid']['input'];
  sellerId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Estate_TypeArgs = {
  where: Estate_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Estate_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MandateArgs = {
  where: Mandate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mandate_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Mandate_Fee_PersonArgs = {
  where: Mandate_Fee_Person_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mandate_Fee_Person_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Mandate_MediaArgs = {
  where: Mandate_Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mandate_Media_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Mandate_RegistryArgs = {
  where: Mandate_Registry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mandate_Registry_By_PkArgs = {
  orderNumber: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Mandate_Registry_Number_LockArgs = {
  where: Mandate_Registry_Number_Lock_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mandate_Registry_Number_Lock_By_PkArgs = {
  key_name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Mandate_StatusArgs = {
  where: Mandate_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mandate_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Mandate_TypeArgs = {
  where: Mandate_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mandate_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SellerArgs = {
  where: Seller_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Seller_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Seller_Legal_StatusArgs = {
  where: Seller_Legal_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Seller_Legal_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Seller_Marital_StatusArgs = {
  where: Seller_Marital_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Seller_Marital_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Seller_MediaArgs = {
  where: Seller_Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Seller_Media_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Seller_MemberArgs = {
  where: Seller_Member_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Seller_Member_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Seller_Tax_SystemArgs = {
  where: Seller_Tax_System_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Seller_Tax_System_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Seller_TypeArgs = {
  where: Seller_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Seller_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_VisitArgs = {
  where: Visit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Visit_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Visit_SpanArgs = {
  where: Visit_Span_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Visit_Span_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootInsertAuthProviderArgs = {
  object: AuthProviders_Insert_Input;
  on_conflict?: InputMaybe<AuthProviders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthProviderRequestArgs = {
  object: AuthProviderRequests_Insert_Input;
  on_conflict?: InputMaybe<AuthProviderRequests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthProviderRequestsArgs = {
  objects: Array<AuthProviderRequests_Insert_Input>;
  on_conflict?: InputMaybe<AuthProviderRequests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthProvidersArgs = {
  objects: Array<AuthProviders_Insert_Input>;
  on_conflict?: InputMaybe<AuthProviders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRefreshTokenArgs = {
  object: AuthRefreshTokens_Insert_Input;
  on_conflict?: InputMaybe<AuthRefreshTokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRefreshTokenTypeArgs = {
  object: AuthRefreshTokenTypes_Insert_Input;
  on_conflict?: InputMaybe<AuthRefreshTokenTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRefreshTokenTypesArgs = {
  objects: Array<AuthRefreshTokenTypes_Insert_Input>;
  on_conflict?: InputMaybe<AuthRefreshTokenTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRefreshTokensArgs = {
  objects: Array<AuthRefreshTokens_Insert_Input>;
  on_conflict?: InputMaybe<AuthRefreshTokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRoleArgs = {
  object: AuthRoles_Insert_Input;
  on_conflict?: InputMaybe<AuthRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRolesArgs = {
  objects: Array<AuthRoles_Insert_Input>;
  on_conflict?: InputMaybe<AuthRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserProviderArgs = {
  object: AuthUserProviders_Insert_Input;
  on_conflict?: InputMaybe<AuthUserProviders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserProvidersArgs = {
  objects: Array<AuthUserProviders_Insert_Input>;
  on_conflict?: InputMaybe<AuthUserProviders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserRoleArgs = {
  object: AuthUserRoles_Insert_Input;
  on_conflict?: InputMaybe<AuthUserRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserRolesArgs = {
  objects: Array<AuthUserRoles_Insert_Input>;
  on_conflict?: InputMaybe<AuthUserRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserSecurityKeyArgs = {
  object: AuthUserSecurityKeys_Insert_Input;
  on_conflict?: InputMaybe<AuthUserSecurityKeys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserSecurityKeysArgs = {
  objects: Array<AuthUserSecurityKeys_Insert_Input>;
  on_conflict?: InputMaybe<AuthUserSecurityKeys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertBucketArgs = {
  object: Buckets_Insert_Input;
  on_conflict?: InputMaybe<Buckets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertBucketsArgs = {
  objects: Array<Buckets_Insert_Input>;
  on_conflict?: InputMaybe<Buckets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFileArgs = {
  object: Files_Insert_Input;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFilesArgs = {
  objects: Array<Files_Insert_Input>;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertUserArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertUsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertVirusArgs = {
  object: Virus_Insert_Input;
  on_conflict?: InputMaybe<Virus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertVirusesArgs = {
  objects: Array<Virus_Insert_Input>;
  on_conflict?: InputMaybe<Virus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AgencyArgs = {
  objects: Array<Agency_Insert_Input>;
  on_conflict?: InputMaybe<Agency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agency_MemberArgs = {
  objects: Array<Agency_Member_Insert_Input>;
  on_conflict?: InputMaybe<Agency_Member_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agency_Member_OneArgs = {
  object: Agency_Member_Insert_Input;
  on_conflict?: InputMaybe<Agency_Member_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agency_OneArgs = {
  object: Agency_Insert_Input;
  on_conflict?: InputMaybe<Agency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ApplicationArgs = {
  objects: Array<Application_Insert_Input>;
  on_conflict?: InputMaybe<Application_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Application_MediaArgs = {
  objects: Array<Application_Media_Insert_Input>;
  on_conflict?: InputMaybe<Application_Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Application_Media_OneArgs = {
  object: Application_Media_Insert_Input;
  on_conflict?: InputMaybe<Application_Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Application_Media_TypeArgs = {
  objects: Array<Application_Media_Type_Insert_Input>;
  on_conflict?: InputMaybe<Application_Media_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Application_Media_Type_OneArgs = {
  object: Application_Media_Type_Insert_Input;
  on_conflict?: InputMaybe<Application_Media_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Application_OneArgs = {
  object: Application_Insert_Input;
  on_conflict?: InputMaybe<Application_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Application_StatusArgs = {
  objects: Array<Application_Status_Insert_Input>;
  on_conflict?: InputMaybe<Application_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Application_Status_OneArgs = {
  object: Application_Status_Insert_Input;
  on_conflict?: InputMaybe<Application_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Buyer_MemberArgs = {
  objects: Array<Buyer_Member_Insert_Input>;
  on_conflict?: InputMaybe<Buyer_Member_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Buyer_Member_FolderArgs = {
  objects: Array<Buyer_Member_Folder_Insert_Input>;
  on_conflict?: InputMaybe<Buyer_Member_Folder_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Buyer_Member_Folder_OneArgs = {
  object: Buyer_Member_Folder_Insert_Input;
  on_conflict?: InputMaybe<Buyer_Member_Folder_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Buyer_Member_OneArgs = {
  object: Buyer_Member_Insert_Input;
  on_conflict?: InputMaybe<Buyer_Member_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CivilityArgs = {
  objects: Array<Civility_Insert_Input>;
  on_conflict?: InputMaybe<Civility_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Civility_OneArgs = {
  object: Civility_Insert_Input;
  on_conflict?: InputMaybe<Civility_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EstateArgs = {
  objects: Array<Estate_Insert_Input>;
  on_conflict?: InputMaybe<Estate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Estate_LinkArgs = {
  objects: Array<Estate_Link_Insert_Input>;
  on_conflict?: InputMaybe<Estate_Link_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Estate_Link_OneArgs = {
  object: Estate_Link_Insert_Input;
  on_conflict?: InputMaybe<Estate_Link_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Estate_MediaArgs = {
  objects: Array<Estate_Media_Insert_Input>;
  on_conflict?: InputMaybe<Estate_Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Estate_Media_OneArgs = {
  object: Estate_Media_Insert_Input;
  on_conflict?: InputMaybe<Estate_Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Estate_Media_TypeArgs = {
  objects: Array<Estate_Media_Type_Insert_Input>;
  on_conflict?: InputMaybe<Estate_Media_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Estate_Media_Type_GroupArgs = {
  objects: Array<Estate_Media_Type_Group_Insert_Input>;
  on_conflict?: InputMaybe<Estate_Media_Type_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Estate_Media_Type_Group_OneArgs = {
  object: Estate_Media_Type_Group_Insert_Input;
  on_conflict?: InputMaybe<Estate_Media_Type_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Estate_Media_Type_NameArgs = {
  objects: Array<Estate_Media_Type_Name_Insert_Input>;
  on_conflict?: InputMaybe<Estate_Media_Type_Name_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Estate_Media_Type_Name_OneArgs = {
  object: Estate_Media_Type_Name_Insert_Input;
  on_conflict?: InputMaybe<Estate_Media_Type_Name_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Estate_Media_Type_OneArgs = {
  object: Estate_Media_Type_Insert_Input;
  on_conflict?: InputMaybe<Estate_Media_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Estate_OneArgs = {
  object: Estate_Insert_Input;
  on_conflict?: InputMaybe<Estate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Estate_RoundArgs = {
  objects: Array<Estate_Round_Insert_Input>;
  on_conflict?: InputMaybe<Estate_Round_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Estate_Round_Buyer_MemberArgs = {
  objects: Array<Estate_Round_Buyer_Member_Insert_Input>;
  on_conflict?: InputMaybe<Estate_Round_Buyer_Member_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Estate_Round_Buyer_Member_OneArgs = {
  object: Estate_Round_Buyer_Member_Insert_Input;
  on_conflict?: InputMaybe<Estate_Round_Buyer_Member_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Estate_Round_OneArgs = {
  object: Estate_Round_Insert_Input;
  on_conflict?: InputMaybe<Estate_Round_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Estate_SellerArgs = {
  objects: Array<Estate_Seller_Insert_Input>;
  on_conflict?: InputMaybe<Estate_Seller_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Estate_Seller_OneArgs = {
  object: Estate_Seller_Insert_Input;
  on_conflict?: InputMaybe<Estate_Seller_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Estate_TypeArgs = {
  objects: Array<Estate_Type_Insert_Input>;
  on_conflict?: InputMaybe<Estate_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Estate_Type_OneArgs = {
  object: Estate_Type_Insert_Input;
  on_conflict?: InputMaybe<Estate_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MandateArgs = {
  objects: Array<Mandate_Insert_Input>;
  on_conflict?: InputMaybe<Mandate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mandate_Fee_PersonArgs = {
  objects: Array<Mandate_Fee_Person_Insert_Input>;
  on_conflict?: InputMaybe<Mandate_Fee_Person_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mandate_Fee_Person_OneArgs = {
  object: Mandate_Fee_Person_Insert_Input;
  on_conflict?: InputMaybe<Mandate_Fee_Person_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mandate_MediaArgs = {
  objects: Array<Mandate_Media_Insert_Input>;
  on_conflict?: InputMaybe<Mandate_Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mandate_Media_OneArgs = {
  object: Mandate_Media_Insert_Input;
  on_conflict?: InputMaybe<Mandate_Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mandate_OneArgs = {
  object: Mandate_Insert_Input;
  on_conflict?: InputMaybe<Mandate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mandate_RegistryArgs = {
  objects: Array<Mandate_Registry_Insert_Input>;
  on_conflict?: InputMaybe<Mandate_Registry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mandate_Registry_Number_LockArgs = {
  objects: Array<Mandate_Registry_Number_Lock_Insert_Input>;
  on_conflict?: InputMaybe<Mandate_Registry_Number_Lock_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mandate_Registry_Number_Lock_OneArgs = {
  object: Mandate_Registry_Number_Lock_Insert_Input;
  on_conflict?: InputMaybe<Mandate_Registry_Number_Lock_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mandate_Registry_OneArgs = {
  object: Mandate_Registry_Insert_Input;
  on_conflict?: InputMaybe<Mandate_Registry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mandate_StatusArgs = {
  objects: Array<Mandate_Status_Insert_Input>;
  on_conflict?: InputMaybe<Mandate_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mandate_Status_OneArgs = {
  object: Mandate_Status_Insert_Input;
  on_conflict?: InputMaybe<Mandate_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mandate_TypeArgs = {
  objects: Array<Mandate_Type_Insert_Input>;
  on_conflict?: InputMaybe<Mandate_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mandate_Type_OneArgs = {
  object: Mandate_Type_Insert_Input;
  on_conflict?: InputMaybe<Mandate_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SellerArgs = {
  objects: Array<Seller_Insert_Input>;
  on_conflict?: InputMaybe<Seller_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Seller_Legal_StatusArgs = {
  objects: Array<Seller_Legal_Status_Insert_Input>;
  on_conflict?: InputMaybe<Seller_Legal_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Seller_Legal_Status_OneArgs = {
  object: Seller_Legal_Status_Insert_Input;
  on_conflict?: InputMaybe<Seller_Legal_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Seller_Marital_StatusArgs = {
  objects: Array<Seller_Marital_Status_Insert_Input>;
  on_conflict?: InputMaybe<Seller_Marital_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Seller_Marital_Status_OneArgs = {
  object: Seller_Marital_Status_Insert_Input;
  on_conflict?: InputMaybe<Seller_Marital_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Seller_MediaArgs = {
  objects: Array<Seller_Media_Insert_Input>;
  on_conflict?: InputMaybe<Seller_Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Seller_Media_OneArgs = {
  object: Seller_Media_Insert_Input;
  on_conflict?: InputMaybe<Seller_Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Seller_MemberArgs = {
  objects: Array<Seller_Member_Insert_Input>;
  on_conflict?: InputMaybe<Seller_Member_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Seller_Member_OneArgs = {
  object: Seller_Member_Insert_Input;
  on_conflict?: InputMaybe<Seller_Member_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Seller_OneArgs = {
  object: Seller_Insert_Input;
  on_conflict?: InputMaybe<Seller_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Seller_Tax_SystemArgs = {
  objects: Array<Seller_Tax_System_Insert_Input>;
  on_conflict?: InputMaybe<Seller_Tax_System_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Seller_Tax_System_OneArgs = {
  object: Seller_Tax_System_Insert_Input;
  on_conflict?: InputMaybe<Seller_Tax_System_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Seller_TypeArgs = {
  objects: Array<Seller_Type_Insert_Input>;
  on_conflict?: InputMaybe<Seller_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Seller_Type_OneArgs = {
  object: Seller_Type_Insert_Input;
  on_conflict?: InputMaybe<Seller_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_VisitArgs = {
  objects: Array<Visit_Insert_Input>;
  on_conflict?: InputMaybe<Visit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Visit_OneArgs = {
  object: Visit_Insert_Input;
  on_conflict?: InputMaybe<Visit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Visit_SpanArgs = {
  objects: Array<Visit_Span_Insert_Input>;
  on_conflict?: InputMaybe<Visit_Span_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Visit_Span_OneArgs = {
  object: Visit_Span_Insert_Input;
  on_conflict?: InputMaybe<Visit_Span_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdateAuthProviderArgs = {
  _set?: InputMaybe<AuthProviders_Set_Input>;
  pk_columns: AuthProviders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthProviderRequestArgs = {
  _append?: InputMaybe<AuthProviderRequests_Append_Input>;
  _delete_at_path?: InputMaybe<AuthProviderRequests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AuthProviderRequests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AuthProviderRequests_Delete_Key_Input>;
  _prepend?: InputMaybe<AuthProviderRequests_Prepend_Input>;
  _set?: InputMaybe<AuthProviderRequests_Set_Input>;
  pk_columns: AuthProviderRequests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthProviderRequestsArgs = {
  _append?: InputMaybe<AuthProviderRequests_Append_Input>;
  _delete_at_path?: InputMaybe<AuthProviderRequests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AuthProviderRequests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AuthProviderRequests_Delete_Key_Input>;
  _prepend?: InputMaybe<AuthProviderRequests_Prepend_Input>;
  _set?: InputMaybe<AuthProviderRequests_Set_Input>;
  where: AuthProviderRequests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthProvidersArgs = {
  _set?: InputMaybe<AuthProviders_Set_Input>;
  where: AuthProviders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokenArgs = {
  _append?: InputMaybe<AuthRefreshTokens_Append_Input>;
  _delete_at_path?: InputMaybe<AuthRefreshTokens_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AuthRefreshTokens_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AuthRefreshTokens_Delete_Key_Input>;
  _prepend?: InputMaybe<AuthRefreshTokens_Prepend_Input>;
  _set?: InputMaybe<AuthRefreshTokens_Set_Input>;
  pk_columns: AuthRefreshTokens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokenTypeArgs = {
  _set?: InputMaybe<AuthRefreshTokenTypes_Set_Input>;
  pk_columns: AuthRefreshTokenTypes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokenTypesArgs = {
  _set?: InputMaybe<AuthRefreshTokenTypes_Set_Input>;
  where: AuthRefreshTokenTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokensArgs = {
  _append?: InputMaybe<AuthRefreshTokens_Append_Input>;
  _delete_at_path?: InputMaybe<AuthRefreshTokens_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AuthRefreshTokens_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AuthRefreshTokens_Delete_Key_Input>;
  _prepend?: InputMaybe<AuthRefreshTokens_Prepend_Input>;
  _set?: InputMaybe<AuthRefreshTokens_Set_Input>;
  where: AuthRefreshTokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthRoleArgs = {
  _set?: InputMaybe<AuthRoles_Set_Input>;
  pk_columns: AuthRoles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthRolesArgs = {
  _set?: InputMaybe<AuthRoles_Set_Input>;
  where: AuthRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserProviderArgs = {
  _set?: InputMaybe<AuthUserProviders_Set_Input>;
  pk_columns: AuthUserProviders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserProvidersArgs = {
  _set?: InputMaybe<AuthUserProviders_Set_Input>;
  where: AuthUserProviders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserRoleArgs = {
  _set?: InputMaybe<AuthUserRoles_Set_Input>;
  pk_columns: AuthUserRoles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserRolesArgs = {
  _set?: InputMaybe<AuthUserRoles_Set_Input>;
  where: AuthUserRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserSecurityKeyArgs = {
  _inc?: InputMaybe<AuthUserSecurityKeys_Inc_Input>;
  _set?: InputMaybe<AuthUserSecurityKeys_Set_Input>;
  pk_columns: AuthUserSecurityKeys_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserSecurityKeysArgs = {
  _inc?: InputMaybe<AuthUserSecurityKeys_Inc_Input>;
  _set?: InputMaybe<AuthUserSecurityKeys_Set_Input>;
  where: AuthUserSecurityKeys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateBucketArgs = {
  _inc?: InputMaybe<Buckets_Inc_Input>;
  _set?: InputMaybe<Buckets_Set_Input>;
  pk_columns: Buckets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateBucketsArgs = {
  _inc?: InputMaybe<Buckets_Inc_Input>;
  _set?: InputMaybe<Buckets_Set_Input>;
  where: Buckets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateFileArgs = {
  _append?: InputMaybe<Files_Append_Input>;
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Files_Delete_Key_Input>;
  _inc?: InputMaybe<Files_Inc_Input>;
  _prepend?: InputMaybe<Files_Prepend_Input>;
  _set?: InputMaybe<Files_Set_Input>;
  pk_columns: Files_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateFilesArgs = {
  _append?: InputMaybe<Files_Append_Input>;
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Files_Delete_Key_Input>;
  _inc?: InputMaybe<Files_Inc_Input>;
  _prepend?: InputMaybe<Files_Prepend_Input>;
  _set?: InputMaybe<Files_Set_Input>;
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateUserArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateUsersArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateVirusArgs = {
  _append?: InputMaybe<Virus_Append_Input>;
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Virus_Delete_Key_Input>;
  _prepend?: InputMaybe<Virus_Prepend_Input>;
  _set?: InputMaybe<Virus_Set_Input>;
  pk_columns: Virus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateVirusesArgs = {
  _append?: InputMaybe<Virus_Append_Input>;
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Virus_Delete_Key_Input>;
  _prepend?: InputMaybe<Virus_Prepend_Input>;
  _set?: InputMaybe<Virus_Set_Input>;
  where: Virus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_AgencyArgs = {
  _set?: InputMaybe<Agency_Set_Input>;
  where: Agency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Agency_By_PkArgs = {
  _set?: InputMaybe<Agency_Set_Input>;
  pk_columns: Agency_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Agency_ManyArgs = {
  updates: Array<Agency_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Agency_MemberArgs = {
  _set?: InputMaybe<Agency_Member_Set_Input>;
  where: Agency_Member_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Agency_Member_By_PkArgs = {
  _set?: InputMaybe<Agency_Member_Set_Input>;
  pk_columns: Agency_Member_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Agency_Member_ManyArgs = {
  updates: Array<Agency_Member_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ApplicationArgs = {
  _append?: InputMaybe<Application_Append_Input>;
  _delete_at_path?: InputMaybe<Application_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Application_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Application_Delete_Key_Input>;
  _inc?: InputMaybe<Application_Inc_Input>;
  _prepend?: InputMaybe<Application_Prepend_Input>;
  _set?: InputMaybe<Application_Set_Input>;
  where: Application_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Application_By_PkArgs = {
  _append?: InputMaybe<Application_Append_Input>;
  _delete_at_path?: InputMaybe<Application_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Application_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Application_Delete_Key_Input>;
  _inc?: InputMaybe<Application_Inc_Input>;
  _prepend?: InputMaybe<Application_Prepend_Input>;
  _set?: InputMaybe<Application_Set_Input>;
  pk_columns: Application_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Application_ManyArgs = {
  updates: Array<Application_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Application_MediaArgs = {
  _set?: InputMaybe<Application_Media_Set_Input>;
  where: Application_Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Application_Media_By_PkArgs = {
  _set?: InputMaybe<Application_Media_Set_Input>;
  pk_columns: Application_Media_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Application_Media_ManyArgs = {
  updates: Array<Application_Media_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Application_Media_TypeArgs = {
  _set?: InputMaybe<Application_Media_Type_Set_Input>;
  where: Application_Media_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Application_Media_Type_By_PkArgs = {
  _set?: InputMaybe<Application_Media_Type_Set_Input>;
  pk_columns: Application_Media_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Application_Media_Type_ManyArgs = {
  updates: Array<Application_Media_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Application_StatusArgs = {
  _set?: InputMaybe<Application_Status_Set_Input>;
  where: Application_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Application_Status_By_PkArgs = {
  _set?: InputMaybe<Application_Status_Set_Input>;
  pk_columns: Application_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Application_Status_ManyArgs = {
  updates: Array<Application_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthProviderRequests_ManyArgs = {
  updates: Array<AuthProviderRequests_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthProviders_ManyArgs = {
  updates: Array<AuthProviders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthRefreshTokenTypes_ManyArgs = {
  updates: Array<AuthRefreshTokenTypes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthRefreshTokens_ManyArgs = {
  updates: Array<AuthRefreshTokens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthRoles_ManyArgs = {
  updates: Array<AuthRoles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthUserProviders_ManyArgs = {
  updates: Array<AuthUserProviders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthUserRoles_ManyArgs = {
  updates: Array<AuthUserRoles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthUserSecurityKeys_ManyArgs = {
  updates: Array<AuthUserSecurityKeys_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Buckets_ManyArgs = {
  updates: Array<Buckets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Buyer_MemberArgs = {
  _set?: InputMaybe<Buyer_Member_Set_Input>;
  where: Buyer_Member_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Buyer_Member_By_PkArgs = {
  _set?: InputMaybe<Buyer_Member_Set_Input>;
  pk_columns: Buyer_Member_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Buyer_Member_FolderArgs = {
  _set?: InputMaybe<Buyer_Member_Folder_Set_Input>;
  where: Buyer_Member_Folder_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Buyer_Member_Folder_By_PkArgs = {
  _set?: InputMaybe<Buyer_Member_Folder_Set_Input>;
  pk_columns: Buyer_Member_Folder_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Buyer_Member_Folder_ManyArgs = {
  updates: Array<Buyer_Member_Folder_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Buyer_Member_ManyArgs = {
  updates: Array<Buyer_Member_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CivilityArgs = {
  _set?: InputMaybe<Civility_Set_Input>;
  where: Civility_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Civility_By_PkArgs = {
  _set?: InputMaybe<Civility_Set_Input>;
  pk_columns: Civility_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Civility_ManyArgs = {
  updates: Array<Civility_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EstateArgs = {
  _append?: InputMaybe<Estate_Append_Input>;
  _delete_at_path?: InputMaybe<Estate_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Estate_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Estate_Delete_Key_Input>;
  _inc?: InputMaybe<Estate_Inc_Input>;
  _prepend?: InputMaybe<Estate_Prepend_Input>;
  _set?: InputMaybe<Estate_Set_Input>;
  where: Estate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_By_PkArgs = {
  _append?: InputMaybe<Estate_Append_Input>;
  _delete_at_path?: InputMaybe<Estate_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Estate_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Estate_Delete_Key_Input>;
  _inc?: InputMaybe<Estate_Inc_Input>;
  _prepend?: InputMaybe<Estate_Prepend_Input>;
  _set?: InputMaybe<Estate_Set_Input>;
  pk_columns: Estate_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_LinkArgs = {
  _set?: InputMaybe<Estate_Link_Set_Input>;
  where: Estate_Link_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_Link_By_PkArgs = {
  _set?: InputMaybe<Estate_Link_Set_Input>;
  pk_columns: Estate_Link_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_Link_ManyArgs = {
  updates: Array<Estate_Link_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_ManyArgs = {
  updates: Array<Estate_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_MediaArgs = {
  _inc?: InputMaybe<Estate_Media_Inc_Input>;
  _set?: InputMaybe<Estate_Media_Set_Input>;
  where: Estate_Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_Media_By_PkArgs = {
  _inc?: InputMaybe<Estate_Media_Inc_Input>;
  _set?: InputMaybe<Estate_Media_Set_Input>;
  pk_columns: Estate_Media_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_Media_ManyArgs = {
  updates: Array<Estate_Media_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_Media_TypeArgs = {
  _set?: InputMaybe<Estate_Media_Type_Set_Input>;
  where: Estate_Media_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_Media_Type_By_PkArgs = {
  _set?: InputMaybe<Estate_Media_Type_Set_Input>;
  pk_columns: Estate_Media_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_Media_Type_GroupArgs = {
  _set?: InputMaybe<Estate_Media_Type_Group_Set_Input>;
  where: Estate_Media_Type_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_Media_Type_Group_By_PkArgs = {
  _set?: InputMaybe<Estate_Media_Type_Group_Set_Input>;
  pk_columns: Estate_Media_Type_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_Media_Type_Group_ManyArgs = {
  updates: Array<Estate_Media_Type_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_Media_Type_ManyArgs = {
  updates: Array<Estate_Media_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_Media_Type_NameArgs = {
  _set?: InputMaybe<Estate_Media_Type_Name_Set_Input>;
  where: Estate_Media_Type_Name_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_Media_Type_Name_By_PkArgs = {
  _set?: InputMaybe<Estate_Media_Type_Name_Set_Input>;
  pk_columns: Estate_Media_Type_Name_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_Media_Type_Name_ManyArgs = {
  updates: Array<Estate_Media_Type_Name_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_RoundArgs = {
  _inc?: InputMaybe<Estate_Round_Inc_Input>;
  _set?: InputMaybe<Estate_Round_Set_Input>;
  where: Estate_Round_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_Round_Buyer_MemberArgs = {
  _set?: InputMaybe<Estate_Round_Buyer_Member_Set_Input>;
  where: Estate_Round_Buyer_Member_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_Round_Buyer_Member_By_PkArgs = {
  _set?: InputMaybe<Estate_Round_Buyer_Member_Set_Input>;
  pk_columns: Estate_Round_Buyer_Member_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_Round_Buyer_Member_ManyArgs = {
  updates: Array<Estate_Round_Buyer_Member_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_Round_By_PkArgs = {
  _inc?: InputMaybe<Estate_Round_Inc_Input>;
  _set?: InputMaybe<Estate_Round_Set_Input>;
  pk_columns: Estate_Round_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_Round_ManyArgs = {
  updates: Array<Estate_Round_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_SellerArgs = {
  _inc?: InputMaybe<Estate_Seller_Inc_Input>;
  _set?: InputMaybe<Estate_Seller_Set_Input>;
  where: Estate_Seller_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_Seller_By_PkArgs = {
  _inc?: InputMaybe<Estate_Seller_Inc_Input>;
  _set?: InputMaybe<Estate_Seller_Set_Input>;
  pk_columns: Estate_Seller_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_Seller_ManyArgs = {
  updates: Array<Estate_Seller_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_TypeArgs = {
  _set?: InputMaybe<Estate_Type_Set_Input>;
  where: Estate_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_Type_By_PkArgs = {
  _set?: InputMaybe<Estate_Type_Set_Input>;
  pk_columns: Estate_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Estate_Type_ManyArgs = {
  updates: Array<Estate_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Files_ManyArgs = {
  updates: Array<Files_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MandateArgs = {
  _inc?: InputMaybe<Mandate_Inc_Input>;
  _set?: InputMaybe<Mandate_Set_Input>;
  where: Mandate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mandate_By_PkArgs = {
  _inc?: InputMaybe<Mandate_Inc_Input>;
  _set?: InputMaybe<Mandate_Set_Input>;
  pk_columns: Mandate_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mandate_Fee_PersonArgs = {
  _set?: InputMaybe<Mandate_Fee_Person_Set_Input>;
  where: Mandate_Fee_Person_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mandate_Fee_Person_By_PkArgs = {
  _set?: InputMaybe<Mandate_Fee_Person_Set_Input>;
  pk_columns: Mandate_Fee_Person_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mandate_Fee_Person_ManyArgs = {
  updates: Array<Mandate_Fee_Person_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mandate_ManyArgs = {
  updates: Array<Mandate_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mandate_MediaArgs = {
  _set?: InputMaybe<Mandate_Media_Set_Input>;
  where: Mandate_Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mandate_Media_By_PkArgs = {
  _set?: InputMaybe<Mandate_Media_Set_Input>;
  pk_columns: Mandate_Media_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mandate_Media_ManyArgs = {
  updates: Array<Mandate_Media_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mandate_RegistryArgs = {
  _set?: InputMaybe<Mandate_Registry_Set_Input>;
  where: Mandate_Registry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mandate_Registry_By_PkArgs = {
  _set?: InputMaybe<Mandate_Registry_Set_Input>;
  pk_columns: Mandate_Registry_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mandate_Registry_ManyArgs = {
  updates: Array<Mandate_Registry_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mandate_Registry_Number_LockArgs = {
  _inc?: InputMaybe<Mandate_Registry_Number_Lock_Inc_Input>;
  _set?: InputMaybe<Mandate_Registry_Number_Lock_Set_Input>;
  where: Mandate_Registry_Number_Lock_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mandate_Registry_Number_Lock_By_PkArgs = {
  _inc?: InputMaybe<Mandate_Registry_Number_Lock_Inc_Input>;
  _set?: InputMaybe<Mandate_Registry_Number_Lock_Set_Input>;
  pk_columns: Mandate_Registry_Number_Lock_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mandate_Registry_Number_Lock_ManyArgs = {
  updates: Array<Mandate_Registry_Number_Lock_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mandate_StatusArgs = {
  _set?: InputMaybe<Mandate_Status_Set_Input>;
  where: Mandate_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mandate_Status_By_PkArgs = {
  _set?: InputMaybe<Mandate_Status_Set_Input>;
  pk_columns: Mandate_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mandate_Status_ManyArgs = {
  updates: Array<Mandate_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mandate_TypeArgs = {
  _set?: InputMaybe<Mandate_Type_Set_Input>;
  where: Mandate_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mandate_Type_By_PkArgs = {
  _set?: InputMaybe<Mandate_Type_Set_Input>;
  pk_columns: Mandate_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mandate_Type_ManyArgs = {
  updates: Array<Mandate_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SellerArgs = {
  _set?: InputMaybe<Seller_Set_Input>;
  where: Seller_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Seller_By_PkArgs = {
  _set?: InputMaybe<Seller_Set_Input>;
  pk_columns: Seller_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Seller_Legal_StatusArgs = {
  _set?: InputMaybe<Seller_Legal_Status_Set_Input>;
  where: Seller_Legal_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Seller_Legal_Status_By_PkArgs = {
  _set?: InputMaybe<Seller_Legal_Status_Set_Input>;
  pk_columns: Seller_Legal_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Seller_Legal_Status_ManyArgs = {
  updates: Array<Seller_Legal_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Seller_ManyArgs = {
  updates: Array<Seller_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Seller_Marital_StatusArgs = {
  _set?: InputMaybe<Seller_Marital_Status_Set_Input>;
  where: Seller_Marital_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Seller_Marital_Status_By_PkArgs = {
  _set?: InputMaybe<Seller_Marital_Status_Set_Input>;
  pk_columns: Seller_Marital_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Seller_Marital_Status_ManyArgs = {
  updates: Array<Seller_Marital_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Seller_MediaArgs = {
  _set?: InputMaybe<Seller_Media_Set_Input>;
  where: Seller_Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Seller_Media_By_PkArgs = {
  _set?: InputMaybe<Seller_Media_Set_Input>;
  pk_columns: Seller_Media_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Seller_Media_ManyArgs = {
  updates: Array<Seller_Media_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Seller_MemberArgs = {
  _set?: InputMaybe<Seller_Member_Set_Input>;
  where: Seller_Member_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Seller_Member_By_PkArgs = {
  _set?: InputMaybe<Seller_Member_Set_Input>;
  pk_columns: Seller_Member_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Seller_Member_ManyArgs = {
  updates: Array<Seller_Member_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Seller_Tax_SystemArgs = {
  _set?: InputMaybe<Seller_Tax_System_Set_Input>;
  where: Seller_Tax_System_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Seller_Tax_System_By_PkArgs = {
  _set?: InputMaybe<Seller_Tax_System_Set_Input>;
  pk_columns: Seller_Tax_System_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Seller_Tax_System_ManyArgs = {
  updates: Array<Seller_Tax_System_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Seller_TypeArgs = {
  _set?: InputMaybe<Seller_Type_Set_Input>;
  where: Seller_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Seller_Type_By_PkArgs = {
  _set?: InputMaybe<Seller_Type_Set_Input>;
  pk_columns: Seller_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Seller_Type_ManyArgs = {
  updates: Array<Seller_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Virus_ManyArgs = {
  updates: Array<Virus_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_VisitArgs = {
  _set?: InputMaybe<Visit_Set_Input>;
  where: Visit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Visit_By_PkArgs = {
  _set?: InputMaybe<Visit_Set_Input>;
  pk_columns: Visit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Visit_ManyArgs = {
  updates: Array<Visit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Visit_SpanArgs = {
  _append?: InputMaybe<Visit_Span_Append_Input>;
  _delete_at_path?: InputMaybe<Visit_Span_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Visit_Span_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Visit_Span_Delete_Key_Input>;
  _prepend?: InputMaybe<Visit_Span_Prepend_Input>;
  _set?: InputMaybe<Visit_Span_Set_Input>;
  where: Visit_Span_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Visit_Span_By_PkArgs = {
  _append?: InputMaybe<Visit_Span_Append_Input>;
  _delete_at_path?: InputMaybe<Visit_Span_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Visit_Span_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Visit_Span_Delete_Key_Input>;
  _prepend?: InputMaybe<Visit_Span_Prepend_Input>;
  _set?: InputMaybe<Visit_Span_Set_Input>;
  pk_columns: Visit_Span_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Visit_Span_ManyArgs = {
  updates: Array<Visit_Span_Updates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "agency" */
  agency: Array<Agency>;
  /** fetch aggregated fields from the table: "agency" */
  agency_aggregate: Agency_Aggregate;
  /** fetch data from the table: "agency" using primary key columns */
  agency_by_pk?: Maybe<Agency>;
  /** fetch data from the table: "agency_member" */
  agency_member: Array<Agency_Member>;
  /** fetch aggregated fields from the table: "agency_member" */
  agency_member_aggregate: Agency_Member_Aggregate;
  /** fetch data from the table: "agency_member" using primary key columns */
  agency_member_by_pk?: Maybe<Agency_Member>;
  /** fetch data from the table: "application" */
  application: Array<Application>;
  /** fetch aggregated fields from the table: "application" */
  application_aggregate: Application_Aggregate;
  /** fetch data from the table: "application" using primary key columns */
  application_by_pk?: Maybe<Application>;
  /** An array relationship */
  application_media: Array<Application_Media>;
  /** An aggregate relationship */
  application_media_aggregate: Application_Media_Aggregate;
  /** fetch data from the table: "application_media" using primary key columns */
  application_media_by_pk?: Maybe<Application_Media>;
  /** fetch data from the table: "application_media_type" */
  application_media_type: Array<Application_Media_Type>;
  /** fetch aggregated fields from the table: "application_media_type" */
  application_media_type_aggregate: Application_Media_Type_Aggregate;
  /** fetch data from the table: "application_media_type" using primary key columns */
  application_media_type_by_pk?: Maybe<Application_Media_Type>;
  /** fetch data from the table: "application_status" */
  application_status: Array<Application_Status>;
  /** fetch aggregated fields from the table: "application_status" */
  application_status_aggregate: Application_Status_Aggregate;
  /** fetch data from the table: "application_status" using primary key columns */
  application_status_by_pk?: Maybe<Application_Status>;
  /** fetch data from the table: "auth.providers" using primary key columns */
  authProvider?: Maybe<AuthProviders>;
  /** fetch data from the table: "auth.provider_requests" using primary key columns */
  authProviderRequest?: Maybe<AuthProviderRequests>;
  /** fetch data from the table: "auth.provider_requests" */
  authProviderRequests: Array<AuthProviderRequests>;
  /** fetch aggregated fields from the table: "auth.provider_requests" */
  authProviderRequestsAggregate: AuthProviderRequests_Aggregate;
  /** fetch data from the table: "auth.providers" */
  authProviders: Array<AuthProviders>;
  /** fetch aggregated fields from the table: "auth.providers" */
  authProvidersAggregate: AuthProviders_Aggregate;
  /** fetch data from the table: "auth.refresh_tokens" using primary key columns */
  authRefreshToken?: Maybe<AuthRefreshTokens>;
  /** fetch data from the table: "auth.refresh_token_types" using primary key columns */
  authRefreshTokenType?: Maybe<AuthRefreshTokenTypes>;
  /** fetch data from the table: "auth.refresh_token_types" */
  authRefreshTokenTypes: Array<AuthRefreshTokenTypes>;
  /** fetch aggregated fields from the table: "auth.refresh_token_types" */
  authRefreshTokenTypesAggregate: AuthRefreshTokenTypes_Aggregate;
  /** fetch data from the table: "auth.refresh_tokens" */
  authRefreshTokens: Array<AuthRefreshTokens>;
  /** fetch aggregated fields from the table: "auth.refresh_tokens" */
  authRefreshTokensAggregate: AuthRefreshTokens_Aggregate;
  /** fetch data from the table: "auth.roles" using primary key columns */
  authRole?: Maybe<AuthRoles>;
  /** fetch data from the table: "auth.roles" */
  authRoles: Array<AuthRoles>;
  /** fetch aggregated fields from the table: "auth.roles" */
  authRolesAggregate: AuthRoles_Aggregate;
  /** fetch data from the table: "auth.user_providers" using primary key columns */
  authUserProvider?: Maybe<AuthUserProviders>;
  /** fetch data from the table: "auth.user_providers" */
  authUserProviders: Array<AuthUserProviders>;
  /** fetch aggregated fields from the table: "auth.user_providers" */
  authUserProvidersAggregate: AuthUserProviders_Aggregate;
  /** fetch data from the table: "auth.user_roles" using primary key columns */
  authUserRole?: Maybe<AuthUserRoles>;
  /** fetch data from the table: "auth.user_roles" */
  authUserRoles: Array<AuthUserRoles>;
  /** fetch aggregated fields from the table: "auth.user_roles" */
  authUserRolesAggregate: AuthUserRoles_Aggregate;
  /** fetch data from the table: "auth.user_security_keys" using primary key columns */
  authUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** fetch data from the table: "auth.user_security_keys" */
  authUserSecurityKeys: Array<AuthUserSecurityKeys>;
  /** fetch aggregated fields from the table: "auth.user_security_keys" */
  authUserSecurityKeysAggregate: AuthUserSecurityKeys_Aggregate;
  /** fetch data from the table: "storage.buckets" using primary key columns */
  bucket?: Maybe<Buckets>;
  /** fetch data from the table: "storage.buckets" */
  buckets: Array<Buckets>;
  /** fetch aggregated fields from the table: "storage.buckets" */
  bucketsAggregate: Buckets_Aggregate;
  /** fetch data from the table: "buyer_member" */
  buyer_member: Array<Buyer_Member>;
  /** fetch aggregated fields from the table: "buyer_member" */
  buyer_member_aggregate: Buyer_Member_Aggregate;
  /** fetch data from the table: "buyer_member" using primary key columns */
  buyer_member_by_pk?: Maybe<Buyer_Member>;
  /** fetch data from the table: "buyer_member_folder" */
  buyer_member_folder: Array<Buyer_Member_Folder>;
  /** fetch aggregated fields from the table: "buyer_member_folder" */
  buyer_member_folder_aggregate: Buyer_Member_Folder_Aggregate;
  /** fetch data from the table: "buyer_member_folder" using primary key columns */
  buyer_member_folder_by_pk?: Maybe<Buyer_Member_Folder>;
  /** fetch data from the table: "civility" */
  civility: Array<Civility>;
  /** fetch aggregated fields from the table: "civility" */
  civility_aggregate: Civility_Aggregate;
  /** fetch data from the table: "civility" using primary key columns */
  civility_by_pk?: Maybe<Civility>;
  /** fetch data from the table: "estate" */
  estate: Array<Estate>;
  /** fetch aggregated fields from the table: "estate" */
  estate_aggregate: Estate_Aggregate;
  /** fetch data from the table: "estate" using primary key columns */
  estate_by_pk?: Maybe<Estate>;
  /** fetch data from the table: "estate_link" */
  estate_link: Array<Estate_Link>;
  /** fetch aggregated fields from the table: "estate_link" */
  estate_link_aggregate: Estate_Link_Aggregate;
  /** fetch data from the table: "estate_link" using primary key columns */
  estate_link_by_pk?: Maybe<Estate_Link>;
  /** An array relationship */
  estate_media: Array<Estate_Media>;
  /** An aggregate relationship */
  estate_media_aggregate: Estate_Media_Aggregate;
  /** fetch data from the table: "estate_media" using primary key columns */
  estate_media_by_pk?: Maybe<Estate_Media>;
  /** fetch data from the table: "estate_media_type" */
  estate_media_type: Array<Estate_Media_Type>;
  /** fetch aggregated fields from the table: "estate_media_type" */
  estate_media_type_aggregate: Estate_Media_Type_Aggregate;
  /** fetch data from the table: "estate_media_type" using primary key columns */
  estate_media_type_by_pk?: Maybe<Estate_Media_Type>;
  /** fetch data from the table: "estate_media_type_group" */
  estate_media_type_group: Array<Estate_Media_Type_Group>;
  /** fetch aggregated fields from the table: "estate_media_type_group" */
  estate_media_type_group_aggregate: Estate_Media_Type_Group_Aggregate;
  /** fetch data from the table: "estate_media_type_group" using primary key columns */
  estate_media_type_group_by_pk?: Maybe<Estate_Media_Type_Group>;
  /** fetch data from the table: "estate_media_type_name" */
  estate_media_type_name: Array<Estate_Media_Type_Name>;
  /** fetch aggregated fields from the table: "estate_media_type_name" */
  estate_media_type_name_aggregate: Estate_Media_Type_Name_Aggregate;
  /** fetch data from the table: "estate_media_type_name" using primary key columns */
  estate_media_type_name_by_pk?: Maybe<Estate_Media_Type_Name>;
  /** fetch data from the table: "estate_round" */
  estate_round: Array<Estate_Round>;
  /** fetch aggregated fields from the table: "estate_round" */
  estate_round_aggregate: Estate_Round_Aggregate;
  /** fetch data from the table: "estate_round_buyer_member" */
  estate_round_buyer_member: Array<Estate_Round_Buyer_Member>;
  /** fetch aggregated fields from the table: "estate_round_buyer_member" */
  estate_round_buyer_member_aggregate: Estate_Round_Buyer_Member_Aggregate;
  /** fetch data from the table: "estate_round_buyer_member" using primary key columns */
  estate_round_buyer_member_by_pk?: Maybe<Estate_Round_Buyer_Member>;
  /** fetch data from the table: "estate_round" using primary key columns */
  estate_round_by_pk?: Maybe<Estate_Round>;
  /** fetch data from the table: "estate_seller" */
  estate_seller: Array<Estate_Seller>;
  /** fetch aggregated fields from the table: "estate_seller" */
  estate_seller_aggregate: Estate_Seller_Aggregate;
  /** fetch data from the table: "estate_seller" using primary key columns */
  estate_seller_by_pk?: Maybe<Estate_Seller>;
  /** fetch data from the table: "estate_type" */
  estate_type: Array<Estate_Type>;
  /** fetch aggregated fields from the table: "estate_type" */
  estate_type_aggregate: Estate_Type_Aggregate;
  /** fetch data from the table: "estate_type" using primary key columns */
  estate_type_by_pk?: Maybe<Estate_Type>;
  /** fetch data from the table: "storage.files" using primary key columns */
  file?: Maybe<Files>;
  /** An array relationship */
  files: Array<Files>;
  /** fetch aggregated fields from the table: "storage.files" */
  filesAggregate: Files_Aggregate;
  /** fetch data from the table: "mandate" */
  mandate: Array<Mandate>;
  /** fetch aggregated fields from the table: "mandate" */
  mandate_aggregate: Mandate_Aggregate;
  /** fetch data from the table: "mandate" using primary key columns */
  mandate_by_pk?: Maybe<Mandate>;
  /** fetch data from the table: "mandate_fee_person" */
  mandate_fee_person: Array<Mandate_Fee_Person>;
  /** fetch aggregated fields from the table: "mandate_fee_person" */
  mandate_fee_person_aggregate: Mandate_Fee_Person_Aggregate;
  /** fetch data from the table: "mandate_fee_person" using primary key columns */
  mandate_fee_person_by_pk?: Maybe<Mandate_Fee_Person>;
  /** An array relationship */
  mandate_media: Array<Mandate_Media>;
  /** An aggregate relationship */
  mandate_media_aggregate: Mandate_Media_Aggregate;
  /** fetch data from the table: "mandate_media" using primary key columns */
  mandate_media_by_pk?: Maybe<Mandate_Media>;
  /** fetch data from the table: "mandate_registry" */
  mandate_registry: Array<Mandate_Registry>;
  /** fetch aggregated fields from the table: "mandate_registry" */
  mandate_registry_aggregate: Mandate_Registry_Aggregate;
  /** fetch data from the table: "mandate_registry" using primary key columns */
  mandate_registry_by_pk?: Maybe<Mandate_Registry>;
  /** fetch data from the table: "mandate_registry_number_lock" */
  mandate_registry_number_lock: Array<Mandate_Registry_Number_Lock>;
  /** fetch aggregated fields from the table: "mandate_registry_number_lock" */
  mandate_registry_number_lock_aggregate: Mandate_Registry_Number_Lock_Aggregate;
  /** fetch data from the table: "mandate_registry_number_lock" using primary key columns */
  mandate_registry_number_lock_by_pk?: Maybe<Mandate_Registry_Number_Lock>;
  /** fetch data from the table: "mandate_status" */
  mandate_status: Array<Mandate_Status>;
  /** fetch aggregated fields from the table: "mandate_status" */
  mandate_status_aggregate: Mandate_Status_Aggregate;
  /** fetch data from the table: "mandate_status" using primary key columns */
  mandate_status_by_pk?: Maybe<Mandate_Status>;
  /** fetch data from the table: "mandate_type" */
  mandate_type: Array<Mandate_Type>;
  /** fetch aggregated fields from the table: "mandate_type" */
  mandate_type_aggregate: Mandate_Type_Aggregate;
  /** fetch data from the table: "mandate_type" using primary key columns */
  mandate_type_by_pk?: Maybe<Mandate_Type>;
  /** fetch data from the table: "seller" */
  seller: Array<Seller>;
  /** fetch aggregated fields from the table: "seller" */
  seller_aggregate: Seller_Aggregate;
  /** fetch data from the table: "seller" using primary key columns */
  seller_by_pk?: Maybe<Seller>;
  /** fetch data from the table: "seller_legal_status" */
  seller_legal_status: Array<Seller_Legal_Status>;
  /** fetch aggregated fields from the table: "seller_legal_status" */
  seller_legal_status_aggregate: Seller_Legal_Status_Aggregate;
  /** fetch data from the table: "seller_legal_status" using primary key columns */
  seller_legal_status_by_pk?: Maybe<Seller_Legal_Status>;
  /** fetch data from the table: "seller_marital_status" */
  seller_marital_status: Array<Seller_Marital_Status>;
  /** fetch aggregated fields from the table: "seller_marital_status" */
  seller_marital_status_aggregate: Seller_Marital_Status_Aggregate;
  /** fetch data from the table: "seller_marital_status" using primary key columns */
  seller_marital_status_by_pk?: Maybe<Seller_Marital_Status>;
  /** An array relationship */
  seller_media: Array<Seller_Media>;
  /** An aggregate relationship */
  seller_media_aggregate: Seller_Media_Aggregate;
  /** fetch data from the table: "seller_media" using primary key columns */
  seller_media_by_pk?: Maybe<Seller_Media>;
  /** fetch data from the table: "seller_member" */
  seller_member: Array<Seller_Member>;
  /** fetch aggregated fields from the table: "seller_member" */
  seller_member_aggregate: Seller_Member_Aggregate;
  /** fetch data from the table: "seller_member" using primary key columns */
  seller_member_by_pk?: Maybe<Seller_Member>;
  /** fetch data from the table: "seller_tax_system" */
  seller_tax_system: Array<Seller_Tax_System>;
  /** fetch aggregated fields from the table: "seller_tax_system" */
  seller_tax_system_aggregate: Seller_Tax_System_Aggregate;
  /** fetch data from the table: "seller_tax_system" using primary key columns */
  seller_tax_system_by_pk?: Maybe<Seller_Tax_System>;
  /** fetch data from the table: "seller_type" */
  seller_type: Array<Seller_Type>;
  /** fetch aggregated fields from the table: "seller_type" */
  seller_type_aggregate: Seller_Type_Aggregate;
  /** fetch data from the table: "seller_type" using primary key columns */
  seller_type_by_pk?: Maybe<Seller_Type>;
  /** fetch data from the table: "auth.users" using primary key columns */
  user?: Maybe<Users>;
  /** fetch data from the table: "auth.users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "auth.users" */
  usersAggregate: Users_Aggregate;
  /** fetch data from the table: "storage.virus" using primary key columns */
  virus?: Maybe<Virus>;
  /** fetch data from the table: "storage.virus" */
  viruses: Array<Virus>;
  /** fetch aggregated fields from the table: "storage.virus" */
  virusesAggregate: Virus_Aggregate;
  /** fetch data from the table: "visit" */
  visit: Array<Visit>;
  /** fetch aggregated fields from the table: "visit" */
  visit_aggregate: Visit_Aggregate;
  /** fetch data from the table: "visit" using primary key columns */
  visit_by_pk?: Maybe<Visit>;
  /** fetch data from the table: "visit_span" */
  visit_span: Array<Visit_Span>;
  /** fetch aggregated fields from the table: "visit_span" */
  visit_span_aggregate: Visit_Span_Aggregate;
  /** fetch data from the table: "visit_span" using primary key columns */
  visit_span_by_pk?: Maybe<Visit_Span>;
};


export type Query_RootAgencyArgs = {
  distinct_on?: InputMaybe<Array<Agency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Order_By>>;
  where?: InputMaybe<Agency_Bool_Exp>;
};


export type Query_RootAgency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Order_By>>;
  where?: InputMaybe<Agency_Bool_Exp>;
};


export type Query_RootAgency_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAgency_MemberArgs = {
  distinct_on?: InputMaybe<Array<Agency_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Member_Order_By>>;
  where?: InputMaybe<Agency_Member_Bool_Exp>;
};


export type Query_RootAgency_Member_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agency_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Member_Order_By>>;
  where?: InputMaybe<Agency_Member_Bool_Exp>;
};


export type Query_RootAgency_Member_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootApplicationArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


export type Query_RootApplication_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


export type Query_RootApplication_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootApplication_MediaArgs = {
  distinct_on?: InputMaybe<Array<Application_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Media_Order_By>>;
  where?: InputMaybe<Application_Media_Bool_Exp>;
};


export type Query_RootApplication_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Media_Order_By>>;
  where?: InputMaybe<Application_Media_Bool_Exp>;
};


export type Query_RootApplication_Media_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootApplication_Media_TypeArgs = {
  distinct_on?: InputMaybe<Array<Application_Media_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Media_Type_Order_By>>;
  where?: InputMaybe<Application_Media_Type_Bool_Exp>;
};


export type Query_RootApplication_Media_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Media_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Media_Type_Order_By>>;
  where?: InputMaybe<Application_Media_Type_Bool_Exp>;
};


export type Query_RootApplication_Media_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootApplication_StatusArgs = {
  distinct_on?: InputMaybe<Array<Application_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Status_Order_By>>;
  where?: InputMaybe<Application_Status_Bool_Exp>;
};


export type Query_RootApplication_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Status_Order_By>>;
  where?: InputMaybe<Application_Status_Bool_Exp>;
};


export type Query_RootApplication_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootAuthProviderArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootAuthProviderRequestArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuthProviderRequestsArgs = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};


export type Query_RootAuthProviderRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};


export type Query_RootAuthProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviders_Order_By>>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};


export type Query_RootAuthProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviders_Order_By>>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};


export type Query_RootAuthRefreshTokenArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuthRefreshTokenTypeArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootAuthRefreshTokenTypesArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};


export type Query_RootAuthRefreshTokenTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};


export type Query_RootAuthRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


export type Query_RootAuthRefreshTokensAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


export type Query_RootAuthRoleArgs = {
  role: Scalars['String']['input'];
};


export type Query_RootAuthRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRoles_Order_By>>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};


export type Query_RootAuthRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRoles_Order_By>>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};


export type Query_RootAuthUserProviderArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuthUserProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


export type Query_RootAuthUserProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


export type Query_RootAuthUserRoleArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuthUserRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


export type Query_RootAuthUserRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


export type Query_RootAuthUserSecurityKeyArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuthUserSecurityKeysArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Query_RootAuthUserSecurityKeysAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Query_RootBucketArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootBucketsArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Query_RootBucketsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Query_RootBuyer_MemberArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Member_Order_By>>;
  where?: InputMaybe<Buyer_Member_Bool_Exp>;
};


export type Query_RootBuyer_Member_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Member_Order_By>>;
  where?: InputMaybe<Buyer_Member_Bool_Exp>;
};


export type Query_RootBuyer_Member_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBuyer_Member_FolderArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Member_Folder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Member_Folder_Order_By>>;
  where?: InputMaybe<Buyer_Member_Folder_Bool_Exp>;
};


export type Query_RootBuyer_Member_Folder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Member_Folder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Member_Folder_Order_By>>;
  where?: InputMaybe<Buyer_Member_Folder_Bool_Exp>;
};


export type Query_RootBuyer_Member_Folder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCivilityArgs = {
  distinct_on?: InputMaybe<Array<Civility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Civility_Order_By>>;
  where?: InputMaybe<Civility_Bool_Exp>;
};


export type Query_RootCivility_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Civility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Civility_Order_By>>;
  where?: InputMaybe<Civility_Bool_Exp>;
};


export type Query_RootCivility_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEstateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Order_By>>;
  where?: InputMaybe<Estate_Bool_Exp>;
};


export type Query_RootEstate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Order_By>>;
  where?: InputMaybe<Estate_Bool_Exp>;
};


export type Query_RootEstate_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEstate_LinkArgs = {
  distinct_on?: InputMaybe<Array<Estate_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Link_Order_By>>;
  where?: InputMaybe<Estate_Link_Bool_Exp>;
};


export type Query_RootEstate_Link_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Link_Order_By>>;
  where?: InputMaybe<Estate_Link_Bool_Exp>;
};


export type Query_RootEstate_Link_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEstate_MediaArgs = {
  distinct_on?: InputMaybe<Array<Estate_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Media_Order_By>>;
  where?: InputMaybe<Estate_Media_Bool_Exp>;
};


export type Query_RootEstate_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Media_Order_By>>;
  where?: InputMaybe<Estate_Media_Bool_Exp>;
};


export type Query_RootEstate_Media_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEstate_Media_TypeArgs = {
  distinct_on?: InputMaybe<Array<Estate_Media_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Media_Type_Order_By>>;
  where?: InputMaybe<Estate_Media_Type_Bool_Exp>;
};


export type Query_RootEstate_Media_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Media_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Media_Type_Order_By>>;
  where?: InputMaybe<Estate_Media_Type_Bool_Exp>;
};


export type Query_RootEstate_Media_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEstate_Media_Type_GroupArgs = {
  distinct_on?: InputMaybe<Array<Estate_Media_Type_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Media_Type_Group_Order_By>>;
  where?: InputMaybe<Estate_Media_Type_Group_Bool_Exp>;
};


export type Query_RootEstate_Media_Type_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Media_Type_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Media_Type_Group_Order_By>>;
  where?: InputMaybe<Estate_Media_Type_Group_Bool_Exp>;
};


export type Query_RootEstate_Media_Type_Group_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEstate_Media_Type_NameArgs = {
  distinct_on?: InputMaybe<Array<Estate_Media_Type_Name_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Media_Type_Name_Order_By>>;
  where?: InputMaybe<Estate_Media_Type_Name_Bool_Exp>;
};


export type Query_RootEstate_Media_Type_Name_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Media_Type_Name_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Media_Type_Name_Order_By>>;
  where?: InputMaybe<Estate_Media_Type_Name_Bool_Exp>;
};


export type Query_RootEstate_Media_Type_Name_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEstate_RoundArgs = {
  distinct_on?: InputMaybe<Array<Estate_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Round_Order_By>>;
  where?: InputMaybe<Estate_Round_Bool_Exp>;
};


export type Query_RootEstate_Round_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Round_Order_By>>;
  where?: InputMaybe<Estate_Round_Bool_Exp>;
};


export type Query_RootEstate_Round_Buyer_MemberArgs = {
  distinct_on?: InputMaybe<Array<Estate_Round_Buyer_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Round_Buyer_Member_Order_By>>;
  where?: InputMaybe<Estate_Round_Buyer_Member_Bool_Exp>;
};


export type Query_RootEstate_Round_Buyer_Member_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Round_Buyer_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Round_Buyer_Member_Order_By>>;
  where?: InputMaybe<Estate_Round_Buyer_Member_Bool_Exp>;
};


export type Query_RootEstate_Round_Buyer_Member_By_PkArgs = {
  buyerMemberId: Scalars['uuid']['input'];
  estateRoundId: Scalars['uuid']['input'];
};


export type Query_RootEstate_Round_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEstate_SellerArgs = {
  distinct_on?: InputMaybe<Array<Estate_Seller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Seller_Order_By>>;
  where?: InputMaybe<Estate_Seller_Bool_Exp>;
};


export type Query_RootEstate_Seller_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Seller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Seller_Order_By>>;
  where?: InputMaybe<Estate_Seller_Bool_Exp>;
};


export type Query_RootEstate_Seller_By_PkArgs = {
  estateId: Scalars['uuid']['input'];
  sellerId: Scalars['uuid']['input'];
};


export type Query_RootEstate_TypeArgs = {
  distinct_on?: InputMaybe<Array<Estate_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Type_Order_By>>;
  where?: InputMaybe<Estate_Type_Bool_Exp>;
};


export type Query_RootEstate_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Type_Order_By>>;
  where?: InputMaybe<Estate_Type_Bool_Exp>;
};


export type Query_RootEstate_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootFileArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootFilesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootMandateArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Order_By>>;
  where?: InputMaybe<Mandate_Bool_Exp>;
};


export type Query_RootMandate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Order_By>>;
  where?: InputMaybe<Mandate_Bool_Exp>;
};


export type Query_RootMandate_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMandate_Fee_PersonArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Fee_Person_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Fee_Person_Order_By>>;
  where?: InputMaybe<Mandate_Fee_Person_Bool_Exp>;
};


export type Query_RootMandate_Fee_Person_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Fee_Person_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Fee_Person_Order_By>>;
  where?: InputMaybe<Mandate_Fee_Person_Bool_Exp>;
};


export type Query_RootMandate_Fee_Person_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootMandate_MediaArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Media_Order_By>>;
  where?: InputMaybe<Mandate_Media_Bool_Exp>;
};


export type Query_RootMandate_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Media_Order_By>>;
  where?: InputMaybe<Mandate_Media_Bool_Exp>;
};


export type Query_RootMandate_Media_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMandate_RegistryArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Registry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Registry_Order_By>>;
  where?: InputMaybe<Mandate_Registry_Bool_Exp>;
};


export type Query_RootMandate_Registry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Registry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Registry_Order_By>>;
  where?: InputMaybe<Mandate_Registry_Bool_Exp>;
};


export type Query_RootMandate_Registry_By_PkArgs = {
  orderNumber: Scalars['String']['input'];
};


export type Query_RootMandate_Registry_Number_LockArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Registry_Number_Lock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Registry_Number_Lock_Order_By>>;
  where?: InputMaybe<Mandate_Registry_Number_Lock_Bool_Exp>;
};


export type Query_RootMandate_Registry_Number_Lock_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Registry_Number_Lock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Registry_Number_Lock_Order_By>>;
  where?: InputMaybe<Mandate_Registry_Number_Lock_Bool_Exp>;
};


export type Query_RootMandate_Registry_Number_Lock_By_PkArgs = {
  key_name: Scalars['String']['input'];
};


export type Query_RootMandate_StatusArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Status_Order_By>>;
  where?: InputMaybe<Mandate_Status_Bool_Exp>;
};


export type Query_RootMandate_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Status_Order_By>>;
  where?: InputMaybe<Mandate_Status_Bool_Exp>;
};


export type Query_RootMandate_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootMandate_TypeArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Type_Order_By>>;
  where?: InputMaybe<Mandate_Type_Bool_Exp>;
};


export type Query_RootMandate_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Type_Order_By>>;
  where?: InputMaybe<Mandate_Type_Bool_Exp>;
};


export type Query_RootMandate_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootSellerArgs = {
  distinct_on?: InputMaybe<Array<Seller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Order_By>>;
  where?: InputMaybe<Seller_Bool_Exp>;
};


export type Query_RootSeller_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Order_By>>;
  where?: InputMaybe<Seller_Bool_Exp>;
};


export type Query_RootSeller_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSeller_Legal_StatusArgs = {
  distinct_on?: InputMaybe<Array<Seller_Legal_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Legal_Status_Order_By>>;
  where?: InputMaybe<Seller_Legal_Status_Bool_Exp>;
};


export type Query_RootSeller_Legal_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seller_Legal_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Legal_Status_Order_By>>;
  where?: InputMaybe<Seller_Legal_Status_Bool_Exp>;
};


export type Query_RootSeller_Legal_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootSeller_Marital_StatusArgs = {
  distinct_on?: InputMaybe<Array<Seller_Marital_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Marital_Status_Order_By>>;
  where?: InputMaybe<Seller_Marital_Status_Bool_Exp>;
};


export type Query_RootSeller_Marital_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seller_Marital_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Marital_Status_Order_By>>;
  where?: InputMaybe<Seller_Marital_Status_Bool_Exp>;
};


export type Query_RootSeller_Marital_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootSeller_MediaArgs = {
  distinct_on?: InputMaybe<Array<Seller_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Media_Order_By>>;
  where?: InputMaybe<Seller_Media_Bool_Exp>;
};


export type Query_RootSeller_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seller_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Media_Order_By>>;
  where?: InputMaybe<Seller_Media_Bool_Exp>;
};


export type Query_RootSeller_Media_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSeller_MemberArgs = {
  distinct_on?: InputMaybe<Array<Seller_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Member_Order_By>>;
  where?: InputMaybe<Seller_Member_Bool_Exp>;
};


export type Query_RootSeller_Member_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seller_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Member_Order_By>>;
  where?: InputMaybe<Seller_Member_Bool_Exp>;
};


export type Query_RootSeller_Member_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSeller_Tax_SystemArgs = {
  distinct_on?: InputMaybe<Array<Seller_Tax_System_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Tax_System_Order_By>>;
  where?: InputMaybe<Seller_Tax_System_Bool_Exp>;
};


export type Query_RootSeller_Tax_System_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seller_Tax_System_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Tax_System_Order_By>>;
  where?: InputMaybe<Seller_Tax_System_Bool_Exp>;
};


export type Query_RootSeller_Tax_System_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootSeller_TypeArgs = {
  distinct_on?: InputMaybe<Array<Seller_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Type_Order_By>>;
  where?: InputMaybe<Seller_Type_Bool_Exp>;
};


export type Query_RootSeller_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seller_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Type_Order_By>>;
  where?: InputMaybe<Seller_Type_Bool_Exp>;
};


export type Query_RootSeller_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootUserArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootVirusArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVirusesArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Query_RootVirusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Query_RootVisitArgs = {
  distinct_on?: InputMaybe<Array<Visit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visit_Order_By>>;
  where?: InputMaybe<Visit_Bool_Exp>;
};


export type Query_RootVisit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Visit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visit_Order_By>>;
  where?: InputMaybe<Visit_Bool_Exp>;
};


export type Query_RootVisit_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVisit_SpanArgs = {
  distinct_on?: InputMaybe<Array<Visit_Span_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visit_Span_Order_By>>;
  where?: InputMaybe<Visit_Span_Bool_Exp>;
};


export type Query_RootVisit_Span_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Visit_Span_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visit_Span_Order_By>>;
  where?: InputMaybe<Visit_Span_Bool_Exp>;
};


export type Query_RootVisit_Span_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "seller" */
export type Seller = {
  __typename?: 'seller';
  accountHolder?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  agency: Agency;
  agencyId: Scalars['uuid']['output'];
  archived: Scalars['Boolean']['output'];
  bankAddress?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  bic?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['String']['output']>;
  birthName?: Maybe<Scalars['String']['output']>;
  birthPlace?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  /** If true, the seller can edit their estates' information and ask for a new "estimation" (aka. create an estate) */
  canEditAndCreateEstate: Scalars['Boolean']['output'];
  civility?: Maybe<Civility_Enum>;
  comment?: Maybe<Scalars['String']['output']>;
  comparution?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  email?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  estate_sellers: Array<Estate_Seller>;
  /** An aggregate relationship */
  estate_sellers_aggregate: Estate_Seller_Aggregate;
  /** An array relationship */
  estates: Array<Estate>;
  /** An aggregate relationship */
  estates_aggregate: Estate_Aggregate;
  /** An object relationship */
  file_idCard?: Maybe<Files>;
  /** An object relationship */
  file_kbis?: Maybe<Files>;
  /** An object relationship */
  file_logo?: Maybe<Files>;
  /** An object relationship */
  file_rib?: Maybe<Files>;
  /** An array relationship */
  files: Array<Seller_Media>;
  /** An aggregate relationship */
  files_aggregate: Seller_Media_Aggregate;
  firstName?: Maybe<Scalars['String']['output']>;
  headquarter?: Maybe<Scalars['String']['output']>;
  hideBuyerContactInfo: Scalars['Boolean']['output'];
  homePhone?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  idCard?: Maybe<Scalars['uuid']['output']>;
  job?: Maybe<Scalars['String']['output']>;
  kbis?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  legalStatus?: Maybe<Seller_Legal_Status_Enum>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['uuid']['output']>;
  maritalStatus?: Maybe<Seller_Marital_Status_Enum>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nationality?: Maybe<Scalars['String']['output']>;
  officePhone?: Maybe<Scalars['String']['output']>;
  rib?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  seller_members: Array<Seller_Member>;
  /** An aggregate relationship */
  seller_members_aggregate: Seller_Member_Aggregate;
  siren?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  taxCountry?: Maybe<Scalars['String']['output']>;
  taxSystem?: Maybe<Seller_Tax_System_Enum>;
  tva: Scalars['Boolean']['output'];
  tvaNumber?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Seller_Type_Enum>;
};


/** columns and relationships of "seller" */
export type SellerEstate_SellersArgs = {
  distinct_on?: InputMaybe<Array<Estate_Seller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Seller_Order_By>>;
  where?: InputMaybe<Estate_Seller_Bool_Exp>;
};


/** columns and relationships of "seller" */
export type SellerEstate_Sellers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Seller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Seller_Order_By>>;
  where?: InputMaybe<Estate_Seller_Bool_Exp>;
};


/** columns and relationships of "seller" */
export type SellerEstatesArgs = {
  distinct_on?: InputMaybe<Array<Estate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Order_By>>;
  where?: InputMaybe<Estate_Bool_Exp>;
};


/** columns and relationships of "seller" */
export type SellerEstates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Order_By>>;
  where?: InputMaybe<Estate_Bool_Exp>;
};


/** columns and relationships of "seller" */
export type SellerFilesArgs = {
  distinct_on?: InputMaybe<Array<Seller_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Media_Order_By>>;
  where?: InputMaybe<Seller_Media_Bool_Exp>;
};


/** columns and relationships of "seller" */
export type SellerFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seller_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Media_Order_By>>;
  where?: InputMaybe<Seller_Media_Bool_Exp>;
};


/** columns and relationships of "seller" */
export type SellerSeller_MembersArgs = {
  distinct_on?: InputMaybe<Array<Seller_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Member_Order_By>>;
  where?: InputMaybe<Seller_Member_Bool_Exp>;
};


/** columns and relationships of "seller" */
export type SellerSeller_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seller_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Member_Order_By>>;
  where?: InputMaybe<Seller_Member_Bool_Exp>;
};

/** aggregated selection of "seller" */
export type Seller_Aggregate = {
  __typename?: 'seller_aggregate';
  aggregate?: Maybe<Seller_Aggregate_Fields>;
  nodes: Array<Seller>;
};

export type Seller_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Seller_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Seller_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Seller_Aggregate_Bool_Exp_Count>;
};

export type Seller_Aggregate_Bool_Exp_Bool_And = {
  arguments: Seller_Select_Column_Seller_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Seller_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Seller_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Seller_Select_Column_Seller_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Seller_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Seller_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Seller_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Seller_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "seller" */
export type Seller_Aggregate_Fields = {
  __typename?: 'seller_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Seller_Max_Fields>;
  min?: Maybe<Seller_Min_Fields>;
};


/** aggregate fields of "seller" */
export type Seller_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Seller_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "seller" */
export type Seller_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Seller_Max_Order_By>;
  min?: InputMaybe<Seller_Min_Order_By>;
};

/** input type for inserting array relation for remote table "seller" */
export type Seller_Arr_Rel_Insert_Input = {
  data: Array<Seller_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Seller_On_Conflict>;
};

/** Boolean expression to filter rows from the table "seller". All fields are combined with a logical 'AND'. */
export type Seller_Bool_Exp = {
  _and?: InputMaybe<Array<Seller_Bool_Exp>>;
  _not?: InputMaybe<Seller_Bool_Exp>;
  _or?: InputMaybe<Array<Seller_Bool_Exp>>;
  accountHolder?: InputMaybe<String_Comparison_Exp>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency?: InputMaybe<Agency_Bool_Exp>;
  agencyId?: InputMaybe<Uuid_Comparison_Exp>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  bankAddress?: InputMaybe<String_Comparison_Exp>;
  bankName?: InputMaybe<String_Comparison_Exp>;
  bic?: InputMaybe<String_Comparison_Exp>;
  birthDate?: InputMaybe<String_Comparison_Exp>;
  birthName?: InputMaybe<String_Comparison_Exp>;
  birthPlace?: InputMaybe<String_Comparison_Exp>;
  businessName?: InputMaybe<String_Comparison_Exp>;
  canEditAndCreateEstate?: InputMaybe<Boolean_Comparison_Exp>;
  civility?: InputMaybe<Civility_Enum_Comparison_Exp>;
  comment?: InputMaybe<String_Comparison_Exp>;
  comparution?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  estate_sellers?: InputMaybe<Estate_Seller_Bool_Exp>;
  estate_sellers_aggregate?: InputMaybe<Estate_Seller_Aggregate_Bool_Exp>;
  estates?: InputMaybe<Estate_Bool_Exp>;
  estates_aggregate?: InputMaybe<Estate_Aggregate_Bool_Exp>;
  file_idCard?: InputMaybe<Files_Bool_Exp>;
  file_kbis?: InputMaybe<Files_Bool_Exp>;
  file_logo?: InputMaybe<Files_Bool_Exp>;
  file_rib?: InputMaybe<Files_Bool_Exp>;
  files?: InputMaybe<Seller_Media_Bool_Exp>;
  files_aggregate?: InputMaybe<Seller_Media_Aggregate_Bool_Exp>;
  firstName?: InputMaybe<String_Comparison_Exp>;
  headquarter?: InputMaybe<String_Comparison_Exp>;
  hideBuyerContactInfo?: InputMaybe<Boolean_Comparison_Exp>;
  homePhone?: InputMaybe<String_Comparison_Exp>;
  iban?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  idCard?: InputMaybe<Uuid_Comparison_Exp>;
  job?: InputMaybe<String_Comparison_Exp>;
  kbis?: InputMaybe<Uuid_Comparison_Exp>;
  lastName?: InputMaybe<String_Comparison_Exp>;
  legalStatus?: InputMaybe<Seller_Legal_Status_Enum_Comparison_Exp>;
  linkUrl?: InputMaybe<String_Comparison_Exp>;
  logo?: InputMaybe<Uuid_Comparison_Exp>;
  maritalStatus?: InputMaybe<Seller_Marital_Status_Enum_Comparison_Exp>;
  mobilePhone?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  nationality?: InputMaybe<String_Comparison_Exp>;
  officePhone?: InputMaybe<String_Comparison_Exp>;
  rib?: InputMaybe<Uuid_Comparison_Exp>;
  seller_members?: InputMaybe<Seller_Member_Bool_Exp>;
  seller_members_aggregate?: InputMaybe<Seller_Member_Aggregate_Bool_Exp>;
  siren?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  taxCountry?: InputMaybe<String_Comparison_Exp>;
  taxSystem?: InputMaybe<Seller_Tax_System_Enum_Comparison_Exp>;
  tva?: InputMaybe<Boolean_Comparison_Exp>;
  tvaNumber?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Seller_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "seller" */
export enum Seller_Constraint {
  /** unique or primary key constraint on columns "id" */
  SellerPkey = 'seller_pkey',
  /** unique or primary key constraint on columns "slug" */
  SellerSlugKey = 'seller_slug_key'
}

/** input type for inserting data into table "seller" */
export type Seller_Insert_Input = {
  accountHolder?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  agency?: InputMaybe<Agency_Obj_Rel_Insert_Input>;
  agencyId?: InputMaybe<Scalars['uuid']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  bankAddress?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  birthName?: InputMaybe<Scalars['String']['input']>;
  birthPlace?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  /** If true, the seller can edit their estates' information and ask for a new "estimation" (aka. create an estate) */
  canEditAndCreateEstate?: InputMaybe<Scalars['Boolean']['input']>;
  civility?: InputMaybe<Civility_Enum>;
  comment?: InputMaybe<Scalars['String']['input']>;
  comparution?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  estate_sellers?: InputMaybe<Estate_Seller_Arr_Rel_Insert_Input>;
  estates?: InputMaybe<Estate_Arr_Rel_Insert_Input>;
  file_idCard?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_kbis?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_logo?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_rib?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  files?: InputMaybe<Seller_Media_Arr_Rel_Insert_Input>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  headquarter?: InputMaybe<Scalars['String']['input']>;
  hideBuyerContactInfo?: InputMaybe<Scalars['Boolean']['input']>;
  homePhone?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idCard?: InputMaybe<Scalars['uuid']['input']>;
  job?: InputMaybe<Scalars['String']['input']>;
  kbis?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  legalStatus?: InputMaybe<Seller_Legal_Status_Enum>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['uuid']['input']>;
  maritalStatus?: InputMaybe<Seller_Marital_Status_Enum>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  officePhone?: InputMaybe<Scalars['String']['input']>;
  rib?: InputMaybe<Scalars['uuid']['input']>;
  seller_members?: InputMaybe<Seller_Member_Arr_Rel_Insert_Input>;
  siren?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  taxCountry?: InputMaybe<Scalars['String']['input']>;
  taxSystem?: InputMaybe<Seller_Tax_System_Enum>;
  tva?: InputMaybe<Scalars['Boolean']['input']>;
  tvaNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Seller_Type_Enum>;
};

/** columns and relationships of "seller_legal_status" */
export type Seller_Legal_Status = {
  __typename?: 'seller_legal_status';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "seller_legal_status" */
export type Seller_Legal_Status_Aggregate = {
  __typename?: 'seller_legal_status_aggregate';
  aggregate?: Maybe<Seller_Legal_Status_Aggregate_Fields>;
  nodes: Array<Seller_Legal_Status>;
};

/** aggregate fields of "seller_legal_status" */
export type Seller_Legal_Status_Aggregate_Fields = {
  __typename?: 'seller_legal_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Seller_Legal_Status_Max_Fields>;
  min?: Maybe<Seller_Legal_Status_Min_Fields>;
};


/** aggregate fields of "seller_legal_status" */
export type Seller_Legal_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Seller_Legal_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "seller_legal_status". All fields are combined with a logical 'AND'. */
export type Seller_Legal_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Seller_Legal_Status_Bool_Exp>>;
  _not?: InputMaybe<Seller_Legal_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Seller_Legal_Status_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "seller_legal_status" */
export enum Seller_Legal_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  SellerLegalStatusPkey = 'seller_legal_status_pkey'
}

export enum Seller_Legal_Status_Enum {
  Charity = 'Charity',
  Eurl = 'EURL',
  Fund = 'Fund',
  Other = 'Other',
  Sarl = 'SARL',
  Sas = 'SAS',
  Sc = 'SC',
  Sci = 'SCI',
  Snc = 'SNC'
}

/** Boolean expression to compare columns of type "seller_legal_status_enum". All fields are combined with logical 'AND'. */
export type Seller_Legal_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Seller_Legal_Status_Enum>;
  _in?: InputMaybe<Array<Seller_Legal_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Seller_Legal_Status_Enum>;
  _nin?: InputMaybe<Array<Seller_Legal_Status_Enum>>;
};

/** input type for inserting data into table "seller_legal_status" */
export type Seller_Legal_Status_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Seller_Legal_Status_Max_Fields = {
  __typename?: 'seller_legal_status_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Seller_Legal_Status_Min_Fields = {
  __typename?: 'seller_legal_status_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "seller_legal_status" */
export type Seller_Legal_Status_Mutation_Response = {
  __typename?: 'seller_legal_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Seller_Legal_Status>;
};

/** on_conflict condition type for table "seller_legal_status" */
export type Seller_Legal_Status_On_Conflict = {
  constraint: Seller_Legal_Status_Constraint;
  update_columns?: Array<Seller_Legal_Status_Update_Column>;
  where?: InputMaybe<Seller_Legal_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "seller_legal_status". */
export type Seller_Legal_Status_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: seller_legal_status */
export type Seller_Legal_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "seller_legal_status" */
export enum Seller_Legal_Status_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "seller_legal_status" */
export type Seller_Legal_Status_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "seller_legal_status" */
export type Seller_Legal_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Seller_Legal_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Seller_Legal_Status_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "seller_legal_status" */
export enum Seller_Legal_Status_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Seller_Legal_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Seller_Legal_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Seller_Legal_Status_Bool_Exp;
};

/** columns and relationships of "seller_marital_status" */
export type Seller_Marital_Status = {
  __typename?: 'seller_marital_status';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "seller_marital_status" */
export type Seller_Marital_Status_Aggregate = {
  __typename?: 'seller_marital_status_aggregate';
  aggregate?: Maybe<Seller_Marital_Status_Aggregate_Fields>;
  nodes: Array<Seller_Marital_Status>;
};

/** aggregate fields of "seller_marital_status" */
export type Seller_Marital_Status_Aggregate_Fields = {
  __typename?: 'seller_marital_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Seller_Marital_Status_Max_Fields>;
  min?: Maybe<Seller_Marital_Status_Min_Fields>;
};


/** aggregate fields of "seller_marital_status" */
export type Seller_Marital_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Seller_Marital_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "seller_marital_status". All fields are combined with a logical 'AND'. */
export type Seller_Marital_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Seller_Marital_Status_Bool_Exp>>;
  _not?: InputMaybe<Seller_Marital_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Seller_Marital_Status_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "seller_marital_status" */
export enum Seller_Marital_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  SellerMaritalStatusPkey = 'seller_marital_status_pkey'
}

export enum Seller_Marital_Status_Enum {
  Divorced = 'Divorced',
  Married = 'Married',
  Pacsed = 'Pacsed',
  Single = 'Single',
  Widowed = 'Widowed'
}

/** Boolean expression to compare columns of type "seller_marital_status_enum". All fields are combined with logical 'AND'. */
export type Seller_Marital_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Seller_Marital_Status_Enum>;
  _in?: InputMaybe<Array<Seller_Marital_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Seller_Marital_Status_Enum>;
  _nin?: InputMaybe<Array<Seller_Marital_Status_Enum>>;
};

/** input type for inserting data into table "seller_marital_status" */
export type Seller_Marital_Status_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Seller_Marital_Status_Max_Fields = {
  __typename?: 'seller_marital_status_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Seller_Marital_Status_Min_Fields = {
  __typename?: 'seller_marital_status_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "seller_marital_status" */
export type Seller_Marital_Status_Mutation_Response = {
  __typename?: 'seller_marital_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Seller_Marital_Status>;
};

/** on_conflict condition type for table "seller_marital_status" */
export type Seller_Marital_Status_On_Conflict = {
  constraint: Seller_Marital_Status_Constraint;
  update_columns?: Array<Seller_Marital_Status_Update_Column>;
  where?: InputMaybe<Seller_Marital_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "seller_marital_status". */
export type Seller_Marital_Status_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: seller_marital_status */
export type Seller_Marital_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "seller_marital_status" */
export enum Seller_Marital_Status_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "seller_marital_status" */
export type Seller_Marital_Status_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "seller_marital_status" */
export type Seller_Marital_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Seller_Marital_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Seller_Marital_Status_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "seller_marital_status" */
export enum Seller_Marital_Status_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Seller_Marital_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Seller_Marital_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Seller_Marital_Status_Bool_Exp;
};

/** aggregate max on columns */
export type Seller_Max_Fields = {
  __typename?: 'seller_max_fields';
  accountHolder?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  agencyId?: Maybe<Scalars['uuid']['output']>;
  bankAddress?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  bic?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['String']['output']>;
  birthName?: Maybe<Scalars['String']['output']>;
  birthPlace?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  comparution?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  headquarter?: Maybe<Scalars['String']['output']>;
  homePhone?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  idCard?: Maybe<Scalars['uuid']['output']>;
  job?: Maybe<Scalars['String']['output']>;
  kbis?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['uuid']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  officePhone?: Maybe<Scalars['String']['output']>;
  rib?: Maybe<Scalars['uuid']['output']>;
  siren?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  taxCountry?: Maybe<Scalars['String']['output']>;
  tvaNumber?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "seller" */
export type Seller_Max_Order_By = {
  accountHolder?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  agencyId?: InputMaybe<Order_By>;
  bankAddress?: InputMaybe<Order_By>;
  bankName?: InputMaybe<Order_By>;
  bic?: InputMaybe<Order_By>;
  birthDate?: InputMaybe<Order_By>;
  birthName?: InputMaybe<Order_By>;
  birthPlace?: InputMaybe<Order_By>;
  businessName?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  comparution?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  headquarter?: InputMaybe<Order_By>;
  homePhone?: InputMaybe<Order_By>;
  iban?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idCard?: InputMaybe<Order_By>;
  job?: InputMaybe<Order_By>;
  kbis?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  linkUrl?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  mobilePhone?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  nationality?: InputMaybe<Order_By>;
  officePhone?: InputMaybe<Order_By>;
  rib?: InputMaybe<Order_By>;
  siren?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  taxCountry?: InputMaybe<Order_By>;
  tvaNumber?: InputMaybe<Order_By>;
};

/** columns and relationships of "seller_media" */
export type Seller_Media = {
  __typename?: 'seller_media';
  /** An object relationship */
  file: Files;
  fileId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  seller: Seller;
  sellerId: Scalars['uuid']['output'];
};

/** aggregated selection of "seller_media" */
export type Seller_Media_Aggregate = {
  __typename?: 'seller_media_aggregate';
  aggregate?: Maybe<Seller_Media_Aggregate_Fields>;
  nodes: Array<Seller_Media>;
};

export type Seller_Media_Aggregate_Bool_Exp = {
  count?: InputMaybe<Seller_Media_Aggregate_Bool_Exp_Count>;
};

export type Seller_Media_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Seller_Media_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Seller_Media_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "seller_media" */
export type Seller_Media_Aggregate_Fields = {
  __typename?: 'seller_media_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Seller_Media_Max_Fields>;
  min?: Maybe<Seller_Media_Min_Fields>;
};


/** aggregate fields of "seller_media" */
export type Seller_Media_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Seller_Media_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "seller_media" */
export type Seller_Media_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Seller_Media_Max_Order_By>;
  min?: InputMaybe<Seller_Media_Min_Order_By>;
};

/** input type for inserting array relation for remote table "seller_media" */
export type Seller_Media_Arr_Rel_Insert_Input = {
  data: Array<Seller_Media_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Seller_Media_On_Conflict>;
};

/** Boolean expression to filter rows from the table "seller_media". All fields are combined with a logical 'AND'. */
export type Seller_Media_Bool_Exp = {
  _and?: InputMaybe<Array<Seller_Media_Bool_Exp>>;
  _not?: InputMaybe<Seller_Media_Bool_Exp>;
  _or?: InputMaybe<Array<Seller_Media_Bool_Exp>>;
  file?: InputMaybe<Files_Bool_Exp>;
  fileId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  seller?: InputMaybe<Seller_Bool_Exp>;
  sellerId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "seller_media" */
export enum Seller_Media_Constraint {
  /** unique or primary key constraint on columns "id" */
  SellerMediaPkey = 'seller_media_pkey'
}

/** input type for inserting data into table "seller_media" */
export type Seller_Media_Insert_Input = {
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  seller?: InputMaybe<Seller_Obj_Rel_Insert_Input>;
  sellerId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Seller_Media_Max_Fields = {
  __typename?: 'seller_media_max_fields';
  fileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sellerId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "seller_media" */
export type Seller_Media_Max_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sellerId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Seller_Media_Min_Fields = {
  __typename?: 'seller_media_min_fields';
  fileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sellerId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "seller_media" */
export type Seller_Media_Min_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sellerId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "seller_media" */
export type Seller_Media_Mutation_Response = {
  __typename?: 'seller_media_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Seller_Media>;
};

/** on_conflict condition type for table "seller_media" */
export type Seller_Media_On_Conflict = {
  constraint: Seller_Media_Constraint;
  update_columns?: Array<Seller_Media_Update_Column>;
  where?: InputMaybe<Seller_Media_Bool_Exp>;
};

/** Ordering options when selecting data from "seller_media". */
export type Seller_Media_Order_By = {
  file?: InputMaybe<Files_Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  seller?: InputMaybe<Seller_Order_By>;
  sellerId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: seller_media */
export type Seller_Media_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "seller_media" */
export enum Seller_Media_Select_Column {
  /** column name */
  FileId = 'fileId',
  /** column name */
  Id = 'id',
  /** column name */
  SellerId = 'sellerId'
}

/** input type for updating data in table "seller_media" */
export type Seller_Media_Set_Input = {
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sellerId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "seller_media" */
export type Seller_Media_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Seller_Media_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Seller_Media_Stream_Cursor_Value_Input = {
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sellerId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "seller_media" */
export enum Seller_Media_Update_Column {
  /** column name */
  FileId = 'fileId',
  /** column name */
  Id = 'id',
  /** column name */
  SellerId = 'sellerId'
}

export type Seller_Media_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Seller_Media_Set_Input>;
  /** filter the rows which have to be updated */
  where: Seller_Media_Bool_Exp;
};

/** columns and relationships of "seller_member" */
export type Seller_Member = {
  __typename?: 'seller_member';
  archived: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  hasSetPassword?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  inviteDate?: Maybe<Scalars['timestamptz']['output']>;
  /** Used only during the invation phase. Not used afterward (check user.email instead) */
  inviteEmail?: Maybe<Scalars['String']['output']>;
  /** Used only during the invation phase. Not used afterward (check user.phoneNumber instead) */
  invitePhone?: Maybe<Scalars['String']['output']>;
  isMainContact: Scalars['Boolean']['output'];
  job?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  pictureFile?: Maybe<Files>;
  pictureFileId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  seller: Seller;
  sellerId: Scalars['uuid']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "seller_member" */
export type Seller_Member_Aggregate = {
  __typename?: 'seller_member_aggregate';
  aggregate?: Maybe<Seller_Member_Aggregate_Fields>;
  nodes: Array<Seller_Member>;
};

export type Seller_Member_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Seller_Member_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Seller_Member_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Seller_Member_Aggregate_Bool_Exp_Count>;
};

export type Seller_Member_Aggregate_Bool_Exp_Bool_And = {
  arguments: Seller_Member_Select_Column_Seller_Member_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Seller_Member_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Seller_Member_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Seller_Member_Select_Column_Seller_Member_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Seller_Member_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Seller_Member_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Seller_Member_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Seller_Member_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "seller_member" */
export type Seller_Member_Aggregate_Fields = {
  __typename?: 'seller_member_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Seller_Member_Max_Fields>;
  min?: Maybe<Seller_Member_Min_Fields>;
};


/** aggregate fields of "seller_member" */
export type Seller_Member_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Seller_Member_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "seller_member" */
export type Seller_Member_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Seller_Member_Max_Order_By>;
  min?: InputMaybe<Seller_Member_Min_Order_By>;
};

/** input type for inserting array relation for remote table "seller_member" */
export type Seller_Member_Arr_Rel_Insert_Input = {
  data: Array<Seller_Member_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Seller_Member_On_Conflict>;
};

/** Boolean expression to filter rows from the table "seller_member". All fields are combined with a logical 'AND'. */
export type Seller_Member_Bool_Exp = {
  _and?: InputMaybe<Array<Seller_Member_Bool_Exp>>;
  _not?: InputMaybe<Seller_Member_Bool_Exp>;
  _or?: InputMaybe<Array<Seller_Member_Bool_Exp>>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  hasSetPassword?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inviteDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  inviteEmail?: InputMaybe<String_Comparison_Exp>;
  invitePhone?: InputMaybe<String_Comparison_Exp>;
  isMainContact?: InputMaybe<Boolean_Comparison_Exp>;
  job?: InputMaybe<String_Comparison_Exp>;
  picture?: InputMaybe<String_Comparison_Exp>;
  pictureFile?: InputMaybe<Files_Bool_Exp>;
  pictureFileId?: InputMaybe<Uuid_Comparison_Exp>;
  seller?: InputMaybe<Seller_Bool_Exp>;
  sellerId?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "seller_member" */
export enum Seller_Member_Constraint {
  /** unique or primary key constraint on columns "inviteEmail" */
  SellerMemberInviteEmailKey = 'seller_member_inviteEmail_key',
  /** unique or primary key constraint on columns "id" */
  SellerMemberPkey = 'seller_member_pkey'
}

/** input type for inserting data into table "seller_member" */
export type Seller_Member_Insert_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasSetPassword?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inviteDate?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Used only during the invation phase. Not used afterward (check user.email instead) */
  inviteEmail?: InputMaybe<Scalars['String']['input']>;
  /** Used only during the invation phase. Not used afterward (check user.phoneNumber instead) */
  invitePhone?: InputMaybe<Scalars['String']['input']>;
  isMainContact?: InputMaybe<Scalars['Boolean']['input']>;
  job?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  pictureFile?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  pictureFileId?: InputMaybe<Scalars['uuid']['input']>;
  seller?: InputMaybe<Seller_Obj_Rel_Insert_Input>;
  sellerId?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Seller_Member_Max_Fields = {
  __typename?: 'seller_member_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  inviteDate?: Maybe<Scalars['timestamptz']['output']>;
  /** Used only during the invation phase. Not used afterward (check user.email instead) */
  inviteEmail?: Maybe<Scalars['String']['output']>;
  /** Used only during the invation phase. Not used afterward (check user.phoneNumber instead) */
  invitePhone?: Maybe<Scalars['String']['output']>;
  job?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  pictureFileId?: Maybe<Scalars['uuid']['output']>;
  sellerId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "seller_member" */
export type Seller_Member_Max_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inviteDate?: InputMaybe<Order_By>;
  /** Used only during the invation phase. Not used afterward (check user.email instead) */
  inviteEmail?: InputMaybe<Order_By>;
  /** Used only during the invation phase. Not used afterward (check user.phoneNumber instead) */
  invitePhone?: InputMaybe<Order_By>;
  job?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  pictureFileId?: InputMaybe<Order_By>;
  sellerId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Seller_Member_Min_Fields = {
  __typename?: 'seller_member_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  inviteDate?: Maybe<Scalars['timestamptz']['output']>;
  /** Used only during the invation phase. Not used afterward (check user.email instead) */
  inviteEmail?: Maybe<Scalars['String']['output']>;
  /** Used only during the invation phase. Not used afterward (check user.phoneNumber instead) */
  invitePhone?: Maybe<Scalars['String']['output']>;
  job?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  pictureFileId?: Maybe<Scalars['uuid']['output']>;
  sellerId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "seller_member" */
export type Seller_Member_Min_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inviteDate?: InputMaybe<Order_By>;
  /** Used only during the invation phase. Not used afterward (check user.email instead) */
  inviteEmail?: InputMaybe<Order_By>;
  /** Used only during the invation phase. Not used afterward (check user.phoneNumber instead) */
  invitePhone?: InputMaybe<Order_By>;
  job?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  pictureFileId?: InputMaybe<Order_By>;
  sellerId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "seller_member" */
export type Seller_Member_Mutation_Response = {
  __typename?: 'seller_member_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Seller_Member>;
};

/** input type for inserting object relation for remote table "seller_member" */
export type Seller_Member_Obj_Rel_Insert_Input = {
  data: Seller_Member_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Seller_Member_On_Conflict>;
};

/** on_conflict condition type for table "seller_member" */
export type Seller_Member_On_Conflict = {
  constraint: Seller_Member_Constraint;
  update_columns?: Array<Seller_Member_Update_Column>;
  where?: InputMaybe<Seller_Member_Bool_Exp>;
};

/** Ordering options when selecting data from "seller_member". */
export type Seller_Member_Order_By = {
  archived?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  hasSetPassword?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inviteDate?: InputMaybe<Order_By>;
  inviteEmail?: InputMaybe<Order_By>;
  invitePhone?: InputMaybe<Order_By>;
  isMainContact?: InputMaybe<Order_By>;
  job?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  pictureFile?: InputMaybe<Files_Order_By>;
  pictureFileId?: InputMaybe<Order_By>;
  seller?: InputMaybe<Seller_Order_By>;
  sellerId?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: seller_member */
export type Seller_Member_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "seller_member" */
export enum Seller_Member_Select_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  Description = 'description',
  /** column name */
  HasSetPassword = 'hasSetPassword',
  /** column name */
  Id = 'id',
  /** column name */
  InviteDate = 'inviteDate',
  /** column name */
  InviteEmail = 'inviteEmail',
  /** column name */
  InvitePhone = 'invitePhone',
  /** column name */
  IsMainContact = 'isMainContact',
  /** column name */
  Job = 'job',
  /** column name */
  Picture = 'picture',
  /** column name */
  PictureFileId = 'pictureFileId',
  /** column name */
  SellerId = 'sellerId',
  /** column name */
  UserId = 'userId'
}

/** select "seller_member_aggregate_bool_exp_bool_and_arguments_columns" columns of table "seller_member" */
export enum Seller_Member_Select_Column_Seller_Member_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Archived = 'archived',
  /** column name */
  HasSetPassword = 'hasSetPassword',
  /** column name */
  IsMainContact = 'isMainContact'
}

/** select "seller_member_aggregate_bool_exp_bool_or_arguments_columns" columns of table "seller_member" */
export enum Seller_Member_Select_Column_Seller_Member_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Archived = 'archived',
  /** column name */
  HasSetPassword = 'hasSetPassword',
  /** column name */
  IsMainContact = 'isMainContact'
}

/** input type for updating data in table "seller_member" */
export type Seller_Member_Set_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasSetPassword?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inviteDate?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Used only during the invation phase. Not used afterward (check user.email instead) */
  inviteEmail?: InputMaybe<Scalars['String']['input']>;
  /** Used only during the invation phase. Not used afterward (check user.phoneNumber instead) */
  invitePhone?: InputMaybe<Scalars['String']['input']>;
  isMainContact?: InputMaybe<Scalars['Boolean']['input']>;
  job?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  pictureFileId?: InputMaybe<Scalars['uuid']['input']>;
  sellerId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "seller_member" */
export type Seller_Member_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Seller_Member_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Seller_Member_Stream_Cursor_Value_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasSetPassword?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inviteDate?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Used only during the invation phase. Not used afterward (check user.email instead) */
  inviteEmail?: InputMaybe<Scalars['String']['input']>;
  /** Used only during the invation phase. Not used afterward (check user.phoneNumber instead) */
  invitePhone?: InputMaybe<Scalars['String']['input']>;
  isMainContact?: InputMaybe<Scalars['Boolean']['input']>;
  job?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  pictureFileId?: InputMaybe<Scalars['uuid']['input']>;
  sellerId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "seller_member" */
export enum Seller_Member_Update_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  Description = 'description',
  /** column name */
  HasSetPassword = 'hasSetPassword',
  /** column name */
  Id = 'id',
  /** column name */
  InviteDate = 'inviteDate',
  /** column name */
  InviteEmail = 'inviteEmail',
  /** column name */
  InvitePhone = 'invitePhone',
  /** column name */
  IsMainContact = 'isMainContact',
  /** column name */
  Job = 'job',
  /** column name */
  Picture = 'picture',
  /** column name */
  PictureFileId = 'pictureFileId',
  /** column name */
  SellerId = 'sellerId',
  /** column name */
  UserId = 'userId'
}

export type Seller_Member_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Seller_Member_Set_Input>;
  /** filter the rows which have to be updated */
  where: Seller_Member_Bool_Exp;
};

/** aggregate min on columns */
export type Seller_Min_Fields = {
  __typename?: 'seller_min_fields';
  accountHolder?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  agencyId?: Maybe<Scalars['uuid']['output']>;
  bankAddress?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  bic?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['String']['output']>;
  birthName?: Maybe<Scalars['String']['output']>;
  birthPlace?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  comparution?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  headquarter?: Maybe<Scalars['String']['output']>;
  homePhone?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  idCard?: Maybe<Scalars['uuid']['output']>;
  job?: Maybe<Scalars['String']['output']>;
  kbis?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['uuid']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  officePhone?: Maybe<Scalars['String']['output']>;
  rib?: Maybe<Scalars['uuid']['output']>;
  siren?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  taxCountry?: Maybe<Scalars['String']['output']>;
  tvaNumber?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "seller" */
export type Seller_Min_Order_By = {
  accountHolder?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  agencyId?: InputMaybe<Order_By>;
  bankAddress?: InputMaybe<Order_By>;
  bankName?: InputMaybe<Order_By>;
  bic?: InputMaybe<Order_By>;
  birthDate?: InputMaybe<Order_By>;
  birthName?: InputMaybe<Order_By>;
  birthPlace?: InputMaybe<Order_By>;
  businessName?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  comparution?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  headquarter?: InputMaybe<Order_By>;
  homePhone?: InputMaybe<Order_By>;
  iban?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idCard?: InputMaybe<Order_By>;
  job?: InputMaybe<Order_By>;
  kbis?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  linkUrl?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  mobilePhone?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  nationality?: InputMaybe<Order_By>;
  officePhone?: InputMaybe<Order_By>;
  rib?: InputMaybe<Order_By>;
  siren?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  taxCountry?: InputMaybe<Order_By>;
  tvaNumber?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "seller" */
export type Seller_Mutation_Response = {
  __typename?: 'seller_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Seller>;
};

/** input type for inserting object relation for remote table "seller" */
export type Seller_Obj_Rel_Insert_Input = {
  data: Seller_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Seller_On_Conflict>;
};

/** on_conflict condition type for table "seller" */
export type Seller_On_Conflict = {
  constraint: Seller_Constraint;
  update_columns?: Array<Seller_Update_Column>;
  where?: InputMaybe<Seller_Bool_Exp>;
};

/** Ordering options when selecting data from "seller". */
export type Seller_Order_By = {
  accountHolder?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  agency?: InputMaybe<Agency_Order_By>;
  agencyId?: InputMaybe<Order_By>;
  archived?: InputMaybe<Order_By>;
  bankAddress?: InputMaybe<Order_By>;
  bankName?: InputMaybe<Order_By>;
  bic?: InputMaybe<Order_By>;
  birthDate?: InputMaybe<Order_By>;
  birthName?: InputMaybe<Order_By>;
  birthPlace?: InputMaybe<Order_By>;
  businessName?: InputMaybe<Order_By>;
  canEditAndCreateEstate?: InputMaybe<Order_By>;
  civility?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  comparution?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  estate_sellers_aggregate?: InputMaybe<Estate_Seller_Aggregate_Order_By>;
  estates_aggregate?: InputMaybe<Estate_Aggregate_Order_By>;
  file_idCard?: InputMaybe<Files_Order_By>;
  file_kbis?: InputMaybe<Files_Order_By>;
  file_logo?: InputMaybe<Files_Order_By>;
  file_rib?: InputMaybe<Files_Order_By>;
  files_aggregate?: InputMaybe<Seller_Media_Aggregate_Order_By>;
  firstName?: InputMaybe<Order_By>;
  headquarter?: InputMaybe<Order_By>;
  hideBuyerContactInfo?: InputMaybe<Order_By>;
  homePhone?: InputMaybe<Order_By>;
  iban?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idCard?: InputMaybe<Order_By>;
  job?: InputMaybe<Order_By>;
  kbis?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  legalStatus?: InputMaybe<Order_By>;
  linkUrl?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  maritalStatus?: InputMaybe<Order_By>;
  mobilePhone?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  nationality?: InputMaybe<Order_By>;
  officePhone?: InputMaybe<Order_By>;
  rib?: InputMaybe<Order_By>;
  seller_members_aggregate?: InputMaybe<Seller_Member_Aggregate_Order_By>;
  siren?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  taxCountry?: InputMaybe<Order_By>;
  taxSystem?: InputMaybe<Order_By>;
  tva?: InputMaybe<Order_By>;
  tvaNumber?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: seller */
export type Seller_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "seller" */
export enum Seller_Select_Column {
  /** column name */
  AccountHolder = 'accountHolder',
  /** column name */
  Address = 'address',
  /** column name */
  AgencyId = 'agencyId',
  /** column name */
  Archived = 'archived',
  /** column name */
  BankAddress = 'bankAddress',
  /** column name */
  BankName = 'bankName',
  /** column name */
  Bic = 'bic',
  /** column name */
  BirthDate = 'birthDate',
  /** column name */
  BirthName = 'birthName',
  /** column name */
  BirthPlace = 'birthPlace',
  /** column name */
  BusinessName = 'businessName',
  /** column name */
  CanEditAndCreateEstate = 'canEditAndCreateEstate',
  /** column name */
  Civility = 'civility',
  /** column name */
  Comment = 'comment',
  /** column name */
  Comparution = 'comparution',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Headquarter = 'headquarter',
  /** column name */
  HideBuyerContactInfo = 'hideBuyerContactInfo',
  /** column name */
  HomePhone = 'homePhone',
  /** column name */
  Iban = 'iban',
  /** column name */
  Id = 'id',
  /** column name */
  IdCard = 'idCard',
  /** column name */
  Job = 'job',
  /** column name */
  Kbis = 'kbis',
  /** column name */
  LastName = 'lastName',
  /** column name */
  LegalStatus = 'legalStatus',
  /** column name */
  LinkUrl = 'linkUrl',
  /** column name */
  Logo = 'logo',
  /** column name */
  MaritalStatus = 'maritalStatus',
  /** column name */
  MobilePhone = 'mobilePhone',
  /** column name */
  Name = 'name',
  /** column name */
  Nationality = 'nationality',
  /** column name */
  OfficePhone = 'officePhone',
  /** column name */
  Rib = 'rib',
  /** column name */
  Siren = 'siren',
  /** column name */
  Slug = 'slug',
  /** column name */
  TaxCountry = 'taxCountry',
  /** column name */
  TaxSystem = 'taxSystem',
  /** column name */
  Tva = 'tva',
  /** column name */
  TvaNumber = 'tvaNumber',
  /** column name */
  Type = 'type'
}

/** select "seller_aggregate_bool_exp_bool_and_arguments_columns" columns of table "seller" */
export enum Seller_Select_Column_Seller_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Archived = 'archived',
  /** column name */
  CanEditAndCreateEstate = 'canEditAndCreateEstate',
  /** column name */
  HideBuyerContactInfo = 'hideBuyerContactInfo',
  /** column name */
  Tva = 'tva'
}

/** select "seller_aggregate_bool_exp_bool_or_arguments_columns" columns of table "seller" */
export enum Seller_Select_Column_Seller_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Archived = 'archived',
  /** column name */
  CanEditAndCreateEstate = 'canEditAndCreateEstate',
  /** column name */
  HideBuyerContactInfo = 'hideBuyerContactInfo',
  /** column name */
  Tva = 'tva'
}

/** input type for updating data in table "seller" */
export type Seller_Set_Input = {
  accountHolder?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  agencyId?: InputMaybe<Scalars['uuid']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  bankAddress?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  birthName?: InputMaybe<Scalars['String']['input']>;
  birthPlace?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  /** If true, the seller can edit their estates' information and ask for a new "estimation" (aka. create an estate) */
  canEditAndCreateEstate?: InputMaybe<Scalars['Boolean']['input']>;
  civility?: InputMaybe<Civility_Enum>;
  comment?: InputMaybe<Scalars['String']['input']>;
  comparution?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  headquarter?: InputMaybe<Scalars['String']['input']>;
  hideBuyerContactInfo?: InputMaybe<Scalars['Boolean']['input']>;
  homePhone?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idCard?: InputMaybe<Scalars['uuid']['input']>;
  job?: InputMaybe<Scalars['String']['input']>;
  kbis?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  legalStatus?: InputMaybe<Seller_Legal_Status_Enum>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['uuid']['input']>;
  maritalStatus?: InputMaybe<Seller_Marital_Status_Enum>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  officePhone?: InputMaybe<Scalars['String']['input']>;
  rib?: InputMaybe<Scalars['uuid']['input']>;
  siren?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  taxCountry?: InputMaybe<Scalars['String']['input']>;
  taxSystem?: InputMaybe<Seller_Tax_System_Enum>;
  tva?: InputMaybe<Scalars['Boolean']['input']>;
  tvaNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Seller_Type_Enum>;
};

/** Streaming cursor of the table "seller" */
export type Seller_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Seller_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Seller_Stream_Cursor_Value_Input = {
  accountHolder?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  agencyId?: InputMaybe<Scalars['uuid']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  bankAddress?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  birthName?: InputMaybe<Scalars['String']['input']>;
  birthPlace?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  /** If true, the seller can edit their estates' information and ask for a new "estimation" (aka. create an estate) */
  canEditAndCreateEstate?: InputMaybe<Scalars['Boolean']['input']>;
  civility?: InputMaybe<Civility_Enum>;
  comment?: InputMaybe<Scalars['String']['input']>;
  comparution?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  headquarter?: InputMaybe<Scalars['String']['input']>;
  hideBuyerContactInfo?: InputMaybe<Scalars['Boolean']['input']>;
  homePhone?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idCard?: InputMaybe<Scalars['uuid']['input']>;
  job?: InputMaybe<Scalars['String']['input']>;
  kbis?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  legalStatus?: InputMaybe<Seller_Legal_Status_Enum>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['uuid']['input']>;
  maritalStatus?: InputMaybe<Seller_Marital_Status_Enum>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  officePhone?: InputMaybe<Scalars['String']['input']>;
  rib?: InputMaybe<Scalars['uuid']['input']>;
  siren?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  taxCountry?: InputMaybe<Scalars['String']['input']>;
  taxSystem?: InputMaybe<Seller_Tax_System_Enum>;
  tva?: InputMaybe<Scalars['Boolean']['input']>;
  tvaNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Seller_Type_Enum>;
};

/** columns and relationships of "seller_tax_system" */
export type Seller_Tax_System = {
  __typename?: 'seller_tax_system';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "seller_tax_system" */
export type Seller_Tax_System_Aggregate = {
  __typename?: 'seller_tax_system_aggregate';
  aggregate?: Maybe<Seller_Tax_System_Aggregate_Fields>;
  nodes: Array<Seller_Tax_System>;
};

/** aggregate fields of "seller_tax_system" */
export type Seller_Tax_System_Aggregate_Fields = {
  __typename?: 'seller_tax_system_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Seller_Tax_System_Max_Fields>;
  min?: Maybe<Seller_Tax_System_Min_Fields>;
};


/** aggregate fields of "seller_tax_system" */
export type Seller_Tax_System_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Seller_Tax_System_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "seller_tax_system". All fields are combined with a logical 'AND'. */
export type Seller_Tax_System_Bool_Exp = {
  _and?: InputMaybe<Array<Seller_Tax_System_Bool_Exp>>;
  _not?: InputMaybe<Seller_Tax_System_Bool_Exp>;
  _or?: InputMaybe<Array<Seller_Tax_System_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "seller_tax_system" */
export enum Seller_Tax_System_Constraint {
  /** unique or primary key constraint on columns "value" */
  SellerTaxSystemPkey = 'seller_tax_system_pkey'
}

export enum Seller_Tax_System_Enum {
  Ir = 'IR',
  Is = 'IS'
}

/** Boolean expression to compare columns of type "seller_tax_system_enum". All fields are combined with logical 'AND'. */
export type Seller_Tax_System_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Seller_Tax_System_Enum>;
  _in?: InputMaybe<Array<Seller_Tax_System_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Seller_Tax_System_Enum>;
  _nin?: InputMaybe<Array<Seller_Tax_System_Enum>>;
};

/** input type for inserting data into table "seller_tax_system" */
export type Seller_Tax_System_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Seller_Tax_System_Max_Fields = {
  __typename?: 'seller_tax_system_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Seller_Tax_System_Min_Fields = {
  __typename?: 'seller_tax_system_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "seller_tax_system" */
export type Seller_Tax_System_Mutation_Response = {
  __typename?: 'seller_tax_system_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Seller_Tax_System>;
};

/** on_conflict condition type for table "seller_tax_system" */
export type Seller_Tax_System_On_Conflict = {
  constraint: Seller_Tax_System_Constraint;
  update_columns?: Array<Seller_Tax_System_Update_Column>;
  where?: InputMaybe<Seller_Tax_System_Bool_Exp>;
};

/** Ordering options when selecting data from "seller_tax_system". */
export type Seller_Tax_System_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: seller_tax_system */
export type Seller_Tax_System_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "seller_tax_system" */
export enum Seller_Tax_System_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "seller_tax_system" */
export type Seller_Tax_System_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "seller_tax_system" */
export type Seller_Tax_System_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Seller_Tax_System_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Seller_Tax_System_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "seller_tax_system" */
export enum Seller_Tax_System_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Seller_Tax_System_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Seller_Tax_System_Set_Input>;
  /** filter the rows which have to be updated */
  where: Seller_Tax_System_Bool_Exp;
};

/** columns and relationships of "seller_type" */
export type Seller_Type = {
  __typename?: 'seller_type';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "seller_type" */
export type Seller_Type_Aggregate = {
  __typename?: 'seller_type_aggregate';
  aggregate?: Maybe<Seller_Type_Aggregate_Fields>;
  nodes: Array<Seller_Type>;
};

/** aggregate fields of "seller_type" */
export type Seller_Type_Aggregate_Fields = {
  __typename?: 'seller_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Seller_Type_Max_Fields>;
  min?: Maybe<Seller_Type_Min_Fields>;
};


/** aggregate fields of "seller_type" */
export type Seller_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Seller_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "seller_type". All fields are combined with a logical 'AND'. */
export type Seller_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Seller_Type_Bool_Exp>>;
  _not?: InputMaybe<Seller_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Seller_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "seller_type" */
export enum Seller_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  SellerTypePkey = 'seller_type_pkey'
}

export enum Seller_Type_Enum {
  Inheritance = 'Inheritance',
  LegalEntity = 'LegalEntity',
  NaturalPerson = 'NaturalPerson'
}

/** Boolean expression to compare columns of type "seller_type_enum". All fields are combined with logical 'AND'. */
export type Seller_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Seller_Type_Enum>;
  _in?: InputMaybe<Array<Seller_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Seller_Type_Enum>;
  _nin?: InputMaybe<Array<Seller_Type_Enum>>;
};

/** input type for inserting data into table "seller_type" */
export type Seller_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Seller_Type_Max_Fields = {
  __typename?: 'seller_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Seller_Type_Min_Fields = {
  __typename?: 'seller_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "seller_type" */
export type Seller_Type_Mutation_Response = {
  __typename?: 'seller_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Seller_Type>;
};

/** on_conflict condition type for table "seller_type" */
export type Seller_Type_On_Conflict = {
  constraint: Seller_Type_Constraint;
  update_columns?: Array<Seller_Type_Update_Column>;
  where?: InputMaybe<Seller_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "seller_type". */
export type Seller_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: seller_type */
export type Seller_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "seller_type" */
export enum Seller_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "seller_type" */
export type Seller_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "seller_type" */
export type Seller_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Seller_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Seller_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "seller_type" */
export enum Seller_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Seller_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Seller_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Seller_Type_Bool_Exp;
};

/** update columns of table "seller" */
export enum Seller_Update_Column {
  /** column name */
  AccountHolder = 'accountHolder',
  /** column name */
  Address = 'address',
  /** column name */
  AgencyId = 'agencyId',
  /** column name */
  Archived = 'archived',
  /** column name */
  BankAddress = 'bankAddress',
  /** column name */
  BankName = 'bankName',
  /** column name */
  Bic = 'bic',
  /** column name */
  BirthDate = 'birthDate',
  /** column name */
  BirthName = 'birthName',
  /** column name */
  BirthPlace = 'birthPlace',
  /** column name */
  BusinessName = 'businessName',
  /** column name */
  CanEditAndCreateEstate = 'canEditAndCreateEstate',
  /** column name */
  Civility = 'civility',
  /** column name */
  Comment = 'comment',
  /** column name */
  Comparution = 'comparution',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Headquarter = 'headquarter',
  /** column name */
  HideBuyerContactInfo = 'hideBuyerContactInfo',
  /** column name */
  HomePhone = 'homePhone',
  /** column name */
  Iban = 'iban',
  /** column name */
  Id = 'id',
  /** column name */
  IdCard = 'idCard',
  /** column name */
  Job = 'job',
  /** column name */
  Kbis = 'kbis',
  /** column name */
  LastName = 'lastName',
  /** column name */
  LegalStatus = 'legalStatus',
  /** column name */
  LinkUrl = 'linkUrl',
  /** column name */
  Logo = 'logo',
  /** column name */
  MaritalStatus = 'maritalStatus',
  /** column name */
  MobilePhone = 'mobilePhone',
  /** column name */
  Name = 'name',
  /** column name */
  Nationality = 'nationality',
  /** column name */
  OfficePhone = 'officePhone',
  /** column name */
  Rib = 'rib',
  /** column name */
  Siren = 'siren',
  /** column name */
  Slug = 'slug',
  /** column name */
  TaxCountry = 'taxCountry',
  /** column name */
  TaxSystem = 'taxSystem',
  /** column name */
  Tva = 'tva',
  /** column name */
  TvaNumber = 'tvaNumber',
  /** column name */
  Type = 'type'
}

export type Seller_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Seller_Set_Input>;
  /** filter the rows which have to be updated */
  where: Seller_Bool_Exp;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "agency" */
  agency: Array<Agency>;
  /** fetch aggregated fields from the table: "agency" */
  agency_aggregate: Agency_Aggregate;
  /** fetch data from the table: "agency" using primary key columns */
  agency_by_pk?: Maybe<Agency>;
  /** fetch data from the table: "agency_member" */
  agency_member: Array<Agency_Member>;
  /** fetch aggregated fields from the table: "agency_member" */
  agency_member_aggregate: Agency_Member_Aggregate;
  /** fetch data from the table: "agency_member" using primary key columns */
  agency_member_by_pk?: Maybe<Agency_Member>;
  /** fetch data from the table in a streaming manner: "agency_member" */
  agency_member_stream: Array<Agency_Member>;
  /** fetch data from the table in a streaming manner: "agency" */
  agency_stream: Array<Agency>;
  /** fetch data from the table: "application" */
  application: Array<Application>;
  /** fetch aggregated fields from the table: "application" */
  application_aggregate: Application_Aggregate;
  /** fetch data from the table: "application" using primary key columns */
  application_by_pk?: Maybe<Application>;
  /** An array relationship */
  application_media: Array<Application_Media>;
  /** An aggregate relationship */
  application_media_aggregate: Application_Media_Aggregate;
  /** fetch data from the table: "application_media" using primary key columns */
  application_media_by_pk?: Maybe<Application_Media>;
  /** fetch data from the table in a streaming manner: "application_media" */
  application_media_stream: Array<Application_Media>;
  /** fetch data from the table: "application_media_type" */
  application_media_type: Array<Application_Media_Type>;
  /** fetch aggregated fields from the table: "application_media_type" */
  application_media_type_aggregate: Application_Media_Type_Aggregate;
  /** fetch data from the table: "application_media_type" using primary key columns */
  application_media_type_by_pk?: Maybe<Application_Media_Type>;
  /** fetch data from the table in a streaming manner: "application_media_type" */
  application_media_type_stream: Array<Application_Media_Type>;
  /** fetch data from the table: "application_status" */
  application_status: Array<Application_Status>;
  /** fetch aggregated fields from the table: "application_status" */
  application_status_aggregate: Application_Status_Aggregate;
  /** fetch data from the table: "application_status" using primary key columns */
  application_status_by_pk?: Maybe<Application_Status>;
  /** fetch data from the table in a streaming manner: "application_status" */
  application_status_stream: Array<Application_Status>;
  /** fetch data from the table in a streaming manner: "application" */
  application_stream: Array<Application>;
  /** fetch data from the table: "auth.providers" using primary key columns */
  authProvider?: Maybe<AuthProviders>;
  /** fetch data from the table: "auth.provider_requests" using primary key columns */
  authProviderRequest?: Maybe<AuthProviderRequests>;
  /** fetch data from the table: "auth.provider_requests" */
  authProviderRequests: Array<AuthProviderRequests>;
  /** fetch aggregated fields from the table: "auth.provider_requests" */
  authProviderRequestsAggregate: AuthProviderRequests_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.provider_requests" */
  authProviderRequests_stream: Array<AuthProviderRequests>;
  /** fetch data from the table: "auth.providers" */
  authProviders: Array<AuthProviders>;
  /** fetch aggregated fields from the table: "auth.providers" */
  authProvidersAggregate: AuthProviders_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.providers" */
  authProviders_stream: Array<AuthProviders>;
  /** fetch data from the table: "auth.refresh_tokens" using primary key columns */
  authRefreshToken?: Maybe<AuthRefreshTokens>;
  /** fetch data from the table: "auth.refresh_token_types" using primary key columns */
  authRefreshTokenType?: Maybe<AuthRefreshTokenTypes>;
  /** fetch data from the table: "auth.refresh_token_types" */
  authRefreshTokenTypes: Array<AuthRefreshTokenTypes>;
  /** fetch aggregated fields from the table: "auth.refresh_token_types" */
  authRefreshTokenTypesAggregate: AuthRefreshTokenTypes_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.refresh_token_types" */
  authRefreshTokenTypes_stream: Array<AuthRefreshTokenTypes>;
  /** fetch data from the table: "auth.refresh_tokens" */
  authRefreshTokens: Array<AuthRefreshTokens>;
  /** fetch aggregated fields from the table: "auth.refresh_tokens" */
  authRefreshTokensAggregate: AuthRefreshTokens_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.refresh_tokens" */
  authRefreshTokens_stream: Array<AuthRefreshTokens>;
  /** fetch data from the table: "auth.roles" using primary key columns */
  authRole?: Maybe<AuthRoles>;
  /** fetch data from the table: "auth.roles" */
  authRoles: Array<AuthRoles>;
  /** fetch aggregated fields from the table: "auth.roles" */
  authRolesAggregate: AuthRoles_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.roles" */
  authRoles_stream: Array<AuthRoles>;
  /** fetch data from the table: "auth.user_providers" using primary key columns */
  authUserProvider?: Maybe<AuthUserProviders>;
  /** fetch data from the table: "auth.user_providers" */
  authUserProviders: Array<AuthUserProviders>;
  /** fetch aggregated fields from the table: "auth.user_providers" */
  authUserProvidersAggregate: AuthUserProviders_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.user_providers" */
  authUserProviders_stream: Array<AuthUserProviders>;
  /** fetch data from the table: "auth.user_roles" using primary key columns */
  authUserRole?: Maybe<AuthUserRoles>;
  /** fetch data from the table: "auth.user_roles" */
  authUserRoles: Array<AuthUserRoles>;
  /** fetch aggregated fields from the table: "auth.user_roles" */
  authUserRolesAggregate: AuthUserRoles_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.user_roles" */
  authUserRoles_stream: Array<AuthUserRoles>;
  /** fetch data from the table: "auth.user_security_keys" using primary key columns */
  authUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** fetch data from the table: "auth.user_security_keys" */
  authUserSecurityKeys: Array<AuthUserSecurityKeys>;
  /** fetch aggregated fields from the table: "auth.user_security_keys" */
  authUserSecurityKeysAggregate: AuthUserSecurityKeys_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.user_security_keys" */
  authUserSecurityKeys_stream: Array<AuthUserSecurityKeys>;
  /** fetch data from the table: "storage.buckets" using primary key columns */
  bucket?: Maybe<Buckets>;
  /** fetch data from the table: "storage.buckets" */
  buckets: Array<Buckets>;
  /** fetch aggregated fields from the table: "storage.buckets" */
  bucketsAggregate: Buckets_Aggregate;
  /** fetch data from the table in a streaming manner: "storage.buckets" */
  buckets_stream: Array<Buckets>;
  /** fetch data from the table: "buyer_member" */
  buyer_member: Array<Buyer_Member>;
  /** fetch aggregated fields from the table: "buyer_member" */
  buyer_member_aggregate: Buyer_Member_Aggregate;
  /** fetch data from the table: "buyer_member" using primary key columns */
  buyer_member_by_pk?: Maybe<Buyer_Member>;
  /** fetch data from the table: "buyer_member_folder" */
  buyer_member_folder: Array<Buyer_Member_Folder>;
  /** fetch aggregated fields from the table: "buyer_member_folder" */
  buyer_member_folder_aggregate: Buyer_Member_Folder_Aggregate;
  /** fetch data from the table: "buyer_member_folder" using primary key columns */
  buyer_member_folder_by_pk?: Maybe<Buyer_Member_Folder>;
  /** fetch data from the table in a streaming manner: "buyer_member_folder" */
  buyer_member_folder_stream: Array<Buyer_Member_Folder>;
  /** fetch data from the table in a streaming manner: "buyer_member" */
  buyer_member_stream: Array<Buyer_Member>;
  /** fetch data from the table: "civility" */
  civility: Array<Civility>;
  /** fetch aggregated fields from the table: "civility" */
  civility_aggregate: Civility_Aggregate;
  /** fetch data from the table: "civility" using primary key columns */
  civility_by_pk?: Maybe<Civility>;
  /** fetch data from the table in a streaming manner: "civility" */
  civility_stream: Array<Civility>;
  /** fetch data from the table: "estate" */
  estate: Array<Estate>;
  /** fetch aggregated fields from the table: "estate" */
  estate_aggregate: Estate_Aggregate;
  /** fetch data from the table: "estate" using primary key columns */
  estate_by_pk?: Maybe<Estate>;
  /** fetch data from the table: "estate_link" */
  estate_link: Array<Estate_Link>;
  /** fetch aggregated fields from the table: "estate_link" */
  estate_link_aggregate: Estate_Link_Aggregate;
  /** fetch data from the table: "estate_link" using primary key columns */
  estate_link_by_pk?: Maybe<Estate_Link>;
  /** fetch data from the table in a streaming manner: "estate_link" */
  estate_link_stream: Array<Estate_Link>;
  /** An array relationship */
  estate_media: Array<Estate_Media>;
  /** An aggregate relationship */
  estate_media_aggregate: Estate_Media_Aggregate;
  /** fetch data from the table: "estate_media" using primary key columns */
  estate_media_by_pk?: Maybe<Estate_Media>;
  /** fetch data from the table in a streaming manner: "estate_media" */
  estate_media_stream: Array<Estate_Media>;
  /** fetch data from the table: "estate_media_type" */
  estate_media_type: Array<Estate_Media_Type>;
  /** fetch aggregated fields from the table: "estate_media_type" */
  estate_media_type_aggregate: Estate_Media_Type_Aggregate;
  /** fetch data from the table: "estate_media_type" using primary key columns */
  estate_media_type_by_pk?: Maybe<Estate_Media_Type>;
  /** fetch data from the table: "estate_media_type_group" */
  estate_media_type_group: Array<Estate_Media_Type_Group>;
  /** fetch aggregated fields from the table: "estate_media_type_group" */
  estate_media_type_group_aggregate: Estate_Media_Type_Group_Aggregate;
  /** fetch data from the table: "estate_media_type_group" using primary key columns */
  estate_media_type_group_by_pk?: Maybe<Estate_Media_Type_Group>;
  /** fetch data from the table in a streaming manner: "estate_media_type_group" */
  estate_media_type_group_stream: Array<Estate_Media_Type_Group>;
  /** fetch data from the table: "estate_media_type_name" */
  estate_media_type_name: Array<Estate_Media_Type_Name>;
  /** fetch aggregated fields from the table: "estate_media_type_name" */
  estate_media_type_name_aggregate: Estate_Media_Type_Name_Aggregate;
  /** fetch data from the table: "estate_media_type_name" using primary key columns */
  estate_media_type_name_by_pk?: Maybe<Estate_Media_Type_Name>;
  /** fetch data from the table in a streaming manner: "estate_media_type_name" */
  estate_media_type_name_stream: Array<Estate_Media_Type_Name>;
  /** fetch data from the table in a streaming manner: "estate_media_type" */
  estate_media_type_stream: Array<Estate_Media_Type>;
  /** fetch data from the table: "estate_round" */
  estate_round: Array<Estate_Round>;
  /** fetch aggregated fields from the table: "estate_round" */
  estate_round_aggregate: Estate_Round_Aggregate;
  /** fetch data from the table: "estate_round_buyer_member" */
  estate_round_buyer_member: Array<Estate_Round_Buyer_Member>;
  /** fetch aggregated fields from the table: "estate_round_buyer_member" */
  estate_round_buyer_member_aggregate: Estate_Round_Buyer_Member_Aggregate;
  /** fetch data from the table: "estate_round_buyer_member" using primary key columns */
  estate_round_buyer_member_by_pk?: Maybe<Estate_Round_Buyer_Member>;
  /** fetch data from the table in a streaming manner: "estate_round_buyer_member" */
  estate_round_buyer_member_stream: Array<Estate_Round_Buyer_Member>;
  /** fetch data from the table: "estate_round" using primary key columns */
  estate_round_by_pk?: Maybe<Estate_Round>;
  /** fetch data from the table in a streaming manner: "estate_round" */
  estate_round_stream: Array<Estate_Round>;
  /** fetch data from the table: "estate_seller" */
  estate_seller: Array<Estate_Seller>;
  /** fetch aggregated fields from the table: "estate_seller" */
  estate_seller_aggregate: Estate_Seller_Aggregate;
  /** fetch data from the table: "estate_seller" using primary key columns */
  estate_seller_by_pk?: Maybe<Estate_Seller>;
  /** fetch data from the table in a streaming manner: "estate_seller" */
  estate_seller_stream: Array<Estate_Seller>;
  /** fetch data from the table in a streaming manner: "estate" */
  estate_stream: Array<Estate>;
  /** fetch data from the table: "estate_type" */
  estate_type: Array<Estate_Type>;
  /** fetch aggregated fields from the table: "estate_type" */
  estate_type_aggregate: Estate_Type_Aggregate;
  /** fetch data from the table: "estate_type" using primary key columns */
  estate_type_by_pk?: Maybe<Estate_Type>;
  /** fetch data from the table in a streaming manner: "estate_type" */
  estate_type_stream: Array<Estate_Type>;
  /** fetch data from the table: "storage.files" using primary key columns */
  file?: Maybe<Files>;
  /** An array relationship */
  files: Array<Files>;
  /** fetch aggregated fields from the table: "storage.files" */
  filesAggregate: Files_Aggregate;
  /** fetch data from the table in a streaming manner: "storage.files" */
  files_stream: Array<Files>;
  /** fetch data from the table: "mandate" */
  mandate: Array<Mandate>;
  /** fetch aggregated fields from the table: "mandate" */
  mandate_aggregate: Mandate_Aggregate;
  /** fetch data from the table: "mandate" using primary key columns */
  mandate_by_pk?: Maybe<Mandate>;
  /** fetch data from the table: "mandate_fee_person" */
  mandate_fee_person: Array<Mandate_Fee_Person>;
  /** fetch aggregated fields from the table: "mandate_fee_person" */
  mandate_fee_person_aggregate: Mandate_Fee_Person_Aggregate;
  /** fetch data from the table: "mandate_fee_person" using primary key columns */
  mandate_fee_person_by_pk?: Maybe<Mandate_Fee_Person>;
  /** fetch data from the table in a streaming manner: "mandate_fee_person" */
  mandate_fee_person_stream: Array<Mandate_Fee_Person>;
  /** An array relationship */
  mandate_media: Array<Mandate_Media>;
  /** An aggregate relationship */
  mandate_media_aggregate: Mandate_Media_Aggregate;
  /** fetch data from the table: "mandate_media" using primary key columns */
  mandate_media_by_pk?: Maybe<Mandate_Media>;
  /** fetch data from the table in a streaming manner: "mandate_media" */
  mandate_media_stream: Array<Mandate_Media>;
  /** fetch data from the table: "mandate_registry" */
  mandate_registry: Array<Mandate_Registry>;
  /** fetch aggregated fields from the table: "mandate_registry" */
  mandate_registry_aggregate: Mandate_Registry_Aggregate;
  /** fetch data from the table: "mandate_registry" using primary key columns */
  mandate_registry_by_pk?: Maybe<Mandate_Registry>;
  /** fetch data from the table: "mandate_registry_number_lock" */
  mandate_registry_number_lock: Array<Mandate_Registry_Number_Lock>;
  /** fetch aggregated fields from the table: "mandate_registry_number_lock" */
  mandate_registry_number_lock_aggregate: Mandate_Registry_Number_Lock_Aggregate;
  /** fetch data from the table: "mandate_registry_number_lock" using primary key columns */
  mandate_registry_number_lock_by_pk?: Maybe<Mandate_Registry_Number_Lock>;
  /** fetch data from the table in a streaming manner: "mandate_registry_number_lock" */
  mandate_registry_number_lock_stream: Array<Mandate_Registry_Number_Lock>;
  /** fetch data from the table in a streaming manner: "mandate_registry" */
  mandate_registry_stream: Array<Mandate_Registry>;
  /** fetch data from the table: "mandate_status" */
  mandate_status: Array<Mandate_Status>;
  /** fetch aggregated fields from the table: "mandate_status" */
  mandate_status_aggregate: Mandate_Status_Aggregate;
  /** fetch data from the table: "mandate_status" using primary key columns */
  mandate_status_by_pk?: Maybe<Mandate_Status>;
  /** fetch data from the table in a streaming manner: "mandate_status" */
  mandate_status_stream: Array<Mandate_Status>;
  /** fetch data from the table in a streaming manner: "mandate" */
  mandate_stream: Array<Mandate>;
  /** fetch data from the table: "mandate_type" */
  mandate_type: Array<Mandate_Type>;
  /** fetch aggregated fields from the table: "mandate_type" */
  mandate_type_aggregate: Mandate_Type_Aggregate;
  /** fetch data from the table: "mandate_type" using primary key columns */
  mandate_type_by_pk?: Maybe<Mandate_Type>;
  /** fetch data from the table in a streaming manner: "mandate_type" */
  mandate_type_stream: Array<Mandate_Type>;
  /** fetch data from the table: "seller" */
  seller: Array<Seller>;
  /** fetch aggregated fields from the table: "seller" */
  seller_aggregate: Seller_Aggregate;
  /** fetch data from the table: "seller" using primary key columns */
  seller_by_pk?: Maybe<Seller>;
  /** fetch data from the table: "seller_legal_status" */
  seller_legal_status: Array<Seller_Legal_Status>;
  /** fetch aggregated fields from the table: "seller_legal_status" */
  seller_legal_status_aggregate: Seller_Legal_Status_Aggregate;
  /** fetch data from the table: "seller_legal_status" using primary key columns */
  seller_legal_status_by_pk?: Maybe<Seller_Legal_Status>;
  /** fetch data from the table in a streaming manner: "seller_legal_status" */
  seller_legal_status_stream: Array<Seller_Legal_Status>;
  /** fetch data from the table: "seller_marital_status" */
  seller_marital_status: Array<Seller_Marital_Status>;
  /** fetch aggregated fields from the table: "seller_marital_status" */
  seller_marital_status_aggregate: Seller_Marital_Status_Aggregate;
  /** fetch data from the table: "seller_marital_status" using primary key columns */
  seller_marital_status_by_pk?: Maybe<Seller_Marital_Status>;
  /** fetch data from the table in a streaming manner: "seller_marital_status" */
  seller_marital_status_stream: Array<Seller_Marital_Status>;
  /** An array relationship */
  seller_media: Array<Seller_Media>;
  /** An aggregate relationship */
  seller_media_aggregate: Seller_Media_Aggregate;
  /** fetch data from the table: "seller_media" using primary key columns */
  seller_media_by_pk?: Maybe<Seller_Media>;
  /** fetch data from the table in a streaming manner: "seller_media" */
  seller_media_stream: Array<Seller_Media>;
  /** fetch data from the table: "seller_member" */
  seller_member: Array<Seller_Member>;
  /** fetch aggregated fields from the table: "seller_member" */
  seller_member_aggregate: Seller_Member_Aggregate;
  /** fetch data from the table: "seller_member" using primary key columns */
  seller_member_by_pk?: Maybe<Seller_Member>;
  /** fetch data from the table in a streaming manner: "seller_member" */
  seller_member_stream: Array<Seller_Member>;
  /** fetch data from the table in a streaming manner: "seller" */
  seller_stream: Array<Seller>;
  /** fetch data from the table: "seller_tax_system" */
  seller_tax_system: Array<Seller_Tax_System>;
  /** fetch aggregated fields from the table: "seller_tax_system" */
  seller_tax_system_aggregate: Seller_Tax_System_Aggregate;
  /** fetch data from the table: "seller_tax_system" using primary key columns */
  seller_tax_system_by_pk?: Maybe<Seller_Tax_System>;
  /** fetch data from the table in a streaming manner: "seller_tax_system" */
  seller_tax_system_stream: Array<Seller_Tax_System>;
  /** fetch data from the table: "seller_type" */
  seller_type: Array<Seller_Type>;
  /** fetch aggregated fields from the table: "seller_type" */
  seller_type_aggregate: Seller_Type_Aggregate;
  /** fetch data from the table: "seller_type" using primary key columns */
  seller_type_by_pk?: Maybe<Seller_Type>;
  /** fetch data from the table in a streaming manner: "seller_type" */
  seller_type_stream: Array<Seller_Type>;
  /** fetch data from the table: "auth.users" using primary key columns */
  user?: Maybe<Users>;
  /** fetch data from the table: "auth.users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "auth.users" */
  usersAggregate: Users_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.users" */
  users_stream: Array<Users>;
  /** fetch data from the table: "storage.virus" using primary key columns */
  virus?: Maybe<Virus>;
  /** fetch data from the table in a streaming manner: "storage.virus" */
  virus_stream: Array<Virus>;
  /** fetch data from the table: "storage.virus" */
  viruses: Array<Virus>;
  /** fetch aggregated fields from the table: "storage.virus" */
  virusesAggregate: Virus_Aggregate;
  /** fetch data from the table: "visit" */
  visit: Array<Visit>;
  /** fetch aggregated fields from the table: "visit" */
  visit_aggregate: Visit_Aggregate;
  /** fetch data from the table: "visit" using primary key columns */
  visit_by_pk?: Maybe<Visit>;
  /** fetch data from the table: "visit_span" */
  visit_span: Array<Visit_Span>;
  /** fetch aggregated fields from the table: "visit_span" */
  visit_span_aggregate: Visit_Span_Aggregate;
  /** fetch data from the table: "visit_span" using primary key columns */
  visit_span_by_pk?: Maybe<Visit_Span>;
  /** fetch data from the table in a streaming manner: "visit_span" */
  visit_span_stream: Array<Visit_Span>;
  /** fetch data from the table in a streaming manner: "visit" */
  visit_stream: Array<Visit>;
};


export type Subscription_RootAgencyArgs = {
  distinct_on?: InputMaybe<Array<Agency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Order_By>>;
  where?: InputMaybe<Agency_Bool_Exp>;
};


export type Subscription_RootAgency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Order_By>>;
  where?: InputMaybe<Agency_Bool_Exp>;
};


export type Subscription_RootAgency_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAgency_MemberArgs = {
  distinct_on?: InputMaybe<Array<Agency_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Member_Order_By>>;
  where?: InputMaybe<Agency_Member_Bool_Exp>;
};


export type Subscription_RootAgency_Member_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agency_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agency_Member_Order_By>>;
  where?: InputMaybe<Agency_Member_Bool_Exp>;
};


export type Subscription_RootAgency_Member_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAgency_Member_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Agency_Member_Stream_Cursor_Input>>;
  where?: InputMaybe<Agency_Member_Bool_Exp>;
};


export type Subscription_RootAgency_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Agency_Stream_Cursor_Input>>;
  where?: InputMaybe<Agency_Bool_Exp>;
};


export type Subscription_RootApplicationArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


export type Subscription_RootApplication_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


export type Subscription_RootApplication_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootApplication_MediaArgs = {
  distinct_on?: InputMaybe<Array<Application_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Media_Order_By>>;
  where?: InputMaybe<Application_Media_Bool_Exp>;
};


export type Subscription_RootApplication_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Media_Order_By>>;
  where?: InputMaybe<Application_Media_Bool_Exp>;
};


export type Subscription_RootApplication_Media_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootApplication_Media_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Application_Media_Stream_Cursor_Input>>;
  where?: InputMaybe<Application_Media_Bool_Exp>;
};


export type Subscription_RootApplication_Media_TypeArgs = {
  distinct_on?: InputMaybe<Array<Application_Media_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Media_Type_Order_By>>;
  where?: InputMaybe<Application_Media_Type_Bool_Exp>;
};


export type Subscription_RootApplication_Media_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Media_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Media_Type_Order_By>>;
  where?: InputMaybe<Application_Media_Type_Bool_Exp>;
};


export type Subscription_RootApplication_Media_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootApplication_Media_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Application_Media_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Application_Media_Type_Bool_Exp>;
};


export type Subscription_RootApplication_StatusArgs = {
  distinct_on?: InputMaybe<Array<Application_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Status_Order_By>>;
  where?: InputMaybe<Application_Status_Bool_Exp>;
};


export type Subscription_RootApplication_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Status_Order_By>>;
  where?: InputMaybe<Application_Status_Bool_Exp>;
};


export type Subscription_RootApplication_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootApplication_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Application_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Application_Status_Bool_Exp>;
};


export type Subscription_RootApplication_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Application_Stream_Cursor_Input>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


export type Subscription_RootAuthProviderArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootAuthProviderRequestArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuthProviderRequestsArgs = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};


export type Subscription_RootAuthProviderRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};


export type Subscription_RootAuthProviderRequests_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthProviderRequests_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};


export type Subscription_RootAuthProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviders_Order_By>>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};


export type Subscription_RootAuthProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviders_Order_By>>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};


export type Subscription_RootAuthProviders_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthProviders_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokenArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuthRefreshTokenTypeArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootAuthRefreshTokenTypesArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokenTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokenTypes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthRefreshTokenTypes_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokensAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokens_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthRefreshTokens_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


export type Subscription_RootAuthRoleArgs = {
  role: Scalars['String']['input'];
};


export type Subscription_RootAuthRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRoles_Order_By>>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};


export type Subscription_RootAuthRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRoles_Order_By>>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};


export type Subscription_RootAuthRoles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthRoles_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};


export type Subscription_RootAuthUserProviderArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuthUserProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


export type Subscription_RootAuthUserProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


export type Subscription_RootAuthUserProviders_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthUserProviders_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


export type Subscription_RootAuthUserRoleArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuthUserRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


export type Subscription_RootAuthUserRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


export type Subscription_RootAuthUserRoles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthUserRoles_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


export type Subscription_RootAuthUserSecurityKeyArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuthUserSecurityKeysArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Subscription_RootAuthUserSecurityKeysAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Subscription_RootAuthUserSecurityKeys_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthUserSecurityKeys_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Subscription_RootBucketArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootBucketsArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Subscription_RootBucketsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Subscription_RootBuckets_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Buckets_Stream_Cursor_Input>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Subscription_RootBuyer_MemberArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Member_Order_By>>;
  where?: InputMaybe<Buyer_Member_Bool_Exp>;
};


export type Subscription_RootBuyer_Member_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Member_Order_By>>;
  where?: InputMaybe<Buyer_Member_Bool_Exp>;
};


export type Subscription_RootBuyer_Member_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBuyer_Member_FolderArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Member_Folder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Member_Folder_Order_By>>;
  where?: InputMaybe<Buyer_Member_Folder_Bool_Exp>;
};


export type Subscription_RootBuyer_Member_Folder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Member_Folder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Member_Folder_Order_By>>;
  where?: InputMaybe<Buyer_Member_Folder_Bool_Exp>;
};


export type Subscription_RootBuyer_Member_Folder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBuyer_Member_Folder_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Buyer_Member_Folder_Stream_Cursor_Input>>;
  where?: InputMaybe<Buyer_Member_Folder_Bool_Exp>;
};


export type Subscription_RootBuyer_Member_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Buyer_Member_Stream_Cursor_Input>>;
  where?: InputMaybe<Buyer_Member_Bool_Exp>;
};


export type Subscription_RootCivilityArgs = {
  distinct_on?: InputMaybe<Array<Civility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Civility_Order_By>>;
  where?: InputMaybe<Civility_Bool_Exp>;
};


export type Subscription_RootCivility_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Civility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Civility_Order_By>>;
  where?: InputMaybe<Civility_Bool_Exp>;
};


export type Subscription_RootCivility_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootCivility_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Civility_Stream_Cursor_Input>>;
  where?: InputMaybe<Civility_Bool_Exp>;
};


export type Subscription_RootEstateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Order_By>>;
  where?: InputMaybe<Estate_Bool_Exp>;
};


export type Subscription_RootEstate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Order_By>>;
  where?: InputMaybe<Estate_Bool_Exp>;
};


export type Subscription_RootEstate_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEstate_LinkArgs = {
  distinct_on?: InputMaybe<Array<Estate_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Link_Order_By>>;
  where?: InputMaybe<Estate_Link_Bool_Exp>;
};


export type Subscription_RootEstate_Link_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Link_Order_By>>;
  where?: InputMaybe<Estate_Link_Bool_Exp>;
};


export type Subscription_RootEstate_Link_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEstate_Link_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Estate_Link_Stream_Cursor_Input>>;
  where?: InputMaybe<Estate_Link_Bool_Exp>;
};


export type Subscription_RootEstate_MediaArgs = {
  distinct_on?: InputMaybe<Array<Estate_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Media_Order_By>>;
  where?: InputMaybe<Estate_Media_Bool_Exp>;
};


export type Subscription_RootEstate_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Media_Order_By>>;
  where?: InputMaybe<Estate_Media_Bool_Exp>;
};


export type Subscription_RootEstate_Media_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEstate_Media_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Estate_Media_Stream_Cursor_Input>>;
  where?: InputMaybe<Estate_Media_Bool_Exp>;
};


export type Subscription_RootEstate_Media_TypeArgs = {
  distinct_on?: InputMaybe<Array<Estate_Media_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Media_Type_Order_By>>;
  where?: InputMaybe<Estate_Media_Type_Bool_Exp>;
};


export type Subscription_RootEstate_Media_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Media_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Media_Type_Order_By>>;
  where?: InputMaybe<Estate_Media_Type_Bool_Exp>;
};


export type Subscription_RootEstate_Media_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEstate_Media_Type_GroupArgs = {
  distinct_on?: InputMaybe<Array<Estate_Media_Type_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Media_Type_Group_Order_By>>;
  where?: InputMaybe<Estate_Media_Type_Group_Bool_Exp>;
};


export type Subscription_RootEstate_Media_Type_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Media_Type_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Media_Type_Group_Order_By>>;
  where?: InputMaybe<Estate_Media_Type_Group_Bool_Exp>;
};


export type Subscription_RootEstate_Media_Type_Group_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEstate_Media_Type_Group_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Estate_Media_Type_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Estate_Media_Type_Group_Bool_Exp>;
};


export type Subscription_RootEstate_Media_Type_NameArgs = {
  distinct_on?: InputMaybe<Array<Estate_Media_Type_Name_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Media_Type_Name_Order_By>>;
  where?: InputMaybe<Estate_Media_Type_Name_Bool_Exp>;
};


export type Subscription_RootEstate_Media_Type_Name_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Media_Type_Name_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Media_Type_Name_Order_By>>;
  where?: InputMaybe<Estate_Media_Type_Name_Bool_Exp>;
};


export type Subscription_RootEstate_Media_Type_Name_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEstate_Media_Type_Name_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Estate_Media_Type_Name_Stream_Cursor_Input>>;
  where?: InputMaybe<Estate_Media_Type_Name_Bool_Exp>;
};


export type Subscription_RootEstate_Media_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Estate_Media_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Estate_Media_Type_Bool_Exp>;
};


export type Subscription_RootEstate_RoundArgs = {
  distinct_on?: InputMaybe<Array<Estate_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Round_Order_By>>;
  where?: InputMaybe<Estate_Round_Bool_Exp>;
};


export type Subscription_RootEstate_Round_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Round_Order_By>>;
  where?: InputMaybe<Estate_Round_Bool_Exp>;
};


export type Subscription_RootEstate_Round_Buyer_MemberArgs = {
  distinct_on?: InputMaybe<Array<Estate_Round_Buyer_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Round_Buyer_Member_Order_By>>;
  where?: InputMaybe<Estate_Round_Buyer_Member_Bool_Exp>;
};


export type Subscription_RootEstate_Round_Buyer_Member_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Round_Buyer_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Round_Buyer_Member_Order_By>>;
  where?: InputMaybe<Estate_Round_Buyer_Member_Bool_Exp>;
};


export type Subscription_RootEstate_Round_Buyer_Member_By_PkArgs = {
  buyerMemberId: Scalars['uuid']['input'];
  estateRoundId: Scalars['uuid']['input'];
};


export type Subscription_RootEstate_Round_Buyer_Member_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Estate_Round_Buyer_Member_Stream_Cursor_Input>>;
  where?: InputMaybe<Estate_Round_Buyer_Member_Bool_Exp>;
};


export type Subscription_RootEstate_Round_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEstate_Round_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Estate_Round_Stream_Cursor_Input>>;
  where?: InputMaybe<Estate_Round_Bool_Exp>;
};


export type Subscription_RootEstate_SellerArgs = {
  distinct_on?: InputMaybe<Array<Estate_Seller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Seller_Order_By>>;
  where?: InputMaybe<Estate_Seller_Bool_Exp>;
};


export type Subscription_RootEstate_Seller_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Seller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Seller_Order_By>>;
  where?: InputMaybe<Estate_Seller_Bool_Exp>;
};


export type Subscription_RootEstate_Seller_By_PkArgs = {
  estateId: Scalars['uuid']['input'];
  sellerId: Scalars['uuid']['input'];
};


export type Subscription_RootEstate_Seller_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Estate_Seller_Stream_Cursor_Input>>;
  where?: InputMaybe<Estate_Seller_Bool_Exp>;
};


export type Subscription_RootEstate_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Estate_Stream_Cursor_Input>>;
  where?: InputMaybe<Estate_Bool_Exp>;
};


export type Subscription_RootEstate_TypeArgs = {
  distinct_on?: InputMaybe<Array<Estate_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Type_Order_By>>;
  where?: InputMaybe<Estate_Type_Bool_Exp>;
};


export type Subscription_RootEstate_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estate_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Estate_Type_Order_By>>;
  where?: InputMaybe<Estate_Type_Bool_Exp>;
};


export type Subscription_RootEstate_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEstate_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Estate_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Estate_Type_Bool_Exp>;
};


export type Subscription_RootFileArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFilesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFiles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Files_Stream_Cursor_Input>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootMandateArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Order_By>>;
  where?: InputMaybe<Mandate_Bool_Exp>;
};


export type Subscription_RootMandate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Order_By>>;
  where?: InputMaybe<Mandate_Bool_Exp>;
};


export type Subscription_RootMandate_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMandate_Fee_PersonArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Fee_Person_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Fee_Person_Order_By>>;
  where?: InputMaybe<Mandate_Fee_Person_Bool_Exp>;
};


export type Subscription_RootMandate_Fee_Person_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Fee_Person_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Fee_Person_Order_By>>;
  where?: InputMaybe<Mandate_Fee_Person_Bool_Exp>;
};


export type Subscription_RootMandate_Fee_Person_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootMandate_Fee_Person_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mandate_Fee_Person_Stream_Cursor_Input>>;
  where?: InputMaybe<Mandate_Fee_Person_Bool_Exp>;
};


export type Subscription_RootMandate_MediaArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Media_Order_By>>;
  where?: InputMaybe<Mandate_Media_Bool_Exp>;
};


export type Subscription_RootMandate_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Media_Order_By>>;
  where?: InputMaybe<Mandate_Media_Bool_Exp>;
};


export type Subscription_RootMandate_Media_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMandate_Media_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mandate_Media_Stream_Cursor_Input>>;
  where?: InputMaybe<Mandate_Media_Bool_Exp>;
};


export type Subscription_RootMandate_RegistryArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Registry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Registry_Order_By>>;
  where?: InputMaybe<Mandate_Registry_Bool_Exp>;
};


export type Subscription_RootMandate_Registry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Registry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Registry_Order_By>>;
  where?: InputMaybe<Mandate_Registry_Bool_Exp>;
};


export type Subscription_RootMandate_Registry_By_PkArgs = {
  orderNumber: Scalars['String']['input'];
};


export type Subscription_RootMandate_Registry_Number_LockArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Registry_Number_Lock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Registry_Number_Lock_Order_By>>;
  where?: InputMaybe<Mandate_Registry_Number_Lock_Bool_Exp>;
};


export type Subscription_RootMandate_Registry_Number_Lock_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Registry_Number_Lock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Registry_Number_Lock_Order_By>>;
  where?: InputMaybe<Mandate_Registry_Number_Lock_Bool_Exp>;
};


export type Subscription_RootMandate_Registry_Number_Lock_By_PkArgs = {
  key_name: Scalars['String']['input'];
};


export type Subscription_RootMandate_Registry_Number_Lock_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mandate_Registry_Number_Lock_Stream_Cursor_Input>>;
  where?: InputMaybe<Mandate_Registry_Number_Lock_Bool_Exp>;
};


export type Subscription_RootMandate_Registry_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mandate_Registry_Stream_Cursor_Input>>;
  where?: InputMaybe<Mandate_Registry_Bool_Exp>;
};


export type Subscription_RootMandate_StatusArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Status_Order_By>>;
  where?: InputMaybe<Mandate_Status_Bool_Exp>;
};


export type Subscription_RootMandate_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Status_Order_By>>;
  where?: InputMaybe<Mandate_Status_Bool_Exp>;
};


export type Subscription_RootMandate_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootMandate_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mandate_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Mandate_Status_Bool_Exp>;
};


export type Subscription_RootMandate_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mandate_Stream_Cursor_Input>>;
  where?: InputMaybe<Mandate_Bool_Exp>;
};


export type Subscription_RootMandate_TypeArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Type_Order_By>>;
  where?: InputMaybe<Mandate_Type_Bool_Exp>;
};


export type Subscription_RootMandate_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mandate_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mandate_Type_Order_By>>;
  where?: InputMaybe<Mandate_Type_Bool_Exp>;
};


export type Subscription_RootMandate_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootMandate_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mandate_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Mandate_Type_Bool_Exp>;
};


export type Subscription_RootSellerArgs = {
  distinct_on?: InputMaybe<Array<Seller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Order_By>>;
  where?: InputMaybe<Seller_Bool_Exp>;
};


export type Subscription_RootSeller_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Order_By>>;
  where?: InputMaybe<Seller_Bool_Exp>;
};


export type Subscription_RootSeller_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSeller_Legal_StatusArgs = {
  distinct_on?: InputMaybe<Array<Seller_Legal_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Legal_Status_Order_By>>;
  where?: InputMaybe<Seller_Legal_Status_Bool_Exp>;
};


export type Subscription_RootSeller_Legal_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seller_Legal_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Legal_Status_Order_By>>;
  where?: InputMaybe<Seller_Legal_Status_Bool_Exp>;
};


export type Subscription_RootSeller_Legal_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootSeller_Legal_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Seller_Legal_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Seller_Legal_Status_Bool_Exp>;
};


export type Subscription_RootSeller_Marital_StatusArgs = {
  distinct_on?: InputMaybe<Array<Seller_Marital_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Marital_Status_Order_By>>;
  where?: InputMaybe<Seller_Marital_Status_Bool_Exp>;
};


export type Subscription_RootSeller_Marital_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seller_Marital_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Marital_Status_Order_By>>;
  where?: InputMaybe<Seller_Marital_Status_Bool_Exp>;
};


export type Subscription_RootSeller_Marital_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootSeller_Marital_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Seller_Marital_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Seller_Marital_Status_Bool_Exp>;
};


export type Subscription_RootSeller_MediaArgs = {
  distinct_on?: InputMaybe<Array<Seller_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Media_Order_By>>;
  where?: InputMaybe<Seller_Media_Bool_Exp>;
};


export type Subscription_RootSeller_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seller_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Media_Order_By>>;
  where?: InputMaybe<Seller_Media_Bool_Exp>;
};


export type Subscription_RootSeller_Media_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSeller_Media_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Seller_Media_Stream_Cursor_Input>>;
  where?: InputMaybe<Seller_Media_Bool_Exp>;
};


export type Subscription_RootSeller_MemberArgs = {
  distinct_on?: InputMaybe<Array<Seller_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Member_Order_By>>;
  where?: InputMaybe<Seller_Member_Bool_Exp>;
};


export type Subscription_RootSeller_Member_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seller_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Member_Order_By>>;
  where?: InputMaybe<Seller_Member_Bool_Exp>;
};


export type Subscription_RootSeller_Member_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSeller_Member_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Seller_Member_Stream_Cursor_Input>>;
  where?: InputMaybe<Seller_Member_Bool_Exp>;
};


export type Subscription_RootSeller_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Seller_Stream_Cursor_Input>>;
  where?: InputMaybe<Seller_Bool_Exp>;
};


export type Subscription_RootSeller_Tax_SystemArgs = {
  distinct_on?: InputMaybe<Array<Seller_Tax_System_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Tax_System_Order_By>>;
  where?: InputMaybe<Seller_Tax_System_Bool_Exp>;
};


export type Subscription_RootSeller_Tax_System_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seller_Tax_System_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Tax_System_Order_By>>;
  where?: InputMaybe<Seller_Tax_System_Bool_Exp>;
};


export type Subscription_RootSeller_Tax_System_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootSeller_Tax_System_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Seller_Tax_System_Stream_Cursor_Input>>;
  where?: InputMaybe<Seller_Tax_System_Bool_Exp>;
};


export type Subscription_RootSeller_TypeArgs = {
  distinct_on?: InputMaybe<Array<Seller_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Type_Order_By>>;
  where?: InputMaybe<Seller_Type_Bool_Exp>;
};


export type Subscription_RootSeller_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seller_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Type_Order_By>>;
  where?: InputMaybe<Seller_Type_Bool_Exp>;
};


export type Subscription_RootSeller_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootSeller_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Seller_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Seller_Type_Bool_Exp>;
};


export type Subscription_RootUserArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootVirusArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVirus_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Virus_Stream_Cursor_Input>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Subscription_RootVirusesArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Subscription_RootVirusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Subscription_RootVisitArgs = {
  distinct_on?: InputMaybe<Array<Visit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visit_Order_By>>;
  where?: InputMaybe<Visit_Bool_Exp>;
};


export type Subscription_RootVisit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Visit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visit_Order_By>>;
  where?: InputMaybe<Visit_Bool_Exp>;
};


export type Subscription_RootVisit_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVisit_SpanArgs = {
  distinct_on?: InputMaybe<Array<Visit_Span_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visit_Span_Order_By>>;
  where?: InputMaybe<Visit_Span_Bool_Exp>;
};


export type Subscription_RootVisit_Span_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Visit_Span_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visit_Span_Order_By>>;
  where?: InputMaybe<Visit_Span_Bool_Exp>;
};


export type Subscription_RootVisit_Span_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVisit_Span_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Visit_Span_Stream_Cursor_Input>>;
  where?: InputMaybe<Visit_Span_Bool_Exp>;
};


export type Subscription_RootVisit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Visit_Stream_Cursor_Input>>;
  where?: InputMaybe<Visit_Bool_Exp>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type Users = {
  __typename?: 'users';
  activeMfaType?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  agency_member?: Maybe<Agency_Member>;
  avatarUrl: Scalars['String']['output'];
  /** An object relationship */
  buyer_member?: Maybe<Buyer_Member>;
  createdAt: Scalars['timestamptz']['output'];
  currentChallenge?: Maybe<Scalars['String']['output']>;
  defaultRole: Scalars['String']['output'];
  /** An object relationship */
  defaultRoleByRole: AuthRoles;
  disabled: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['citext']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  lastSeen?: Maybe<Scalars['timestamptz']['output']>;
  locale: Scalars['String']['output'];
  metadata: Scalars['user_metadata']['output'];
  newEmail?: Maybe<Scalars['citext']['output']>;
  otpHash?: Maybe<Scalars['String']['output']>;
  otpHashExpiresAt: Scalars['timestamptz']['output'];
  otpMethodLastUsed?: Maybe<Scalars['String']['output']>;
  passwordHash?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberVerified: Scalars['Boolean']['output'];
  /** An array relationship */
  refreshTokens: Array<AuthRefreshTokens>;
  /** An aggregate relationship */
  refreshTokens_aggregate: AuthRefreshTokens_Aggregate;
  /** An array relationship */
  roles: Array<AuthUserRoles>;
  /** An aggregate relationship */
  roles_aggregate: AuthUserRoles_Aggregate;
  /** An array relationship */
  securityKeys: Array<AuthUserSecurityKeys>;
  /** An aggregate relationship */
  securityKeys_aggregate: AuthUserSecurityKeys_Aggregate;
  /** An object relationship */
  seller_member?: Maybe<Seller_Member>;
  /** An array relationship */
  seller_members: Array<Seller_Member>;
  /** An aggregate relationship */
  seller_members_aggregate: Seller_Member_Aggregate;
  ticket?: Maybe<Scalars['String']['output']>;
  ticketExpiresAt: Scalars['timestamptz']['output'];
  totpSecret?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  userProviders: Array<AuthUserProviders>;
  /** An aggregate relationship */
  userProviders_aggregate: AuthUserProviders_Aggregate;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRefreshTokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersSecurityKeysArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersSecurityKeys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersSeller_MembersArgs = {
  distinct_on?: InputMaybe<Array<Seller_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Member_Order_By>>;
  where?: InputMaybe<Seller_Member_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersSeller_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seller_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Member_Order_By>>;
  where?: InputMaybe<Seller_Member_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersUserProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersUserProviders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};

/** aggregated selection of "auth.users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

export type Users_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Users_Aggregate_Bool_Exp_Count>;
};

export type Users_Aggregate_Bool_Exp_Bool_And = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
};


/** aggregate fields of "auth.users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.users" */
export type Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Max_Order_By>;
  min?: InputMaybe<Users_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Users_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "auth.users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  activeMfaType?: InputMaybe<String_Comparison_Exp>;
  agency_member?: InputMaybe<Agency_Member_Bool_Exp>;
  avatarUrl?: InputMaybe<String_Comparison_Exp>;
  buyer_member?: InputMaybe<Buyer_Member_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currentChallenge?: InputMaybe<String_Comparison_Exp>;
  defaultRole?: InputMaybe<String_Comparison_Exp>;
  defaultRoleByRole?: InputMaybe<AuthRoles_Bool_Exp>;
  disabled?: InputMaybe<Boolean_Comparison_Exp>;
  displayName?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<Citext_Comparison_Exp>;
  emailVerified?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isAnonymous?: InputMaybe<Boolean_Comparison_Exp>;
  lastSeen?: InputMaybe<Timestamptz_Comparison_Exp>;
  locale?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  newEmail?: InputMaybe<Citext_Comparison_Exp>;
  otpHash?: InputMaybe<String_Comparison_Exp>;
  otpHashExpiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  otpMethodLastUsed?: InputMaybe<String_Comparison_Exp>;
  passwordHash?: InputMaybe<String_Comparison_Exp>;
  phoneNumber?: InputMaybe<String_Comparison_Exp>;
  phoneNumberVerified?: InputMaybe<Boolean_Comparison_Exp>;
  refreshTokens?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Bool_Exp>;
  roles?: InputMaybe<AuthUserRoles_Bool_Exp>;
  roles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Bool_Exp>;
  securityKeys?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
  securityKeys_aggregate?: InputMaybe<AuthUserSecurityKeys_Aggregate_Bool_Exp>;
  seller_member?: InputMaybe<Seller_Member_Bool_Exp>;
  seller_members?: InputMaybe<Seller_Member_Bool_Exp>;
  seller_members_aggregate?: InputMaybe<Seller_Member_Aggregate_Bool_Exp>;
  ticket?: InputMaybe<String_Comparison_Exp>;
  ticketExpiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  totpSecret?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userProviders?: InputMaybe<AuthUserProviders_Bool_Exp>;
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "auth.users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "email" */
  UsersEmailKey = 'users_email_key',
  /** unique or primary key constraint on columns "phone_number" */
  UsersPhoneNumberKey = 'users_phone_number_key',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Users_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Users_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Users_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "auth.users" */
export type Users_Insert_Input = {
  activeMfaType?: InputMaybe<Scalars['String']['input']>;
  agency_member?: InputMaybe<Agency_Member_Obj_Rel_Insert_Input>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  buyer_member?: InputMaybe<Buyer_Member_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currentChallenge?: InputMaybe<Scalars['String']['input']>;
  defaultRole?: InputMaybe<Scalars['String']['input']>;
  defaultRoleByRole?: InputMaybe<AuthRoles_Obj_Rel_Insert_Input>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  lastSeen?: InputMaybe<Scalars['timestamptz']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  newEmail?: InputMaybe<Scalars['citext']['input']>;
  otpHash?: InputMaybe<Scalars['String']['input']>;
  otpHashExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  otpMethodLastUsed?: InputMaybe<Scalars['String']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberVerified?: InputMaybe<Scalars['Boolean']['input']>;
  refreshTokens?: InputMaybe<AuthRefreshTokens_Arr_Rel_Insert_Input>;
  roles?: InputMaybe<AuthUserRoles_Arr_Rel_Insert_Input>;
  securityKeys?: InputMaybe<AuthUserSecurityKeys_Arr_Rel_Insert_Input>;
  seller_member?: InputMaybe<Seller_Member_Obj_Rel_Insert_Input>;
  seller_members?: InputMaybe<Seller_Member_Arr_Rel_Insert_Input>;
  ticket?: InputMaybe<Scalars['String']['input']>;
  ticketExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userProviders?: InputMaybe<AuthUserProviders_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  activeMfaType?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  currentChallenge?: Maybe<Scalars['String']['output']>;
  defaultRole?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['citext']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastSeen?: Maybe<Scalars['timestamptz']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  newEmail?: Maybe<Scalars['citext']['output']>;
  otpHash?: Maybe<Scalars['String']['output']>;
  otpHashExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  otpMethodLastUsed?: Maybe<Scalars['String']['output']>;
  passwordHash?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  ticket?: Maybe<Scalars['String']['output']>;
  ticketExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  totpSecret?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "auth.users" */
export type Users_Max_Order_By = {
  activeMfaType?: InputMaybe<Order_By>;
  avatarUrl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentChallenge?: InputMaybe<Order_By>;
  defaultRole?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastSeen?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  newEmail?: InputMaybe<Order_By>;
  otpHash?: InputMaybe<Order_By>;
  otpHashExpiresAt?: InputMaybe<Order_By>;
  otpMethodLastUsed?: InputMaybe<Order_By>;
  passwordHash?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  ticket?: InputMaybe<Order_By>;
  ticketExpiresAt?: InputMaybe<Order_By>;
  totpSecret?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  activeMfaType?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  currentChallenge?: Maybe<Scalars['String']['output']>;
  defaultRole?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['citext']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastSeen?: Maybe<Scalars['timestamptz']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  newEmail?: Maybe<Scalars['citext']['output']>;
  otpHash?: Maybe<Scalars['String']['output']>;
  otpHashExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  otpMethodLastUsed?: Maybe<Scalars['String']['output']>;
  passwordHash?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  ticket?: Maybe<Scalars['String']['output']>;
  ticketExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  totpSecret?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "auth.users" */
export type Users_Min_Order_By = {
  activeMfaType?: InputMaybe<Order_By>;
  avatarUrl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentChallenge?: InputMaybe<Order_By>;
  defaultRole?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastSeen?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  newEmail?: InputMaybe<Order_By>;
  otpHash?: InputMaybe<Order_By>;
  otpHashExpiresAt?: InputMaybe<Order_By>;
  otpMethodLastUsed?: InputMaybe<Order_By>;
  passwordHash?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  ticket?: InputMaybe<Order_By>;
  ticketExpiresAt?: InputMaybe<Order_By>;
  totpSecret?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "auth.users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "auth.users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.users". */
export type Users_Order_By = {
  activeMfaType?: InputMaybe<Order_By>;
  agency_member?: InputMaybe<Agency_Member_Order_By>;
  avatarUrl?: InputMaybe<Order_By>;
  buyer_member?: InputMaybe<Buyer_Member_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentChallenge?: InputMaybe<Order_By>;
  defaultRole?: InputMaybe<Order_By>;
  defaultRoleByRole?: InputMaybe<AuthRoles_Order_By>;
  disabled?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  emailVerified?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isAnonymous?: InputMaybe<Order_By>;
  lastSeen?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  newEmail?: InputMaybe<Order_By>;
  otpHash?: InputMaybe<Order_By>;
  otpHashExpiresAt?: InputMaybe<Order_By>;
  otpMethodLastUsed?: InputMaybe<Order_By>;
  passwordHash?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  phoneNumberVerified?: InputMaybe<Order_By>;
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Order_By>;
  roles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Order_By>;
  securityKeys_aggregate?: InputMaybe<AuthUserSecurityKeys_Aggregate_Order_By>;
  seller_member?: InputMaybe<Seller_Member_Order_By>;
  seller_members_aggregate?: InputMaybe<Seller_Member_Aggregate_Order_By>;
  ticket?: InputMaybe<Order_By>;
  ticketExpiresAt?: InputMaybe<Order_By>;
  totpSecret?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Order_By>;
};

/** primary key columns input for table: auth.users */
export type Users_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Users_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "auth.users" */
export enum Users_Select_Column {
  /** column name */
  ActiveMfaType = 'activeMfaType',
  /** column name */
  AvatarUrl = 'avatarUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrentChallenge = 'currentChallenge',
  /** column name */
  DefaultRole = 'defaultRole',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  LastSeen = 'lastSeen',
  /** column name */
  Locale = 'locale',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NewEmail = 'newEmail',
  /** column name */
  OtpHash = 'otpHash',
  /** column name */
  OtpHashExpiresAt = 'otpHashExpiresAt',
  /** column name */
  OtpMethodLastUsed = 'otpMethodLastUsed',
  /** column name */
  PasswordHash = 'passwordHash',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified',
  /** column name */
  Ticket = 'ticket',
  /** column name */
  TicketExpiresAt = 'ticketExpiresAt',
  /** column name */
  TotpSecret = 'totpSecret',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "auth.users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Disabled = 'disabled',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified'
}

/** select "users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "auth.users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Disabled = 'disabled',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified'
}

/** input type for updating data in table "auth.users" */
export type Users_Set_Input = {
  activeMfaType?: InputMaybe<Scalars['String']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currentChallenge?: InputMaybe<Scalars['String']['input']>;
  defaultRole?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  lastSeen?: InputMaybe<Scalars['timestamptz']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  newEmail?: InputMaybe<Scalars['citext']['input']>;
  otpHash?: InputMaybe<Scalars['String']['input']>;
  otpHashExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  otpMethodLastUsed?: InputMaybe<Scalars['String']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberVerified?: InputMaybe<Scalars['Boolean']['input']>;
  ticket?: InputMaybe<Scalars['String']['input']>;
  ticketExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  activeMfaType?: InputMaybe<Scalars['String']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currentChallenge?: InputMaybe<Scalars['String']['input']>;
  defaultRole?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  lastSeen?: InputMaybe<Scalars['timestamptz']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  newEmail?: InputMaybe<Scalars['citext']['input']>;
  otpHash?: InputMaybe<Scalars['String']['input']>;
  otpHashExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  otpMethodLastUsed?: InputMaybe<Scalars['String']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberVerified?: InputMaybe<Scalars['Boolean']['input']>;
  ticket?: InputMaybe<Scalars['String']['input']>;
  ticketExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "auth.users" */
export enum Users_Update_Column {
  /** column name */
  ActiveMfaType = 'activeMfaType',
  /** column name */
  AvatarUrl = 'avatarUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrentChallenge = 'currentChallenge',
  /** column name */
  DefaultRole = 'defaultRole',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  LastSeen = 'lastSeen',
  /** column name */
  Locale = 'locale',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NewEmail = 'newEmail',
  /** column name */
  OtpHash = 'otpHash',
  /** column name */
  OtpHashExpiresAt = 'otpHashExpiresAt',
  /** column name */
  OtpMethodLastUsed = 'otpMethodLastUsed',
  /** column name */
  PasswordHash = 'passwordHash',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified',
  /** column name */
  Ticket = 'ticket',
  /** column name */
  TicketExpiresAt = 'ticketExpiresAt',
  /** column name */
  TotpSecret = 'totpSecret',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Users_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Users_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Users_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** columns and relationships of "storage.virus" */
export type Virus = {
  __typename?: 'virus';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  file: Files;
  fileId: Scalars['uuid']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  userSession: Scalars['jsonb']['output'];
  virus: Scalars['String']['output'];
};


/** columns and relationships of "storage.virus" */
export type VirusUserSessionArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "storage.virus" */
export type Virus_Aggregate = {
  __typename?: 'virus_aggregate';
  aggregate?: Maybe<Virus_Aggregate_Fields>;
  nodes: Array<Virus>;
};

/** aggregate fields of "storage.virus" */
export type Virus_Aggregate_Fields = {
  __typename?: 'virus_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Virus_Max_Fields>;
  min?: Maybe<Virus_Min_Fields>;
};


/** aggregate fields of "storage.virus" */
export type Virus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Virus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Virus_Append_Input = {
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "storage.virus". All fields are combined with a logical 'AND'. */
export type Virus_Bool_Exp = {
  _and?: InputMaybe<Array<Virus_Bool_Exp>>;
  _not?: InputMaybe<Virus_Bool_Exp>;
  _or?: InputMaybe<Array<Virus_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  fileId?: InputMaybe<Uuid_Comparison_Exp>;
  filename?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userSession?: InputMaybe<Jsonb_Comparison_Exp>;
  virus?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "storage.virus" */
export enum Virus_Constraint {
  /** unique or primary key constraint on columns "id" */
  VirusPkey = 'virus_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Virus_Delete_At_Path_Input = {
  userSession?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Virus_Delete_Elem_Input = {
  userSession?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Virus_Delete_Key_Input = {
  userSession?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "storage.virus" */
export type Virus_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
  virus?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Virus_Max_Fields = {
  __typename?: 'virus_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  virus?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Virus_Min_Fields = {
  __typename?: 'virus_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  virus?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "storage.virus" */
export type Virus_Mutation_Response = {
  __typename?: 'virus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Virus>;
};

/** on_conflict condition type for table "storage.virus" */
export type Virus_On_Conflict = {
  constraint: Virus_Constraint;
  update_columns?: Array<Virus_Update_Column>;
  where?: InputMaybe<Virus_Bool_Exp>;
};

/** Ordering options when selecting data from "storage.virus". */
export type Virus_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  fileId?: InputMaybe<Order_By>;
  filename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userSession?: InputMaybe<Order_By>;
  virus?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storage.virus */
export type Virus_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Virus_Prepend_Input = {
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "storage.virus" */
export enum Virus_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserSession = 'userSession',
  /** column name */
  Virus = 'virus'
}

/** input type for updating data in table "storage.virus" */
export type Virus_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
  virus?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "virus" */
export type Virus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Virus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Virus_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
  virus?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "storage.virus" */
export enum Virus_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserSession = 'userSession',
  /** column name */
  Virus = 'virus'
}

export type Virus_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Virus_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Virus_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Virus_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Virus_Set_Input>;
  /** filter the rows which have to be updated */
  where: Virus_Bool_Exp;
};

/** columns and relationships of "visit" */
export type Visit = {
  __typename?: 'visit';
  buyerId: Scalars['uuid']['output'];
  /** An object relationship */
  buyer_member: Buyer_Member;
  createdAt: Scalars['timestamptz']['output'];
  endTime: Scalars['timestamptz']['output'];
  /** An object relationship */
  estate: Estate;
  estateId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  isVisitDone: Scalars['Boolean']['output'];
  spanId?: Maybe<Scalars['uuid']['output']>;
  startTime: Scalars['timestamptz']['output'];
  /** An object relationship */
  visit_span?: Maybe<Visit_Span>;
};

/** aggregated selection of "visit" */
export type Visit_Aggregate = {
  __typename?: 'visit_aggregate';
  aggregate?: Maybe<Visit_Aggregate_Fields>;
  nodes: Array<Visit>;
};

export type Visit_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Visit_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Visit_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Visit_Aggregate_Bool_Exp_Count>;
};

export type Visit_Aggregate_Bool_Exp_Bool_And = {
  arguments: Visit_Select_Column_Visit_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Visit_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Visit_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Visit_Select_Column_Visit_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Visit_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Visit_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Visit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Visit_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "visit" */
export type Visit_Aggregate_Fields = {
  __typename?: 'visit_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Visit_Max_Fields>;
  min?: Maybe<Visit_Min_Fields>;
};


/** aggregate fields of "visit" */
export type Visit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Visit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "visit" */
export type Visit_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Visit_Max_Order_By>;
  min?: InputMaybe<Visit_Min_Order_By>;
};

/** input type for inserting array relation for remote table "visit" */
export type Visit_Arr_Rel_Insert_Input = {
  data: Array<Visit_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Visit_On_Conflict>;
};

/** Boolean expression to filter rows from the table "visit". All fields are combined with a logical 'AND'. */
export type Visit_Bool_Exp = {
  _and?: InputMaybe<Array<Visit_Bool_Exp>>;
  _not?: InputMaybe<Visit_Bool_Exp>;
  _or?: InputMaybe<Array<Visit_Bool_Exp>>;
  buyerId?: InputMaybe<Uuid_Comparison_Exp>;
  buyer_member?: InputMaybe<Buyer_Member_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  endTime?: InputMaybe<Timestamptz_Comparison_Exp>;
  estate?: InputMaybe<Estate_Bool_Exp>;
  estateId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isVisitDone?: InputMaybe<Boolean_Comparison_Exp>;
  spanId?: InputMaybe<Uuid_Comparison_Exp>;
  startTime?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_span?: InputMaybe<Visit_Span_Bool_Exp>;
};

/** unique or primary key constraints on table "visit" */
export enum Visit_Constraint {
  /** unique or primary key constraint on columns "endTime", "buyerId", "spanId", "startTime" */
  VisitSlotBuyerIdSpanIdStartTimeEndTimeKey = 'visit_slot_buyerId_spanId_startTime_endTime_key',
  /** unique or primary key constraint on columns "id" */
  VisitSlotPkey = 'visit_slot_pkey'
}

/** input type for inserting data into table "visit" */
export type Visit_Insert_Input = {
  buyerId?: InputMaybe<Scalars['uuid']['input']>;
  buyer_member?: InputMaybe<Buyer_Member_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endTime?: InputMaybe<Scalars['timestamptz']['input']>;
  estate?: InputMaybe<Estate_Obj_Rel_Insert_Input>;
  estateId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isVisitDone?: InputMaybe<Scalars['Boolean']['input']>;
  spanId?: InputMaybe<Scalars['uuid']['input']>;
  startTime?: InputMaybe<Scalars['timestamptz']['input']>;
  visit_span?: InputMaybe<Visit_Span_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Visit_Max_Fields = {
  __typename?: 'visit_max_fields';
  buyerId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  endTime?: Maybe<Scalars['timestamptz']['output']>;
  estateId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  spanId?: Maybe<Scalars['uuid']['output']>;
  startTime?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "visit" */
export type Visit_Max_Order_By = {
  buyerId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  endTime?: InputMaybe<Order_By>;
  estateId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  spanId?: InputMaybe<Order_By>;
  startTime?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Visit_Min_Fields = {
  __typename?: 'visit_min_fields';
  buyerId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  endTime?: Maybe<Scalars['timestamptz']['output']>;
  estateId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  spanId?: Maybe<Scalars['uuid']['output']>;
  startTime?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "visit" */
export type Visit_Min_Order_By = {
  buyerId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  endTime?: InputMaybe<Order_By>;
  estateId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  spanId?: InputMaybe<Order_By>;
  startTime?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "visit" */
export type Visit_Mutation_Response = {
  __typename?: 'visit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Visit>;
};

/** on_conflict condition type for table "visit" */
export type Visit_On_Conflict = {
  constraint: Visit_Constraint;
  update_columns?: Array<Visit_Update_Column>;
  where?: InputMaybe<Visit_Bool_Exp>;
};

/** Ordering options when selecting data from "visit". */
export type Visit_Order_By = {
  buyerId?: InputMaybe<Order_By>;
  buyer_member?: InputMaybe<Buyer_Member_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  endTime?: InputMaybe<Order_By>;
  estate?: InputMaybe<Estate_Order_By>;
  estateId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isVisitDone?: InputMaybe<Order_By>;
  spanId?: InputMaybe<Order_By>;
  startTime?: InputMaybe<Order_By>;
  visit_span?: InputMaybe<Visit_Span_Order_By>;
};

/** primary key columns input for table: visit */
export type Visit_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "visit" */
export enum Visit_Select_Column {
  /** column name */
  BuyerId = 'buyerId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  EstateId = 'estateId',
  /** column name */
  Id = 'id',
  /** column name */
  IsVisitDone = 'isVisitDone',
  /** column name */
  SpanId = 'spanId',
  /** column name */
  StartTime = 'startTime'
}

/** select "visit_aggregate_bool_exp_bool_and_arguments_columns" columns of table "visit" */
export enum Visit_Select_Column_Visit_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsVisitDone = 'isVisitDone'
}

/** select "visit_aggregate_bool_exp_bool_or_arguments_columns" columns of table "visit" */
export enum Visit_Select_Column_Visit_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsVisitDone = 'isVisitDone'
}

/** input type for updating data in table "visit" */
export type Visit_Set_Input = {
  buyerId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endTime?: InputMaybe<Scalars['timestamptz']['input']>;
  estateId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isVisitDone?: InputMaybe<Scalars['Boolean']['input']>;
  spanId?: InputMaybe<Scalars['uuid']['input']>;
  startTime?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "visit_span" */
export type Visit_Span = {
  __typename?: 'visit_span';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  estate: Estate;
  estateId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  span: Array<Scalars['visit_span_span']['output']>;
  /** An array relationship */
  visits: Array<Visit>;
  /** An aggregate relationship */
  visits_aggregate: Visit_Aggregate;
};


/** columns and relationships of "visit_span" */
export type Visit_SpanSpanArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "visit_span" */
export type Visit_SpanVisitsArgs = {
  distinct_on?: InputMaybe<Array<Visit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visit_Order_By>>;
  where?: InputMaybe<Visit_Bool_Exp>;
};


/** columns and relationships of "visit_span" */
export type Visit_SpanVisits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Visit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visit_Order_By>>;
  where?: InputMaybe<Visit_Bool_Exp>;
};

/** aggregated selection of "visit_span" */
export type Visit_Span_Aggregate = {
  __typename?: 'visit_span_aggregate';
  aggregate?: Maybe<Visit_Span_Aggregate_Fields>;
  nodes: Array<Visit_Span>;
};

export type Visit_Span_Aggregate_Bool_Exp = {
  count?: InputMaybe<Visit_Span_Aggregate_Bool_Exp_Count>;
};

export type Visit_Span_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Visit_Span_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Visit_Span_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "visit_span" */
export type Visit_Span_Aggregate_Fields = {
  __typename?: 'visit_span_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Visit_Span_Max_Fields>;
  min?: Maybe<Visit_Span_Min_Fields>;
};


/** aggregate fields of "visit_span" */
export type Visit_Span_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Visit_Span_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "visit_span" */
export type Visit_Span_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Visit_Span_Max_Order_By>;
  min?: InputMaybe<Visit_Span_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Visit_Span_Append_Input = {
  span?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "visit_span" */
export type Visit_Span_Arr_Rel_Insert_Input = {
  data: Array<Visit_Span_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Visit_Span_On_Conflict>;
};

/** Boolean expression to filter rows from the table "visit_span". All fields are combined with a logical 'AND'. */
export type Visit_Span_Bool_Exp = {
  _and?: InputMaybe<Array<Visit_Span_Bool_Exp>>;
  _not?: InputMaybe<Visit_Span_Bool_Exp>;
  _or?: InputMaybe<Array<Visit_Span_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  estate?: InputMaybe<Estate_Bool_Exp>;
  estateId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  span?: InputMaybe<Jsonb_Comparison_Exp>;
  visits?: InputMaybe<Visit_Bool_Exp>;
  visits_aggregate?: InputMaybe<Visit_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "visit_span" */
export enum Visit_Span_Constraint {
  /** unique or primary key constraint on columns "id" */
  VisitSpanPkey = 'visit_span_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Visit_Span_Delete_At_Path_Input = {
  span?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Visit_Span_Delete_Elem_Input = {
  span?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Visit_Span_Delete_Key_Input = {
  span?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "visit_span" */
export type Visit_Span_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  estate?: InputMaybe<Estate_Obj_Rel_Insert_Input>;
  estateId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  span?: InputMaybe<Scalars['jsonb']['input']>;
  visits?: InputMaybe<Visit_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Visit_Span_Max_Fields = {
  __typename?: 'visit_span_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  estateId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "visit_span" */
export type Visit_Span_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  estateId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Visit_Span_Min_Fields = {
  __typename?: 'visit_span_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  estateId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "visit_span" */
export type Visit_Span_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  estateId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "visit_span" */
export type Visit_Span_Mutation_Response = {
  __typename?: 'visit_span_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Visit_Span>;
};

/** input type for inserting object relation for remote table "visit_span" */
export type Visit_Span_Obj_Rel_Insert_Input = {
  data: Visit_Span_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Visit_Span_On_Conflict>;
};

/** on_conflict condition type for table "visit_span" */
export type Visit_Span_On_Conflict = {
  constraint: Visit_Span_Constraint;
  update_columns?: Array<Visit_Span_Update_Column>;
  where?: InputMaybe<Visit_Span_Bool_Exp>;
};

/** Ordering options when selecting data from "visit_span". */
export type Visit_Span_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  estate?: InputMaybe<Estate_Order_By>;
  estateId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  span?: InputMaybe<Order_By>;
  visits_aggregate?: InputMaybe<Visit_Aggregate_Order_By>;
};

/** primary key columns input for table: visit_span */
export type Visit_Span_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Visit_Span_Prepend_Input = {
  span?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "visit_span" */
export enum Visit_Span_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EstateId = 'estateId',
  /** column name */
  Id = 'id',
  /** column name */
  Span = 'span'
}

/** input type for updating data in table "visit_span" */
export type Visit_Span_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  estateId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  span?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "visit_span" */
export type Visit_Span_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Visit_Span_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Visit_Span_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  estateId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  span?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "visit_span" */
export enum Visit_Span_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EstateId = 'estateId',
  /** column name */
  Id = 'id',
  /** column name */
  Span = 'span'
}

export type Visit_Span_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Visit_Span_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Visit_Span_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Visit_Span_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Visit_Span_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Visit_Span_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Visit_Span_Set_Input>;
  /** filter the rows which have to be updated */
  where: Visit_Span_Bool_Exp;
};

/** Streaming cursor of the table "visit" */
export type Visit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Visit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Visit_Stream_Cursor_Value_Input = {
  buyerId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endTime?: InputMaybe<Scalars['timestamptz']['input']>;
  estateId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isVisitDone?: InputMaybe<Scalars['Boolean']['input']>;
  spanId?: InputMaybe<Scalars['uuid']['input']>;
  startTime?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "visit" */
export enum Visit_Update_Column {
  /** column name */
  BuyerId = 'buyerId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  EstateId = 'estateId',
  /** column name */
  Id = 'id',
  /** column name */
  IsVisitDone = 'isVisitDone',
  /** column name */
  SpanId = 'spanId',
  /** column name */
  StartTime = 'startTime'
}

export type Visit_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Visit_Set_Input>;
  /** filter the rows which have to be updated */
  where: Visit_Bool_Exp;
};

export type AgencyFragment = { __typename?: 'agency', id: string, name: string };

export type AgencyMemberFragment = { __typename?: 'agency_member', id: string, userId?: string | null, picture?: string | null, inviteDate?: string | null, archived: boolean, agencyId: string, hasSetPassword?: boolean | null, inviteEmail?: string | null, user?: { __typename?: 'users', displayName: string, email?: string | null, metadata: UserMetadata } | null };

export type CreateAgencyMemberMutationVariables = Exact<{
  inviteEmail: Scalars['String']['input'];
  inviteDate: Scalars['timestamptz']['input'];
  agencyId: Scalars['uuid']['input'];
}>;


export type CreateAgencyMemberMutation = { __typename?: 'mutation_root', insert_agency_member_one?: { __typename?: 'agency_member', id: string } | null };

export type GetAgencyMemberQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetAgencyMemberQuery = { __typename?: 'query_root', agency_member_by_pk?: { __typename?: 'agency_member', id: string, userId?: string | null, picture?: string | null, inviteDate?: string | null, archived: boolean, agencyId: string, hasSetPassword?: boolean | null, inviteEmail?: string | null, user?: { __typename?: 'users', displayName: string, email?: string | null, metadata: UserMetadata } | null } | null };

export type GetAgencyMemberByUserIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetAgencyMemberByUserIdQuery = { __typename?: 'query_root', agency_member: Array<{ __typename?: 'agency_member', id: string, userId?: string | null, picture?: string | null, inviteDate?: string | null, archived: boolean, agencyId: string, hasSetPassword?: boolean | null, inviteEmail?: string | null, user?: { __typename?: 'users', displayName: string, email?: string | null, metadata: UserMetadata } | null }> };

export type GetAgencyMemberByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetAgencyMemberByEmailQuery = { __typename?: 'query_root', agency_member: Array<{ __typename?: 'agency_member', id: string, userId?: string | null, picture?: string | null, inviteDate?: string | null, archived: boolean, agencyId: string, hasSetPassword?: boolean | null, inviteEmail?: string | null, user?: { __typename?: 'users', displayName: string, email?: string | null, metadata: UserMetadata } | null }> };

export type UpdateAgencyMemberMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  values: Agency_Member_Set_Input;
}>;


export type UpdateAgencyMemberMutation = { __typename?: 'mutation_root', update_agency_member_by_pk?: { __typename?: 'agency_member', id: string, userId?: string | null, picture?: string | null, inviteDate?: string | null, archived: boolean, agencyId: string, hasSetPassword?: boolean | null, inviteEmail?: string | null, user?: { __typename?: 'users', displayName: string, email?: string | null, metadata: UserMetadata } | null } | null };

export type ApplicationFragment = { __typename?: 'application', id: string, createdAt: string, updatedAt: string, submitDate?: string | null, archived: boolean, status: Application_Status_Enum, offerAmount?: number | null, contribution?: number | null, loan?: number | null, acquisitionAmount?: any | null, score: number, tags?: any | null, comment?: string | null, notary: any, alertOnHigherOffer?: boolean | null, acceptedDraftCompromise: boolean, confirmOfferOnHonor?: boolean | null, dateConfirmConformityAndAcceptedPrivacyPolicy?: string | null, buyerId: string, estateId: string, roundId?: string | null, promiseOfSaleSignatureDate?: string | null, promiseOfSalesFileId?: string | null, authenticActSignatureDate?: string | null, authenticActFileId?: string | null, hasDraftBeenEdited: boolean, cancellationDocumentFileId?: string | null, needsPropertySaleToFinanceAcquisition?: boolean | null, hasNoAdditionalSuspensiveCondition?: boolean | null, additionalSuspensiveConditionDescription?: string | null };

export type ApplicationWithBuyerMemberFoldersFragment = { __typename?: 'application', hasDraftBeenEdited: boolean, id: string, createdAt: string, updatedAt: string, submitDate?: string | null, archived: boolean, status: Application_Status_Enum, offerAmount?: number | null, contribution?: number | null, loan?: number | null, acquisitionAmount?: any | null, score: number, tags?: any | null, comment?: string | null, notary: any, alertOnHigherOffer?: boolean | null, acceptedDraftCompromise: boolean, confirmOfferOnHonor?: boolean | null, dateConfirmConformityAndAcceptedPrivacyPolicy?: string | null, buyerId: string, estateId: string, roundId?: string | null, promiseOfSaleSignatureDate?: string | null, promiseOfSalesFileId?: string | null, authenticActSignatureDate?: string | null, authenticActFileId?: string | null, cancellationDocumentFileId?: string | null, needsPropertySaleToFinanceAcquisition?: boolean | null, hasNoAdditionalSuspensiveCondition?: boolean | null, additionalSuspensiveConditionDescription?: string | null, buyer_member_folders: Array<{ __typename?: 'buyer_member_folder', id: string, address?: string | null, bankAccountBic?: string | null, bankAccountHolder?: string | null, bankAccountIban?: string | null, bankAccountRibFileId?: string | null, bankAccountBankAddress?: string | null, bankAccountBankName?: string | null, birthDate?: string | null, birthName?: string | null, birthPlace?: string | null, civility?: Civility_Enum | null, comment?: string | null, companyName?: string | null, countryOfTaxResidence?: string | null, emailAddress?: string | null, firstName?: string | null, fluentInFrench?: boolean | null, homePhone?: string | null, identityDocumentFileId?: string | null, individualOrLegalEntity?: Seller_Type_Enum | null, kbisFileId?: string | null, languagesSpoken?: string | null, lastName?: string | null, legalForm?: Seller_Legal_Status_Enum | null, maritalStatus?: string | null, mobilePhone?: string | null, nationality?: string | null, registeredOfficeAddress?: string | null, sirenNumber?: string | null, subjectToVat?: boolean | null, taxRegimeCompany?: string | null, vatNumber?: string | null, workPhone?: string | null, isBuyerLegalRepresentative?: boolean | null, legalRepresentativeFirstName?: string | null, legalRepresentativeLastName?: string | null, legalRepresentativeBirthName?: string | null, legalRepresentativeBirthDate?: string | null, legalRepresentativeBirthPlace?: string | null, legalRepresentativeNationality?: string | null, legalRepresentativeCivility?: string | null }>, application_medias: Array<{ __typename?: 'application_media', id: string, name?: string | null, fileId: string, applicationId: string, type: Application_Media_Type_Enum, file: { __typename?: 'files', mimeType?: string | null } }> };

export type GetUserApplicationsWithBuyerMemberFoldersQueryVariables = Exact<{
  estateId: Scalars['uuid']['input'];
  buyerMemberId: Scalars['uuid']['input'];
}>;


export type GetUserApplicationsWithBuyerMemberFoldersQuery = { __typename?: 'query_root', application: Array<{ __typename?: 'application', hasDraftBeenEdited: boolean, id: string, createdAt: string, updatedAt: string, submitDate?: string | null, archived: boolean, status: Application_Status_Enum, offerAmount?: number | null, contribution?: number | null, loan?: number | null, acquisitionAmount?: any | null, score: number, tags?: any | null, comment?: string | null, notary: any, alertOnHigherOffer?: boolean | null, acceptedDraftCompromise: boolean, confirmOfferOnHonor?: boolean | null, dateConfirmConformityAndAcceptedPrivacyPolicy?: string | null, buyerId: string, estateId: string, roundId?: string | null, promiseOfSaleSignatureDate?: string | null, promiseOfSalesFileId?: string | null, authenticActSignatureDate?: string | null, authenticActFileId?: string | null, cancellationDocumentFileId?: string | null, needsPropertySaleToFinanceAcquisition?: boolean | null, hasNoAdditionalSuspensiveCondition?: boolean | null, additionalSuspensiveConditionDescription?: string | null, buyer_member_folders: Array<{ __typename?: 'buyer_member_folder', id: string, address?: string | null, bankAccountBic?: string | null, bankAccountHolder?: string | null, bankAccountIban?: string | null, bankAccountRibFileId?: string | null, bankAccountBankAddress?: string | null, bankAccountBankName?: string | null, birthDate?: string | null, birthName?: string | null, birthPlace?: string | null, civility?: Civility_Enum | null, comment?: string | null, companyName?: string | null, countryOfTaxResidence?: string | null, emailAddress?: string | null, firstName?: string | null, fluentInFrench?: boolean | null, homePhone?: string | null, identityDocumentFileId?: string | null, individualOrLegalEntity?: Seller_Type_Enum | null, kbisFileId?: string | null, languagesSpoken?: string | null, lastName?: string | null, legalForm?: Seller_Legal_Status_Enum | null, maritalStatus?: string | null, mobilePhone?: string | null, nationality?: string | null, registeredOfficeAddress?: string | null, sirenNumber?: string | null, subjectToVat?: boolean | null, taxRegimeCompany?: string | null, vatNumber?: string | null, workPhone?: string | null, isBuyerLegalRepresentative?: boolean | null, legalRepresentativeFirstName?: string | null, legalRepresentativeLastName?: string | null, legalRepresentativeBirthName?: string | null, legalRepresentativeBirthDate?: string | null, legalRepresentativeBirthPlace?: string | null, legalRepresentativeNationality?: string | null, legalRepresentativeCivility?: string | null }>, application_medias: Array<{ __typename?: 'application_media', id: string, name?: string | null, fileId: string, applicationId: string, type: Application_Media_Type_Enum, file: { __typename?: 'files', mimeType?: string | null } }> }> };

export type UpdateUserApplicationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  values: Application_Set_Input;
}>;


export type UpdateUserApplicationMutation = { __typename?: 'mutation_root', update_application_by_pk?: { __typename?: 'application', id: string, createdAt: string, updatedAt: string, submitDate?: string | null, archived: boolean, status: Application_Status_Enum, offerAmount?: number | null, contribution?: number | null, loan?: number | null, acquisitionAmount?: any | null, score: number, tags?: any | null, comment?: string | null, notary: any, alertOnHigherOffer?: boolean | null, acceptedDraftCompromise: boolean, confirmOfferOnHonor?: boolean | null, dateConfirmConformityAndAcceptedPrivacyPolicy?: string | null, buyerId: string, estateId: string, roundId?: string | null, promiseOfSaleSignatureDate?: string | null, promiseOfSalesFileId?: string | null, authenticActSignatureDate?: string | null, authenticActFileId?: string | null, hasDraftBeenEdited: boolean, cancellationDocumentFileId?: string | null, needsPropertySaleToFinanceAcquisition?: boolean | null, hasNoAdditionalSuspensiveCondition?: boolean | null, additionalSuspensiveConditionDescription?: string | null } | null };

export type ApplicationMediaFragment = { __typename?: 'application_media', id: string, name?: string | null, fileId: string, applicationId: string, type: Application_Media_Type_Enum, file: { __typename?: 'files', mimeType?: string | null } };

export type BuyerMemberFragment = { __typename?: 'buyer_member', id: string, userId?: string | null, user?: { __typename?: 'users', displayName: string, email?: string | null, phoneNumber?: string | null } | null };

export type CreateBuyerMemberMutationVariables = Exact<{
  values: Buyer_Member_Insert_Input;
}>;


export type CreateBuyerMemberMutation = { __typename?: 'mutation_root', insert_buyer_member_one?: { __typename?: 'buyer_member', id: string, userId?: string | null } | null };

export type UpdateBuyerMemberMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  values: Buyer_Member_Set_Input;
}>;


export type UpdateBuyerMemberMutation = { __typename?: 'mutation_root', update_buyer_member_by_pk?: { __typename?: 'buyer_member', id: string } | null };

export type GetBuyerMemberQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetBuyerMemberQuery = { __typename?: 'query_root', buyer_member_by_pk?: { __typename?: 'buyer_member', id: string, userId?: string | null, user?: { __typename?: 'users', displayName: string, email?: string | null, phoneNumber?: string | null } | null } | null };

export type BuyerMemberFolderFragment = { __typename?: 'buyer_member_folder', id: string, address?: string | null, bankAccountBic?: string | null, bankAccountHolder?: string | null, bankAccountIban?: string | null, bankAccountRibFileId?: string | null, bankAccountBankAddress?: string | null, bankAccountBankName?: string | null, birthDate?: string | null, birthName?: string | null, birthPlace?: string | null, civility?: Civility_Enum | null, comment?: string | null, companyName?: string | null, countryOfTaxResidence?: string | null, emailAddress?: string | null, firstName?: string | null, fluentInFrench?: boolean | null, homePhone?: string | null, identityDocumentFileId?: string | null, individualOrLegalEntity?: Seller_Type_Enum | null, kbisFileId?: string | null, languagesSpoken?: string | null, lastName?: string | null, legalForm?: Seller_Legal_Status_Enum | null, maritalStatus?: string | null, mobilePhone?: string | null, nationality?: string | null, registeredOfficeAddress?: string | null, sirenNumber?: string | null, subjectToVat?: boolean | null, taxRegimeCompany?: string | null, vatNumber?: string | null, workPhone?: string | null, isBuyerLegalRepresentative?: boolean | null, legalRepresentativeFirstName?: string | null, legalRepresentativeLastName?: string | null, legalRepresentativeBirthName?: string | null, legalRepresentativeBirthDate?: string | null, legalRepresentativeBirthPlace?: string | null, legalRepresentativeNationality?: string | null, legalRepresentativeCivility?: string | null };

export type EstateFragment = { __typename?: 'estate', id: string, name?: string | null, address: string, city: string, zipCode: string, type?: Estate_Type_Enum | null, archived: boolean, startEstimate?: number | null, endEstimate?: number | null, isPublished: boolean, isSaleOpen: boolean, servicesAndConditions: EstateServicesAndConditions, features: EstateFeatures, coownership: EstateCoownership, diagnosticsData: EstateDiagnosticsData, virtualVisits: EstateVirtualVisits, firstPrice?: number | null, reservePrice?: number | null, sellerData?: EstateSellerData | null, publicationTitle?: string | null, publicationDescription?: string | null, publicationMention?: string | null, canConnectedBuyerSeeAddress: boolean, maxVisitPerSlot: any, visitSlotDuration: any, missionHeadId?: string | null, sellerId: string, currentRoundId?: string | null, estateRounds: Array<{ __typename?: 'estate_round', id: string, number: number, isPublic: boolean, startDate: string, endDate: string, closingEmailSent: boolean, estateId: string, opt_blindRound: boolean, opt_enforceOfferGap: boolean, opt_minOfferGap?: any | null }> };

export type GetEstateQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetEstateQuery = { __typename?: 'query_root', estate_by_pk?: { __typename?: 'estate', id: string, name?: string | null, address: string, city: string, zipCode: string, type?: Estate_Type_Enum | null, archived: boolean, startEstimate?: number | null, endEstimate?: number | null, isPublished: boolean, isSaleOpen: boolean, servicesAndConditions: EstateServicesAndConditions, features: EstateFeatures, coownership: EstateCoownership, diagnosticsData: EstateDiagnosticsData, virtualVisits: EstateVirtualVisits, firstPrice?: number | null, reservePrice?: number | null, sellerData?: EstateSellerData | null, publicationTitle?: string | null, publicationDescription?: string | null, publicationMention?: string | null, canConnectedBuyerSeeAddress: boolean, maxVisitPerSlot: any, visitSlotDuration: any, missionHeadId?: string | null, sellerId: string, currentRoundId?: string | null, estateRounds: Array<{ __typename?: 'estate_round', id: string, number: number, isPublic: boolean, startDate: string, endDate: string, closingEmailSent: boolean, estateId: string, opt_blindRound: boolean, opt_enforceOfferGap: boolean, opt_minOfferGap?: any | null }> } | null };

export type EstateSellerFragment = { __typename?: 'estate_seller', sellerId: string, estateId: string, ownershipShare: any };

export type EstateLinkFragment = { __typename?: 'estate_link', id: string, name: string, url?: string | null };

export type EstateMediaFragment = { __typename?: 'estate_media', id: string, name?: string | null, estateId: string, typeId: string, position: number, isCensored: boolean, originalVersionId?: string | null, fileId: string };

export type EstateMediaTypeFragment = { __typename?: 'estate_media_type', id: string, name: Estate_Media_Type_Name_Enum, group: Estate_Media_Type_Group_Enum, hasCensoredVersion: boolean, needVisitDone: boolean };

export type EstateRoundFragment = { __typename?: 'estate_round', id: string, number: number, isPublic: boolean, startDate: string, endDate: string, closingEmailSent: boolean, estateId: string, opt_blindRound: boolean, opt_enforceOfferGap: boolean, opt_minOfferGap?: any | null, estate: { __typename?: 'estate', isSaleOpen: boolean } };

export type EstateRoundBuyerMemberFragment = { __typename?: 'estate_round_buyer_member', buyerMemberId: string, estateRoundId: string };

export type FileFragment = { __typename?: 'files', id: string, name?: string | null, size?: number | null, mimeType?: string | null };

export type MandateFragment = { __typename?: 'mandate', id: string, createdAt: string, type: Mandate_Type_Enum, amendmentNumber?: string | null, precontractualDate?: string | null, mainSignDate?: string | null, reservePrice?: string | null, firstPrice?: string | null, effectiveDate?: string | null, initialDuration: number, renewalDuration: number, maxRenewal: number, fixedFee: number, fixedFeeThreshold: number, feeVATRate: any, proportionalFeesRate: any, feePerson?: Mandate_Fee_Person_Enum | null, particularConditions?: string | null, earnedMoney?: number | null, earnedMoneyPaid?: number | null, cancellationDate?: string | null, effectiveCancellationDate?: string | null, status: Mandate_Status_Enum, mandate_registry?: { __typename?: 'mandate_registry', orderNumber: string, estateLabel: string, objectLabel: string, representativesAddress: string, representativesNames: string, generatedAt: string, observations?: string | null } | null };

export type MandateRegistryFragment = { __typename?: 'mandate_registry', orderNumber: string, estateLabel: string, objectLabel: string, representativesAddress: string, representativesNames: string, generatedAt: string, observations?: string | null };

export type MandateMediaFragment = { __typename?: 'mandate_media', id: string, mandateId: string, fileId: string, created_at: string };

export type SellerFragment = { __typename?: 'seller', id: string, archived: boolean, createdAt: string, slug?: string | null, name: string, logo?: string | null, email?: string | null, linkUrl?: string | null, type?: Seller_Type_Enum | null, legalStatus?: Seller_Legal_Status_Enum | null, taxSystem?: Seller_Tax_System_Enum | null, businessName?: string | null, siren?: string | null, headquarter?: string | null, kbis?: string | null, tva: boolean, tvaNumber?: string | null, civility?: Civility_Enum | null, firstName?: string | null, lastName?: string | null, birthName?: string | null, job?: string | null, maritalStatus?: Seller_Marital_Status_Enum | null, address?: string | null, mobilePhone?: string | null, officePhone?: string | null, homePhone?: string | null, birthDate?: string | null, birthPlace?: string | null, nationality?: string | null, taxCountry?: string | null, idCard?: string | null, comment?: string | null, iban?: string | null, bic?: string | null, accountHolder?: string | null, bankName?: string | null, bankAddress?: string | null, rib?: string | null, agencyId: string, comparution?: string | null, canEditAndCreateEstate: boolean, hideBuyerContactInfo: boolean };

export type SellerMemberFragment = { __typename?: 'seller_member', id: string, sellerId: string, archived: boolean, description: string, pictureFileId?: string | null, picture?: string | null, userId?: string | null, invitePhone?: string | null, inviteEmail?: string | null, inviteDate?: string | null, job?: string | null, isMainContact: boolean, hasSetPassword?: boolean | null, user?: { __typename?: 'users', phoneNumber?: string | null, email?: string | null, displayName: string, metadata: UserMetadata } | null };

export type SellerMemberAndItsSellerTypeFragment = { __typename?: 'seller_member', id: string, sellerId: string, userId?: string | null, inviteEmail?: string | null, job?: string | null, invitePhone?: string | null, inviteDate?: string | null, hasSetPassword?: boolean | null, isMainContact: boolean, seller: { __typename?: 'seller', id: string, type?: Seller_Type_Enum | null }, user?: { __typename?: 'users', displayName: string, email?: string | null, metadata: UserMetadata, phoneNumber?: string | null } | null };

export type CreateSellerMemberMutationVariables = Exact<{
  inviteEmail: Scalars['String']['input'];
  inviteDate: Scalars['timestamptz']['input'];
  sellerId: Scalars['uuid']['input'];
  isMainContact: Scalars['Boolean']['input'];
}>;


export type CreateSellerMemberMutation = { __typename?: 'mutation_root', insert_seller_member_one?: { __typename?: 'seller_member', id: string } | null };

export type UpdateSellerMemberMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  values: Seller_Member_Set_Input;
}>;


export type UpdateSellerMemberMutation = { __typename?: 'mutation_root', update_seller_member_by_pk?: { __typename?: 'seller_member', id: string, sellerId: string, archived: boolean, description: string, pictureFileId?: string | null, picture?: string | null, userId?: string | null, invitePhone?: string | null, inviteEmail?: string | null, inviteDate?: string | null, job?: string | null, isMainContact: boolean, hasSetPassword?: boolean | null, user?: { __typename?: 'users', phoneNumber?: string | null, email?: string | null, displayName: string, metadata: UserMetadata } | null } | null };

export type UserFragment = { __typename?: 'users', id: string, phoneNumber?: string | null, displayName: string, email?: string | null, metadata: UserMetadata };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  values: Users_Set_Input;
}>;


export type UpdateUserMutation = { __typename?: 'mutation_root', updateUser?: { __typename?: 'users', id: string, phoneNumber?: string | null, displayName: string, email?: string | null, metadata: UserMetadata } | null };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'mutation_root', deleteUser?: { __typename?: 'users', id: string } | null };

export type GetUserByEmailQueryVariables = Exact<{
  email: Scalars['citext']['input'];
}>;


export type GetUserByEmailQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: string, phoneNumber?: string | null, displayName: string, email?: string | null, metadata: UserMetadata }> };

export type VisitFragment = { __typename?: 'visit', id: string, createdAt: string, startTime: string, endTime: string, isVisitDone: boolean, spanId?: string | null, buyerId: string, estateId: string };

export type VisitSpanFragment = { __typename?: 'visit_span', id: string, createdAt: string, span: Array<VisitSpanSpan>, estateId: string };

export type AgencyWithMembersAndSellersFragment = { __typename?: 'agency', id: string, name: string, agency_members: Array<{ __typename?: 'agency_member', id: string, userId?: string | null, picture?: string | null, inviteDate?: string | null, archived: boolean, agencyId: string, hasSetPassword?: boolean | null, inviteEmail?: string | null, user?: { __typename?: 'users', displayName: string, email?: string | null, metadata: UserMetadata } | null }>, sellers: Array<{ __typename?: 'seller', id: string, archived: boolean, createdAt: string, slug?: string | null, name: string, logo?: string | null, email?: string | null, linkUrl?: string | null, type?: Seller_Type_Enum | null, legalStatus?: Seller_Legal_Status_Enum | null, taxSystem?: Seller_Tax_System_Enum | null, businessName?: string | null, siren?: string | null, headquarter?: string | null, kbis?: string | null, tva: boolean, tvaNumber?: string | null, civility?: Civility_Enum | null, firstName?: string | null, lastName?: string | null, birthName?: string | null, job?: string | null, maritalStatus?: Seller_Marital_Status_Enum | null, address?: string | null, mobilePhone?: string | null, officePhone?: string | null, homePhone?: string | null, birthDate?: string | null, birthPlace?: string | null, nationality?: string | null, taxCountry?: string | null, idCard?: string | null, comment?: string | null, iban?: string | null, bic?: string | null, accountHolder?: string | null, bankName?: string | null, bankAddress?: string | null, rib?: string | null, agencyId: string, comparution?: string | null, canEditAndCreateEstate: boolean, hideBuyerContactInfo: boolean }> };

export type AgenciesSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type AgenciesSubscription = { __typename?: 'subscription_root', agency: Array<{ __typename?: 'agency', id: string, name: string, agency_members: Array<{ __typename?: 'agency_member', id: string, userId?: string | null, picture?: string | null, inviteDate?: string | null, archived: boolean, agencyId: string, hasSetPassword?: boolean | null, inviteEmail?: string | null, user?: { __typename?: 'users', displayName: string, email?: string | null, metadata: UserMetadata } | null }>, sellers: Array<{ __typename?: 'seller', id: string, archived: boolean, createdAt: string, slug?: string | null, name: string, logo?: string | null, email?: string | null, linkUrl?: string | null, type?: Seller_Type_Enum | null, legalStatus?: Seller_Legal_Status_Enum | null, taxSystem?: Seller_Tax_System_Enum | null, businessName?: string | null, siren?: string | null, headquarter?: string | null, kbis?: string | null, tva: boolean, tvaNumber?: string | null, civility?: Civility_Enum | null, firstName?: string | null, lastName?: string | null, birthName?: string | null, job?: string | null, maritalStatus?: Seller_Marital_Status_Enum | null, address?: string | null, mobilePhone?: string | null, officePhone?: string | null, homePhone?: string | null, birthDate?: string | null, birthPlace?: string | null, nationality?: string | null, taxCountry?: string | null, idCard?: string | null, comment?: string | null, iban?: string | null, bic?: string | null, accountHolder?: string | null, bankName?: string | null, bankAddress?: string | null, rib?: string | null, agencyId: string, comparution?: string | null, canEditAndCreateEstate: boolean, hideBuyerContactInfo: boolean }> }> };

export type GetAgencyMembersQueryVariables = Exact<{
  agencyId: Scalars['uuid']['input'];
  archived: Scalars['Boolean']['input'];
}>;


export type GetAgencyMembersQuery = { __typename?: 'query_root', agency_member: Array<{ __typename?: 'agency_member', id: string, userId?: string | null, picture?: string | null, inviteDate?: string | null, archived: boolean, agencyId: string, hasSetPassword?: boolean | null, inviteEmail?: string | null, user?: { __typename?: 'users', displayName: string, email?: string | null, metadata: UserMetadata } | null }> };

export type AgencyMembersSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type AgencyMembersSubscription = { __typename?: 'subscription_root', agency_member: Array<{ __typename?: 'agency_member', id: string, userId?: string | null, picture?: string | null, inviteDate?: string | null, archived: boolean, agencyId: string, hasSetPassword?: boolean | null, inviteEmail?: string | null, user?: { __typename?: 'users', displayName: string, email?: string | null, metadata: UserMetadata } | null }> };

export type DeleteAgencyMemberMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteAgencyMemberMutation = { __typename?: 'mutation_root', delete_agency_member_by_pk?: { __typename?: 'agency_member', id: string } | null };

export type ApplicationIdAndStatusFragment = { __typename?: 'application', estateId: string, status: Application_Status_Enum, promiseOfSaleSignatureDate?: string | null, promiseOfSalesFileId?: string | null, authenticActSignatureDate?: string | null, authenticActFileId?: string | null };

export type GetApplicationsStatusesByEstatesIdsQueryVariables = Exact<{
  estateIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetApplicationsStatusesByEstatesIdsQuery = { __typename?: 'query_root', application: Array<{ __typename?: 'application', estateId: string, status: Application_Status_Enum, promiseOfSaleSignatureDate?: string | null, promiseOfSalesFileId?: string | null, authenticActSignatureDate?: string | null, authenticActFileId?: string | null }> };

export type GetApplicationsQueryVariables = Exact<{
  estateId: Scalars['uuid']['input'];
}>;


export type GetApplicationsQuery = { __typename?: 'query_root', application: Array<{ __typename?: 'application', id: string, createdAt: string, updatedAt: string, submitDate?: string | null, archived: boolean, status: Application_Status_Enum, offerAmount?: number | null, contribution?: number | null, loan?: number | null, acquisitionAmount?: any | null, score: number, tags?: any | null, comment?: string | null, notary: any, alertOnHigherOffer?: boolean | null, acceptedDraftCompromise: boolean, confirmOfferOnHonor?: boolean | null, dateConfirmConformityAndAcceptedPrivacyPolicy?: string | null, buyerId: string, estateId: string, roundId?: string | null, promiseOfSaleSignatureDate?: string | null, promiseOfSalesFileId?: string | null, authenticActSignatureDate?: string | null, authenticActFileId?: string | null, hasDraftBeenEdited: boolean, cancellationDocumentFileId?: string | null, needsPropertySaleToFinanceAcquisition?: boolean | null, hasNoAdditionalSuspensiveCondition?: boolean | null, additionalSuspensiveConditionDescription?: string | null }> };

export type GetApplicationScoreQueryVariables = Exact<{
  estateId: Scalars['uuid']['input'];
  buyerMemberId: Scalars['uuid']['input'];
}>;


export type GetApplicationScoreQuery = { __typename?: 'query_root', application: Array<{ __typename?: 'application', id: string, score: number }> };

export type UpdateApplicationScoreMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  score: Scalars['Int']['input'];
}>;


export type UpdateApplicationScoreMutation = { __typename?: 'mutation_root', update_application_by_pk?: { __typename?: 'application', id: string, score: number } | null };

export type WebappApplicationFragment = { __typename?: 'application', id: string, createdAt: string, updatedAt: string, submitDate?: string | null, archived: boolean, status: Application_Status_Enum, offerAmount?: number | null, contribution?: number | null, loan?: number | null, acquisitionAmount?: any | null, score: number, tags?: any | null, comment?: string | null, notary: any, alertOnHigherOffer?: boolean | null, acceptedDraftCompromise: boolean, confirmOfferOnHonor?: boolean | null, dateConfirmConformityAndAcceptedPrivacyPolicy?: string | null, buyerId: string, estateId: string, roundId?: string | null, promiseOfSaleSignatureDate?: string | null, promiseOfSalesFileId?: string | null, authenticActSignatureDate?: string | null, authenticActFileId?: string | null, hasDraftBeenEdited: boolean, cancellationDocumentFileId?: string | null, needsPropertySaleToFinanceAcquisition?: boolean | null, hasNoAdditionalSuspensiveCondition?: boolean | null, additionalSuspensiveConditionDescription?: string | null, buyer_member: { __typename?: 'buyer_member', id: string, userId?: string | null, visits: Array<{ __typename?: 'visit', id: string, createdAt: string, startTime: string, endTime: string, isVisitDone: boolean, spanId?: string | null, buyerId: string, estateId: string }>, user?: { __typename?: 'users', displayName: string, email?: string | null, phoneNumber?: string | null } | null }, application_medias: Array<{ __typename?: 'application_media', id: string, name?: string | null, fileId: string, applicationId: string, type: Application_Media_Type_Enum, file: { __typename?: 'files', mimeType?: string | null } }>, estate: { __typename?: 'estate', mandate?: { __typename?: 'mandate', fixedFee: number, proportionalFeesRate: any, feeVATRate: any, fixedFeeThreshold: number } | null, seller: { __typename?: 'seller', hideBuyerContactInfo: boolean } }, round?: { __typename?: 'estate_round', number: number } | null };

export type ApplicationsSubscriptionVariables = Exact<{
  estateId: Scalars['uuid']['input'];
}>;


export type ApplicationsSubscription = { __typename?: 'subscription_root', application: Array<{ __typename?: 'application', id: string, createdAt: string, updatedAt: string, submitDate?: string | null, archived: boolean, status: Application_Status_Enum, offerAmount?: number | null, contribution?: number | null, loan?: number | null, acquisitionAmount?: any | null, score: number, tags?: any | null, comment?: string | null, notary: any, alertOnHigherOffer?: boolean | null, acceptedDraftCompromise: boolean, confirmOfferOnHonor?: boolean | null, dateConfirmConformityAndAcceptedPrivacyPolicy?: string | null, buyerId: string, estateId: string, roundId?: string | null, promiseOfSaleSignatureDate?: string | null, promiseOfSalesFileId?: string | null, authenticActSignatureDate?: string | null, authenticActFileId?: string | null, hasDraftBeenEdited: boolean, cancellationDocumentFileId?: string | null, needsPropertySaleToFinanceAcquisition?: boolean | null, hasNoAdditionalSuspensiveCondition?: boolean | null, additionalSuspensiveConditionDescription?: string | null, buyer_member: { __typename?: 'buyer_member', id: string, userId?: string | null, visits: Array<{ __typename?: 'visit', id: string, createdAt: string, startTime: string, endTime: string, isVisitDone: boolean, spanId?: string | null, buyerId: string, estateId: string }>, user?: { __typename?: 'users', displayName: string, email?: string | null, phoneNumber?: string | null } | null }, application_medias: Array<{ __typename?: 'application_media', id: string, name?: string | null, fileId: string, applicationId: string, type: Application_Media_Type_Enum, file: { __typename?: 'files', mimeType?: string | null } }>, estate: { __typename?: 'estate', mandate?: { __typename?: 'mandate', fixedFee: number, proportionalFeesRate: any, feeVATRate: any, fixedFeeThreshold: number } | null, seller: { __typename?: 'seller', hideBuyerContactInfo: boolean } }, round?: { __typename?: 'estate_round', number: number } | null }> };

export type UpdateApplicationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  values: Application_Set_Input;
}>;


export type UpdateApplicationMutation = { __typename?: 'mutation_root', update_application_by_pk?: { __typename?: 'application', id: string } | null };

export type GetBuyerMemberFoldersByApplicationIdQueryVariables = Exact<{
  applicationId: Scalars['uuid']['input'];
}>;


export type GetBuyerMemberFoldersByApplicationIdQuery = { __typename?: 'query_root', buyer_member_folder: Array<{ __typename?: 'buyer_member_folder', id: string, address?: string | null, bankAccountBic?: string | null, bankAccountHolder?: string | null, bankAccountIban?: string | null, bankAccountRibFileId?: string | null, bankAccountBankAddress?: string | null, bankAccountBankName?: string | null, birthDate?: string | null, birthName?: string | null, birthPlace?: string | null, civility?: Civility_Enum | null, comment?: string | null, companyName?: string | null, countryOfTaxResidence?: string | null, emailAddress?: string | null, firstName?: string | null, fluentInFrench?: boolean | null, homePhone?: string | null, identityDocumentFileId?: string | null, individualOrLegalEntity?: Seller_Type_Enum | null, kbisFileId?: string | null, languagesSpoken?: string | null, lastName?: string | null, legalForm?: Seller_Legal_Status_Enum | null, maritalStatus?: string | null, mobilePhone?: string | null, nationality?: string | null, registeredOfficeAddress?: string | null, sirenNumber?: string | null, subjectToVat?: boolean | null, taxRegimeCompany?: string | null, vatNumber?: string | null, workPhone?: string | null, isBuyerLegalRepresentative?: boolean | null, legalRepresentativeFirstName?: string | null, legalRepresentativeLastName?: string | null, legalRepresentativeBirthName?: string | null, legalRepresentativeBirthDate?: string | null, legalRepresentativeBirthPlace?: string | null, legalRepresentativeNationality?: string | null, legalRepresentativeCivility?: string | null }> };

export type WebappEstateFragment = { __typename?: 'estate', estimationAskedDate?: string | null, estimationPublishedDate?: string | null, currentRoundId?: string | null, id: string, name?: string | null, address: string, city: string, zipCode: string, type?: Estate_Type_Enum | null, archived: boolean, startEstimate?: number | null, endEstimate?: number | null, isPublished: boolean, isSaleOpen: boolean, servicesAndConditions: EstateServicesAndConditions, features: EstateFeatures, coownership: EstateCoownership, diagnosticsData: EstateDiagnosticsData, virtualVisits: EstateVirtualVisits, firstPrice?: number | null, reservePrice?: number | null, sellerData?: EstateSellerData | null, publicationTitle?: string | null, publicationDescription?: string | null, publicationMention?: string | null, canConnectedBuyerSeeAddress: boolean, maxVisitPerSlot: any, visitSlotDuration: any, missionHeadId?: string | null, sellerId: string, estimationAskedBy?: { __typename?: 'seller_member', id: string, sellerId: string, archived: boolean, description: string, pictureFileId?: string | null, picture?: string | null, userId?: string | null, invitePhone?: string | null, inviteEmail?: string | null, inviteDate?: string | null, job?: string | null, isMainContact: boolean, hasSetPassword?: boolean | null, user?: { __typename?: 'users', phoneNumber?: string | null, email?: string | null, displayName: string, metadata: UserMetadata } | null } | null, visit_spans: Array<{ __typename?: 'visit_span', id: string, createdAt: string, span: Array<VisitSpanSpan>, estateId: string, visits: Array<{ __typename?: 'visit', id: string, createdAt: string, startTime: string, endTime: string, isVisitDone: boolean, spanId?: string | null, buyerId: string, estateId: string }> }>, applications: Array<{ __typename?: 'application', status: Application_Status_Enum }>, mission_head?: { __typename?: 'agency_member', user?: { __typename?: 'users', displayName: string } | null } | null, seller: { __typename?: 'seller', id: string, archived: boolean, createdAt: string, slug?: string | null, name: string, logo?: string | null, email?: string | null, linkUrl?: string | null, type?: Seller_Type_Enum | null, legalStatus?: Seller_Legal_Status_Enum | null, taxSystem?: Seller_Tax_System_Enum | null, businessName?: string | null, siren?: string | null, headquarter?: string | null, kbis?: string | null, tva: boolean, tvaNumber?: string | null, civility?: Civility_Enum | null, firstName?: string | null, lastName?: string | null, birthName?: string | null, job?: string | null, maritalStatus?: Seller_Marital_Status_Enum | null, address?: string | null, mobilePhone?: string | null, officePhone?: string | null, homePhone?: string | null, birthDate?: string | null, birthPlace?: string | null, nationality?: string | null, taxCountry?: string | null, idCard?: string | null, comment?: string | null, iban?: string | null, bic?: string | null, accountHolder?: string | null, bankName?: string | null, bankAddress?: string | null, rib?: string | null, agencyId: string, comparution?: string | null, canEditAndCreateEstate: boolean, hideBuyerContactInfo: boolean, agency: { __typename?: 'agency', name: string } }, estate_sellers: Array<{ __typename?: 'estate_seller', estateId: string, sellerId: string, seller: { __typename?: 'seller', id: string, archived: boolean, createdAt: string, slug?: string | null, name: string, logo?: string | null, email?: string | null, linkUrl?: string | null, type?: Seller_Type_Enum | null, legalStatus?: Seller_Legal_Status_Enum | null, taxSystem?: Seller_Tax_System_Enum | null, businessName?: string | null, siren?: string | null, headquarter?: string | null, kbis?: string | null, tva: boolean, tvaNumber?: string | null, civility?: Civility_Enum | null, firstName?: string | null, lastName?: string | null, birthName?: string | null, job?: string | null, maritalStatus?: Seller_Marital_Status_Enum | null, address?: string | null, mobilePhone?: string | null, officePhone?: string | null, homePhone?: string | null, birthDate?: string | null, birthPlace?: string | null, nationality?: string | null, taxCountry?: string | null, idCard?: string | null, comment?: string | null, iban?: string | null, bic?: string | null, accountHolder?: string | null, bankName?: string | null, bankAddress?: string | null, rib?: string | null, agencyId: string, comparution?: string | null, canEditAndCreateEstate: boolean, hideBuyerContactInfo: boolean } }>, mandate?: { __typename?: 'mandate', id: string, fixedFeeThreshold: number, fixedFee: number, feeVATRate: any, proportionalFeesRate: any, firstPrice?: string | null, reservePrice?: string | null, mandate_media: Array<{ __typename?: 'mandate_media', id: string }> } | null, estate_links: Array<{ __typename?: 'estate_link', id: string, name: string, url?: string | null }>, estateRounds: Array<{ __typename?: 'estate_round', id: string, number: number, isPublic: boolean, startDate: string, endDate: string, closingEmailSent: boolean, estateId: string, opt_blindRound: boolean, opt_enforceOfferGap: boolean, opt_minOfferGap?: any | null }> };

export type WebappSimpleEstateFragment = { __typename?: 'estate', createdAt?: string | null, id: string, isPublished: boolean, isSaleOpen: boolean, applicationAcceptedDate?: string | null, address: string, zipCode: string, city: string, name?: string | null, startEstimate?: number | null, endEstimate?: number | null, firstPrice?: number | null, reservePrice?: number | null, features: EstateFeatures, archived: boolean, type?: Estate_Type_Enum | null, estimationPublishedDate?: string | null, sellerId: string, currentRoundId?: string | null, missionHeadId?: string | null, estateRounds: Array<{ __typename?: 'estate_round', id: string, number: number, isPublic: boolean, startDate: string, endDate: string }>, seller: { __typename?: 'seller', id: string, name: string }, estate_sellers: Array<{ __typename?: 'estate_seller', estateId: string, sellerId: string }>, mission_head?: { __typename?: 'agency_member', user?: { __typename?: 'users', displayName: string } | null } | null, mandate?: { __typename?: 'mandate', mainSignDate?: string | null, mandate_registry?: { __typename?: 'mandate_registry', orderNumber: string } | null, mandate_media: Array<{ __typename?: 'mandate_media', id: string }> } | null };

export type EstateForTableFragment = { __typename?: 'estate', createdAt?: string | null, id: string, isPublished: boolean, isSaleOpen: boolean, applicationAcceptedDate?: string | null, address: string, zipCode: string, city: string, name?: string | null, startEstimate?: number | null, endEstimate?: number | null, firstPrice?: number | null, reservePrice?: number | null, features: EstateFeatures, archived: boolean, type?: Estate_Type_Enum | null, estimationPublishedDate?: string | null, sellerId: string, currentRoundId?: string | null, missionHeadId?: string | null, applications: Array<{ __typename?: 'application', hasDraftBeenEdited: boolean, estateId: string, status: Application_Status_Enum, promiseOfSaleSignatureDate?: string | null, promiseOfSalesFileId?: string | null, authenticActSignatureDate?: string | null, authenticActFileId?: string | null, buyer_member: { __typename?: 'buyer_member', visits: Array<{ __typename?: 'visit', id: string }> } }>, visits: Array<{ __typename?: 'visit', id: string, isVisitDone: boolean }>, estateRounds: Array<{ __typename?: 'estate_round', id: string, number: number, isPublic: boolean, startDate: string, endDate: string }>, seller: { __typename?: 'seller', id: string, name: string }, estate_sellers: Array<{ __typename?: 'estate_seller', estateId: string, sellerId: string }>, mission_head?: { __typename?: 'agency_member', user?: { __typename?: 'users', displayName: string } | null } | null, mandate?: { __typename?: 'mandate', mainSignDate?: string | null, mandate_registry?: { __typename?: 'mandate_registry', orderNumber: string } | null, mandate_media: Array<{ __typename?: 'mandate_media', id: string }> } | null };

export type GetEstateForTableQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEstateForTableQuery = { __typename?: 'query_root', estate: Array<{ __typename?: 'estate', createdAt?: string | null, id: string, isPublished: boolean, isSaleOpen: boolean, applicationAcceptedDate?: string | null, address: string, zipCode: string, city: string, name?: string | null, startEstimate?: number | null, endEstimate?: number | null, firstPrice?: number | null, reservePrice?: number | null, features: EstateFeatures, archived: boolean, type?: Estate_Type_Enum | null, estimationPublishedDate?: string | null, sellerId: string, currentRoundId?: string | null, missionHeadId?: string | null, applications: Array<{ __typename?: 'application', hasDraftBeenEdited: boolean, estateId: string, status: Application_Status_Enum, promiseOfSaleSignatureDate?: string | null, promiseOfSalesFileId?: string | null, authenticActSignatureDate?: string | null, authenticActFileId?: string | null, buyer_member: { __typename?: 'buyer_member', visits: Array<{ __typename?: 'visit', id: string }> } }>, visits: Array<{ __typename?: 'visit', id: string, isVisitDone: boolean }>, estateRounds: Array<{ __typename?: 'estate_round', id: string, number: number, isPublic: boolean, startDate: string, endDate: string }>, seller: { __typename?: 'seller', id: string, name: string }, estate_sellers: Array<{ __typename?: 'estate_seller', estateId: string, sellerId: string }>, mission_head?: { __typename?: 'agency_member', user?: { __typename?: 'users', displayName: string } | null } | null, mandate?: { __typename?: 'mandate', mainSignDate?: string | null, mandate_registry?: { __typename?: 'mandate_registry', orderNumber: string } | null, mandate_media: Array<{ __typename?: 'mandate_media', id: string }> } | null }> };

export type GetEstatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEstatesQuery = { __typename?: 'query_root', estate: Array<{ __typename?: 'estate', createdAt?: string | null, id: string, isPublished: boolean, isSaleOpen: boolean, applicationAcceptedDate?: string | null, address: string, zipCode: string, city: string, name?: string | null, startEstimate?: number | null, endEstimate?: number | null, firstPrice?: number | null, reservePrice?: number | null, features: EstateFeatures, archived: boolean, type?: Estate_Type_Enum | null, estimationPublishedDate?: string | null, sellerId: string, currentRoundId?: string | null, missionHeadId?: string | null, estateRounds: Array<{ __typename?: 'estate_round', id: string, number: number, isPublic: boolean, startDate: string, endDate: string }>, seller: { __typename?: 'seller', id: string, name: string }, estate_sellers: Array<{ __typename?: 'estate_seller', estateId: string, sellerId: string }>, mission_head?: { __typename?: 'agency_member', user?: { __typename?: 'users', displayName: string } | null } | null, mandate?: { __typename?: 'mandate', mainSignDate?: string | null, mandate_registry?: { __typename?: 'mandate_registry', orderNumber: string } | null, mandate_media: Array<{ __typename?: 'mandate_media', id: string }> } | null }> };

export type EstateForSidebarFragment = { __typename?: 'estate', id: string, missionHeadId?: string | null, isPublished: boolean, applicationAcceptedDate?: string | null, name?: string | null, address: string, zipCode: string, city: string, isSaleOpen: boolean, archived: boolean, currentRoundId?: string | null, estateRounds: Array<{ __typename?: 'estate_round', id: string, number: number, isPublic: boolean, startDate: string, endDate: string }>, applications: Array<{ __typename?: 'application', estateId: string, status: Application_Status_Enum, promiseOfSaleSignatureDate?: string | null, promiseOfSalesFileId?: string | null, authenticActSignatureDate?: string | null, authenticActFileId?: string | null }> };

export type GetEstateForSidebarSubscriptionVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetEstateForSidebarSubscription = { __typename?: 'subscription_root', estate_by_pk?: { __typename?: 'estate', id: string, missionHeadId?: string | null, isPublished: boolean, applicationAcceptedDate?: string | null, name?: string | null, address: string, zipCode: string, city: string, isSaleOpen: boolean, archived: boolean, currentRoundId?: string | null, estateRounds: Array<{ __typename?: 'estate_round', id: string, number: number, isPublic: boolean, startDate: string, endDate: string }>, applications: Array<{ __typename?: 'application', estateId: string, status: Application_Status_Enum, promiseOfSaleSignatureDate?: string | null, promiseOfSalesFileId?: string | null, authenticActSignatureDate?: string | null, authenticActFileId?: string | null }> } | null };

export type EstateForSellersPageFragment = { __typename?: 'estate', id: string, sellerId: string, sellerData?: EstateSellerData | null, seller: { __typename?: 'seller', id: string, name: string }, mandate?: { __typename?: 'mandate', id: string, mandate_registry?: { __typename?: 'mandate_registry', orderNumber: string } | null } | null };

export type GetEstateForSellersPageQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetEstateForSellersPageQuery = { __typename?: 'query_root', estate_by_pk?: { __typename?: 'estate', id: string, sellerId: string, sellerData?: EstateSellerData | null, seller: { __typename?: 'seller', id: string, name: string }, mandate?: { __typename?: 'mandate', id: string, mandate_registry?: { __typename?: 'mandate_registry', orderNumber: string } | null } | null } | null, estate_seller: Array<{ __typename?: 'estate_seller', sellerId: string, estateId: string, ownershipShare: any, seller: { __typename?: 'seller', name: string } }> };

export type EstateForMainPageFragment = { __typename?: 'estate', id: string, type?: Estate_Type_Enum | null, archived: boolean, name?: string | null, address: string, zipCode: string, city: string, features: EstateFeatures, servicesAndConditions: EstateServicesAndConditions, coownership: EstateCoownership, publicationTitle?: string | null, publicationDescription?: string | null, publicationMention?: string | null, canConnectedBuyerSeeAddress: boolean, startEstimate?: number | null, endEstimate?: number | null, estimationAskedDate?: string | null, estimationPublishedDate?: string | null, estimationAskedBy?: { __typename?: 'seller_member', id: string, user?: { __typename?: 'users', displayName: string } | null } | null, mandate?: { __typename?: 'mandate', id: string, mandate_registry?: { __typename?: 'mandate_registry', orderNumber: string } | null } | null };

export type GetEstateForMainPageQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetEstateForMainPageQuery = { __typename?: 'query_root', estate_by_pk?: { __typename?: 'estate', id: string, type?: Estate_Type_Enum | null, archived: boolean, name?: string | null, address: string, zipCode: string, city: string, features: EstateFeatures, servicesAndConditions: EstateServicesAndConditions, coownership: EstateCoownership, publicationTitle?: string | null, publicationDescription?: string | null, publicationMention?: string | null, canConnectedBuyerSeeAddress: boolean, startEstimate?: number | null, endEstimate?: number | null, estimationAskedDate?: string | null, estimationPublishedDate?: string | null, estimationAskedBy?: { __typename?: 'seller_member', id: string, user?: { __typename?: 'users', displayName: string } | null } | null, mandate?: { __typename?: 'mandate', id: string, mandate_registry?: { __typename?: 'mandate_registry', orderNumber: string } | null } | null } | null };

export type EstateForDocumentsPageFragment = { __typename?: 'estate', id: string, coownership: EstateCoownership, diagnosticsData: EstateDiagnosticsData };

export type GetEstateForDocumentsPageQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetEstateForDocumentsPageQuery = { __typename?: 'query_root', estate_by_pk?: { __typename?: 'estate', id: string, coownership: EstateCoownership, diagnosticsData: EstateDiagnosticsData } | null };

export type EstateForMediasPageFragment = { __typename?: 'estate', id: string, virtualVisits: EstateVirtualVisits };

export type GetEstateForMediasPageQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetEstateForMediasPageQuery = { __typename?: 'query_root', estate_by_pk?: { __typename?: 'estate', id: string, virtualVisits: EstateVirtualVisits } | null };

export type EstateForMandatePageFragment = { __typename?: 'estate', id: string, type?: Estate_Type_Enum | null, address: string, zipCode: string, city: string, seller: { __typename?: 'seller', id: string, name: string, type?: Seller_Type_Enum | null, headquarter?: string | null, address?: string | null, agencyId: string }, estate_sellers: Array<{ __typename?: 'estate_seller', estateId: string, sellerId: string, seller: { __typename?: 'seller', id: string, name: string, type?: Seller_Type_Enum | null, headquarter?: string | null, address?: string | null } }>, mandate?: { __typename?: 'mandate', id: string } | null };

export type GetEstateForMandatePageQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetEstateForMandatePageQuery = { __typename?: 'query_root', estate_by_pk?: { __typename?: 'estate', id: string, type?: Estate_Type_Enum | null, address: string, zipCode: string, city: string, seller: { __typename?: 'seller', id: string, name: string, type?: Seller_Type_Enum | null, headquarter?: string | null, address?: string | null, agencyId: string }, estate_sellers: Array<{ __typename?: 'estate_seller', estateId: string, sellerId: string, seller: { __typename?: 'seller', id: string, name: string, type?: Seller_Type_Enum | null, headquarter?: string | null, address?: string | null } }>, mandate?: { __typename?: 'mandate', id: string } | null } | null };

export type EstateForSalePageFragment = { __typename?: 'estate', id: string, isPublished: boolean, isSaleOpen: boolean, applicationAcceptedDate?: string | null, archived: boolean, address: string, firstPrice?: number | null, reservePrice?: number | null, currentRoundId?: string | null, visitSlotDuration: any, maxVisitPerSlot: any, estate_links: Array<{ __typename?: 'estate_link', id: string, name: string, url?: string | null }>, estateRounds: Array<{ __typename?: 'estate_round', id: string, startDate: string, endDate: string, number: number, isPublic: boolean, opt_blindRound: boolean, opt_enforceOfferGap: boolean, opt_minOfferGap?: any | null, estateRoundBuyerMembers: Array<{ __typename?: 'estate_round_buyer_member', buyerMemberId: string }> }>, seller: { __typename?: 'seller', id: string, agency: { __typename?: 'agency', name: string } }, mandate?: { __typename?: 'mandate', id: string, fixedFeeThreshold: number, fixedFee: number, feeVATRate: any, proportionalFeesRate: any } | null, visit_spans: Array<{ __typename?: 'visit_span', id: string, span: Array<VisitSpanSpan> }>, visits: Array<{ __typename?: 'visit', id: string, isVisitDone: boolean }>, applications: Array<{ __typename?: 'application', status: Application_Status_Enum, hasDraftBeenEdited: boolean, buyer_member: { __typename?: 'buyer_member', visits: Array<{ __typename?: 'visit', id: string }> } }> };

export type GetEstateForSalePageSubscriptionVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetEstateForSalePageSubscription = { __typename?: 'subscription_root', estate_by_pk?: { __typename?: 'estate', id: string, isPublished: boolean, isSaleOpen: boolean, applicationAcceptedDate?: string | null, archived: boolean, address: string, firstPrice?: number | null, reservePrice?: number | null, currentRoundId?: string | null, visitSlotDuration: any, maxVisitPerSlot: any, estate_links: Array<{ __typename?: 'estate_link', id: string, name: string, url?: string | null }>, estateRounds: Array<{ __typename?: 'estate_round', id: string, startDate: string, endDate: string, number: number, isPublic: boolean, opt_blindRound: boolean, opt_enforceOfferGap: boolean, opt_minOfferGap?: any | null, estateRoundBuyerMembers: Array<{ __typename?: 'estate_round_buyer_member', buyerMemberId: string }> }>, seller: { __typename?: 'seller', id: string, agency: { __typename?: 'agency', name: string } }, mandate?: { __typename?: 'mandate', id: string, fixedFeeThreshold: number, fixedFee: number, feeVATRate: any, proportionalFeesRate: any } | null, visit_spans: Array<{ __typename?: 'visit_span', id: string, span: Array<VisitSpanSpan> }>, visits: Array<{ __typename?: 'visit', id: string, isVisitDone: boolean }>, applications: Array<{ __typename?: 'application', status: Application_Status_Enum, hasDraftBeenEdited: boolean, buyer_member: { __typename?: 'buyer_member', visits: Array<{ __typename?: 'visit', id: string }> } }> } | null };

export type GetEstateArchivedQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetEstateArchivedQuery = { __typename?: 'query_root', estate_by_pk?: { __typename?: 'estate', id: string, isPublished: boolean, archived: boolean, applications: Array<{ __typename?: 'application', id: string, status: Application_Status_Enum }> } | null };

export type CreateEstateMutationVariables = Exact<{
  values: Estate_Insert_Input;
}>;


export type CreateEstateMutation = { __typename?: 'mutation_root', insert_estate_one?: { __typename?: 'estate', id: string, name?: string | null, address: string, city: string, zipCode: string, type?: Estate_Type_Enum | null, archived: boolean, startEstimate?: number | null, endEstimate?: number | null, isPublished: boolean, isSaleOpen: boolean, servicesAndConditions: EstateServicesAndConditions, features: EstateFeatures, coownership: EstateCoownership, diagnosticsData: EstateDiagnosticsData, virtualVisits: EstateVirtualVisits, firstPrice?: number | null, reservePrice?: number | null, sellerData?: EstateSellerData | null, publicationTitle?: string | null, publicationDescription?: string | null, publicationMention?: string | null, canConnectedBuyerSeeAddress: boolean, maxVisitPerSlot: any, visitSlotDuration: any, missionHeadId?: string | null, sellerId: string, currentRoundId?: string | null, estateRounds: Array<{ __typename?: 'estate_round', id: string, number: number, isPublic: boolean, startDate: string, endDate: string, closingEmailSent: boolean, estateId: string, opt_blindRound: boolean, opt_enforceOfferGap: boolean, opt_minOfferGap?: any | null }> } | null };

export type UpdateEstateMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  values: Estate_Set_Input;
}>;


export type UpdateEstateMutation = { __typename?: 'mutation_root', update_estate_by_pk?: { __typename?: 'estate', id: string, name?: string | null, address: string, city: string, zipCode: string, type?: Estate_Type_Enum | null, archived: boolean, startEstimate?: number | null, endEstimate?: number | null, isPublished: boolean, isSaleOpen: boolean, servicesAndConditions: EstateServicesAndConditions, features: EstateFeatures, coownership: EstateCoownership, diagnosticsData: EstateDiagnosticsData, virtualVisits: EstateVirtualVisits, firstPrice?: number | null, reservePrice?: number | null, sellerData?: EstateSellerData | null, publicationTitle?: string | null, publicationDescription?: string | null, publicationMention?: string | null, canConnectedBuyerSeeAddress: boolean, maxVisitPerSlot: any, visitSlotDuration: any, missionHeadId?: string | null, sellerId: string, currentRoundId?: string | null, estateRounds: Array<{ __typename?: 'estate_round', id: string, number: number, isPublic: boolean, startDate: string, endDate: string, closingEmailSent: boolean, estateId: string, opt_blindRound: boolean, opt_enforceOfferGap: boolean, opt_minOfferGap?: any | null }> } | null };

export type GetEstateApplicantsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetEstateApplicantsQuery = { __typename?: 'query_root', estate_by_pk?: { __typename?: 'estate', applications: Array<{ __typename?: 'application', buyer_member: { __typename?: 'buyer_member', id: string, user?: { __typename?: 'users', displayName: string, email?: string | null } | null } }> } | null };

export type GetEstateVisitsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetEstateVisitsQuery = { __typename?: 'query_root', visit: Array<{ __typename?: 'visit', id: string, createdAt: string, startTime: string, endTime: string, isVisitDone: boolean, spanId?: string | null, buyerId: string, estateId: string, buyer_member: { __typename?: 'buyer_member', user?: { __typename?: 'users', displayName: string } | null } }> };

export type UpdateEstateRoundMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  values: Estate_Round_Set_Input;
}>;


export type UpdateEstateRoundMutation = { __typename?: 'mutation_root', update_estate_round_by_pk?: { __typename?: 'estate_round', id: string, number: number, isPublic: boolean, startDate: string, endDate: string, closingEmailSent: boolean, estateId: string, opt_blindRound: boolean, opt_enforceOfferGap: boolean, opt_minOfferGap?: any | null, estate: { __typename?: 'estate', isSaleOpen: boolean } } | null };

export type CreateEstateLinkMutationVariables = Exact<{
  values: Estate_Link_Insert_Input;
}>;


export type CreateEstateLinkMutation = { __typename?: 'mutation_root', insert_estate_link_one?: { __typename?: 'estate_link', id: string, name: string, url?: string | null } | null };

export type UpdateEstateLinkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  values: Estate_Link_Set_Input;
}>;


export type UpdateEstateLinkMutation = { __typename?: 'mutation_root', update_estate_link_by_pk?: { __typename?: 'estate_link', id: string, name: string, url?: string | null } | null };

export type DeleteEstateLinkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteEstateLinkMutation = { __typename?: 'mutation_root', delete_estate_link_by_pk?: { __typename?: 'estate_link', id: string } | null };

export type EstateSellersQueryVariables = Exact<{
  estateId: Scalars['uuid']['input'];
}>;


export type EstateSellersQuery = { __typename?: 'query_root', estate_seller: Array<{ __typename?: 'estate_seller', sellerId: string, estateId: string, ownershipShare: any }> };

export type CreateEstateSellersMutationVariables = Exact<{
  valuesToCreate: Array<Estate_Seller_Insert_Input> | Estate_Seller_Insert_Input;
}>;


export type CreateEstateSellersMutation = { __typename?: 'mutation_root', insert_estate_seller?: { __typename?: 'estate_seller_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'estate_seller', sellerId: string, estateId: string, ownershipShare: any }> } | null };

export type UpdateEstateSellerMutationVariables = Exact<{
  ownershipShare: Scalars['numeric']['input'];
  sellerId: Scalars['uuid']['input'];
  estateId: Scalars['uuid']['input'];
}>;


export type UpdateEstateSellerMutation = { __typename?: 'mutation_root', update_estate_seller?: { __typename?: 'estate_seller_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'estate_seller', sellerId: string, estateId: string, ownershipShare: any }> } | null };

export type DeleteEstateSellersMutationVariables = Exact<{
  sellerIdsToDelete: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  estateId: Scalars['uuid']['input'];
}>;


export type DeleteEstateSellersMutation = { __typename?: 'mutation_root', delete_estate_seller?: { __typename?: 'estate_seller_mutation_response', affected_rows: number } | null };

export type GetSellersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSellersQuery = { __typename?: 'query_root', seller: Array<{ __typename?: 'seller', id: string, name: string, archived: boolean }> };

export type WebappEstateMediaFragment = { __typename?: 'estate_media', id: string, name?: string | null, estateId: string, typeId: string, position: number, isCensored: boolean, originalVersionId?: string | null, fileId: string, file: { __typename?: 'files', id: string, name?: string | null, size?: number | null, mimeType?: string | null }, type: { __typename?: 'estate_media_type', id: string, name: Estate_Media_Type_Name_Enum, group: Estate_Media_Type_Group_Enum, hasCensoredVersion: boolean, needVisitDone: boolean }, censoredVersion?: { __typename?: 'estate_media', id: string, name?: string | null, estateId: string, typeId: string, position: number, isCensored: boolean, originalVersionId?: string | null, fileId: string, file: { __typename?: 'files', id: string, name?: string | null, size?: number | null, mimeType?: string | null }, type: { __typename?: 'estate_media_type', id: string, name: Estate_Media_Type_Name_Enum, group: Estate_Media_Type_Group_Enum, hasCensoredVersion: boolean, needVisitDone: boolean } } | null };

export type GetEstateMediaQueryVariables = Exact<{
  estateId: Scalars['uuid']['input'];
  typeGroup: Estate_Media_Type_Group_Enum;
}>;


export type GetEstateMediaQuery = { __typename?: 'query_root', estate_media: Array<{ __typename?: 'estate_media', id: string, name?: string | null, estateId: string, typeId: string, position: number, isCensored: boolean, originalVersionId?: string | null, fileId: string, file: { __typename?: 'files', id: string, name?: string | null, size?: number | null, mimeType?: string | null }, type: { __typename?: 'estate_media_type', id: string, name: Estate_Media_Type_Name_Enum, group: Estate_Media_Type_Group_Enum, hasCensoredVersion: boolean, needVisitDone: boolean }, censoredVersion?: { __typename?: 'estate_media', id: string, name?: string | null, estateId: string, typeId: string, position: number, isCensored: boolean, originalVersionId?: string | null, fileId: string, file: { __typename?: 'files', id: string, name?: string | null, size?: number | null, mimeType?: string | null }, type: { __typename?: 'estate_media_type', id: string, name: Estate_Media_Type_Name_Enum, group: Estate_Media_Type_Group_Enum, hasCensoredVersion: boolean, needVisitDone: boolean } } | null }> };

export type CreateEstateMediaMutationVariables = Exact<{
  values: Estate_Media_Insert_Input;
}>;


export type CreateEstateMediaMutation = { __typename?: 'mutation_root', insert_estate_media_one?: { __typename?: 'estate_media', id: string, name?: string | null, estateId: string, typeId: string, position: number, isCensored: boolean, originalVersionId?: string | null, fileId: string } | null };

export type UpdateEstateMediaMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  values: Estate_Media_Set_Input;
}>;


export type UpdateEstateMediaMutation = { __typename?: 'mutation_root', update_estate_media_by_pk?: { __typename?: 'estate_media', id: string, name?: string | null, estateId: string, typeId: string, position: number, isCensored: boolean, originalVersionId?: string | null, fileId: string } | null };

export type ReorderEstateMediasMutationVariables = Exact<{
  updates: Array<Estate_Media_Updates> | Estate_Media_Updates;
}>;


export type ReorderEstateMediasMutation = { __typename?: 'mutation_root', update_estate_media_many?: Array<{ __typename?: 'estate_media_mutation_response', affected_rows: number } | null> | null };

export type DeleteEstateMediaMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteEstateMediaMutation = { __typename?: 'mutation_root', delete_estate_media_by_pk?: { __typename?: 'estate_media', id: string, name?: string | null, estateId: string, typeId: string, position: number, isCensored: boolean, originalVersionId?: string | null, fileId: string } | null };

export type GetEstateMediaTypesQueryVariables = Exact<{
  group?: InputMaybe<Estate_Media_Type_Group_Enum>;
}>;


export type GetEstateMediaTypesQuery = { __typename?: 'query_root', estate_media_type: Array<{ __typename?: 'estate_media_type', id: string, name: Estate_Media_Type_Name_Enum, group: Estate_Media_Type_Group_Enum, hasCensoredVersion: boolean, needVisitDone: boolean }> };

export type GetFileQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetFileQuery = { __typename?: 'query_root', file?: { __typename?: 'files', id: string, name?: string | null, size?: number | null, mimeType?: string | null } | null };

export type GetMandatesQueryVariables = Exact<{
  agencyId: Scalars['uuid']['input'];
}>;


export type GetMandatesQuery = { __typename?: 'query_root', mandate: Array<{ __typename?: 'mandate', id: string, createdAt: string, type: Mandate_Type_Enum, amendmentNumber?: string | null, precontractualDate?: string | null, mainSignDate?: string | null, reservePrice?: string | null, firstPrice?: string | null, effectiveDate?: string | null, initialDuration: number, renewalDuration: number, maxRenewal: number, fixedFee: number, fixedFeeThreshold: number, feeVATRate: any, proportionalFeesRate: any, feePerson?: Mandate_Fee_Person_Enum | null, particularConditions?: string | null, earnedMoney?: number | null, earnedMoneyPaid?: number | null, cancellationDate?: string | null, effectiveCancellationDate?: string | null, status: Mandate_Status_Enum, mandate_registry?: { __typename?: 'mandate_registry', orderNumber: string, estateLabel: string, objectLabel: string, representativesAddress: string, representativesNames: string, generatedAt: string, observations?: string | null } | null }> };

export type GetMandateQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetMandateQuery = { __typename?: 'query_root', mandate_by_pk?: { __typename?: 'mandate', id: string, createdAt: string, type: Mandate_Type_Enum, amendmentNumber?: string | null, precontractualDate?: string | null, mainSignDate?: string | null, reservePrice?: string | null, firstPrice?: string | null, effectiveDate?: string | null, initialDuration: number, renewalDuration: number, maxRenewal: number, fixedFee: number, fixedFeeThreshold: number, feeVATRate: any, proportionalFeesRate: any, feePerson?: Mandate_Fee_Person_Enum | null, particularConditions?: string | null, earnedMoney?: number | null, earnedMoneyPaid?: number | null, cancellationDate?: string | null, effectiveCancellationDate?: string | null, status: Mandate_Status_Enum, mandate_media: Array<{ __typename?: 'mandate_media', id: string, mandateId: string, fileId: string, created_at: string }>, mandate_registry?: { __typename?: 'mandate_registry', orderNumber: string, estateLabel: string, objectLabel: string, representativesAddress: string, representativesNames: string, generatedAt: string, observations?: string | null } | null } | null };

export type WebappMandateFragment = { __typename?: 'mandate', id: string, createdAt: string, type: Mandate_Type_Enum, amendmentNumber?: string | null, precontractualDate?: string | null, mainSignDate?: string | null, reservePrice?: string | null, firstPrice?: string | null, effectiveDate?: string | null, initialDuration: number, renewalDuration: number, maxRenewal: number, fixedFee: number, fixedFeeThreshold: number, feeVATRate: any, proportionalFeesRate: any, feePerson?: Mandate_Fee_Person_Enum | null, particularConditions?: string | null, earnedMoney?: number | null, earnedMoneyPaid?: number | null, cancellationDate?: string | null, effectiveCancellationDate?: string | null, status: Mandate_Status_Enum, mandate_media: Array<{ __typename?: 'mandate_media', id: string, mandateId: string, fileId: string, created_at: string }>, mandate_registry?: { __typename?: 'mandate_registry', orderNumber: string, estateLabel: string, objectLabel: string, representativesAddress: string, representativesNames: string, generatedAt: string, observations?: string | null } | null };

export type CreateMandateMutationVariables = Exact<{
  values: Mandate_Insert_Input;
}>;


export type CreateMandateMutation = { __typename?: 'mutation_root', insert_mandate_one?: { __typename?: 'mandate', id: string } | null };

export type UpdateMandateMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  values: Mandate_Set_Input;
}>;


export type UpdateMandateMutation = { __typename?: 'mutation_root', update_mandate_by_pk?: { __typename?: 'mandate', id: string, createdAt: string, type: Mandate_Type_Enum, amendmentNumber?: string | null, precontractualDate?: string | null, mainSignDate?: string | null, reservePrice?: string | null, firstPrice?: string | null, effectiveDate?: string | null, initialDuration: number, renewalDuration: number, maxRenewal: number, fixedFee: number, fixedFeeThreshold: number, feeVATRate: any, proportionalFeesRate: any, feePerson?: Mandate_Fee_Person_Enum | null, particularConditions?: string | null, earnedMoney?: number | null, earnedMoneyPaid?: number | null, cancellationDate?: string | null, effectiveCancellationDate?: string | null, status: Mandate_Status_Enum, mandate_registry?: { __typename?: 'mandate_registry', orderNumber: string, estateLabel: string, objectLabel: string, representativesAddress: string, representativesNames: string, generatedAt: string, observations?: string | null } | null } | null };

export type UploadMandateMediaMutationVariables = Exact<{
  fileId: Scalars['uuid']['input'];
  mandateId: Scalars['uuid']['input'];
}>;


export type UploadMandateMediaMutation = { __typename?: 'mutation_root', insert_mandate_media_one?: { __typename?: 'mandate_media', id: string } | null };

export type CreateMandateRegistryMutationVariables = Exact<{
  values: Mandate_Registry_Insert_Input;
}>;


export type CreateMandateRegistryMutation = { __typename?: 'mutation_root', insert_mandate_registry_one?: { __typename?: 'mandate_registry', mandateId: string, orderNumber: string, estateLabel: string, objectLabel: string, representativesAddress: string, representativesNames: string, generatedAt: string, observations?: string | null } | null };

export type SellerWithAgencyFragment = { __typename?: 'seller', id: string, archived: boolean, createdAt: string, slug?: string | null, name: string, logo?: string | null, email?: string | null, linkUrl?: string | null, type?: Seller_Type_Enum | null, legalStatus?: Seller_Legal_Status_Enum | null, taxSystem?: Seller_Tax_System_Enum | null, businessName?: string | null, siren?: string | null, headquarter?: string | null, kbis?: string | null, tva: boolean, tvaNumber?: string | null, civility?: Civility_Enum | null, firstName?: string | null, lastName?: string | null, birthName?: string | null, job?: string | null, maritalStatus?: Seller_Marital_Status_Enum | null, address?: string | null, mobilePhone?: string | null, officePhone?: string | null, homePhone?: string | null, birthDate?: string | null, birthPlace?: string | null, nationality?: string | null, taxCountry?: string | null, idCard?: string | null, comment?: string | null, iban?: string | null, bic?: string | null, accountHolder?: string | null, bankName?: string | null, bankAddress?: string | null, rib?: string | null, agencyId: string, comparution?: string | null, canEditAndCreateEstate: boolean, hideBuyerContactInfo: boolean, agency: { __typename?: 'agency', id: string, name: string } };

export type SellerWithAgencyAndMembersFragment = { __typename?: 'seller', id: string, archived: boolean, createdAt: string, slug?: string | null, name: string, logo?: string | null, email?: string | null, linkUrl?: string | null, type?: Seller_Type_Enum | null, legalStatus?: Seller_Legal_Status_Enum | null, taxSystem?: Seller_Tax_System_Enum | null, businessName?: string | null, siren?: string | null, headquarter?: string | null, kbis?: string | null, tva: boolean, tvaNumber?: string | null, civility?: Civility_Enum | null, firstName?: string | null, lastName?: string | null, birthName?: string | null, job?: string | null, maritalStatus?: Seller_Marital_Status_Enum | null, address?: string | null, mobilePhone?: string | null, officePhone?: string | null, homePhone?: string | null, birthDate?: string | null, birthPlace?: string | null, nationality?: string | null, taxCountry?: string | null, idCard?: string | null, comment?: string | null, iban?: string | null, bic?: string | null, accountHolder?: string | null, bankName?: string | null, bankAddress?: string | null, rib?: string | null, agencyId: string, comparution?: string | null, canEditAndCreateEstate: boolean, hideBuyerContactInfo: boolean, seller_members: Array<{ __typename?: 'seller_member', id: string, sellerId: string, archived: boolean, description: string, pictureFileId?: string | null, picture?: string | null, userId?: string | null, invitePhone?: string | null, inviteEmail?: string | null, inviteDate?: string | null, job?: string | null, isMainContact: boolean, hasSetPassword?: boolean | null, user?: { __typename?: 'users', phoneNumber?: string | null, email?: string | null, displayName: string, metadata: UserMetadata } | null }>, agency: { __typename?: 'agency', id: string, name: string } };

export type SellersSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SellersSubscription = { __typename?: 'subscription_root', seller: Array<{ __typename?: 'seller', id: string, archived: boolean, createdAt: string, slug?: string | null, name: string, logo?: string | null, email?: string | null, linkUrl?: string | null, type?: Seller_Type_Enum | null, legalStatus?: Seller_Legal_Status_Enum | null, taxSystem?: Seller_Tax_System_Enum | null, businessName?: string | null, siren?: string | null, headquarter?: string | null, kbis?: string | null, tva: boolean, tvaNumber?: string | null, civility?: Civility_Enum | null, firstName?: string | null, lastName?: string | null, birthName?: string | null, job?: string | null, maritalStatus?: Seller_Marital_Status_Enum | null, address?: string | null, mobilePhone?: string | null, officePhone?: string | null, homePhone?: string | null, birthDate?: string | null, birthPlace?: string | null, nationality?: string | null, taxCountry?: string | null, idCard?: string | null, comment?: string | null, iban?: string | null, bic?: string | null, accountHolder?: string | null, bankName?: string | null, bankAddress?: string | null, rib?: string | null, agencyId: string, comparution?: string | null, canEditAndCreateEstate: boolean, hideBuyerContactInfo: boolean, seller_members: Array<{ __typename?: 'seller_member', id: string, sellerId: string, archived: boolean, description: string, pictureFileId?: string | null, picture?: string | null, userId?: string | null, invitePhone?: string | null, inviteEmail?: string | null, inviteDate?: string | null, job?: string | null, isMainContact: boolean, hasSetPassword?: boolean | null, user?: { __typename?: 'users', phoneNumber?: string | null, email?: string | null, displayName: string, metadata: UserMetadata } | null }>, agency: { __typename?: 'agency', id: string, name: string } }> };

export type SellerSubscriptionVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type SellerSubscription = { __typename?: 'subscription_root', seller_by_pk?: { __typename?: 'seller', id: string, archived: boolean, createdAt: string, slug?: string | null, name: string, logo?: string | null, email?: string | null, linkUrl?: string | null, type?: Seller_Type_Enum | null, legalStatus?: Seller_Legal_Status_Enum | null, taxSystem?: Seller_Tax_System_Enum | null, businessName?: string | null, siren?: string | null, headquarter?: string | null, kbis?: string | null, tva: boolean, tvaNumber?: string | null, civility?: Civility_Enum | null, firstName?: string | null, lastName?: string | null, birthName?: string | null, job?: string | null, maritalStatus?: Seller_Marital_Status_Enum | null, address?: string | null, mobilePhone?: string | null, officePhone?: string | null, homePhone?: string | null, birthDate?: string | null, birthPlace?: string | null, nationality?: string | null, taxCountry?: string | null, idCard?: string | null, comment?: string | null, iban?: string | null, bic?: string | null, accountHolder?: string | null, bankName?: string | null, bankAddress?: string | null, rib?: string | null, agencyId: string, comparution?: string | null, canEditAndCreateEstate: boolean, hideBuyerContactInfo: boolean, seller_members: Array<{ __typename?: 'seller_member', id: string, sellerId: string, archived: boolean, description: string, pictureFileId?: string | null, picture?: string | null, userId?: string | null, invitePhone?: string | null, inviteEmail?: string | null, inviteDate?: string | null, job?: string | null, isMainContact: boolean, hasSetPassword?: boolean | null, user?: { __typename?: 'users', phoneNumber?: string | null, email?: string | null, displayName: string, metadata: UserMetadata } | null }>, agency: { __typename?: 'agency', id: string, name: string } } | null };

export type SellerBySlugSubscriptionVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type SellerBySlugSubscription = { __typename?: 'subscription_root', seller: Array<{ __typename?: 'seller', id: string, archived: boolean, createdAt: string, slug?: string | null, name: string, logo?: string | null, email?: string | null, linkUrl?: string | null, type?: Seller_Type_Enum | null, legalStatus?: Seller_Legal_Status_Enum | null, taxSystem?: Seller_Tax_System_Enum | null, businessName?: string | null, siren?: string | null, headquarter?: string | null, kbis?: string | null, tva: boolean, tvaNumber?: string | null, civility?: Civility_Enum | null, firstName?: string | null, lastName?: string | null, birthName?: string | null, job?: string | null, maritalStatus?: Seller_Marital_Status_Enum | null, address?: string | null, mobilePhone?: string | null, officePhone?: string | null, homePhone?: string | null, birthDate?: string | null, birthPlace?: string | null, nationality?: string | null, taxCountry?: string | null, idCard?: string | null, comment?: string | null, iban?: string | null, bic?: string | null, accountHolder?: string | null, bankName?: string | null, bankAddress?: string | null, rib?: string | null, agencyId: string, comparution?: string | null, canEditAndCreateEstate: boolean, hideBuyerContactInfo: boolean, seller_members: Array<{ __typename?: 'seller_member', id: string, sellerId: string, archived: boolean, description: string, pictureFileId?: string | null, picture?: string | null, userId?: string | null, invitePhone?: string | null, inviteEmail?: string | null, inviteDate?: string | null, job?: string | null, isMainContact: boolean, hasSetPassword?: boolean | null, user?: { __typename?: 'users', phoneNumber?: string | null, email?: string | null, displayName: string, metadata: UserMetadata } | null }>, agency: { __typename?: 'agency', id: string, name: string } }> };

export type UpdateSellerMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  values: Seller_Set_Input;
}>;


export type UpdateSellerMutation = { __typename?: 'mutation_root', update_seller_by_pk?: { __typename?: 'seller', id: string } | null };

export type SellerMemberWithUserAndSellerNamesFragment = { __typename?: 'seller_member', id: string, sellerId: string, archived: boolean, description: string, pictureFileId?: string | null, picture?: string | null, userId?: string | null, invitePhone?: string | null, inviteEmail?: string | null, inviteDate?: string | null, job?: string | null, isMainContact: boolean, hasSetPassword?: boolean | null, user?: { __typename?: 'users', id: string, displayName: string, email?: string | null, phoneNumber?: string | null, metadata: UserMetadata } | null, seller: { __typename?: 'seller', id: string, name: string } };

export type GetSellerMembersBySellerIdsQueryVariables = Exact<{
  sellerIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetSellerMembersBySellerIdsQuery = { __typename?: 'query_root', seller_member: Array<{ __typename?: 'seller_member', id: string, sellerId: string, archived: boolean, description: string, pictureFileId?: string | null, picture?: string | null, userId?: string | null, invitePhone?: string | null, inviteEmail?: string | null, inviteDate?: string | null, job?: string | null, isMainContact: boolean, hasSetPassword?: boolean | null, user?: { __typename?: 'users', id: string, displayName: string, email?: string | null, phoneNumber?: string | null, metadata: UserMetadata } | null, seller: { __typename?: 'seller', id: string, name: string } }> };

export type GetSellerMemberByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetSellerMemberByIdQuery = { __typename?: 'query_root', seller_member_by_pk?: { __typename?: 'seller_member', id: string, sellerId: string, archived: boolean, description: string, pictureFileId?: string | null, picture?: string | null, userId?: string | null, invitePhone?: string | null, inviteEmail?: string | null, inviteDate?: string | null, job?: string | null, isMainContact: boolean, hasSetPassword?: boolean | null, user?: { __typename?: 'users', phoneNumber?: string | null, email?: string | null, displayName: string, metadata: UserMetadata } | null } | null };

export type DeleteSellerMemberMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteSellerMemberMutation = { __typename?: 'mutation_root', delete_seller_member_by_pk?: { __typename?: 'seller_member', id: string } | null };

export type CurrentMemberAsSellerMemberFragment = { __typename?: 'seller_member', isMainContact: boolean, user?: { __typename?: 'users', displayName: string, email?: string | null } | null };

export type GetCurrentMemberAsSellerMemberSubscriptionVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetCurrentMemberAsSellerMemberSubscription = { __typename?: 'subscription_root', seller_member: Array<{ __typename?: 'seller_member', isMainContact: boolean, user?: { __typename?: 'users', displayName: string, email?: string | null } | null }> };

export type CurrentMemberAsAgencyMemberFragment = { __typename?: 'agency_member', user?: { __typename?: 'users', displayName: string, email?: string | null } | null };

export type GetCurrentMemberAsAgencyMemberSubscriptionVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetCurrentMemberAsAgencyMemberSubscription = { __typename?: 'subscription_root', agency_member: Array<{ __typename?: 'agency_member', user?: { __typename?: 'users', displayName: string, email?: string | null } | null }> };

export type SearchBuyerMembersQueryVariables = Exact<{
  displayNameSearch: Scalars['String']['input'];
  emailSearch: Scalars['citext']['input'];
}>;


export type SearchBuyerMembersQuery = { __typename?: 'query_root', buyer_member: Array<{ __typename?: 'buyer_member', id: string, userId?: string | null, user?: { __typename?: 'users', displayName: string, email?: string | null, phoneNumber?: string | null } | null }> };

export type UpdateVisitIsVisitDoneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  isVisitDone: Scalars['Boolean']['input'];
}>;


export type UpdateVisitIsVisitDoneMutation = { __typename?: 'mutation_root', update_visit_by_pk?: { __typename?: 'visit', id: string, isVisitDone: boolean } | null };

export type DeleteVisitMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteVisitMutation = { __typename?: 'mutation_root', delete_visit_by_pk?: { __typename?: 'visit', id: string } | null };

export type UpdateVisitTimeMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  startTime: Scalars['timestamptz']['input'];
  endTime: Scalars['timestamptz']['input'];
}>;


export type UpdateVisitTimeMutation = { __typename?: 'mutation_root', update_visit_by_pk?: { __typename?: 'visit', id: string, startTime: string, endTime: string } | null };

export type CreateVisitMutationVariables = Exact<{
  estateId: Scalars['uuid']['input'];
  buyerId: Scalars['uuid']['input'];
  startTime: Scalars['timestamptz']['input'];
  endTime: Scalars['timestamptz']['input'];
}>;


export type CreateVisitMutation = { __typename?: 'mutation_root', insert_visit_one?: { __typename?: 'visit', id: string, startTime: string, endTime: string, estateId: string, buyerId: string } | null };

export type UpsertVisitSpanMutationVariables = Exact<{
  valuesToCreate: Array<Visit_Span_Insert_Input> | Visit_Span_Insert_Input;
  valuesToUpdate: Array<Visit_Span_Updates> | Visit_Span_Updates;
  idsToDelete: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UpsertVisitSpanMutation = { __typename?: 'mutation_root', insert_visit_span?: { __typename?: 'visit_span_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'visit_span', id: string, createdAt: string, span: Array<VisitSpanSpan>, estateId: string }> } | null, update_visit_span_many?: Array<{ __typename?: 'visit_span_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'visit_span', id: string, createdAt: string, span: Array<VisitSpanSpan>, estateId: string }> } | null> | null, delete_visit_span?: { __typename?: 'visit_span_mutation_response', affected_rows: number } | null };

export const ApplicationFragmentDoc = gql`
    fragment Application on application {
  id
  createdAt
  updatedAt
  submitDate
  archived
  status
  offerAmount
  contribution
  loan
  acquisitionAmount
  score
  tags
  comment
  notary
  alertOnHigherOffer
  acceptedDraftCompromise
  confirmOfferOnHonor
  dateConfirmConformityAndAcceptedPrivacyPolicy
  buyerId
  estateId
  roundId
  promiseOfSaleSignatureDate
  promiseOfSalesFileId
  authenticActSignatureDate
  authenticActFileId
  hasDraftBeenEdited
  cancellationDocumentFileId
  needsPropertySaleToFinanceAcquisition
  hasNoAdditionalSuspensiveCondition
  additionalSuspensiveConditionDescription
}
    `;
export const BuyerMemberFolderFragmentDoc = gql`
    fragment BuyerMemberFolder on buyer_member_folder {
  id
  address
  bankAccountBic
  bankAccountHolder
  bankAccountIban
  bankAccountRibFileId
  bankAccountBankAddress
  bankAccountBankName
  birthDate
  birthName
  birthPlace
  civility
  comment
  companyName
  countryOfTaxResidence
  emailAddress
  firstName
  fluentInFrench
  homePhone
  identityDocumentFileId
  individualOrLegalEntity
  kbisFileId
  languagesSpoken
  lastName
  legalForm
  maritalStatus
  mobilePhone
  nationality
  registeredOfficeAddress
  sirenNumber
  subjectToVat
  taxRegimeCompany
  vatNumber
  workPhone
  isBuyerLegalRepresentative
  legalRepresentativeFirstName
  legalRepresentativeLastName
  legalRepresentativeBirthName
  legalRepresentativeBirthDate
  legalRepresentativeBirthPlace
  legalRepresentativeNationality
  legalRepresentativeCivility
}
    `;
export const ApplicationMediaFragmentDoc = gql`
    fragment ApplicationMedia on application_media {
  id
  name
  fileId
  applicationId
  type
  file {
    mimeType
  }
}
    `;
export const ApplicationWithBuyerMemberFoldersFragmentDoc = gql`
    fragment ApplicationWithBuyerMemberFolders on application {
  ...Application
  buyer_member_folders {
    ...BuyerMemberFolder
  }
  hasDraftBeenEdited
  application_medias {
    ...ApplicationMedia
  }
}
    ${ApplicationFragmentDoc}
${BuyerMemberFolderFragmentDoc}
${ApplicationMediaFragmentDoc}`;
export const EstateSellerFragmentDoc = gql`
    fragment EstateSeller on estate_seller {
  sellerId
  estateId
  ownershipShare
}
    `;
export const EstateLinkFragmentDoc = gql`
    fragment EstateLink on estate_link {
  id
  name
  url
}
    `;
export const EstateRoundFragmentDoc = gql`
    fragment EstateRound on estate_round {
  id
  number
  isPublic
  startDate
  endDate
  closingEmailSent
  estateId
  opt_blindRound
  opt_enforceOfferGap
  opt_minOfferGap
  estate {
    isSaleOpen
  }
}
    `;
export const EstateRoundBuyerMemberFragmentDoc = gql`
    fragment EstateRoundBuyerMember on estate_round_buyer_member {
  buyerMemberId
  estateRoundId
}
    `;
export const MandateRegistryFragmentDoc = gql`
    fragment MandateRegistry on mandate_registry {
  orderNumber
  estateLabel
  objectLabel
  representativesAddress
  representativesNames
  generatedAt
  observations
}
    `;
export const SellerMemberAndItsSellerTypeFragmentDoc = gql`
    fragment SellerMemberAndItsSellerType on seller_member {
  id
  sellerId
  userId
  inviteEmail
  job
  invitePhone
  inviteDate
  hasSetPassword
  isMainContact
  seller {
    id
    type
  }
  user {
    displayName
    email
    metadata
    phoneNumber
  }
}
    `;
export const UserFragmentDoc = gql`
    fragment User on users {
  id
  phoneNumber
  displayName
  email
  metadata
}
    `;
export const AgencyFragmentDoc = gql`
    fragment Agency on agency {
  id
  name
}
    `;
export const AgencyMemberFragmentDoc = gql`
    fragment AgencyMember on agency_member {
  id
  userId
  picture
  inviteDate
  archived
  agencyId
  hasSetPassword
  inviteEmail
  user {
    displayName
    email
    metadata
  }
}
    `;
export const SellerFragmentDoc = gql`
    fragment Seller on seller {
  id
  archived
  createdAt
  slug
  name
  logo
  email
  linkUrl
  type
  legalStatus
  taxSystem
  businessName
  siren
  headquarter
  kbis
  tva
  tvaNumber
  civility
  firstName
  lastName
  birthName
  job
  maritalStatus
  address
  mobilePhone
  officePhone
  homePhone
  birthDate
  birthPlace
  nationality
  taxCountry
  idCard
  comment
  iban
  bic
  accountHolder
  bankName
  bankAddress
  rib
  agencyId
  comparution
  canEditAndCreateEstate
  hideBuyerContactInfo
}
    `;
export const AgencyWithMembersAndSellersFragmentDoc = gql`
    fragment AgencyWithMembersAndSellers on agency {
  ...Agency
  agency_members {
    ...AgencyMember
  }
  sellers {
    ...Seller
  }
}
    ${AgencyFragmentDoc}
${AgencyMemberFragmentDoc}
${SellerFragmentDoc}`;
export const BuyerMemberFragmentDoc = gql`
    fragment BuyerMember on buyer_member {
  id
  userId
  user {
    displayName
    email
    phoneNumber
  }
}
    `;
export const VisitFragmentDoc = gql`
    fragment Visit on visit {
  id
  createdAt
  startTime
  endTime
  isVisitDone
  spanId
  buyerId
  estateId
}
    `;
export const WebappApplicationFragmentDoc = gql`
    fragment WebappApplication on application {
  ...Application
  buyer_member {
    ...BuyerMember
    visits(where: {estateId: {_eq: $estateId}}) {
      ...Visit
    }
  }
  application_medias {
    ...ApplicationMedia
  }
  estate {
    mandate {
      fixedFee
      proportionalFeesRate
      feeVATRate
      fixedFeeThreshold
    }
    seller {
      hideBuyerContactInfo
    }
  }
  round {
    number
  }
}
    ${ApplicationFragmentDoc}
${BuyerMemberFragmentDoc}
${VisitFragmentDoc}
${ApplicationMediaFragmentDoc}`;
export const EstateFragmentDoc = gql`
    fragment Estate on estate {
  id
  name
  address
  city
  zipCode
  type
  archived
  startEstimate
  endEstimate
  isPublished
  isSaleOpen
  servicesAndConditions
  features
  coownership
  diagnosticsData
  virtualVisits
  firstPrice
  reservePrice
  sellerData
  publicationTitle
  publicationDescription
  publicationMention
  canConnectedBuyerSeeAddress
  maxVisitPerSlot
  visitSlotDuration
  missionHeadId
  sellerId
  currentRoundId
  estateRounds {
    id
    number
    isPublic
    startDate
    endDate
    closingEmailSent
    estateId
    opt_blindRound
    opt_enforceOfferGap
    opt_minOfferGap
  }
}
    `;
export const SellerMemberFragmentDoc = gql`
    fragment SellerMember on seller_member {
  id
  sellerId
  archived
  description
  pictureFileId
  picture
  userId
  invitePhone
  inviteEmail
  inviteDate
  job
  isMainContact
  hasSetPassword
  user {
    phoneNumber
    email
    displayName
    metadata
  }
}
    `;
export const VisitSpanFragmentDoc = gql`
    fragment VisitSpan on visit_span {
  id
  createdAt
  span
  estateId
}
    `;
export const WebappEstateFragmentDoc = gql`
    fragment WebappEstate on estate {
  ...Estate
  estimationAskedBy {
    ...SellerMember
  }
  estimationAskedDate
  estimationPublishedDate
  visit_spans {
    ...VisitSpan
    visits {
      ...Visit
    }
  }
  currentRoundId
  applications {
    status
  }
  mission_head {
    user {
      displayName
    }
  }
  seller {
    ...Seller
    agency {
      name
    }
  }
  estate_sellers {
    estateId
    sellerId
    seller {
      ...Seller
    }
  }
  mandate {
    id
    fixedFeeThreshold
    fixedFee
    feeVATRate
    proportionalFeesRate
    firstPrice
    reservePrice
    mandate_media {
      id
    }
  }
  estate_links {
    id
    name
    url
  }
}
    ${EstateFragmentDoc}
${SellerMemberFragmentDoc}
${VisitSpanFragmentDoc}
${VisitFragmentDoc}
${SellerFragmentDoc}`;
export const WebappSimpleEstateFragmentDoc = gql`
    fragment WebappSimpleEstate on estate {
  createdAt
  id
  isPublished
  isSaleOpen
  applicationAcceptedDate
  address
  zipCode
  city
  name
  startEstimate
  endEstimate
  firstPrice
  reservePrice
  features
  archived
  type
  estimationPublishedDate
  sellerId
  currentRoundId
  estateRounds {
    id
    number
    isPublic
    startDate
    endDate
  }
  seller {
    id
    name
  }
  estate_sellers {
    estateId
    sellerId
  }
  missionHeadId
  mission_head {
    user {
      displayName
    }
  }
  mandate {
    mandate_registry {
      orderNumber
    }
    mainSignDate
    mandate_media {
      id
    }
  }
}
    `;
export const ApplicationIdAndStatusFragmentDoc = gql`
    fragment ApplicationIdAndStatus on application {
  estateId
  status
  promiseOfSaleSignatureDate
  promiseOfSalesFileId
  authenticActSignatureDate
  authenticActFileId
}
    `;
export const EstateForTableFragmentDoc = gql`
    fragment EstateForTable on estate {
  ...WebappSimpleEstate
  applications {
    ...ApplicationIdAndStatus
    buyer_member {
      visits {
        id
      }
    }
    hasDraftBeenEdited
  }
  visits {
    id
    isVisitDone
  }
}
    ${WebappSimpleEstateFragmentDoc}
${ApplicationIdAndStatusFragmentDoc}`;
export const EstateForSidebarFragmentDoc = gql`
    fragment EstateForSidebar on estate {
  id
  missionHeadId
  isPublished
  applicationAcceptedDate
  name
  address
  zipCode
  city
  isSaleOpen
  archived
  currentRoundId
  estateRounds {
    id
    number
    isPublic
    startDate
    endDate
  }
  applications {
    ...ApplicationIdAndStatus
  }
}
    ${ApplicationIdAndStatusFragmentDoc}`;
export const EstateForSellersPageFragmentDoc = gql`
    fragment EstateForSellersPage on estate {
  id
  sellerId
  seller {
    id
    name
  }
  sellerData
  mandate {
    id
    mandate_registry {
      orderNumber
    }
  }
}
    `;
export const EstateForMainPageFragmentDoc = gql`
    fragment EstateForMainPage on estate {
  id
  type
  archived
  name
  address
  zipCode
  city
  features
  servicesAndConditions
  coownership
  publicationTitle
  publicationDescription
  publicationMention
  canConnectedBuyerSeeAddress
  startEstimate
  endEstimate
  estimationAskedBy {
    id
    user {
      displayName
    }
  }
  estimationAskedDate
  estimationPublishedDate
  mandate {
    id
    mandate_registry {
      orderNumber
    }
  }
}
    `;
export const EstateForDocumentsPageFragmentDoc = gql`
    fragment EstateForDocumentsPage on estate {
  id
  coownership
  diagnosticsData
}
    `;
export const EstateForMediasPageFragmentDoc = gql`
    fragment EstateForMediasPage on estate {
  id
  virtualVisits
}
    `;
export const EstateForMandatePageFragmentDoc = gql`
    fragment EstateForMandatePage on estate {
  id
  type
  address
  zipCode
  city
  seller {
    id
    name
    type
    headquarter
    address
    agencyId
  }
  estate_sellers {
    estateId
    sellerId
    seller {
      id
      name
      type
      headquarter
      address
    }
  }
  mandate {
    id
  }
}
    `;
export const EstateForSalePageFragmentDoc = gql`
    fragment EstateForSalePage on estate {
  id
  isPublished
  isSaleOpen
  applicationAcceptedDate
  archived
  address
  firstPrice
  reservePrice
  estate_links {
    id
    name
    url
  }
  estateRounds {
    id
    startDate
    endDate
    number
    isPublic
    opt_blindRound
    opt_enforceOfferGap
    opt_minOfferGap
    estateRoundBuyerMembers {
      buyerMemberId
    }
  }
  currentRoundId
  seller {
    id
    agency {
      name
    }
  }
  mandate {
    id
    fixedFeeThreshold
    fixedFee
    feeVATRate
    proportionalFeesRate
  }
  visit_spans {
    id
    span
  }
  visitSlotDuration
  maxVisitPerSlot
  visits {
    id
    isVisitDone
  }
  applications {
    status
    buyer_member {
      visits {
        id
      }
    }
    hasDraftBeenEdited
  }
}
    `;
export const EstateMediaFragmentDoc = gql`
    fragment EstateMedia on estate_media {
  id
  name
  estateId
  typeId
  position
  isCensored
  originalVersionId
  fileId
}
    `;
export const FileFragmentDoc = gql`
    fragment File on files {
  id
  name
  size
  mimeType
}
    `;
export const EstateMediaTypeFragmentDoc = gql`
    fragment EstateMediaType on estate_media_type {
  id
  name
  group
  hasCensoredVersion
  needVisitDone
}
    `;
export const WebappEstateMediaFragmentDoc = gql`
    fragment WebappEstateMedia on estate_media {
  ...EstateMedia
  file {
    ...File
  }
  type {
    ...EstateMediaType
  }
  censoredVersion {
    ...EstateMedia
    file {
      ...File
    }
    type {
      ...EstateMediaType
    }
  }
}
    ${EstateMediaFragmentDoc}
${FileFragmentDoc}
${EstateMediaTypeFragmentDoc}`;
export const MandateFragmentDoc = gql`
    fragment Mandate on mandate {
  id
  createdAt
  type
  amendmentNumber
  precontractualDate
  mainSignDate
  reservePrice
  firstPrice
  effectiveDate
  initialDuration
  renewalDuration
  maxRenewal
  fixedFee
  fixedFeeThreshold
  feeVATRate
  proportionalFeesRate
  feePerson
  particularConditions
  earnedMoney
  earnedMoneyPaid
  cancellationDate
  effectiveCancellationDate
  status
  mandate_registry {
    orderNumber
    estateLabel
    objectLabel
    representativesAddress
    representativesNames
    generatedAt
    observations
  }
}
    `;
export const MandateMediaFragmentDoc = gql`
    fragment MandateMedia on mandate_media {
  id
  mandateId
  fileId
  created_at
}
    `;
export const WebappMandateFragmentDoc = gql`
    fragment WebappMandate on mandate {
  ...Mandate
  mandate_media {
    ...MandateMedia
  }
}
    ${MandateFragmentDoc}
${MandateMediaFragmentDoc}`;
export const SellerWithAgencyFragmentDoc = gql`
    fragment SellerWithAgency on seller {
  ...Seller
  agency {
    ...Agency
  }
}
    ${SellerFragmentDoc}
${AgencyFragmentDoc}`;
export const SellerWithAgencyAndMembersFragmentDoc = gql`
    fragment SellerWithAgencyAndMembers on seller {
  ...SellerWithAgency
  seller_members(where: {archived: {_eq: false}}) {
    ...SellerMember
  }
}
    ${SellerWithAgencyFragmentDoc}
${SellerMemberFragmentDoc}`;
export const SellerMemberWithUserAndSellerNamesFragmentDoc = gql`
    fragment SellerMemberWithUserAndSellerNames on seller_member {
  ...SellerMember
  user {
    id
    displayName
    email
  }
  seller {
    id
    name
  }
}
    ${SellerMemberFragmentDoc}`;
export const CurrentMemberAsSellerMemberFragmentDoc = gql`
    fragment CurrentMemberAsSellerMember on seller_member {
  isMainContact
  user {
    displayName
    email
  }
}
    `;
export const CurrentMemberAsAgencyMemberFragmentDoc = gql`
    fragment CurrentMemberAsAgencyMember on agency_member {
  user {
    displayName
    email
  }
}
    `;
export const CreateAgencyMemberDocument = gql`
    mutation createAgencyMember($inviteEmail: String!, $inviteDate: timestamptz!, $agencyId: uuid!) {
  insert_agency_member_one(
    object: {inviteEmail: $inviteEmail, inviteDate: $inviteDate, agencyId: $agencyId}
  ) {
    id
  }
}
    `;
export type CreateAgencyMemberMutationFn = Apollo.MutationFunction<CreateAgencyMemberMutation, CreateAgencyMemberMutationVariables>;

/**
 * __useCreateAgencyMemberMutation__
 *
 * To run a mutation, you first call `useCreateAgencyMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgencyMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgencyMemberMutation, { data, loading, error }] = useCreateAgencyMemberMutation({
 *   variables: {
 *      inviteEmail: // value for 'inviteEmail'
 *      inviteDate: // value for 'inviteDate'
 *      agencyId: // value for 'agencyId'
 *   },
 * });
 */
export function useCreateAgencyMemberMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgencyMemberMutation, CreateAgencyMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgencyMemberMutation, CreateAgencyMemberMutationVariables>(CreateAgencyMemberDocument, options);
      }
export type CreateAgencyMemberMutationHookResult = ReturnType<typeof useCreateAgencyMemberMutation>;
export type CreateAgencyMemberMutationResult = Apollo.MutationResult<CreateAgencyMemberMutation>;
export type CreateAgencyMemberMutationOptions = Apollo.BaseMutationOptions<CreateAgencyMemberMutation, CreateAgencyMemberMutationVariables>;
export const GetAgencyMemberDocument = gql`
    query getAgencyMember($id: uuid!) {
  agency_member_by_pk(id: $id) {
    ...AgencyMember
  }
}
    ${AgencyMemberFragmentDoc}`;

/**
 * __useGetAgencyMemberQuery__
 *
 * To run a query within a React component, call `useGetAgencyMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyMemberQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAgencyMemberQuery(baseOptions: Apollo.QueryHookOptions<GetAgencyMemberQuery, GetAgencyMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyMemberQuery, GetAgencyMemberQueryVariables>(GetAgencyMemberDocument, options);
      }
export function useGetAgencyMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyMemberQuery, GetAgencyMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyMemberQuery, GetAgencyMemberQueryVariables>(GetAgencyMemberDocument, options);
        }
export type GetAgencyMemberQueryHookResult = ReturnType<typeof useGetAgencyMemberQuery>;
export type GetAgencyMemberLazyQueryHookResult = ReturnType<typeof useGetAgencyMemberLazyQuery>;
export type GetAgencyMemberQueryResult = Apollo.QueryResult<GetAgencyMemberQuery, GetAgencyMemberQueryVariables>;
export function refetchGetAgencyMemberQuery(variables: GetAgencyMemberQueryVariables) {
      return { query: GetAgencyMemberDocument, variables: variables }
    }
export const GetAgencyMemberByUserIdDocument = gql`
    query getAgencyMemberByUserId($id: uuid!) {
  agency_member(where: {userId: {_eq: $id}}, limit: 1) {
    ...AgencyMember
  }
}
    ${AgencyMemberFragmentDoc}`;

/**
 * __useGetAgencyMemberByUserIdQuery__
 *
 * To run a query within a React component, call `useGetAgencyMemberByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyMemberByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyMemberByUserIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAgencyMemberByUserIdQuery(baseOptions: Apollo.QueryHookOptions<GetAgencyMemberByUserIdQuery, GetAgencyMemberByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyMemberByUserIdQuery, GetAgencyMemberByUserIdQueryVariables>(GetAgencyMemberByUserIdDocument, options);
      }
export function useGetAgencyMemberByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyMemberByUserIdQuery, GetAgencyMemberByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyMemberByUserIdQuery, GetAgencyMemberByUserIdQueryVariables>(GetAgencyMemberByUserIdDocument, options);
        }
export type GetAgencyMemberByUserIdQueryHookResult = ReturnType<typeof useGetAgencyMemberByUserIdQuery>;
export type GetAgencyMemberByUserIdLazyQueryHookResult = ReturnType<typeof useGetAgencyMemberByUserIdLazyQuery>;
export type GetAgencyMemberByUserIdQueryResult = Apollo.QueryResult<GetAgencyMemberByUserIdQuery, GetAgencyMemberByUserIdQueryVariables>;
export function refetchGetAgencyMemberByUserIdQuery(variables: GetAgencyMemberByUserIdQueryVariables) {
      return { query: GetAgencyMemberByUserIdDocument, variables: variables }
    }
export const GetAgencyMemberByEmailDocument = gql`
    query getAgencyMemberByEmail($email: String!) {
  agency_member(where: {inviteEmail: {_eq: $email}}, limit: 1) {
    ...AgencyMember
  }
}
    ${AgencyMemberFragmentDoc}`;

/**
 * __useGetAgencyMemberByEmailQuery__
 *
 * To run a query within a React component, call `useGetAgencyMemberByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyMemberByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyMemberByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetAgencyMemberByEmailQuery(baseOptions: Apollo.QueryHookOptions<GetAgencyMemberByEmailQuery, GetAgencyMemberByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyMemberByEmailQuery, GetAgencyMemberByEmailQueryVariables>(GetAgencyMemberByEmailDocument, options);
      }
export function useGetAgencyMemberByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyMemberByEmailQuery, GetAgencyMemberByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyMemberByEmailQuery, GetAgencyMemberByEmailQueryVariables>(GetAgencyMemberByEmailDocument, options);
        }
export type GetAgencyMemberByEmailQueryHookResult = ReturnType<typeof useGetAgencyMemberByEmailQuery>;
export type GetAgencyMemberByEmailLazyQueryHookResult = ReturnType<typeof useGetAgencyMemberByEmailLazyQuery>;
export type GetAgencyMemberByEmailQueryResult = Apollo.QueryResult<GetAgencyMemberByEmailQuery, GetAgencyMemberByEmailQueryVariables>;
export function refetchGetAgencyMemberByEmailQuery(variables: GetAgencyMemberByEmailQueryVariables) {
      return { query: GetAgencyMemberByEmailDocument, variables: variables }
    }
export const UpdateAgencyMemberDocument = gql`
    mutation updateAgencyMember($id: uuid!, $values: agency_member_set_input!) {
  update_agency_member_by_pk(pk_columns: {id: $id}, _set: $values) {
    ...AgencyMember
  }
}
    ${AgencyMemberFragmentDoc}`;
export type UpdateAgencyMemberMutationFn = Apollo.MutationFunction<UpdateAgencyMemberMutation, UpdateAgencyMemberMutationVariables>;

/**
 * __useUpdateAgencyMemberMutation__
 *
 * To run a mutation, you first call `useUpdateAgencyMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgencyMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgencyMemberMutation, { data, loading, error }] = useUpdateAgencyMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpdateAgencyMemberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAgencyMemberMutation, UpdateAgencyMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAgencyMemberMutation, UpdateAgencyMemberMutationVariables>(UpdateAgencyMemberDocument, options);
      }
export type UpdateAgencyMemberMutationHookResult = ReturnType<typeof useUpdateAgencyMemberMutation>;
export type UpdateAgencyMemberMutationResult = Apollo.MutationResult<UpdateAgencyMemberMutation>;
export type UpdateAgencyMemberMutationOptions = Apollo.BaseMutationOptions<UpdateAgencyMemberMutation, UpdateAgencyMemberMutationVariables>;
export const GetUserApplicationsWithBuyerMemberFoldersDocument = gql`
    query getUserApplicationsWithBuyerMemberFolders($estateId: uuid!, $buyerMemberId: uuid!) {
  application(
    where: {estateId: {_eq: $estateId}, buyerId: {_eq: $buyerMemberId}}
    order_by: {createdAt: desc}
  ) {
    ...ApplicationWithBuyerMemberFolders
  }
}
    ${ApplicationWithBuyerMemberFoldersFragmentDoc}`;

/**
 * __useGetUserApplicationsWithBuyerMemberFoldersQuery__
 *
 * To run a query within a React component, call `useGetUserApplicationsWithBuyerMemberFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserApplicationsWithBuyerMemberFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserApplicationsWithBuyerMemberFoldersQuery({
 *   variables: {
 *      estateId: // value for 'estateId'
 *      buyerMemberId: // value for 'buyerMemberId'
 *   },
 * });
 */
export function useGetUserApplicationsWithBuyerMemberFoldersQuery(baseOptions: Apollo.QueryHookOptions<GetUserApplicationsWithBuyerMemberFoldersQuery, GetUserApplicationsWithBuyerMemberFoldersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserApplicationsWithBuyerMemberFoldersQuery, GetUserApplicationsWithBuyerMemberFoldersQueryVariables>(GetUserApplicationsWithBuyerMemberFoldersDocument, options);
      }
export function useGetUserApplicationsWithBuyerMemberFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserApplicationsWithBuyerMemberFoldersQuery, GetUserApplicationsWithBuyerMemberFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserApplicationsWithBuyerMemberFoldersQuery, GetUserApplicationsWithBuyerMemberFoldersQueryVariables>(GetUserApplicationsWithBuyerMemberFoldersDocument, options);
        }
export type GetUserApplicationsWithBuyerMemberFoldersQueryHookResult = ReturnType<typeof useGetUserApplicationsWithBuyerMemberFoldersQuery>;
export type GetUserApplicationsWithBuyerMemberFoldersLazyQueryHookResult = ReturnType<typeof useGetUserApplicationsWithBuyerMemberFoldersLazyQuery>;
export type GetUserApplicationsWithBuyerMemberFoldersQueryResult = Apollo.QueryResult<GetUserApplicationsWithBuyerMemberFoldersQuery, GetUserApplicationsWithBuyerMemberFoldersQueryVariables>;
export function refetchGetUserApplicationsWithBuyerMemberFoldersQuery(variables: GetUserApplicationsWithBuyerMemberFoldersQueryVariables) {
      return { query: GetUserApplicationsWithBuyerMemberFoldersDocument, variables: variables }
    }
export const UpdateUserApplicationDocument = gql`
    mutation updateUserApplication($id: uuid!, $values: application_set_input!) {
  update_application_by_pk(pk_columns: {id: $id}, _set: $values) {
    ...Application
  }
}
    ${ApplicationFragmentDoc}`;
export type UpdateUserApplicationMutationFn = Apollo.MutationFunction<UpdateUserApplicationMutation, UpdateUserApplicationMutationVariables>;

/**
 * __useUpdateUserApplicationMutation__
 *
 * To run a mutation, you first call `useUpdateUserApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserApplicationMutation, { data, loading, error }] = useUpdateUserApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpdateUserApplicationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserApplicationMutation, UpdateUserApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserApplicationMutation, UpdateUserApplicationMutationVariables>(UpdateUserApplicationDocument, options);
      }
export type UpdateUserApplicationMutationHookResult = ReturnType<typeof useUpdateUserApplicationMutation>;
export type UpdateUserApplicationMutationResult = Apollo.MutationResult<UpdateUserApplicationMutation>;
export type UpdateUserApplicationMutationOptions = Apollo.BaseMutationOptions<UpdateUserApplicationMutation, UpdateUserApplicationMutationVariables>;
export const CreateBuyerMemberDocument = gql`
    mutation createBuyerMember($values: buyer_member_insert_input!) {
  insert_buyer_member_one(object: $values) {
    id
    userId
  }
}
    `;
export type CreateBuyerMemberMutationFn = Apollo.MutationFunction<CreateBuyerMemberMutation, CreateBuyerMemberMutationVariables>;

/**
 * __useCreateBuyerMemberMutation__
 *
 * To run a mutation, you first call `useCreateBuyerMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBuyerMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBuyerMemberMutation, { data, loading, error }] = useCreateBuyerMemberMutation({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useCreateBuyerMemberMutation(baseOptions?: Apollo.MutationHookOptions<CreateBuyerMemberMutation, CreateBuyerMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBuyerMemberMutation, CreateBuyerMemberMutationVariables>(CreateBuyerMemberDocument, options);
      }
export type CreateBuyerMemberMutationHookResult = ReturnType<typeof useCreateBuyerMemberMutation>;
export type CreateBuyerMemberMutationResult = Apollo.MutationResult<CreateBuyerMemberMutation>;
export type CreateBuyerMemberMutationOptions = Apollo.BaseMutationOptions<CreateBuyerMemberMutation, CreateBuyerMemberMutationVariables>;
export const UpdateBuyerMemberDocument = gql`
    mutation updateBuyerMember($id: uuid!, $values: buyer_member_set_input!) {
  update_buyer_member_by_pk(pk_columns: {id: $id}, _set: $values) {
    id
  }
}
    `;
export type UpdateBuyerMemberMutationFn = Apollo.MutationFunction<UpdateBuyerMemberMutation, UpdateBuyerMemberMutationVariables>;

/**
 * __useUpdateBuyerMemberMutation__
 *
 * To run a mutation, you first call `useUpdateBuyerMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBuyerMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBuyerMemberMutation, { data, loading, error }] = useUpdateBuyerMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpdateBuyerMemberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBuyerMemberMutation, UpdateBuyerMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBuyerMemberMutation, UpdateBuyerMemberMutationVariables>(UpdateBuyerMemberDocument, options);
      }
export type UpdateBuyerMemberMutationHookResult = ReturnType<typeof useUpdateBuyerMemberMutation>;
export type UpdateBuyerMemberMutationResult = Apollo.MutationResult<UpdateBuyerMemberMutation>;
export type UpdateBuyerMemberMutationOptions = Apollo.BaseMutationOptions<UpdateBuyerMemberMutation, UpdateBuyerMemberMutationVariables>;
export const GetBuyerMemberDocument = gql`
    query getBuyerMember($id: uuid!) {
  buyer_member_by_pk(id: $id) {
    ...BuyerMember
  }
}
    ${BuyerMemberFragmentDoc}`;

/**
 * __useGetBuyerMemberQuery__
 *
 * To run a query within a React component, call `useGetBuyerMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuyerMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuyerMemberQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBuyerMemberQuery(baseOptions: Apollo.QueryHookOptions<GetBuyerMemberQuery, GetBuyerMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBuyerMemberQuery, GetBuyerMemberQueryVariables>(GetBuyerMemberDocument, options);
      }
export function useGetBuyerMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBuyerMemberQuery, GetBuyerMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBuyerMemberQuery, GetBuyerMemberQueryVariables>(GetBuyerMemberDocument, options);
        }
export type GetBuyerMemberQueryHookResult = ReturnType<typeof useGetBuyerMemberQuery>;
export type GetBuyerMemberLazyQueryHookResult = ReturnType<typeof useGetBuyerMemberLazyQuery>;
export type GetBuyerMemberQueryResult = Apollo.QueryResult<GetBuyerMemberQuery, GetBuyerMemberQueryVariables>;
export function refetchGetBuyerMemberQuery(variables: GetBuyerMemberQueryVariables) {
      return { query: GetBuyerMemberDocument, variables: variables }
    }
export const GetEstateDocument = gql`
    query getEstate($id: uuid!) {
  estate_by_pk(id: $id) {
    ...Estate
  }
}
    ${EstateFragmentDoc}`;

/**
 * __useGetEstateQuery__
 *
 * To run a query within a React component, call `useGetEstateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEstateQuery(baseOptions: Apollo.QueryHookOptions<GetEstateQuery, GetEstateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEstateQuery, GetEstateQueryVariables>(GetEstateDocument, options);
      }
export function useGetEstateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEstateQuery, GetEstateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEstateQuery, GetEstateQueryVariables>(GetEstateDocument, options);
        }
export type GetEstateQueryHookResult = ReturnType<typeof useGetEstateQuery>;
export type GetEstateLazyQueryHookResult = ReturnType<typeof useGetEstateLazyQuery>;
export type GetEstateQueryResult = Apollo.QueryResult<GetEstateQuery, GetEstateQueryVariables>;
export function refetchGetEstateQuery(variables: GetEstateQueryVariables) {
      return { query: GetEstateDocument, variables: variables }
    }
export const CreateSellerMemberDocument = gql`
    mutation createSellerMember($inviteEmail: String!, $inviteDate: timestamptz!, $sellerId: uuid!, $isMainContact: Boolean!) {
  insert_seller_member_one(
    object: {inviteEmail: $inviteEmail, inviteDate: $inviteDate, sellerId: $sellerId, isMainContact: $isMainContact}
  ) {
    id
  }
}
    `;
export type CreateSellerMemberMutationFn = Apollo.MutationFunction<CreateSellerMemberMutation, CreateSellerMemberMutationVariables>;

/**
 * __useCreateSellerMemberMutation__
 *
 * To run a mutation, you first call `useCreateSellerMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSellerMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSellerMemberMutation, { data, loading, error }] = useCreateSellerMemberMutation({
 *   variables: {
 *      inviteEmail: // value for 'inviteEmail'
 *      inviteDate: // value for 'inviteDate'
 *      sellerId: // value for 'sellerId'
 *      isMainContact: // value for 'isMainContact'
 *   },
 * });
 */
export function useCreateSellerMemberMutation(baseOptions?: Apollo.MutationHookOptions<CreateSellerMemberMutation, CreateSellerMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSellerMemberMutation, CreateSellerMemberMutationVariables>(CreateSellerMemberDocument, options);
      }
export type CreateSellerMemberMutationHookResult = ReturnType<typeof useCreateSellerMemberMutation>;
export type CreateSellerMemberMutationResult = Apollo.MutationResult<CreateSellerMemberMutation>;
export type CreateSellerMemberMutationOptions = Apollo.BaseMutationOptions<CreateSellerMemberMutation, CreateSellerMemberMutationVariables>;
export const UpdateSellerMemberDocument = gql`
    mutation updateSellerMember($id: uuid!, $values: seller_member_set_input!) {
  update_seller_member_by_pk(pk_columns: {id: $id}, _set: $values) {
    ...SellerMember
  }
}
    ${SellerMemberFragmentDoc}`;
export type UpdateSellerMemberMutationFn = Apollo.MutationFunction<UpdateSellerMemberMutation, UpdateSellerMemberMutationVariables>;

/**
 * __useUpdateSellerMemberMutation__
 *
 * To run a mutation, you first call `useUpdateSellerMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSellerMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSellerMemberMutation, { data, loading, error }] = useUpdateSellerMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpdateSellerMemberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSellerMemberMutation, UpdateSellerMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSellerMemberMutation, UpdateSellerMemberMutationVariables>(UpdateSellerMemberDocument, options);
      }
export type UpdateSellerMemberMutationHookResult = ReturnType<typeof useUpdateSellerMemberMutation>;
export type UpdateSellerMemberMutationResult = Apollo.MutationResult<UpdateSellerMemberMutation>;
export type UpdateSellerMemberMutationOptions = Apollo.BaseMutationOptions<UpdateSellerMemberMutation, UpdateSellerMemberMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($id: uuid!, $values: users_set_input!) {
  updateUser(pk_columns: {id: $id}, _set: $values) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($id: uuid!) {
  deleteUser(id: $id) {
    id
  }
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const GetUserByEmailDocument = gql`
    query getUserByEmail($email: citext!) {
  users(where: {email: {_eq: $email}}) {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useGetUserByEmailQuery__
 *
 * To run a query within a React component, call `useGetUserByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetUserByEmailQuery(baseOptions: Apollo.QueryHookOptions<GetUserByEmailQuery, GetUserByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByEmailQuery, GetUserByEmailQueryVariables>(GetUserByEmailDocument, options);
      }
export function useGetUserByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByEmailQuery, GetUserByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByEmailQuery, GetUserByEmailQueryVariables>(GetUserByEmailDocument, options);
        }
export type GetUserByEmailQueryHookResult = ReturnType<typeof useGetUserByEmailQuery>;
export type GetUserByEmailLazyQueryHookResult = ReturnType<typeof useGetUserByEmailLazyQuery>;
export type GetUserByEmailQueryResult = Apollo.QueryResult<GetUserByEmailQuery, GetUserByEmailQueryVariables>;
export function refetchGetUserByEmailQuery(variables: GetUserByEmailQueryVariables) {
      return { query: GetUserByEmailDocument, variables: variables }
    }
export const AgenciesDocument = gql`
    subscription agencies {
  agency(order_by: {name: asc}) {
    ...AgencyWithMembersAndSellers
  }
}
    ${AgencyWithMembersAndSellersFragmentDoc}`;

/**
 * __useAgenciesSubscription__
 *
 * To run a query within a React component, call `useAgenciesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAgenciesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgenciesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useAgenciesSubscription(baseOptions?: Apollo.SubscriptionHookOptions<AgenciesSubscription, AgenciesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AgenciesSubscription, AgenciesSubscriptionVariables>(AgenciesDocument, options);
      }
export type AgenciesSubscriptionHookResult = ReturnType<typeof useAgenciesSubscription>;
export type AgenciesSubscriptionResult = Apollo.SubscriptionResult<AgenciesSubscription>;
export const GetAgencyMembersDocument = gql`
    query getAgencyMembers($agencyId: uuid!, $archived: Boolean!) {
  agency_member(where: {agencyId: {_eq: $agencyId}, archived: {_eq: $archived}}) {
    ...AgencyMember
  }
}
    ${AgencyMemberFragmentDoc}`;

/**
 * __useGetAgencyMembersQuery__
 *
 * To run a query within a React component, call `useGetAgencyMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyMembersQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useGetAgencyMembersQuery(baseOptions: Apollo.QueryHookOptions<GetAgencyMembersQuery, GetAgencyMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyMembersQuery, GetAgencyMembersQueryVariables>(GetAgencyMembersDocument, options);
      }
export function useGetAgencyMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyMembersQuery, GetAgencyMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyMembersQuery, GetAgencyMembersQueryVariables>(GetAgencyMembersDocument, options);
        }
export type GetAgencyMembersQueryHookResult = ReturnType<typeof useGetAgencyMembersQuery>;
export type GetAgencyMembersLazyQueryHookResult = ReturnType<typeof useGetAgencyMembersLazyQuery>;
export type GetAgencyMembersQueryResult = Apollo.QueryResult<GetAgencyMembersQuery, GetAgencyMembersQueryVariables>;
export function refetchGetAgencyMembersQuery(variables: GetAgencyMembersQueryVariables) {
      return { query: GetAgencyMembersDocument, variables: variables }
    }
export const AgencyMembersDocument = gql`
    subscription agencyMembers {
  agency_member(
    order_by: {user: {displayName: asc}}
    where: {archived: {_eq: false}}
  ) {
    ...AgencyMember
  }
}
    ${AgencyMemberFragmentDoc}`;

/**
 * __useAgencyMembersSubscription__
 *
 * To run a query within a React component, call `useAgencyMembersSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAgencyMembersSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgencyMembersSubscription({
 *   variables: {
 *   },
 * });
 */
export function useAgencyMembersSubscription(baseOptions?: Apollo.SubscriptionHookOptions<AgencyMembersSubscription, AgencyMembersSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AgencyMembersSubscription, AgencyMembersSubscriptionVariables>(AgencyMembersDocument, options);
      }
export type AgencyMembersSubscriptionHookResult = ReturnType<typeof useAgencyMembersSubscription>;
export type AgencyMembersSubscriptionResult = Apollo.SubscriptionResult<AgencyMembersSubscription>;
export const DeleteAgencyMemberDocument = gql`
    mutation deleteAgencyMember($id: uuid!) {
  delete_agency_member_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteAgencyMemberMutationFn = Apollo.MutationFunction<DeleteAgencyMemberMutation, DeleteAgencyMemberMutationVariables>;

/**
 * __useDeleteAgencyMemberMutation__
 *
 * To run a mutation, you first call `useDeleteAgencyMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAgencyMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAgencyMemberMutation, { data, loading, error }] = useDeleteAgencyMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAgencyMemberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAgencyMemberMutation, DeleteAgencyMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAgencyMemberMutation, DeleteAgencyMemberMutationVariables>(DeleteAgencyMemberDocument, options);
      }
export type DeleteAgencyMemberMutationHookResult = ReturnType<typeof useDeleteAgencyMemberMutation>;
export type DeleteAgencyMemberMutationResult = Apollo.MutationResult<DeleteAgencyMemberMutation>;
export type DeleteAgencyMemberMutationOptions = Apollo.BaseMutationOptions<DeleteAgencyMemberMutation, DeleteAgencyMemberMutationVariables>;
export const GetApplicationsStatusesByEstatesIdsDocument = gql`
    query getApplicationsStatusesByEstatesIds($estateIds: [uuid!]!) {
  application(where: {estateId: {_in: $estateIds}}) {
    ...ApplicationIdAndStatus
  }
}
    ${ApplicationIdAndStatusFragmentDoc}`;

/**
 * __useGetApplicationsStatusesByEstatesIdsQuery__
 *
 * To run a query within a React component, call `useGetApplicationsStatusesByEstatesIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationsStatusesByEstatesIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationsStatusesByEstatesIdsQuery({
 *   variables: {
 *      estateIds: // value for 'estateIds'
 *   },
 * });
 */
export function useGetApplicationsStatusesByEstatesIdsQuery(baseOptions: Apollo.QueryHookOptions<GetApplicationsStatusesByEstatesIdsQuery, GetApplicationsStatusesByEstatesIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationsStatusesByEstatesIdsQuery, GetApplicationsStatusesByEstatesIdsQueryVariables>(GetApplicationsStatusesByEstatesIdsDocument, options);
      }
export function useGetApplicationsStatusesByEstatesIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationsStatusesByEstatesIdsQuery, GetApplicationsStatusesByEstatesIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationsStatusesByEstatesIdsQuery, GetApplicationsStatusesByEstatesIdsQueryVariables>(GetApplicationsStatusesByEstatesIdsDocument, options);
        }
export type GetApplicationsStatusesByEstatesIdsQueryHookResult = ReturnType<typeof useGetApplicationsStatusesByEstatesIdsQuery>;
export type GetApplicationsStatusesByEstatesIdsLazyQueryHookResult = ReturnType<typeof useGetApplicationsStatusesByEstatesIdsLazyQuery>;
export type GetApplicationsStatusesByEstatesIdsQueryResult = Apollo.QueryResult<GetApplicationsStatusesByEstatesIdsQuery, GetApplicationsStatusesByEstatesIdsQueryVariables>;
export function refetchGetApplicationsStatusesByEstatesIdsQuery(variables: GetApplicationsStatusesByEstatesIdsQueryVariables) {
      return { query: GetApplicationsStatusesByEstatesIdsDocument, variables: variables }
    }
export const GetApplicationsDocument = gql`
    query getApplications($estateId: uuid!) {
  application(where: {estateId: {_eq: $estateId}}) {
    ...Application
  }
}
    ${ApplicationFragmentDoc}`;

/**
 * __useGetApplicationsQuery__
 *
 * To run a query within a React component, call `useGetApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationsQuery({
 *   variables: {
 *      estateId: // value for 'estateId'
 *   },
 * });
 */
export function useGetApplicationsQuery(baseOptions: Apollo.QueryHookOptions<GetApplicationsQuery, GetApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationsQuery, GetApplicationsQueryVariables>(GetApplicationsDocument, options);
      }
export function useGetApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationsQuery, GetApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationsQuery, GetApplicationsQueryVariables>(GetApplicationsDocument, options);
        }
export type GetApplicationsQueryHookResult = ReturnType<typeof useGetApplicationsQuery>;
export type GetApplicationsLazyQueryHookResult = ReturnType<typeof useGetApplicationsLazyQuery>;
export type GetApplicationsQueryResult = Apollo.QueryResult<GetApplicationsQuery, GetApplicationsQueryVariables>;
export function refetchGetApplicationsQuery(variables: GetApplicationsQueryVariables) {
      return { query: GetApplicationsDocument, variables: variables }
    }
export const GetApplicationScoreDocument = gql`
    query getApplicationScore($estateId: uuid!, $buyerMemberId: uuid!) {
  application(
    where: {estateId: {_eq: $estateId}, buyerId: {_eq: $buyerMemberId}, status: {_eq: Submitted}, archived: {_eq: false}}
    order_by: {updatedAt: desc}
    limit: 1
  ) {
    id
    score
  }
}
    `;

/**
 * __useGetApplicationScoreQuery__
 *
 * To run a query within a React component, call `useGetApplicationScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationScoreQuery({
 *   variables: {
 *      estateId: // value for 'estateId'
 *      buyerMemberId: // value for 'buyerMemberId'
 *   },
 * });
 */
export function useGetApplicationScoreQuery(baseOptions: Apollo.QueryHookOptions<GetApplicationScoreQuery, GetApplicationScoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationScoreQuery, GetApplicationScoreQueryVariables>(GetApplicationScoreDocument, options);
      }
export function useGetApplicationScoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationScoreQuery, GetApplicationScoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationScoreQuery, GetApplicationScoreQueryVariables>(GetApplicationScoreDocument, options);
        }
export type GetApplicationScoreQueryHookResult = ReturnType<typeof useGetApplicationScoreQuery>;
export type GetApplicationScoreLazyQueryHookResult = ReturnType<typeof useGetApplicationScoreLazyQuery>;
export type GetApplicationScoreQueryResult = Apollo.QueryResult<GetApplicationScoreQuery, GetApplicationScoreQueryVariables>;
export function refetchGetApplicationScoreQuery(variables: GetApplicationScoreQueryVariables) {
      return { query: GetApplicationScoreDocument, variables: variables }
    }
export const UpdateApplicationScoreDocument = gql`
    mutation updateApplicationScore($id: uuid!, $score: Int!) {
  update_application_by_pk(pk_columns: {id: $id}, _set: {score: $score}) {
    id
    score
  }
}
    `;
export type UpdateApplicationScoreMutationFn = Apollo.MutationFunction<UpdateApplicationScoreMutation, UpdateApplicationScoreMutationVariables>;

/**
 * __useUpdateApplicationScoreMutation__
 *
 * To run a mutation, you first call `useUpdateApplicationScoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApplicationScoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApplicationScoreMutation, { data, loading, error }] = useUpdateApplicationScoreMutation({
 *   variables: {
 *      id: // value for 'id'
 *      score: // value for 'score'
 *   },
 * });
 */
export function useUpdateApplicationScoreMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApplicationScoreMutation, UpdateApplicationScoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApplicationScoreMutation, UpdateApplicationScoreMutationVariables>(UpdateApplicationScoreDocument, options);
      }
export type UpdateApplicationScoreMutationHookResult = ReturnType<typeof useUpdateApplicationScoreMutation>;
export type UpdateApplicationScoreMutationResult = Apollo.MutationResult<UpdateApplicationScoreMutation>;
export type UpdateApplicationScoreMutationOptions = Apollo.BaseMutationOptions<UpdateApplicationScoreMutation, UpdateApplicationScoreMutationVariables>;
export const ApplicationsDocument = gql`
    subscription applications($estateId: uuid!) {
  application(
    where: {estateId: {_eq: $estateId}}
    order_by: [{archived: asc}, {submitDate: asc}, {updatedAt: asc}, {createdAt: asc}]
  ) {
    ...WebappApplication
  }
}
    ${WebappApplicationFragmentDoc}`;

/**
 * __useApplicationsSubscription__
 *
 * To run a query within a React component, call `useApplicationsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useApplicationsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationsSubscription({
 *   variables: {
 *      estateId: // value for 'estateId'
 *   },
 * });
 */
export function useApplicationsSubscription(baseOptions: Apollo.SubscriptionHookOptions<ApplicationsSubscription, ApplicationsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ApplicationsSubscription, ApplicationsSubscriptionVariables>(ApplicationsDocument, options);
      }
export type ApplicationsSubscriptionHookResult = ReturnType<typeof useApplicationsSubscription>;
export type ApplicationsSubscriptionResult = Apollo.SubscriptionResult<ApplicationsSubscription>;
export const UpdateApplicationDocument = gql`
    mutation updateApplication($id: uuid!, $values: application_set_input!) {
  update_application_by_pk(pk_columns: {id: $id}, _set: $values) {
    id
  }
}
    `;
export type UpdateApplicationMutationFn = Apollo.MutationFunction<UpdateApplicationMutation, UpdateApplicationMutationVariables>;

/**
 * __useUpdateApplicationMutation__
 *
 * To run a mutation, you first call `useUpdateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApplicationMutation, { data, loading, error }] = useUpdateApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpdateApplicationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApplicationMutation, UpdateApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApplicationMutation, UpdateApplicationMutationVariables>(UpdateApplicationDocument, options);
      }
export type UpdateApplicationMutationHookResult = ReturnType<typeof useUpdateApplicationMutation>;
export type UpdateApplicationMutationResult = Apollo.MutationResult<UpdateApplicationMutation>;
export type UpdateApplicationMutationOptions = Apollo.BaseMutationOptions<UpdateApplicationMutation, UpdateApplicationMutationVariables>;
export const GetBuyerMemberFoldersByApplicationIdDocument = gql`
    query getBuyerMemberFoldersByApplicationId($applicationId: uuid!) {
  buyer_member_folder(where: {applicationId: {_eq: $applicationId}}) {
    ...BuyerMemberFolder
  }
}
    ${BuyerMemberFolderFragmentDoc}`;

/**
 * __useGetBuyerMemberFoldersByApplicationIdQuery__
 *
 * To run a query within a React component, call `useGetBuyerMemberFoldersByApplicationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuyerMemberFoldersByApplicationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuyerMemberFoldersByApplicationIdQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useGetBuyerMemberFoldersByApplicationIdQuery(baseOptions: Apollo.QueryHookOptions<GetBuyerMemberFoldersByApplicationIdQuery, GetBuyerMemberFoldersByApplicationIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBuyerMemberFoldersByApplicationIdQuery, GetBuyerMemberFoldersByApplicationIdQueryVariables>(GetBuyerMemberFoldersByApplicationIdDocument, options);
      }
export function useGetBuyerMemberFoldersByApplicationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBuyerMemberFoldersByApplicationIdQuery, GetBuyerMemberFoldersByApplicationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBuyerMemberFoldersByApplicationIdQuery, GetBuyerMemberFoldersByApplicationIdQueryVariables>(GetBuyerMemberFoldersByApplicationIdDocument, options);
        }
export type GetBuyerMemberFoldersByApplicationIdQueryHookResult = ReturnType<typeof useGetBuyerMemberFoldersByApplicationIdQuery>;
export type GetBuyerMemberFoldersByApplicationIdLazyQueryHookResult = ReturnType<typeof useGetBuyerMemberFoldersByApplicationIdLazyQuery>;
export type GetBuyerMemberFoldersByApplicationIdQueryResult = Apollo.QueryResult<GetBuyerMemberFoldersByApplicationIdQuery, GetBuyerMemberFoldersByApplicationIdQueryVariables>;
export function refetchGetBuyerMemberFoldersByApplicationIdQuery(variables: GetBuyerMemberFoldersByApplicationIdQueryVariables) {
      return { query: GetBuyerMemberFoldersByApplicationIdDocument, variables: variables }
    }
export const GetEstateForTableDocument = gql`
    query getEstateForTable {
  estate(order_by: {createdAt: desc}) {
    ...EstateForTable
  }
}
    ${EstateForTableFragmentDoc}`;

/**
 * __useGetEstateForTableQuery__
 *
 * To run a query within a React component, call `useGetEstateForTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstateForTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstateForTableQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEstateForTableQuery(baseOptions?: Apollo.QueryHookOptions<GetEstateForTableQuery, GetEstateForTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEstateForTableQuery, GetEstateForTableQueryVariables>(GetEstateForTableDocument, options);
      }
export function useGetEstateForTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEstateForTableQuery, GetEstateForTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEstateForTableQuery, GetEstateForTableQueryVariables>(GetEstateForTableDocument, options);
        }
export type GetEstateForTableQueryHookResult = ReturnType<typeof useGetEstateForTableQuery>;
export type GetEstateForTableLazyQueryHookResult = ReturnType<typeof useGetEstateForTableLazyQuery>;
export type GetEstateForTableQueryResult = Apollo.QueryResult<GetEstateForTableQuery, GetEstateForTableQueryVariables>;
export function refetchGetEstateForTableQuery(variables?: GetEstateForTableQueryVariables) {
      return { query: GetEstateForTableDocument, variables: variables }
    }
export const GetEstatesDocument = gql`
    query getEstates {
  estate(order_by: {createdAt: desc}) {
    ...WebappSimpleEstate
  }
}
    ${WebappSimpleEstateFragmentDoc}`;

/**
 * __useGetEstatesQuery__
 *
 * To run a query within a React component, call `useGetEstatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEstatesQuery(baseOptions?: Apollo.QueryHookOptions<GetEstatesQuery, GetEstatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEstatesQuery, GetEstatesQueryVariables>(GetEstatesDocument, options);
      }
export function useGetEstatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEstatesQuery, GetEstatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEstatesQuery, GetEstatesQueryVariables>(GetEstatesDocument, options);
        }
export type GetEstatesQueryHookResult = ReturnType<typeof useGetEstatesQuery>;
export type GetEstatesLazyQueryHookResult = ReturnType<typeof useGetEstatesLazyQuery>;
export type GetEstatesQueryResult = Apollo.QueryResult<GetEstatesQuery, GetEstatesQueryVariables>;
export function refetchGetEstatesQuery(variables?: GetEstatesQueryVariables) {
      return { query: GetEstatesDocument, variables: variables }
    }
export const GetEstateForSidebarDocument = gql`
    subscription getEstateForSidebar($id: uuid!) {
  estate_by_pk(id: $id) {
    ...EstateForSidebar
  }
}
    ${EstateForSidebarFragmentDoc}`;

/**
 * __useGetEstateForSidebarSubscription__
 *
 * To run a query within a React component, call `useGetEstateForSidebarSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetEstateForSidebarSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstateForSidebarSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEstateForSidebarSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetEstateForSidebarSubscription, GetEstateForSidebarSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetEstateForSidebarSubscription, GetEstateForSidebarSubscriptionVariables>(GetEstateForSidebarDocument, options);
      }
export type GetEstateForSidebarSubscriptionHookResult = ReturnType<typeof useGetEstateForSidebarSubscription>;
export type GetEstateForSidebarSubscriptionResult = Apollo.SubscriptionResult<GetEstateForSidebarSubscription>;
export const GetEstateForSellersPageDocument = gql`
    query getEstateForSellersPage($id: uuid!) {
  estate_by_pk(id: $id) {
    ...EstateForSellersPage
  }
  estate_seller(where: {estateId: {_eq: $id}}) {
    ...EstateSeller
    seller {
      name
    }
  }
}
    ${EstateForSellersPageFragmentDoc}
${EstateSellerFragmentDoc}`;

/**
 * __useGetEstateForSellersPageQuery__
 *
 * To run a query within a React component, call `useGetEstateForSellersPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstateForSellersPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstateForSellersPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEstateForSellersPageQuery(baseOptions: Apollo.QueryHookOptions<GetEstateForSellersPageQuery, GetEstateForSellersPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEstateForSellersPageQuery, GetEstateForSellersPageQueryVariables>(GetEstateForSellersPageDocument, options);
      }
export function useGetEstateForSellersPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEstateForSellersPageQuery, GetEstateForSellersPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEstateForSellersPageQuery, GetEstateForSellersPageQueryVariables>(GetEstateForSellersPageDocument, options);
        }
export type GetEstateForSellersPageQueryHookResult = ReturnType<typeof useGetEstateForSellersPageQuery>;
export type GetEstateForSellersPageLazyQueryHookResult = ReturnType<typeof useGetEstateForSellersPageLazyQuery>;
export type GetEstateForSellersPageQueryResult = Apollo.QueryResult<GetEstateForSellersPageQuery, GetEstateForSellersPageQueryVariables>;
export function refetchGetEstateForSellersPageQuery(variables: GetEstateForSellersPageQueryVariables) {
      return { query: GetEstateForSellersPageDocument, variables: variables }
    }
export const GetEstateForMainPageDocument = gql`
    query getEstateForMainPage($id: uuid!) {
  estate_by_pk(id: $id) {
    ...EstateForMainPage
  }
}
    ${EstateForMainPageFragmentDoc}`;

/**
 * __useGetEstateForMainPageQuery__
 *
 * To run a query within a React component, call `useGetEstateForMainPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstateForMainPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstateForMainPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEstateForMainPageQuery(baseOptions: Apollo.QueryHookOptions<GetEstateForMainPageQuery, GetEstateForMainPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEstateForMainPageQuery, GetEstateForMainPageQueryVariables>(GetEstateForMainPageDocument, options);
      }
export function useGetEstateForMainPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEstateForMainPageQuery, GetEstateForMainPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEstateForMainPageQuery, GetEstateForMainPageQueryVariables>(GetEstateForMainPageDocument, options);
        }
export type GetEstateForMainPageQueryHookResult = ReturnType<typeof useGetEstateForMainPageQuery>;
export type GetEstateForMainPageLazyQueryHookResult = ReturnType<typeof useGetEstateForMainPageLazyQuery>;
export type GetEstateForMainPageQueryResult = Apollo.QueryResult<GetEstateForMainPageQuery, GetEstateForMainPageQueryVariables>;
export function refetchGetEstateForMainPageQuery(variables: GetEstateForMainPageQueryVariables) {
      return { query: GetEstateForMainPageDocument, variables: variables }
    }
export const GetEstateForDocumentsPageDocument = gql`
    query getEstateForDocumentsPage($id: uuid!) {
  estate_by_pk(id: $id) {
    ...EstateForDocumentsPage
  }
}
    ${EstateForDocumentsPageFragmentDoc}`;

/**
 * __useGetEstateForDocumentsPageQuery__
 *
 * To run a query within a React component, call `useGetEstateForDocumentsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstateForDocumentsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstateForDocumentsPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEstateForDocumentsPageQuery(baseOptions: Apollo.QueryHookOptions<GetEstateForDocumentsPageQuery, GetEstateForDocumentsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEstateForDocumentsPageQuery, GetEstateForDocumentsPageQueryVariables>(GetEstateForDocumentsPageDocument, options);
      }
export function useGetEstateForDocumentsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEstateForDocumentsPageQuery, GetEstateForDocumentsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEstateForDocumentsPageQuery, GetEstateForDocumentsPageQueryVariables>(GetEstateForDocumentsPageDocument, options);
        }
export type GetEstateForDocumentsPageQueryHookResult = ReturnType<typeof useGetEstateForDocumentsPageQuery>;
export type GetEstateForDocumentsPageLazyQueryHookResult = ReturnType<typeof useGetEstateForDocumentsPageLazyQuery>;
export type GetEstateForDocumentsPageQueryResult = Apollo.QueryResult<GetEstateForDocumentsPageQuery, GetEstateForDocumentsPageQueryVariables>;
export function refetchGetEstateForDocumentsPageQuery(variables: GetEstateForDocumentsPageQueryVariables) {
      return { query: GetEstateForDocumentsPageDocument, variables: variables }
    }
export const GetEstateForMediasPageDocument = gql`
    query getEstateForMediasPage($id: uuid!) {
  estate_by_pk(id: $id) {
    ...EstateForMediasPage
  }
}
    ${EstateForMediasPageFragmentDoc}`;

/**
 * __useGetEstateForMediasPageQuery__
 *
 * To run a query within a React component, call `useGetEstateForMediasPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstateForMediasPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstateForMediasPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEstateForMediasPageQuery(baseOptions: Apollo.QueryHookOptions<GetEstateForMediasPageQuery, GetEstateForMediasPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEstateForMediasPageQuery, GetEstateForMediasPageQueryVariables>(GetEstateForMediasPageDocument, options);
      }
export function useGetEstateForMediasPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEstateForMediasPageQuery, GetEstateForMediasPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEstateForMediasPageQuery, GetEstateForMediasPageQueryVariables>(GetEstateForMediasPageDocument, options);
        }
export type GetEstateForMediasPageQueryHookResult = ReturnType<typeof useGetEstateForMediasPageQuery>;
export type GetEstateForMediasPageLazyQueryHookResult = ReturnType<typeof useGetEstateForMediasPageLazyQuery>;
export type GetEstateForMediasPageQueryResult = Apollo.QueryResult<GetEstateForMediasPageQuery, GetEstateForMediasPageQueryVariables>;
export function refetchGetEstateForMediasPageQuery(variables: GetEstateForMediasPageQueryVariables) {
      return { query: GetEstateForMediasPageDocument, variables: variables }
    }
export const GetEstateForMandatePageDocument = gql`
    query getEstateForMandatePage($id: uuid!) {
  estate_by_pk(id: $id) {
    ...EstateForMandatePage
  }
}
    ${EstateForMandatePageFragmentDoc}`;

/**
 * __useGetEstateForMandatePageQuery__
 *
 * To run a query within a React component, call `useGetEstateForMandatePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstateForMandatePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstateForMandatePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEstateForMandatePageQuery(baseOptions: Apollo.QueryHookOptions<GetEstateForMandatePageQuery, GetEstateForMandatePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEstateForMandatePageQuery, GetEstateForMandatePageQueryVariables>(GetEstateForMandatePageDocument, options);
      }
export function useGetEstateForMandatePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEstateForMandatePageQuery, GetEstateForMandatePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEstateForMandatePageQuery, GetEstateForMandatePageQueryVariables>(GetEstateForMandatePageDocument, options);
        }
export type GetEstateForMandatePageQueryHookResult = ReturnType<typeof useGetEstateForMandatePageQuery>;
export type GetEstateForMandatePageLazyQueryHookResult = ReturnType<typeof useGetEstateForMandatePageLazyQuery>;
export type GetEstateForMandatePageQueryResult = Apollo.QueryResult<GetEstateForMandatePageQuery, GetEstateForMandatePageQueryVariables>;
export function refetchGetEstateForMandatePageQuery(variables: GetEstateForMandatePageQueryVariables) {
      return { query: GetEstateForMandatePageDocument, variables: variables }
    }
export const GetEstateForSalePageDocument = gql`
    subscription getEstateForSalePage($id: uuid!) {
  estate_by_pk(id: $id) {
    ...EstateForSalePage
  }
}
    ${EstateForSalePageFragmentDoc}`;

/**
 * __useGetEstateForSalePageSubscription__
 *
 * To run a query within a React component, call `useGetEstateForSalePageSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetEstateForSalePageSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstateForSalePageSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEstateForSalePageSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetEstateForSalePageSubscription, GetEstateForSalePageSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetEstateForSalePageSubscription, GetEstateForSalePageSubscriptionVariables>(GetEstateForSalePageDocument, options);
      }
export type GetEstateForSalePageSubscriptionHookResult = ReturnType<typeof useGetEstateForSalePageSubscription>;
export type GetEstateForSalePageSubscriptionResult = Apollo.SubscriptionResult<GetEstateForSalePageSubscription>;
export const GetEstateArchivedDocument = gql`
    query getEstateArchived($id: uuid!) {
  estate_by_pk(id: $id) {
    id
    isPublished
    archived
    applications {
      id
      status
    }
  }
}
    `;

/**
 * __useGetEstateArchivedQuery__
 *
 * To run a query within a React component, call `useGetEstateArchivedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstateArchivedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstateArchivedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEstateArchivedQuery(baseOptions: Apollo.QueryHookOptions<GetEstateArchivedQuery, GetEstateArchivedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEstateArchivedQuery, GetEstateArchivedQueryVariables>(GetEstateArchivedDocument, options);
      }
export function useGetEstateArchivedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEstateArchivedQuery, GetEstateArchivedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEstateArchivedQuery, GetEstateArchivedQueryVariables>(GetEstateArchivedDocument, options);
        }
export type GetEstateArchivedQueryHookResult = ReturnType<typeof useGetEstateArchivedQuery>;
export type GetEstateArchivedLazyQueryHookResult = ReturnType<typeof useGetEstateArchivedLazyQuery>;
export type GetEstateArchivedQueryResult = Apollo.QueryResult<GetEstateArchivedQuery, GetEstateArchivedQueryVariables>;
export function refetchGetEstateArchivedQuery(variables: GetEstateArchivedQueryVariables) {
      return { query: GetEstateArchivedDocument, variables: variables }
    }
export const CreateEstateDocument = gql`
    mutation createEstate($values: estate_insert_input!) {
  insert_estate_one(object: $values) {
    ...Estate
  }
}
    ${EstateFragmentDoc}`;
export type CreateEstateMutationFn = Apollo.MutationFunction<CreateEstateMutation, CreateEstateMutationVariables>;

/**
 * __useCreateEstateMutation__
 *
 * To run a mutation, you first call `useCreateEstateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEstateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEstateMutation, { data, loading, error }] = useCreateEstateMutation({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useCreateEstateMutation(baseOptions?: Apollo.MutationHookOptions<CreateEstateMutation, CreateEstateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEstateMutation, CreateEstateMutationVariables>(CreateEstateDocument, options);
      }
export type CreateEstateMutationHookResult = ReturnType<typeof useCreateEstateMutation>;
export type CreateEstateMutationResult = Apollo.MutationResult<CreateEstateMutation>;
export type CreateEstateMutationOptions = Apollo.BaseMutationOptions<CreateEstateMutation, CreateEstateMutationVariables>;
export const UpdateEstateDocument = gql`
    mutation updateEstate($id: uuid!, $values: estate_set_input!) {
  update_estate_by_pk(pk_columns: {id: $id}, _set: $values) {
    ...Estate
  }
}
    ${EstateFragmentDoc}`;
export type UpdateEstateMutationFn = Apollo.MutationFunction<UpdateEstateMutation, UpdateEstateMutationVariables>;

/**
 * __useUpdateEstateMutation__
 *
 * To run a mutation, you first call `useUpdateEstateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEstateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEstateMutation, { data, loading, error }] = useUpdateEstateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpdateEstateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEstateMutation, UpdateEstateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEstateMutation, UpdateEstateMutationVariables>(UpdateEstateDocument, options);
      }
export type UpdateEstateMutationHookResult = ReturnType<typeof useUpdateEstateMutation>;
export type UpdateEstateMutationResult = Apollo.MutationResult<UpdateEstateMutation>;
export type UpdateEstateMutationOptions = Apollo.BaseMutationOptions<UpdateEstateMutation, UpdateEstateMutationVariables>;
export const GetEstateApplicantsDocument = gql`
    query getEstateApplicants($id: uuid!) {
  estate_by_pk(id: $id) {
    applications {
      buyer_member {
        id
        user {
          displayName
          email
        }
      }
    }
  }
}
    `;

/**
 * __useGetEstateApplicantsQuery__
 *
 * To run a query within a React component, call `useGetEstateApplicantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstateApplicantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstateApplicantsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEstateApplicantsQuery(baseOptions: Apollo.QueryHookOptions<GetEstateApplicantsQuery, GetEstateApplicantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEstateApplicantsQuery, GetEstateApplicantsQueryVariables>(GetEstateApplicantsDocument, options);
      }
export function useGetEstateApplicantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEstateApplicantsQuery, GetEstateApplicantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEstateApplicantsQuery, GetEstateApplicantsQueryVariables>(GetEstateApplicantsDocument, options);
        }
export type GetEstateApplicantsQueryHookResult = ReturnType<typeof useGetEstateApplicantsQuery>;
export type GetEstateApplicantsLazyQueryHookResult = ReturnType<typeof useGetEstateApplicantsLazyQuery>;
export type GetEstateApplicantsQueryResult = Apollo.QueryResult<GetEstateApplicantsQuery, GetEstateApplicantsQueryVariables>;
export function refetchGetEstateApplicantsQuery(variables: GetEstateApplicantsQueryVariables) {
      return { query: GetEstateApplicantsDocument, variables: variables }
    }
export const GetEstateVisitsDocument = gql`
    query getEstateVisits($id: uuid!) {
  visit(where: {estateId: {_eq: $id}}) {
    ...Visit
    buyer_member {
      user {
        displayName
      }
    }
  }
}
    ${VisitFragmentDoc}`;

/**
 * __useGetEstateVisitsQuery__
 *
 * To run a query within a React component, call `useGetEstateVisitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstateVisitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstateVisitsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEstateVisitsQuery(baseOptions: Apollo.QueryHookOptions<GetEstateVisitsQuery, GetEstateVisitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEstateVisitsQuery, GetEstateVisitsQueryVariables>(GetEstateVisitsDocument, options);
      }
export function useGetEstateVisitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEstateVisitsQuery, GetEstateVisitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEstateVisitsQuery, GetEstateVisitsQueryVariables>(GetEstateVisitsDocument, options);
        }
export type GetEstateVisitsQueryHookResult = ReturnType<typeof useGetEstateVisitsQuery>;
export type GetEstateVisitsLazyQueryHookResult = ReturnType<typeof useGetEstateVisitsLazyQuery>;
export type GetEstateVisitsQueryResult = Apollo.QueryResult<GetEstateVisitsQuery, GetEstateVisitsQueryVariables>;
export function refetchGetEstateVisitsQuery(variables: GetEstateVisitsQueryVariables) {
      return { query: GetEstateVisitsDocument, variables: variables }
    }
export const UpdateEstateRoundDocument = gql`
    mutation updateEstateRound($id: uuid!, $values: estate_round_set_input!) {
  update_estate_round_by_pk(pk_columns: {id: $id}, _set: $values) {
    ...EstateRound
  }
}
    ${EstateRoundFragmentDoc}`;
export type UpdateEstateRoundMutationFn = Apollo.MutationFunction<UpdateEstateRoundMutation, UpdateEstateRoundMutationVariables>;

/**
 * __useUpdateEstateRoundMutation__
 *
 * To run a mutation, you first call `useUpdateEstateRoundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEstateRoundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEstateRoundMutation, { data, loading, error }] = useUpdateEstateRoundMutation({
 *   variables: {
 *      id: // value for 'id'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpdateEstateRoundMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEstateRoundMutation, UpdateEstateRoundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEstateRoundMutation, UpdateEstateRoundMutationVariables>(UpdateEstateRoundDocument, options);
      }
export type UpdateEstateRoundMutationHookResult = ReturnType<typeof useUpdateEstateRoundMutation>;
export type UpdateEstateRoundMutationResult = Apollo.MutationResult<UpdateEstateRoundMutation>;
export type UpdateEstateRoundMutationOptions = Apollo.BaseMutationOptions<UpdateEstateRoundMutation, UpdateEstateRoundMutationVariables>;
export const CreateEstateLinkDocument = gql`
    mutation createEstateLink($values: estate_link_insert_input!) {
  insert_estate_link_one(object: $values) {
    ...EstateLink
  }
}
    ${EstateLinkFragmentDoc}`;
export type CreateEstateLinkMutationFn = Apollo.MutationFunction<CreateEstateLinkMutation, CreateEstateLinkMutationVariables>;

/**
 * __useCreateEstateLinkMutation__
 *
 * To run a mutation, you first call `useCreateEstateLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEstateLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEstateLinkMutation, { data, loading, error }] = useCreateEstateLinkMutation({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useCreateEstateLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateEstateLinkMutation, CreateEstateLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEstateLinkMutation, CreateEstateLinkMutationVariables>(CreateEstateLinkDocument, options);
      }
export type CreateEstateLinkMutationHookResult = ReturnType<typeof useCreateEstateLinkMutation>;
export type CreateEstateLinkMutationResult = Apollo.MutationResult<CreateEstateLinkMutation>;
export type CreateEstateLinkMutationOptions = Apollo.BaseMutationOptions<CreateEstateLinkMutation, CreateEstateLinkMutationVariables>;
export const UpdateEstateLinkDocument = gql`
    mutation updateEstateLink($id: uuid!, $values: estate_link_set_input!) {
  update_estate_link_by_pk(pk_columns: {id: $id}, _set: $values) {
    ...EstateLink
  }
}
    ${EstateLinkFragmentDoc}`;
export type UpdateEstateLinkMutationFn = Apollo.MutationFunction<UpdateEstateLinkMutation, UpdateEstateLinkMutationVariables>;

/**
 * __useUpdateEstateLinkMutation__
 *
 * To run a mutation, you first call `useUpdateEstateLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEstateLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEstateLinkMutation, { data, loading, error }] = useUpdateEstateLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpdateEstateLinkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEstateLinkMutation, UpdateEstateLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEstateLinkMutation, UpdateEstateLinkMutationVariables>(UpdateEstateLinkDocument, options);
      }
export type UpdateEstateLinkMutationHookResult = ReturnType<typeof useUpdateEstateLinkMutation>;
export type UpdateEstateLinkMutationResult = Apollo.MutationResult<UpdateEstateLinkMutation>;
export type UpdateEstateLinkMutationOptions = Apollo.BaseMutationOptions<UpdateEstateLinkMutation, UpdateEstateLinkMutationVariables>;
export const DeleteEstateLinkDocument = gql`
    mutation deleteEstateLink($id: uuid!) {
  delete_estate_link_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteEstateLinkMutationFn = Apollo.MutationFunction<DeleteEstateLinkMutation, DeleteEstateLinkMutationVariables>;

/**
 * __useDeleteEstateLinkMutation__
 *
 * To run a mutation, you first call `useDeleteEstateLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEstateLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEstateLinkMutation, { data, loading, error }] = useDeleteEstateLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEstateLinkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEstateLinkMutation, DeleteEstateLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEstateLinkMutation, DeleteEstateLinkMutationVariables>(DeleteEstateLinkDocument, options);
      }
export type DeleteEstateLinkMutationHookResult = ReturnType<typeof useDeleteEstateLinkMutation>;
export type DeleteEstateLinkMutationResult = Apollo.MutationResult<DeleteEstateLinkMutation>;
export type DeleteEstateLinkMutationOptions = Apollo.BaseMutationOptions<DeleteEstateLinkMutation, DeleteEstateLinkMutationVariables>;
export const EstateSellersDocument = gql`
    query EstateSellers($estateId: uuid!) {
  estate_seller(where: {estateId: {_eq: $estateId}}) {
    ...EstateSeller
  }
}
    ${EstateSellerFragmentDoc}`;

/**
 * __useEstateSellersQuery__
 *
 * To run a query within a React component, call `useEstateSellersQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstateSellersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstateSellersQuery({
 *   variables: {
 *      estateId: // value for 'estateId'
 *   },
 * });
 */
export function useEstateSellersQuery(baseOptions: Apollo.QueryHookOptions<EstateSellersQuery, EstateSellersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EstateSellersQuery, EstateSellersQueryVariables>(EstateSellersDocument, options);
      }
export function useEstateSellersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EstateSellersQuery, EstateSellersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EstateSellersQuery, EstateSellersQueryVariables>(EstateSellersDocument, options);
        }
export type EstateSellersQueryHookResult = ReturnType<typeof useEstateSellersQuery>;
export type EstateSellersLazyQueryHookResult = ReturnType<typeof useEstateSellersLazyQuery>;
export type EstateSellersQueryResult = Apollo.QueryResult<EstateSellersQuery, EstateSellersQueryVariables>;
export function refetchEstateSellersQuery(variables: EstateSellersQueryVariables) {
      return { query: EstateSellersDocument, variables: variables }
    }
export const CreateEstateSellersDocument = gql`
    mutation createEstateSellers($valuesToCreate: [estate_seller_insert_input!]!) {
  insert_estate_seller(objects: $valuesToCreate) {
    affected_rows
    returning {
      ...EstateSeller
    }
  }
}
    ${EstateSellerFragmentDoc}`;
export type CreateEstateSellersMutationFn = Apollo.MutationFunction<CreateEstateSellersMutation, CreateEstateSellersMutationVariables>;

/**
 * __useCreateEstateSellersMutation__
 *
 * To run a mutation, you first call `useCreateEstateSellersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEstateSellersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEstateSellersMutation, { data, loading, error }] = useCreateEstateSellersMutation({
 *   variables: {
 *      valuesToCreate: // value for 'valuesToCreate'
 *   },
 * });
 */
export function useCreateEstateSellersMutation(baseOptions?: Apollo.MutationHookOptions<CreateEstateSellersMutation, CreateEstateSellersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEstateSellersMutation, CreateEstateSellersMutationVariables>(CreateEstateSellersDocument, options);
      }
export type CreateEstateSellersMutationHookResult = ReturnType<typeof useCreateEstateSellersMutation>;
export type CreateEstateSellersMutationResult = Apollo.MutationResult<CreateEstateSellersMutation>;
export type CreateEstateSellersMutationOptions = Apollo.BaseMutationOptions<CreateEstateSellersMutation, CreateEstateSellersMutationVariables>;
export const UpdateEstateSellerDocument = gql`
    mutation updateEstateSeller($ownershipShare: numeric!, $sellerId: uuid!, $estateId: uuid!) {
  update_estate_seller(
    where: {estateId: {_eq: $estateId}, sellerId: {_eq: $sellerId}}
    _set: {ownershipShare: $ownershipShare}
  ) {
    affected_rows
    returning {
      ...EstateSeller
    }
  }
}
    ${EstateSellerFragmentDoc}`;
export type UpdateEstateSellerMutationFn = Apollo.MutationFunction<UpdateEstateSellerMutation, UpdateEstateSellerMutationVariables>;

/**
 * __useUpdateEstateSellerMutation__
 *
 * To run a mutation, you first call `useUpdateEstateSellerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEstateSellerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEstateSellerMutation, { data, loading, error }] = useUpdateEstateSellerMutation({
 *   variables: {
 *      ownershipShare: // value for 'ownershipShare'
 *      sellerId: // value for 'sellerId'
 *      estateId: // value for 'estateId'
 *   },
 * });
 */
export function useUpdateEstateSellerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEstateSellerMutation, UpdateEstateSellerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEstateSellerMutation, UpdateEstateSellerMutationVariables>(UpdateEstateSellerDocument, options);
      }
export type UpdateEstateSellerMutationHookResult = ReturnType<typeof useUpdateEstateSellerMutation>;
export type UpdateEstateSellerMutationResult = Apollo.MutationResult<UpdateEstateSellerMutation>;
export type UpdateEstateSellerMutationOptions = Apollo.BaseMutationOptions<UpdateEstateSellerMutation, UpdateEstateSellerMutationVariables>;
export const DeleteEstateSellersDocument = gql`
    mutation deleteEstateSellers($sellerIdsToDelete: [uuid!]!, $estateId: uuid!) {
  delete_estate_seller(
    where: {_and: [{sellerId: {_in: $sellerIdsToDelete}}, {estateId: {_eq: $estateId}}]}
  ) {
    affected_rows
  }
}
    `;
export type DeleteEstateSellersMutationFn = Apollo.MutationFunction<DeleteEstateSellersMutation, DeleteEstateSellersMutationVariables>;

/**
 * __useDeleteEstateSellersMutation__
 *
 * To run a mutation, you first call `useDeleteEstateSellersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEstateSellersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEstateSellersMutation, { data, loading, error }] = useDeleteEstateSellersMutation({
 *   variables: {
 *      sellerIdsToDelete: // value for 'sellerIdsToDelete'
 *      estateId: // value for 'estateId'
 *   },
 * });
 */
export function useDeleteEstateSellersMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEstateSellersMutation, DeleteEstateSellersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEstateSellersMutation, DeleteEstateSellersMutationVariables>(DeleteEstateSellersDocument, options);
      }
export type DeleteEstateSellersMutationHookResult = ReturnType<typeof useDeleteEstateSellersMutation>;
export type DeleteEstateSellersMutationResult = Apollo.MutationResult<DeleteEstateSellersMutation>;
export type DeleteEstateSellersMutationOptions = Apollo.BaseMutationOptions<DeleteEstateSellersMutation, DeleteEstateSellersMutationVariables>;
export const GetSellersDocument = gql`
    query getSellers {
  seller {
    id
    name
    archived
  }
}
    `;

/**
 * __useGetSellersQuery__
 *
 * To run a query within a React component, call `useGetSellersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSellersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSellersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSellersQuery(baseOptions?: Apollo.QueryHookOptions<GetSellersQuery, GetSellersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSellersQuery, GetSellersQueryVariables>(GetSellersDocument, options);
      }
export function useGetSellersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSellersQuery, GetSellersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSellersQuery, GetSellersQueryVariables>(GetSellersDocument, options);
        }
export type GetSellersQueryHookResult = ReturnType<typeof useGetSellersQuery>;
export type GetSellersLazyQueryHookResult = ReturnType<typeof useGetSellersLazyQuery>;
export type GetSellersQueryResult = Apollo.QueryResult<GetSellersQuery, GetSellersQueryVariables>;
export function refetchGetSellersQuery(variables?: GetSellersQueryVariables) {
      return { query: GetSellersDocument, variables: variables }
    }
export const GetEstateMediaDocument = gql`
    query getEstateMedia($estateId: uuid!, $typeGroup: estate_media_type_group_enum!) {
  estate_media(
    where: {estateId: {_eq: $estateId}, type: {group: {_eq: $typeGroup}}}
    order_by: [{position: asc}, {file: {createdAt: asc}}]
  ) {
    ...WebappEstateMedia
  }
}
    ${WebappEstateMediaFragmentDoc}`;

/**
 * __useGetEstateMediaQuery__
 *
 * To run a query within a React component, call `useGetEstateMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstateMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstateMediaQuery({
 *   variables: {
 *      estateId: // value for 'estateId'
 *      typeGroup: // value for 'typeGroup'
 *   },
 * });
 */
export function useGetEstateMediaQuery(baseOptions: Apollo.QueryHookOptions<GetEstateMediaQuery, GetEstateMediaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEstateMediaQuery, GetEstateMediaQueryVariables>(GetEstateMediaDocument, options);
      }
export function useGetEstateMediaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEstateMediaQuery, GetEstateMediaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEstateMediaQuery, GetEstateMediaQueryVariables>(GetEstateMediaDocument, options);
        }
export type GetEstateMediaQueryHookResult = ReturnType<typeof useGetEstateMediaQuery>;
export type GetEstateMediaLazyQueryHookResult = ReturnType<typeof useGetEstateMediaLazyQuery>;
export type GetEstateMediaQueryResult = Apollo.QueryResult<GetEstateMediaQuery, GetEstateMediaQueryVariables>;
export function refetchGetEstateMediaQuery(variables: GetEstateMediaQueryVariables) {
      return { query: GetEstateMediaDocument, variables: variables }
    }
export const CreateEstateMediaDocument = gql`
    mutation createEstateMedia($values: estate_media_insert_input!) {
  insert_estate_media_one(object: $values) {
    ...EstateMedia
  }
}
    ${EstateMediaFragmentDoc}`;
export type CreateEstateMediaMutationFn = Apollo.MutationFunction<CreateEstateMediaMutation, CreateEstateMediaMutationVariables>;

/**
 * __useCreateEstateMediaMutation__
 *
 * To run a mutation, you first call `useCreateEstateMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEstateMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEstateMediaMutation, { data, loading, error }] = useCreateEstateMediaMutation({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useCreateEstateMediaMutation(baseOptions?: Apollo.MutationHookOptions<CreateEstateMediaMutation, CreateEstateMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEstateMediaMutation, CreateEstateMediaMutationVariables>(CreateEstateMediaDocument, options);
      }
export type CreateEstateMediaMutationHookResult = ReturnType<typeof useCreateEstateMediaMutation>;
export type CreateEstateMediaMutationResult = Apollo.MutationResult<CreateEstateMediaMutation>;
export type CreateEstateMediaMutationOptions = Apollo.BaseMutationOptions<CreateEstateMediaMutation, CreateEstateMediaMutationVariables>;
export const UpdateEstateMediaDocument = gql`
    mutation updateEstateMedia($id: uuid!, $values: estate_media_set_input!) {
  update_estate_media_by_pk(pk_columns: {id: $id}, _set: $values) {
    ...EstateMedia
  }
}
    ${EstateMediaFragmentDoc}`;
export type UpdateEstateMediaMutationFn = Apollo.MutationFunction<UpdateEstateMediaMutation, UpdateEstateMediaMutationVariables>;

/**
 * __useUpdateEstateMediaMutation__
 *
 * To run a mutation, you first call `useUpdateEstateMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEstateMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEstateMediaMutation, { data, loading, error }] = useUpdateEstateMediaMutation({
 *   variables: {
 *      id: // value for 'id'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpdateEstateMediaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEstateMediaMutation, UpdateEstateMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEstateMediaMutation, UpdateEstateMediaMutationVariables>(UpdateEstateMediaDocument, options);
      }
export type UpdateEstateMediaMutationHookResult = ReturnType<typeof useUpdateEstateMediaMutation>;
export type UpdateEstateMediaMutationResult = Apollo.MutationResult<UpdateEstateMediaMutation>;
export type UpdateEstateMediaMutationOptions = Apollo.BaseMutationOptions<UpdateEstateMediaMutation, UpdateEstateMediaMutationVariables>;
export const ReorderEstateMediasDocument = gql`
    mutation reorderEstateMedias($updates: [estate_media_updates!]!) {
  update_estate_media_many(updates: $updates) {
    affected_rows
  }
}
    `;
export type ReorderEstateMediasMutationFn = Apollo.MutationFunction<ReorderEstateMediasMutation, ReorderEstateMediasMutationVariables>;

/**
 * __useReorderEstateMediasMutation__
 *
 * To run a mutation, you first call `useReorderEstateMediasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderEstateMediasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderEstateMediasMutation, { data, loading, error }] = useReorderEstateMediasMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useReorderEstateMediasMutation(baseOptions?: Apollo.MutationHookOptions<ReorderEstateMediasMutation, ReorderEstateMediasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderEstateMediasMutation, ReorderEstateMediasMutationVariables>(ReorderEstateMediasDocument, options);
      }
export type ReorderEstateMediasMutationHookResult = ReturnType<typeof useReorderEstateMediasMutation>;
export type ReorderEstateMediasMutationResult = Apollo.MutationResult<ReorderEstateMediasMutation>;
export type ReorderEstateMediasMutationOptions = Apollo.BaseMutationOptions<ReorderEstateMediasMutation, ReorderEstateMediasMutationVariables>;
export const DeleteEstateMediaDocument = gql`
    mutation deleteEstateMedia($id: uuid!) {
  delete_estate_media_by_pk(id: $id) {
    ...EstateMedia
  }
}
    ${EstateMediaFragmentDoc}`;
export type DeleteEstateMediaMutationFn = Apollo.MutationFunction<DeleteEstateMediaMutation, DeleteEstateMediaMutationVariables>;

/**
 * __useDeleteEstateMediaMutation__
 *
 * To run a mutation, you first call `useDeleteEstateMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEstateMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEstateMediaMutation, { data, loading, error }] = useDeleteEstateMediaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEstateMediaMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEstateMediaMutation, DeleteEstateMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEstateMediaMutation, DeleteEstateMediaMutationVariables>(DeleteEstateMediaDocument, options);
      }
export type DeleteEstateMediaMutationHookResult = ReturnType<typeof useDeleteEstateMediaMutation>;
export type DeleteEstateMediaMutationResult = Apollo.MutationResult<DeleteEstateMediaMutation>;
export type DeleteEstateMediaMutationOptions = Apollo.BaseMutationOptions<DeleteEstateMediaMutation, DeleteEstateMediaMutationVariables>;
export const GetEstateMediaTypesDocument = gql`
    query getEstateMediaTypes($group: estate_media_type_group_enum) {
  estate_media_type {
    ...EstateMediaType
  }
}
    ${EstateMediaTypeFragmentDoc}`;

/**
 * __useGetEstateMediaTypesQuery__
 *
 * To run a query within a React component, call `useGetEstateMediaTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstateMediaTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstateMediaTypesQuery({
 *   variables: {
 *      group: // value for 'group'
 *   },
 * });
 */
export function useGetEstateMediaTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetEstateMediaTypesQuery, GetEstateMediaTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEstateMediaTypesQuery, GetEstateMediaTypesQueryVariables>(GetEstateMediaTypesDocument, options);
      }
export function useGetEstateMediaTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEstateMediaTypesQuery, GetEstateMediaTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEstateMediaTypesQuery, GetEstateMediaTypesQueryVariables>(GetEstateMediaTypesDocument, options);
        }
export type GetEstateMediaTypesQueryHookResult = ReturnType<typeof useGetEstateMediaTypesQuery>;
export type GetEstateMediaTypesLazyQueryHookResult = ReturnType<typeof useGetEstateMediaTypesLazyQuery>;
export type GetEstateMediaTypesQueryResult = Apollo.QueryResult<GetEstateMediaTypesQuery, GetEstateMediaTypesQueryVariables>;
export function refetchGetEstateMediaTypesQuery(variables?: GetEstateMediaTypesQueryVariables) {
      return { query: GetEstateMediaTypesDocument, variables: variables }
    }
export const GetFileDocument = gql`
    query getFile($id: uuid!) {
  file(id: $id) {
    ...File
  }
}
    ${FileFragmentDoc}`;

/**
 * __useGetFileQuery__
 *
 * To run a query within a React component, call `useGetFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFileQuery(baseOptions: Apollo.QueryHookOptions<GetFileQuery, GetFileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileQuery, GetFileQueryVariables>(GetFileDocument, options);
      }
export function useGetFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileQuery, GetFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileQuery, GetFileQueryVariables>(GetFileDocument, options);
        }
export type GetFileQueryHookResult = ReturnType<typeof useGetFileQuery>;
export type GetFileLazyQueryHookResult = ReturnType<typeof useGetFileLazyQuery>;
export type GetFileQueryResult = Apollo.QueryResult<GetFileQuery, GetFileQueryVariables>;
export function refetchGetFileQuery(variables: GetFileQueryVariables) {
      return { query: GetFileDocument, variables: variables }
    }
export const GetMandatesDocument = gql`
    query getMandates($agencyId: uuid!) {
  mandate(where: {estate: {seller: {agencyId: {_eq: $agencyId}}}}) {
    ...Mandate
  }
}
    ${MandateFragmentDoc}`;

/**
 * __useGetMandatesQuery__
 *
 * To run a query within a React component, call `useGetMandatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMandatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMandatesQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *   },
 * });
 */
export function useGetMandatesQuery(baseOptions: Apollo.QueryHookOptions<GetMandatesQuery, GetMandatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMandatesQuery, GetMandatesQueryVariables>(GetMandatesDocument, options);
      }
export function useGetMandatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMandatesQuery, GetMandatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMandatesQuery, GetMandatesQueryVariables>(GetMandatesDocument, options);
        }
export type GetMandatesQueryHookResult = ReturnType<typeof useGetMandatesQuery>;
export type GetMandatesLazyQueryHookResult = ReturnType<typeof useGetMandatesLazyQuery>;
export type GetMandatesQueryResult = Apollo.QueryResult<GetMandatesQuery, GetMandatesQueryVariables>;
export function refetchGetMandatesQuery(variables: GetMandatesQueryVariables) {
      return { query: GetMandatesDocument, variables: variables }
    }
export const GetMandateDocument = gql`
    query getMandate($id: uuid!) {
  mandate_by_pk(id: $id) {
    ...WebappMandate
  }
}
    ${WebappMandateFragmentDoc}`;

/**
 * __useGetMandateQuery__
 *
 * To run a query within a React component, call `useGetMandateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMandateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMandateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMandateQuery(baseOptions: Apollo.QueryHookOptions<GetMandateQuery, GetMandateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMandateQuery, GetMandateQueryVariables>(GetMandateDocument, options);
      }
export function useGetMandateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMandateQuery, GetMandateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMandateQuery, GetMandateQueryVariables>(GetMandateDocument, options);
        }
export type GetMandateQueryHookResult = ReturnType<typeof useGetMandateQuery>;
export type GetMandateLazyQueryHookResult = ReturnType<typeof useGetMandateLazyQuery>;
export type GetMandateQueryResult = Apollo.QueryResult<GetMandateQuery, GetMandateQueryVariables>;
export function refetchGetMandateQuery(variables: GetMandateQueryVariables) {
      return { query: GetMandateDocument, variables: variables }
    }
export const CreateMandateDocument = gql`
    mutation createMandate($values: mandate_insert_input!) {
  insert_mandate_one(object: $values) {
    id
  }
}
    `;
export type CreateMandateMutationFn = Apollo.MutationFunction<CreateMandateMutation, CreateMandateMutationVariables>;

/**
 * __useCreateMandateMutation__
 *
 * To run a mutation, you first call `useCreateMandateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMandateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMandateMutation, { data, loading, error }] = useCreateMandateMutation({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useCreateMandateMutation(baseOptions?: Apollo.MutationHookOptions<CreateMandateMutation, CreateMandateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMandateMutation, CreateMandateMutationVariables>(CreateMandateDocument, options);
      }
export type CreateMandateMutationHookResult = ReturnType<typeof useCreateMandateMutation>;
export type CreateMandateMutationResult = Apollo.MutationResult<CreateMandateMutation>;
export type CreateMandateMutationOptions = Apollo.BaseMutationOptions<CreateMandateMutation, CreateMandateMutationVariables>;
export const UpdateMandateDocument = gql`
    mutation updateMandate($id: uuid!, $values: mandate_set_input!) {
  update_mandate_by_pk(pk_columns: {id: $id}, _set: $values) {
    ...Mandate
  }
}
    ${MandateFragmentDoc}`;
export type UpdateMandateMutationFn = Apollo.MutationFunction<UpdateMandateMutation, UpdateMandateMutationVariables>;

/**
 * __useUpdateMandateMutation__
 *
 * To run a mutation, you first call `useUpdateMandateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMandateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMandateMutation, { data, loading, error }] = useUpdateMandateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpdateMandateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMandateMutation, UpdateMandateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMandateMutation, UpdateMandateMutationVariables>(UpdateMandateDocument, options);
      }
export type UpdateMandateMutationHookResult = ReturnType<typeof useUpdateMandateMutation>;
export type UpdateMandateMutationResult = Apollo.MutationResult<UpdateMandateMutation>;
export type UpdateMandateMutationOptions = Apollo.BaseMutationOptions<UpdateMandateMutation, UpdateMandateMutationVariables>;
export const UploadMandateMediaDocument = gql`
    mutation uploadMandateMedia($fileId: uuid!, $mandateId: uuid!) {
  insert_mandate_media_one(object: {fileId: $fileId, mandateId: $mandateId}) {
    id
  }
}
    `;
export type UploadMandateMediaMutationFn = Apollo.MutationFunction<UploadMandateMediaMutation, UploadMandateMediaMutationVariables>;

/**
 * __useUploadMandateMediaMutation__
 *
 * To run a mutation, you first call `useUploadMandateMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMandateMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMandateMediaMutation, { data, loading, error }] = useUploadMandateMediaMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      mandateId: // value for 'mandateId'
 *   },
 * });
 */
export function useUploadMandateMediaMutation(baseOptions?: Apollo.MutationHookOptions<UploadMandateMediaMutation, UploadMandateMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadMandateMediaMutation, UploadMandateMediaMutationVariables>(UploadMandateMediaDocument, options);
      }
export type UploadMandateMediaMutationHookResult = ReturnType<typeof useUploadMandateMediaMutation>;
export type UploadMandateMediaMutationResult = Apollo.MutationResult<UploadMandateMediaMutation>;
export type UploadMandateMediaMutationOptions = Apollo.BaseMutationOptions<UploadMandateMediaMutation, UploadMandateMediaMutationVariables>;
export const CreateMandateRegistryDocument = gql`
    mutation createMandateRegistry($values: mandate_registry_insert_input!) {
  insert_mandate_registry_one(object: $values) {
    ...MandateRegistry
    mandateId
  }
}
    ${MandateRegistryFragmentDoc}`;
export type CreateMandateRegistryMutationFn = Apollo.MutationFunction<CreateMandateRegistryMutation, CreateMandateRegistryMutationVariables>;

/**
 * __useCreateMandateRegistryMutation__
 *
 * To run a mutation, you first call `useCreateMandateRegistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMandateRegistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMandateRegistryMutation, { data, loading, error }] = useCreateMandateRegistryMutation({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useCreateMandateRegistryMutation(baseOptions?: Apollo.MutationHookOptions<CreateMandateRegistryMutation, CreateMandateRegistryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMandateRegistryMutation, CreateMandateRegistryMutationVariables>(CreateMandateRegistryDocument, options);
      }
export type CreateMandateRegistryMutationHookResult = ReturnType<typeof useCreateMandateRegistryMutation>;
export type CreateMandateRegistryMutationResult = Apollo.MutationResult<CreateMandateRegistryMutation>;
export type CreateMandateRegistryMutationOptions = Apollo.BaseMutationOptions<CreateMandateRegistryMutation, CreateMandateRegistryMutationVariables>;
export const SellersDocument = gql`
    subscription sellers {
  seller {
    ...SellerWithAgencyAndMembers
  }
}
    ${SellerWithAgencyAndMembersFragmentDoc}`;

/**
 * __useSellersSubscription__
 *
 * To run a query within a React component, call `useSellersSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSellersSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellersSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSellersSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SellersSubscription, SellersSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SellersSubscription, SellersSubscriptionVariables>(SellersDocument, options);
      }
export type SellersSubscriptionHookResult = ReturnType<typeof useSellersSubscription>;
export type SellersSubscriptionResult = Apollo.SubscriptionResult<SellersSubscription>;
export const SellerDocument = gql`
    subscription seller($id: uuid!) {
  seller_by_pk(id: $id) {
    ...SellerWithAgencyAndMembers
  }
}
    ${SellerWithAgencyAndMembersFragmentDoc}`;

/**
 * __useSellerSubscription__
 *
 * To run a query within a React component, call `useSellerSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSellerSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSellerSubscription(baseOptions: Apollo.SubscriptionHookOptions<SellerSubscription, SellerSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SellerSubscription, SellerSubscriptionVariables>(SellerDocument, options);
      }
export type SellerSubscriptionHookResult = ReturnType<typeof useSellerSubscription>;
export type SellerSubscriptionResult = Apollo.SubscriptionResult<SellerSubscription>;
export const SellerBySlugDocument = gql`
    subscription sellerBySlug($slug: String!) {
  seller(where: {slug: {_eq: $slug}}, limit: 1) {
    ...SellerWithAgencyAndMembers
  }
}
    ${SellerWithAgencyAndMembersFragmentDoc}`;

/**
 * __useSellerBySlugSubscription__
 *
 * To run a query within a React component, call `useSellerBySlugSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSellerBySlugSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerBySlugSubscription({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useSellerBySlugSubscription(baseOptions: Apollo.SubscriptionHookOptions<SellerBySlugSubscription, SellerBySlugSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SellerBySlugSubscription, SellerBySlugSubscriptionVariables>(SellerBySlugDocument, options);
      }
export type SellerBySlugSubscriptionHookResult = ReturnType<typeof useSellerBySlugSubscription>;
export type SellerBySlugSubscriptionResult = Apollo.SubscriptionResult<SellerBySlugSubscription>;
export const UpdateSellerDocument = gql`
    mutation updateSeller($id: uuid!, $values: seller_set_input!) {
  update_seller_by_pk(pk_columns: {id: $id}, _set: $values) {
    id
  }
}
    `;
export type UpdateSellerMutationFn = Apollo.MutationFunction<UpdateSellerMutation, UpdateSellerMutationVariables>;

/**
 * __useUpdateSellerMutation__
 *
 * To run a mutation, you first call `useUpdateSellerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSellerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSellerMutation, { data, loading, error }] = useUpdateSellerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpdateSellerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSellerMutation, UpdateSellerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSellerMutation, UpdateSellerMutationVariables>(UpdateSellerDocument, options);
      }
export type UpdateSellerMutationHookResult = ReturnType<typeof useUpdateSellerMutation>;
export type UpdateSellerMutationResult = Apollo.MutationResult<UpdateSellerMutation>;
export type UpdateSellerMutationOptions = Apollo.BaseMutationOptions<UpdateSellerMutation, UpdateSellerMutationVariables>;
export const GetSellerMembersBySellerIdsDocument = gql`
    query getSellerMembersBySellerIds($sellerIds: [uuid!]!) {
  seller_member(where: {sellerId: {_in: $sellerIds}}) {
    ...SellerMemberWithUserAndSellerNames
  }
}
    ${SellerMemberWithUserAndSellerNamesFragmentDoc}`;

/**
 * __useGetSellerMembersBySellerIdsQuery__
 *
 * To run a query within a React component, call `useGetSellerMembersBySellerIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSellerMembersBySellerIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSellerMembersBySellerIdsQuery({
 *   variables: {
 *      sellerIds: // value for 'sellerIds'
 *   },
 * });
 */
export function useGetSellerMembersBySellerIdsQuery(baseOptions: Apollo.QueryHookOptions<GetSellerMembersBySellerIdsQuery, GetSellerMembersBySellerIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSellerMembersBySellerIdsQuery, GetSellerMembersBySellerIdsQueryVariables>(GetSellerMembersBySellerIdsDocument, options);
      }
export function useGetSellerMembersBySellerIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSellerMembersBySellerIdsQuery, GetSellerMembersBySellerIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSellerMembersBySellerIdsQuery, GetSellerMembersBySellerIdsQueryVariables>(GetSellerMembersBySellerIdsDocument, options);
        }
export type GetSellerMembersBySellerIdsQueryHookResult = ReturnType<typeof useGetSellerMembersBySellerIdsQuery>;
export type GetSellerMembersBySellerIdsLazyQueryHookResult = ReturnType<typeof useGetSellerMembersBySellerIdsLazyQuery>;
export type GetSellerMembersBySellerIdsQueryResult = Apollo.QueryResult<GetSellerMembersBySellerIdsQuery, GetSellerMembersBySellerIdsQueryVariables>;
export function refetchGetSellerMembersBySellerIdsQuery(variables: GetSellerMembersBySellerIdsQueryVariables) {
      return { query: GetSellerMembersBySellerIdsDocument, variables: variables }
    }
export const GetSellerMemberByIdDocument = gql`
    query getSellerMemberById($id: uuid!) {
  seller_member_by_pk(id: $id) {
    ...SellerMember
  }
}
    ${SellerMemberFragmentDoc}`;

/**
 * __useGetSellerMemberByIdQuery__
 *
 * To run a query within a React component, call `useGetSellerMemberByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSellerMemberByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSellerMemberByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSellerMemberByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSellerMemberByIdQuery, GetSellerMemberByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSellerMemberByIdQuery, GetSellerMemberByIdQueryVariables>(GetSellerMemberByIdDocument, options);
      }
export function useGetSellerMemberByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSellerMemberByIdQuery, GetSellerMemberByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSellerMemberByIdQuery, GetSellerMemberByIdQueryVariables>(GetSellerMemberByIdDocument, options);
        }
export type GetSellerMemberByIdQueryHookResult = ReturnType<typeof useGetSellerMemberByIdQuery>;
export type GetSellerMemberByIdLazyQueryHookResult = ReturnType<typeof useGetSellerMemberByIdLazyQuery>;
export type GetSellerMemberByIdQueryResult = Apollo.QueryResult<GetSellerMemberByIdQuery, GetSellerMemberByIdQueryVariables>;
export function refetchGetSellerMemberByIdQuery(variables: GetSellerMemberByIdQueryVariables) {
      return { query: GetSellerMemberByIdDocument, variables: variables }
    }
export const DeleteSellerMemberDocument = gql`
    mutation deleteSellerMember($id: uuid!) {
  delete_seller_member_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteSellerMemberMutationFn = Apollo.MutationFunction<DeleteSellerMemberMutation, DeleteSellerMemberMutationVariables>;

/**
 * __useDeleteSellerMemberMutation__
 *
 * To run a mutation, you first call `useDeleteSellerMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSellerMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSellerMemberMutation, { data, loading, error }] = useDeleteSellerMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSellerMemberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSellerMemberMutation, DeleteSellerMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSellerMemberMutation, DeleteSellerMemberMutationVariables>(DeleteSellerMemberDocument, options);
      }
export type DeleteSellerMemberMutationHookResult = ReturnType<typeof useDeleteSellerMemberMutation>;
export type DeleteSellerMemberMutationResult = Apollo.MutationResult<DeleteSellerMemberMutation>;
export type DeleteSellerMemberMutationOptions = Apollo.BaseMutationOptions<DeleteSellerMemberMutation, DeleteSellerMemberMutationVariables>;
export const GetCurrentMemberAsSellerMemberDocument = gql`
    subscription getCurrentMemberAsSellerMember($userId: uuid!) {
  seller_member(where: {userId: {_eq: $userId}}) {
    ...CurrentMemberAsSellerMember
  }
}
    ${CurrentMemberAsSellerMemberFragmentDoc}`;

/**
 * __useGetCurrentMemberAsSellerMemberSubscription__
 *
 * To run a query within a React component, call `useGetCurrentMemberAsSellerMemberSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentMemberAsSellerMemberSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentMemberAsSellerMemberSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetCurrentMemberAsSellerMemberSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetCurrentMemberAsSellerMemberSubscription, GetCurrentMemberAsSellerMemberSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetCurrentMemberAsSellerMemberSubscription, GetCurrentMemberAsSellerMemberSubscriptionVariables>(GetCurrentMemberAsSellerMemberDocument, options);
      }
export type GetCurrentMemberAsSellerMemberSubscriptionHookResult = ReturnType<typeof useGetCurrentMemberAsSellerMemberSubscription>;
export type GetCurrentMemberAsSellerMemberSubscriptionResult = Apollo.SubscriptionResult<GetCurrentMemberAsSellerMemberSubscription>;
export const GetCurrentMemberAsAgencyMemberDocument = gql`
    subscription getCurrentMemberAsAgencyMember($userId: uuid!) {
  agency_member(where: {userId: {_eq: $userId}}) {
    ...CurrentMemberAsAgencyMember
  }
}
    ${CurrentMemberAsAgencyMemberFragmentDoc}`;

/**
 * __useGetCurrentMemberAsAgencyMemberSubscription__
 *
 * To run a query within a React component, call `useGetCurrentMemberAsAgencyMemberSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentMemberAsAgencyMemberSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentMemberAsAgencyMemberSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetCurrentMemberAsAgencyMemberSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetCurrentMemberAsAgencyMemberSubscription, GetCurrentMemberAsAgencyMemberSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetCurrentMemberAsAgencyMemberSubscription, GetCurrentMemberAsAgencyMemberSubscriptionVariables>(GetCurrentMemberAsAgencyMemberDocument, options);
      }
export type GetCurrentMemberAsAgencyMemberSubscriptionHookResult = ReturnType<typeof useGetCurrentMemberAsAgencyMemberSubscription>;
export type GetCurrentMemberAsAgencyMemberSubscriptionResult = Apollo.SubscriptionResult<GetCurrentMemberAsAgencyMemberSubscription>;
export const SearchBuyerMembersDocument = gql`
    query searchBuyerMembers($displayNameSearch: String!, $emailSearch: citext!) {
  buyer_member(
    where: {user: {_or: [{displayName: {_ilike: $displayNameSearch}}, {email: {_ilike: $emailSearch}}]}}
    order_by: {user: {displayName: asc}}
    limit: 10
  ) {
    ...BuyerMember
  }
}
    ${BuyerMemberFragmentDoc}`;

/**
 * __useSearchBuyerMembersQuery__
 *
 * To run a query within a React component, call `useSearchBuyerMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchBuyerMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchBuyerMembersQuery({
 *   variables: {
 *      displayNameSearch: // value for 'displayNameSearch'
 *      emailSearch: // value for 'emailSearch'
 *   },
 * });
 */
export function useSearchBuyerMembersQuery(baseOptions: Apollo.QueryHookOptions<SearchBuyerMembersQuery, SearchBuyerMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchBuyerMembersQuery, SearchBuyerMembersQueryVariables>(SearchBuyerMembersDocument, options);
      }
export function useSearchBuyerMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchBuyerMembersQuery, SearchBuyerMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchBuyerMembersQuery, SearchBuyerMembersQueryVariables>(SearchBuyerMembersDocument, options);
        }
export type SearchBuyerMembersQueryHookResult = ReturnType<typeof useSearchBuyerMembersQuery>;
export type SearchBuyerMembersLazyQueryHookResult = ReturnType<typeof useSearchBuyerMembersLazyQuery>;
export type SearchBuyerMembersQueryResult = Apollo.QueryResult<SearchBuyerMembersQuery, SearchBuyerMembersQueryVariables>;
export function refetchSearchBuyerMembersQuery(variables: SearchBuyerMembersQueryVariables) {
      return { query: SearchBuyerMembersDocument, variables: variables }
    }
export const UpdateVisitIsVisitDoneDocument = gql`
    mutation updateVisitIsVisitDone($id: uuid!, $isVisitDone: Boolean!) {
  update_visit_by_pk(pk_columns: {id: $id}, _set: {isVisitDone: $isVisitDone}) {
    id
    isVisitDone
  }
}
    `;
export type UpdateVisitIsVisitDoneMutationFn = Apollo.MutationFunction<UpdateVisitIsVisitDoneMutation, UpdateVisitIsVisitDoneMutationVariables>;

/**
 * __useUpdateVisitIsVisitDoneMutation__
 *
 * To run a mutation, you first call `useUpdateVisitIsVisitDoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVisitIsVisitDoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVisitIsVisitDoneMutation, { data, loading, error }] = useUpdateVisitIsVisitDoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isVisitDone: // value for 'isVisitDone'
 *   },
 * });
 */
export function useUpdateVisitIsVisitDoneMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVisitIsVisitDoneMutation, UpdateVisitIsVisitDoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVisitIsVisitDoneMutation, UpdateVisitIsVisitDoneMutationVariables>(UpdateVisitIsVisitDoneDocument, options);
      }
export type UpdateVisitIsVisitDoneMutationHookResult = ReturnType<typeof useUpdateVisitIsVisitDoneMutation>;
export type UpdateVisitIsVisitDoneMutationResult = Apollo.MutationResult<UpdateVisitIsVisitDoneMutation>;
export type UpdateVisitIsVisitDoneMutationOptions = Apollo.BaseMutationOptions<UpdateVisitIsVisitDoneMutation, UpdateVisitIsVisitDoneMutationVariables>;
export const DeleteVisitDocument = gql`
    mutation deleteVisit($id: uuid!) {
  delete_visit_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteVisitMutationFn = Apollo.MutationFunction<DeleteVisitMutation, DeleteVisitMutationVariables>;

/**
 * __useDeleteVisitMutation__
 *
 * To run a mutation, you first call `useDeleteVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVisitMutation, { data, loading, error }] = useDeleteVisitMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVisitMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVisitMutation, DeleteVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVisitMutation, DeleteVisitMutationVariables>(DeleteVisitDocument, options);
      }
export type DeleteVisitMutationHookResult = ReturnType<typeof useDeleteVisitMutation>;
export type DeleteVisitMutationResult = Apollo.MutationResult<DeleteVisitMutation>;
export type DeleteVisitMutationOptions = Apollo.BaseMutationOptions<DeleteVisitMutation, DeleteVisitMutationVariables>;
export const UpdateVisitTimeDocument = gql`
    mutation updateVisitTime($id: uuid!, $startTime: timestamptz!, $endTime: timestamptz!) {
  update_visit_by_pk(
    pk_columns: {id: $id}
    _set: {startTime: $startTime, endTime: $endTime}
  ) {
    id
    startTime
    endTime
  }
}
    `;
export type UpdateVisitTimeMutationFn = Apollo.MutationFunction<UpdateVisitTimeMutation, UpdateVisitTimeMutationVariables>;

/**
 * __useUpdateVisitTimeMutation__
 *
 * To run a mutation, you first call `useUpdateVisitTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVisitTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVisitTimeMutation, { data, loading, error }] = useUpdateVisitTimeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useUpdateVisitTimeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVisitTimeMutation, UpdateVisitTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVisitTimeMutation, UpdateVisitTimeMutationVariables>(UpdateVisitTimeDocument, options);
      }
export type UpdateVisitTimeMutationHookResult = ReturnType<typeof useUpdateVisitTimeMutation>;
export type UpdateVisitTimeMutationResult = Apollo.MutationResult<UpdateVisitTimeMutation>;
export type UpdateVisitTimeMutationOptions = Apollo.BaseMutationOptions<UpdateVisitTimeMutation, UpdateVisitTimeMutationVariables>;
export const CreateVisitDocument = gql`
    mutation createVisit($estateId: uuid!, $buyerId: uuid!, $startTime: timestamptz!, $endTime: timestamptz!) {
  insert_visit_one(
    object: {estateId: $estateId, buyerId: $buyerId, startTime: $startTime, endTime: $endTime}
  ) {
    id
    startTime
    endTime
    estateId
    buyerId
  }
}
    `;
export type CreateVisitMutationFn = Apollo.MutationFunction<CreateVisitMutation, CreateVisitMutationVariables>;

/**
 * __useCreateVisitMutation__
 *
 * To run a mutation, you first call `useCreateVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVisitMutation, { data, loading, error }] = useCreateVisitMutation({
 *   variables: {
 *      estateId: // value for 'estateId'
 *      buyerId: // value for 'buyerId'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useCreateVisitMutation(baseOptions?: Apollo.MutationHookOptions<CreateVisitMutation, CreateVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVisitMutation, CreateVisitMutationVariables>(CreateVisitDocument, options);
      }
export type CreateVisitMutationHookResult = ReturnType<typeof useCreateVisitMutation>;
export type CreateVisitMutationResult = Apollo.MutationResult<CreateVisitMutation>;
export type CreateVisitMutationOptions = Apollo.BaseMutationOptions<CreateVisitMutation, CreateVisitMutationVariables>;
export const UpsertVisitSpanDocument = gql`
    mutation upsertVisitSpan($valuesToCreate: [visit_span_insert_input!]!, $valuesToUpdate: [visit_span_updates!]!, $idsToDelete: [uuid!]!) {
  insert_visit_span(objects: $valuesToCreate) {
    affected_rows
    returning {
      ...VisitSpan
    }
  }
  update_visit_span_many(updates: $valuesToUpdate) {
    affected_rows
    returning {
      ...VisitSpan
    }
  }
  delete_visit_span(where: {id: {_in: $idsToDelete}}) {
    affected_rows
  }
}
    ${VisitSpanFragmentDoc}`;
export type UpsertVisitSpanMutationFn = Apollo.MutationFunction<UpsertVisitSpanMutation, UpsertVisitSpanMutationVariables>;

/**
 * __useUpsertVisitSpanMutation__
 *
 * To run a mutation, you first call `useUpsertVisitSpanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertVisitSpanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertVisitSpanMutation, { data, loading, error }] = useUpsertVisitSpanMutation({
 *   variables: {
 *      valuesToCreate: // value for 'valuesToCreate'
 *      valuesToUpdate: // value for 'valuesToUpdate'
 *      idsToDelete: // value for 'idsToDelete'
 *   },
 * });
 */
export function useUpsertVisitSpanMutation(baseOptions?: Apollo.MutationHookOptions<UpsertVisitSpanMutation, UpsertVisitSpanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertVisitSpanMutation, UpsertVisitSpanMutationVariables>(UpsertVisitSpanDocument, options);
      }
export type UpsertVisitSpanMutationHookResult = ReturnType<typeof useUpsertVisitSpanMutation>;
export type UpsertVisitSpanMutationResult = Apollo.MutationResult<UpsertVisitSpanMutation>;
export type UpsertVisitSpanMutationOptions = Apollo.BaseMutationOptions<UpsertVisitSpanMutation, UpsertVisitSpanMutationVariables>;